(function(global, factory) {
  typeof exports === "object" && typeof module !== "undefined" ? factory(exports, require("vue")) : typeof define === "function" && define.amd ? define(["exports", "vue"], factory) : (global = typeof globalThis !== "undefined" ? globalThis : global || self, factory(global["cf-design-mobile"] = {}, global.Vue));
})(this, function(exports2, vue) {
  "use strict";
  function noop() {
  }
  var extend = Object.assign;
  var inBrowser$1 = typeof window !== "undefined";
  function pick(obj, keys, ignoreUndefined) {
    return keys.reduce((ret, key) => {
      if (!ignoreUndefined || obj[key] !== void 0) {
        ret[key] = obj[key];
      }
      return ret;
    }, {});
  }
  var DEFAULT_CONFIG = {
    platform: "mobile",
    prefix: "cf"
  };
  var FORM_KEY = Symbol("cf-form");
  function genBem(name2, mods) {
    if (!mods) {
      return "";
    }
    if (typeof mods === "string") {
      return " " + name2 + "--" + mods;
    }
    if (Array.isArray(mods)) {
      return mods.reduce((ret, item) => ret + genBem(name2, item), "");
    }
    return Object.keys(mods).reduce((ret, key) => ret + (mods[key] ? genBem(name2, key) : ""), "");
  }
  function createBEM(name2) {
    return (el, mods) => {
      if (el && typeof el !== "string") {
        mods = el;
        el = "";
      }
      el = el ? name2 + "__" + el : name2;
      return "" + el + genBem(el, mods);
    };
  }
  var {
    prefix
  } = DEFAULT_CONFIG;
  function setNamespace(newPrefix) {
    prefix = newPrefix;
  }
  function createNamespace(name2) {
    var prefixedName = prefix + "-" + name2;
    return [prefixedName, createBEM(prefixedName)];
  }
  var width;
  var height;
  function useWindowSize() {
    if (!width) {
      width = vue.ref(0);
      height = vue.ref(0);
      if (inBrowser$1) {
        var update = () => {
          width.value = window.innerWidth;
          height.value = window.innerHeight;
        };
        update();
        window.addEventListener("resize", update, {
          passive: true
        });
        window.addEventListener("orientationchange", update, {
          passive: true
        });
      }
    }
    return {
      width,
      height
    };
  }
  var isWindow = (val) => val === window;
  var makeDOMRect = (width2, height2) => ({
    top: 0,
    left: 0,
    right: width2,
    bottom: height2,
    width: width2,
    height: height2
  });
  var useRect = (elementOrRef) => {
    var element = vue.unref(elementOrRef);
    if (isWindow(element)) {
      var width2 = element.innerWidth;
      var height2 = element.innerHeight;
      return makeDOMRect(width2, height2);
    }
    if (element != null && element.getBoundingClientRect) {
      return element.getBoundingClientRect();
    }
    return makeDOMRect(0, 0);
  };
  var isDef = (val) => val !== void 0 && val !== null;
  var isFunction = (val) => typeof val === "function";
  var isObject$1 = (val) => val !== null && typeof val === "object";
  var isPromise = (val) => isObject$1(val) && isFunction(val.then) && isFunction(val.catch);
  var isDate = (val) => Object.prototype.toString.call(val) === "[object Date]" && !Number.isNaN(val.getTime());
  var isNumeric = (val) => typeof val === "number" || /^\d+(\.\d+)?$/.test(val);
  var isIOS$1 = () => inBrowser$1 ? /ios|iphone|ipad|ipod/.test(navigator.userAgent.toLowerCase()) : false;
  function getScrollTop(el) {
    var top2 = "scrollTop" in el ? el.scrollTop : el.pageYOffset;
    return Math.max(top2, 0);
  }
  function setScrollTop(el, value) {
    if ("scrollTop" in el) {
      el.scrollTop = value;
    } else {
      el.scrollTo(el.scrollX, value);
    }
  }
  function getRootScrollTop() {
    return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
  }
  function setRootScrollTop(value) {
    setScrollTop(window, value);
    setScrollTop(document.body, value);
  }
  function getElementTop(el, scroller) {
    if (el === window) {
      return 0;
    }
    var scrollTop = scroller ? getScrollTop(scroller) : getRootScrollTop();
    return useRect(el).top + scrollTop;
  }
  var isIOS = isIOS$1();
  function resetScroll() {
    if (isIOS) {
      setRootScrollTop(getRootScrollTop());
    }
  }
  var stopPropagation = (event) => event.stopPropagation();
  function preventDefault(event, isStopPropagation) {
    if (typeof event.cancelable !== "boolean" || event.cancelable) {
      event.preventDefault();
    }
    if (isStopPropagation) {
      stopPropagation(event);
    }
  }
  function isHidden(elementRef) {
    var el = vue.unref(elementRef);
    if (!el) {
      return false;
    }
    var style = window.getComputedStyle(el);
    var hidden = style.display === "none";
    var parentHidden = el.offsetParent === null && style.position !== "fixed";
    return hidden || parentHidden;
  }
  var {
    width: windowWidth,
    height: windowHeight
  } = useWindowSize();
  var unknownProp = null;
  var numericProp = [Number, String];
  var truthProp = {
    type: Boolean,
    default: true
  };
  var falseProp = {
    type: Boolean,
    default: false
  };
  var makeRequiredProp = (type) => ({
    type,
    required: true
  });
  var makeArrayProp = () => ({
    type: Array,
    default: () => []
  });
  var makeNumberProp = (defaultVal) => ({
    type: Number,
    default: defaultVal
  });
  var makeNumericProp = (defaultVal) => ({
    type: numericProp,
    default: defaultVal
  });
  var makeStringProp = (defaultVal) => ({
    type: String,
    default: defaultVal
  });
  function addUnit(value) {
    if (isDef(value)) {
      return isNumeric(value) ? value + "px" : String(value);
    }
    return void 0;
  }
  function getSizeStyle(originSize) {
    if (isDef(originSize)) {
      var size = addUnit(originSize);
      return {
        width: size,
        height: size
      };
    }
  }
  function getZIndexStyle(zIndex) {
    var style = {};
    if (zIndex !== void 0) {
      style.zIndex = +zIndex;
    }
    return style;
  }
  var rootFontSize;
  function getRootFontSize() {
    if (!rootFontSize) {
      var doc = document.documentElement;
      var fontSize = doc.style.fontSize || window.getComputedStyle(doc).fontSize;
      rootFontSize = parseFloat(fontSize);
    }
    return rootFontSize;
  }
  function convertRem(value) {
    value = value.replace(/rem/g, "");
    return +value * getRootFontSize();
  }
  function convertVw(value) {
    value = value.replace(/vw/g, "");
    return +value * windowWidth.value / 100;
  }
  function convertVh(value) {
    value = value.replace(/vh/g, "");
    return +value * windowHeight.value / 100;
  }
  function unitToPx(value) {
    if (typeof value === "number") {
      return value;
    }
    if (inBrowser$1) {
      if (value.includes("rem")) {
        return convertRem(value);
      }
      if (value.includes("vw")) {
        return convertVw(value);
      }
      if (value.includes("vh")) {
        return convertVh(value);
      }
    }
    return parseFloat(value);
  }
  var camelizeRE = /-(\w)/g;
  var camelize = (str) => str.replace(camelizeRE, (_, c) => c.toUpperCase());
  function padZero(num, targetLength) {
    if (targetLength === void 0) {
      targetLength = 2;
    }
    var str = num + "";
    while (str.length < targetLength) {
      str = "0" + str;
    }
    return str;
  }
  var clamp = (num, min2, max2) => Math.min(Math.max(num, min2), max2);
  function trimExtraChar(value, char, regExp) {
    var index2 = value.indexOf(char);
    if (index2 === -1) {
      return value;
    }
    if (char === "-" && index2 !== 0) {
      return value.slice(0, index2);
    }
    return value.slice(0, index2 + 1) + value.slice(index2).replace(regExp, "");
  }
  function formatNumber(value, allowDot, allowMinus) {
    if (allowDot === void 0) {
      allowDot = true;
    }
    if (allowMinus === void 0) {
      allowMinus = true;
    }
    if (allowDot) {
      value = trimExtraChar(value, ".", /\./g);
    } else {
      value = value.split(".")[0];
    }
    if (allowMinus) {
      value = trimExtraChar(value, "-", /-/g);
    } else {
      value = value.replace(/-/, "");
    }
    var regExp = allowDot ? /[^-0-9.]/g : /[^-0-9]/g;
    return value.replace(regExp, "");
  }
  function addNumber(num1, num2) {
    var cardinal = Math.pow(10, 10);
    return Math.round((num1 + num2) * cardinal) / cardinal;
  }
  function callInterceptor(interceptor, _ref) {
    var {
      args = [],
      done,
      canceled
    } = _ref;
    if (interceptor) {
      var returnVal = interceptor.apply(null, args);
      if (isPromise(returnVal)) {
        returnVal.then((value) => {
          if (value) {
            done();
          } else if (canceled) {
            canceled();
          }
        }).catch(noop);
      } else if (returnVal) {
        done();
      } else if (canceled) {
        canceled();
      }
    } else {
      done();
    }
  }
  function withInstall(options) {
    options.install = (app) => {
      var {
        name: name2
      } = options;
      app.component(name2, options);
      app.component(camelize("-" + name2), options);
    };
    return options;
  }
  function _extends$a() {
    _extends$a = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends$a.apply(this, arguments);
  }
  function flattenVNodes(children) {
    var result = [];
    var traverse = (children2) => {
      if (Array.isArray(children2)) {
        children2.forEach((child) => {
          if (vue.isVNode(child)) {
            var _child$component;
            result.push(child);
            if ((_child$component = child.component) != null && _child$component.subTree) {
              traverse(child.component.subTree.children);
            }
            if (child.children) {
              traverse(child.children);
            }
          }
        });
      }
    };
    traverse(children);
    return result;
  }
  function sortChildren(parent, publicChildren, internalChildren) {
    var vnodes = flattenVNodes(parent.subTree.children);
    internalChildren.sort((a, b) => vnodes.indexOf(a.vnode) - vnodes.indexOf(b.vnode));
    var orderedPublicChildren = internalChildren.map((item) => item.proxy);
    publicChildren.sort((a, b) => {
      var indexA = orderedPublicChildren.indexOf(a);
      var indexB = orderedPublicChildren.indexOf(b);
      return indexA - indexB;
    });
  }
  function useChildren(key) {
    var publicChildren = vue.reactive([]);
    var internalChildren = vue.reactive([]);
    var parent = vue.getCurrentInstance();
    var linkChildren = (value) => {
      var link = (child) => {
        if (child.proxy) {
          internalChildren.push(child);
          publicChildren.push(child.proxy);
          sortChildren(parent, publicChildren, internalChildren);
        }
      };
      var unlink = (child) => {
        var index2 = internalChildren.indexOf(child);
        publicChildren.splice(index2, 1);
        internalChildren.splice(index2, 1);
      };
      var provideOption = _extends$a({
        link,
        unlink,
        children: publicChildren,
        internalChildren
      }, value);
      vue.provide(key, _extends$a({}, provideOption));
    };
    return {
      children: publicChildren,
      linkChildren
    };
  }
  var [name$15, bem$C] = createNamespace("action-bar");
  var ACTION_BAR_KEY = Symbol(name$15);
  var actionBarProps = {
    safeAreaInsetBottom: truthProp
  };
  var _ActionBar = vue.defineComponent({
    name: name$15,
    props: actionBarProps,
    setup(props, _ref) {
      var {
        slots
      } = _ref;
      var {
        linkChildren
      } = useChildren(ACTION_BAR_KEY);
      linkChildren();
      return () => vue.createVNode("div", {
        "class": [bem$C(), {
          "van-safe-area-bottom": props.safeAreaInsetBottom
        }]
      }, [slots.default == null ? void 0 : slots.default()]);
    }
  });
  var ActionBar = withInstall(_ActionBar);
  function useParent(key) {
    var parent = vue.inject(key, null);
    if (parent) {
      var instance2 = vue.getCurrentInstance();
      var {
        link: _link,
        unlink: _unlink,
        internalChildren
      } = parent;
      if (instance2) {
        _link(instance2);
        vue.onUnmounted(() => _unlink(instance2));
        var index2 = vue.computed(() => internalChildren.indexOf(instance2));
        return {
          parent,
          index: index2
        };
      }
    }
    return {
      parent: null,
      index: vue.ref(-1)
    };
  }
  function useExpose(apis) {
    var instance2 = vue.getCurrentInstance();
    if (instance2) {
      Object.assign(instance2.proxy, apis);
    }
  }
  var routeProps = {
    to: [String, Object],
    url: String,
    replace: Boolean
  };
  function route(vm) {
    var router = vm.$router;
    var {
      to,
      url,
      replace
    } = vm;
    if (to && router) {
      router[replace ? "replace" : "push"](to);
    } else if (url) {
      replace ? location.replace(url) : location.href = url;
    }
  }
  function useRoute() {
    var vm = vue.getCurrentInstance().proxy;
    return () => route(vm);
  }
  var [name$14] = createNamespace("config-provider");
  var CONFIG_PROVIDER_KEY = Symbol(name$14);
  var configProviderProps = {
    platform: makeStringProp(DEFAULT_CONFIG.platform),
    prefix: makeStringProp(DEFAULT_CONFIG.prefix)
  };
  var _ConfigProvider = vue.defineComponent({
    name: name$14,
    props: configProviderProps,
    setup(props, _ref) {
      var {
        slots
      } = _ref;
      vue.provide(CONFIG_PROVIDER_KEY, props);
      setNamespace(props.prefix);
      return () => vue.createVNode(vue.Fragment, null, [slots.default == null ? void 0 : slots.default()]);
    }
  });
  function useConfigProvider() {
    return vue.inject(CONFIG_PROVIDER_KEY, DEFAULT_CONFIG);
  }
  function useGlobalClassName() {
    var {
      prefix: prefix2
    } = vue.inject(CONFIG_PROVIDER_KEY, DEFAULT_CONFIG);
    var BORDER = prefix2 + "-hairline";
    return {
      BORDER,
      BORDER_TOP: BORDER + "--top",
      BORDER_LEFT: BORDER + "--left",
      BORDER_BOTTOM: BORDER + "--bottom",
      BORDER_SURROUND: BORDER + "--surround",
      BORDER_TOP_BOTTOM: BORDER + "--top-bottom",
      BORDER_UNSET_TOP_BOTTOM: BORDER + "-unset--top-bottom",
      HAPTICS_FEEDBACK: prefix2 + "-haptics-feedback",
      BODY_LOCK_CLASS: prefix2 + "-overflow-hidden"
    };
  }
  function SvgComponent$F(props) {
    return vue.createVNode("svg", vue.mergeProps({
      "viewBox": "0 0 1024 1024",
      "xmlns": "http://www.w3.org/2000/svg",
      "p-id": 5644,
      "width": "1em",
      "height": "1em"
    }, props), [vue.createVNode("path", {
      "d": "M524.629333 56.888889c195.527111 0 353.962667 154.567111 353.962667 345.258667 0 52.622222-15.985778 110.762667-45.624889 173.795555-29.127111 62.065778-70.712889 127.431111-121.571555 194.332445a1881.031111 1881.031111 0 0 1-160.142223 183.864888l-2.958222 2.901334-0.910222 0.910222a32.768 32.768 0 0 1-46.023111-0.568889 591.758222 591.758222 0 0 1-14.279111-15.018667 2122.752 2122.752 0 0 1-149.333334-178.176c-41.358222-55.409778-76.686222-109.283556-104.163555-160.540444C192.967111 527.928889 170.666667 460.401778 170.666667 402.147556 170.666667 211.456 329.159111 56.888889 524.629333 56.888889z m0 229.489778a113.777778 113.777778 0 1 0 0 227.555555 113.777778 113.777778 0 0 0 0-227.555555z",
      "fill": "currentColor",
      "p-id": 5645
    }, null)]);
  }
  function SvgComponent$E(props) {
    return vue.createVNode("svg", vue.mergeProps({
      "viewBox": "0 0 1024 1024",
      "xmlns": "http://www.w3.org/2000/svg",
      "p-id": 5517,
      "width": "1em",
      "height": "1em"
    }, props), [vue.createVNode("path", {
      "d": "M700.050286 560.054857L389.485714 860.16c-42.642286 41.252571-106.203429-25.746286-63.341714-67.145143 92.16-89.088 184.32-178.029714 276.333714-267.117714C509.878857 433.737143 417.353143 341.577143 324.754286 249.417143c-42.130286-41.984 21.430857-108.982857 63.414857-67.072l311.954286 310.491428c17.188571 17.188571 17.627429 50.102857 0 67.145143z",
      "fill": "currentColor",
      "p-id": 5518
    }, null)]);
  }
  function SvgComponent$D(props) {
    return vue.createVNode("svg", vue.mergeProps({
      "viewBox": "0 0 1024 1024",
      "xmlns": "http://www.w3.org/2000/svg",
      "p-id": 5263,
      "width": "1em",
      "height": "1em"
    }, props), [vue.createVNode("path", {
      "d": "M741.218462 364.937846a39.384615 39.384615 0 0 1 58.28923 52.617846l-4.726154 5.19877-256 236.307692a39.384615 39.384615 0 0 1-47.497846 4.568615l-5.986461-4.568615-256-236.307692a39.384615 39.384615 0 0 1 47.812923-62.227693l5.592615 4.411077L512 576.512l229.218462-211.574154z",
      "fill": "currentColor",
      "p-id": 5264
    }, null)]);
  }
  function SvgComponent$C(props) {
    return vue.createVNode("svg", vue.mergeProps({
      "viewBox": "0 0 1024 1024",
      "xmlns": "http://www.w3.org/2000/svg",
      "p-id": 109860,
      "width": "1em",
      "height": "1em"
    }, props), [vue.createVNode("path", {
      "d": "M648.557714 280.868571A36.571429 36.571429 0 0 0 599.771429 226.742857l-4.827429 4.388572-219.428571 237.714285a36.571429 36.571429 0 0 0-4.242286 44.105143l4.242286 5.558857 219.428571 237.714286a36.571429 36.571429 0 0 0 57.782857-44.397714l-4.096-5.193143L452.096 493.714286l196.461714-212.845715z",
      "p-id": 109861,
      "fill": "currentColor"
    }, null)]);
  }
  function SvgComponent$B(props) {
    return vue.createVNode("svg", vue.mergeProps({
      "viewBox": "0 0 1024 1024",
      "xmlns": "http://www.w3.org/2000/svg",
      "p-id": 110024,
      "width": "1em",
      "height": "1em"
    }, props), [vue.createVNode("path", {
      "d": "M560.054857 323.949714l300.178286 310.564572c41.252571 42.642286-25.746286 106.203429-67.145143 63.341714-89.088-92.16-178.029714-184.32-267.117714-276.333714C433.737143 514.121143 341.577143 606.646857 249.417143 699.245714c-41.984 42.130286-108.982857-21.430857-67.072-63.414857l310.491428-311.954286c17.188571-17.188571 50.102857-17.627429 67.145143 0z",
      "p-id": 110025,
      "fill": "currentColor"
    }, null)]);
  }
  function SvgComponent$A(props) {
    return vue.createVNode("svg", vue.mergeProps({
      "viewBox": "0 0 1024 1024",
      "xmlns": "http://www.w3.org/2000/svg",
      "p-id": 60300,
      "width": "1em",
      "height": "1em"
    }, props), [vue.createVNode("path", {
      "d": "M560.054857 323.949714l300.178286 310.564572c41.252571 42.642286-25.746286 106.203429-67.145143 63.341714-89.088-92.16-178.029714-184.32-267.117714-276.333714C433.737143 514.121143 341.577143 606.646857 249.417143 699.245714c-41.984 42.130286-108.982857-21.430857-67.072-63.414857l310.491428-311.954286c17.188571-17.188571 50.102857-17.627429 67.145143 0z",
      "p-id": 60301,
      "fill": "currentColor"
    }, null)]);
  }
  function SvgComponent$z(props) {
    return vue.createVNode("svg", vue.mergeProps({
      "viewBox": "0 0 1024 1024",
      "xmlns": "http://www.w3.org/2000/svg",
      "p-id": 6020,
      "width": "1em",
      "height": "1em"
    }, props), [vue.createVNode("path", {
      "d": "M547.108571 107.52a54.857143 54.857143 0 0 1 4.900572 71.972571l-4.900572 5.558858L278.674286 453.485714h631.954285a54.857143 54.857143 0 0 1 7.533715 109.275429l-7.460572 0.512-631.881143-0.073143 268.434286 268.434286a54.857143 54.857143 0 0 1 4.827429 71.972571l-4.900572 5.632a54.857143 54.857143 0 0 1-71.972571 4.900572l-5.632-4.900572-362.057143-362.057143a54.857143 54.857143 0 0 1-4.827429-71.972571l4.900572-5.632 362.057143-362.057143a54.857143 54.857143 0 0 1 77.531428 0z",
      "p-id": 6021,
      "fill": "currentColor"
    }, null)]);
  }
  function SvgComponent$y(props) {
    return vue.createVNode("svg", vue.mergeProps({
      "viewBox": "0 0 1024 1024",
      "xmlns": "http://www.w3.org/2000/svg",
      "p-id": 30614,
      "width": "1em",
      "height": "1em"
    }, props), [vue.createVNode("path", {
      "d": "M849.984 748.48a64 64 0 0 0 97.28-82.88l-5.248-6.08-371.584-384A64 64 0 0 0 486.016 268.8l-6.08 5.248-396.48 384A64 64 0 0 0 166.4 755.2l6.144-5.248L522.88 410.56l327.04 337.92z",
      "p-id": 30615,
      "fill": "currentColor"
    }, null)]);
  }
  function SvgComponent$x(props) {
    return vue.createVNode("svg", vue.mergeProps({
      "viewBox": "0 0 1024 1024",
      "xmlns": "http://www.w3.org/2000/svg",
      "p-id": 5256,
      "width": "1em",
      "height": "1em"
    }, props), [vue.createVNode("path", {
      "d": "M638.789818 113.757091a46.545455 46.545455 0 0 1 38.725818 20.759273l62.045091 93.044363h181.015273a46.545455 46.545455 0 0 1 46.545455 46.545455v589.591273a46.545455 46.545455 0 0 1-46.545455 46.545454H103.424a46.545455 46.545455 0 0 1-46.545455-46.545454V274.106182a46.545455 46.545455 0 0 1 46.545455-46.545455h181.061818l61.998546-93.090909a46.545455 46.545455 0 0 1 38.725818-20.712727h253.579636zM512 341.364364a227.560727 227.560727 0 1 0 0 455.074909 227.560727 227.560727 0 0 0 0-455.121455z m0 113.757091a113.757091 113.757091 0 1 1 0 227.560727 113.757091 113.757091 0 0 1 0-227.607273z",
      "p-id": 5257,
      "fill": "currentColor"
    }, null)]);
  }
  function SvgComponent$w(props) {
    return vue.createVNode("svg", vue.mergeProps({
      "viewBox": "0 0 1024 1024",
      "xmlns": "http://www.w3.org/2000/svg",
      "p-id": 24445,
      "width": "1em",
      "height": "1em"
    }, props), [vue.createVNode("path", {
      "d": "M960 0a64 64 0 0 1 64 64v896a64 64 0 0 1-64 64H64a64 64 0 0 1-64-64V64a64 64 0 0 1 64-64h896zM528 224C360.096 224 224 341.536 224 486.56c0 75.328 36.736 143.264 95.616 191.136l7.456 5.888-7.296 71.008-0.16 3.744a32 32 0 0 0 44.096 29.152l3.552-1.696 81.44-45.728c25.28 5.888 51.84 9.024 79.296 9.024 167.904 0 304-117.536 304-262.528C832 341.536 695.904 224 528 224z m-25.344 307.84a25.344 25.344 0 1 1 0 50.688H418.24a25.344 25.344 0 0 1 0-50.688h84.48z m135.136-106.944a25.344 25.344 0 1 1 0 50.656h-219.584a25.344 25.344 0 0 1 0-50.656h219.584z",
      "fill": "currentColor",
      "p-id": 24446
    }, null)]);
  }
  function SvgComponent$v(props) {
    return vue.createVNode("svg", vue.mergeProps({
      "viewBox": "0 0 1024 1024",
      "xmlns": "http://www.w3.org/2000/svg",
      "p-id": 5390,
      "width": "1em",
      "height": "1em"
    }, props), [vue.createVNode("path", {
      "d": "M10.88 588.032a38.784 38.784 0 0 1-3.52-49.6l26.304-35.2a33.088 33.088 0 0 1 45.312-8l227.968 161.28a38.912 38.912 0 0 0 43.968-2.176l602.496-518.208a34.432 34.432 0 0 1 46.592 1.92l14.848 15.744c12.928 13.632 11.968 35.328-1.6 49.664L366.72 887.936c-20.096 21.312-53.12 20.352-73.856-1.536L10.944 588.032z",
      "fill": "currentColor",
      "p-id": 5391
    }, null)]);
  }
  function SvgComponent$u(props) {
    return vue.createVNode("svg", vue.mergeProps({
      "viewBox": "0 0 1024 1024",
      "xmlns": "http://www.w3.org/2000/svg",
      "p-id": 5136,
      "width": "1em",
      "height": "1em"
    }, props), [vue.createVNode("path", {
      "d": "M765.76 194.816a44.8 44.8 0 1 1 63.424 63.424L575.36 512l253.824 253.824a44.8 44.8 0 1 1-63.424 63.424L511.936 575.36l-253.696 253.824a44.864 44.864 0 0 1-57.856 4.736l-5.568-4.736a44.8 44.8 0 0 1 0-63.424l253.696-253.824-253.696-253.696a44.8 44.8 0 0 1 63.424-63.424L512 448.512z",
      "fill": "currentColor",
      "p-id": 5137
    }, null)]);
  }
  function SvgComponent$t(props) {
    return vue.createVNode("svg", vue.mergeProps({
      "viewBox": "0 0 1024 1024",
      "xmlns": "http://www.w3.org/2000/svg",
      "p-id": 5540,
      "width": "1em",
      "height": "1em"
    }, props), [vue.createVNode("path", {
      "d": "M512 73.142857a438.857143 438.857143 0 1 1 0 877.714286A438.857143 438.857143 0 0 1 512 73.142857zM408.576 356.864a36.571429 36.571429 0 1 0-51.712 51.712l103.350857 103.350857L356.937143 615.424a36.571429 36.571429 0 1 0 51.712 51.712l103.350857-103.424 103.497143 103.424a36.571429 36.571429 0 1 0 51.712-51.712L563.712 512l103.424-103.350857a36.571429 36.571429 0 1 0-51.712-51.712L512 460.214857z",
      "p-id": 5541,
      "fill": "currentColor"
    }, null)]);
  }
  function SvgComponent$s(props) {
    return vue.createVNode("svg", vue.mergeProps({
      "viewBox": "0 0 1024 1024",
      "xmlns": "http://www.w3.org/2000/svg",
      "p-id": 7459,
      "width": "1em",
      "height": "1em"
    }, props), [vue.createVNode("path", {
      "d": "M295.497143 329.142857h433.005714a36.571429 36.571429 0 0 1 28.525714 59.392l-216.502857 270.628572a36.571429 36.571429 0 0 1-57.051428 0l-216.502857-270.628572a36.571429 36.571429 0 0 1 28.525714-59.392z",
      "fill": "currentColor",
      "p-id": 7460
    }, null)]);
  }
  function SvgComponent$r(props) {
    return vue.createVNode("svg", vue.mergeProps({
      "viewBox": "0 0 1024 1024",
      "xmlns": "http://www.w3.org/2000/svg",
      "p-id": 5590,
      "width": "1em",
      "height": "1em"
    }, props), [vue.createVNode("path", {
      "d": "M512 866.462144a78.768928 78.768928 0 1 1 0 157.537856 78.768928 78.768928 0 0 1 0-157.537856z m58.525313-866.458206c11.421495 0 20.479921 8.861504 20.243615 21.070689l-16.659628 745.547901a21.661455 21.661455 0 0 1-20.873766 21.070689h-82.510452a20.873766 20.873766 0 0 1-20.834382-21.070689L433.231072 21.074627A19.889154 19.889154 0 0 1 453.474687 0.003938h117.050626z",
      "p-id": 5591,
      "fill": "currentColor"
    }, null)]);
  }
  function SvgComponent$q(props) {
    return vue.createVNode("svg", vue.mergeProps({
      "viewBox": "0 0 1024 1024",
      "xmlns": "http://www.w3.org/2000/svg",
      "p-id": 5390,
      "width": "1em",
      "height": "1em"
    }, props), [vue.createVNode("path", {
      "d": "M739.555556 56.888889a227.555556 227.555556 0 0 1 227.555555 227.555555v455.111112a227.555556 227.555556 0 0 1-227.555555 227.555555H284.444444a227.555556 227.555556 0 0 1-227.555555-227.555555V284.444444a227.555556 227.555556 0 0 1 227.555555-227.555555h455.111112z m34.133333 288.881778a17.294222 17.294222 0 0 0-22.129778-0.853334l-285.582222 228.124445a19.626667 19.626667 0 0 1-20.821333 0.967111l-108.088889-70.997333a16.497778 16.497778 0 0 0-21.504 3.470222l-12.515556 15.530666a16.156444 16.156444 0 0 0 1.706667 21.845334l133.688889 131.299555a25.031111 25.031111 0 0 0 34.986666 0.739556l306.574223-301.340445c6.371556-6.257778 6.826667-15.872 0.739555-21.902222z",
      "fill": "currentColor",
      "p-id": 5391
    }, null)]);
  }
  function SvgComponent$p(props) {
    return vue.createVNode("svg", vue.mergeProps({
      "viewBox": "0 0 1024 1024",
      "xmlns": "http://www.w3.org/2000/svg",
      "p-id": 30001,
      "width": "1em",
      "height": "1em"
    }, props), [vue.createVNode("path", {
      "d": "M512 113.777778a42.666667 42.666667 0 0 1 42.666667 42.666666v312.888889h312.888889a42.666667 42.666667 0 1 1 0 85.333334H554.609778l0.056889 312.888889a42.666667 42.666667 0 1 1-85.333334 0l-0.056889-312.888889H156.444444a42.666667 42.666667 0 0 1 0-85.333334h312.888889v-312.888889A42.666667 42.666667 0 0 1 512 113.777778z",
      "p-id": 30002,
      "fill": "currentColor"
    }, null)]);
  }
  function SvgComponent$o(props) {
    return vue.createVNode("svg", vue.mergeProps({
      "viewBox": "0 0 1024 1024",
      "xmlns": "http://www.w3.org/2000/svg",
      "p-id": 5008,
      "width": "1em",
      "height": "1em"
    }, props), [vue.createVNode("path", {
      "d": "M512 0a512 512 0 1 1 0 1024A512 512 0 0 1 512 0z m306.517333 325.006222a21.333333 21.333333 0 0 0-26.225777-0.967111l-338.887112 256.568889a24.348444 24.348444 0 0 1-24.746666 1.137778L300.430222 501.873778a20.309333 20.309333 0 0 0-25.486222 3.982222l-14.791111 17.408c-6.371556 7.395556-5.176889 17.863111 1.991111 24.576l158.549333 147.740444c11.662222 10.808889 30.208 11.320889 41.528889 0.796445l363.747556-339.000889c7.623111-7.111111 8.135111-17.863111 0.853333-24.632889z",
      "fill": "currentColor",
      "p-id": 5009
    }, null)]);
  }
  function SvgComponent$n(props) {
    return vue.createVNode("svg", vue.mergeProps({
      "viewBox": "0 0 1024 1024",
      "xmlns": "http://www.w3.org/2000/svg",
      "p-id": 5644,
      "width": "1em",
      "height": "1em"
    }, props), [vue.createVNode("path", {
      "d": "M512 0a512 512 0 1 1 0 1024A512 512 0 0 1 512 0z m0 56.888889a455.111111 455.111111 0 1 0 0 910.222222A455.111111 455.111111 0 0 0 512 56.888889z m0 170.666667a284.444444 284.444444 0 1 1 0 568.888888A284.444444 284.444444 0 0 1 512 227.555556z",
      "fill": "currentColor",
      "p-id": 5645
    }, null)]);
  }
  function SvgComponent$m(props) {
    return vue.createVNode("svg", vue.mergeProps({
      "viewBox": "0 0 1024 1024",
      "xmlns": "http://www.w3.org/2000/svg",
      "p-id": 5390,
      "width": "1em",
      "height": "1em"
    }, props), [vue.createVNode("path", {
      "d": "M10.88 588.032a38.784 38.784 0 0 1-3.52-49.6l26.304-35.2a33.088 33.088 0 0 1 45.312-8l227.968 161.28a38.912 38.912 0 0 0 43.968-2.176l602.496-518.208a34.432 34.432 0 0 1 46.592 1.92l14.848 15.744c12.928 13.632 11.968 35.328-1.6 49.664L366.72 887.936c-20.096 21.312-53.12 20.352-73.856-1.536L10.944 588.032z",
      "fill": "currentColor",
      "p-id": 5391
    }, null)]);
  }
  function SvgComponent$l(props) {
    return vue.createVNode("svg", vue.mergeProps({
      "viewBox": "0 0 1024 1024",
      "xmlns": "http://www.w3.org/2000/svg",
      "p-id": 60868,
      "width": "1em",
      "height": "1em"
    }, props), [vue.createVNode("path", {
      "d": "M512 64a448 448 0 1 1 0 896A448 448 0 0 1 512 64.073143z m0 76.068571a372.077714 372.077714 0 1 0 0.146286 744.082286A372.077714 372.077714 0 0 0 512 139.995429z m24.137143 139.922286c4.388571 0 7.972571 3.657143 7.972571 8.045714V535.405714l142.628572 103.131429a8.045714 8.045714 0 0 1 1.755428 11.190857l-28.525714 38.985143a8.045714 8.045714 0 0 1-11.264 1.682286L483.328 569.929143a7.899429 7.899429 0 0 1-3.291429-6.582857V288.109714c0-4.388571 3.584-8.045714 7.972572-8.045714z",
      "fill": "currentColor",
      "p-id": 60869
    }, null)]);
  }
  function SvgComponent$k(props) {
    return vue.createVNode("svg", vue.mergeProps({
      "viewBox": "0 0 1024 1024",
      "xmlns": "http://www.w3.org/2000/svg",
      "p-id": 6942,
      "width": "1em",
      "height": "1em"
    }, props), [vue.createVNode("path", {
      "d": "M512 960A448 448 0 1 0 512 64a448 448 0 0 0 0 896z m23.990857-384h-47.981714a8.045714 8.045714 0 0 1-8.045714-8.045714V296.082286c0-4.388571 3.657143-8.045714 8.045714-8.045715h47.981714c4.388571 0 8.045714 3.657143 8.045714 8.045715v272.018285c0 4.388571-3.657143 7.972571-8.045714 7.972572zM512 736.036571A47.981714 47.981714 0 1 1 512 640a47.981714 47.981714 0 0 1 0 96.036571z",
      "fill": "currentColor",
      "p-id": 6943
    }, null)]);
  }
  function SvgComponent$j(props) {
    return vue.createVNode("svg", vue.mergeProps({
      "viewBox": "0 0 1024 1024",
      "xmlns": "http://www.w3.org/2000/svg",
      "p-id": 5771,
      "width": "1em",
      "height": "1em"
    }, props), [vue.createVNode("path", {
      "d": "M512 512m-455.111111 0a455.111111 455.111111 0 1 0 910.222222 0 455.111111 455.111111 0 1 0-910.222222 0Z",
      "fill": "#267EF0",
      "p-id": 5772
    }, null), vue.createVNode("path", {
      "d": "M512 0a512 512 0 1 1 0 1024A512 512 0 0 1 512 0z m0 85.333333a426.666667 426.666667 0 1 0 0 853.333334 426.666667 426.666667 0 0 0 0-853.333334z",
      "fill": "#FFFFFF",
      "p-id": 5773
    }, null), vue.createVNode("path", {
      "d": "M284.444444 455.111111m56.888889 0l341.333334 0q56.888889 0 56.888889 56.888889l0 0q0 56.888889-56.888889 56.888889l-341.333334 0q-56.888889 0-56.888889-56.888889l0 0q0-56.888889 56.888889-56.888889Z",
      "fill": "#FFFFFF",
      "p-id": 5774
    }, null), vue.createVNode("path", {
      "d": "M568.888889 284.444444m0 56.888889l0 341.333334q0 56.888889-56.888889 56.888889l0 0q-56.888889 0-56.888889-56.888889l0-341.333334q0-56.888889 56.888889-56.888889l0 0q56.888889 0 56.888889 56.888889Z",
      "fill": "#FFFFFF",
      "p-id": 5775
    }, null)]);
  }
  function SvgComponent$i(props) {
    return vue.createVNode("svg", vue.mergeProps({
      "viewBox": "0 0 1024 1024",
      "xmlns": "http://www.w3.org/2000/svg",
      "p-id": 5901,
      "width": "1em",
      "height": "1em"
    }, props), [vue.createVNode("path", {
      "d": "M512 512m-455.111111 0a455.111111 455.111111 0 1 0 910.222222 0 455.111111 455.111111 0 1 0-910.222222 0Z",
      "fill": "#F33530",
      "p-id": 5902
    }, null), vue.createVNode("path", {
      "d": "M512 0a512 512 0 1 1 0 1024A512 512 0 0 1 512 0z m0 85.333333a426.666667 426.666667 0 1 0 0 853.333334 426.666667 426.666667 0 0 0 0-853.333334z",
      "fill": "#FFFFFF",
      "p-id": 5903
    }, null), vue.createVNode("path", {
      "d": "M284.444444 455.111111m56.888889 0l341.333334 0q56.888889 0 56.888889 56.888889l0 0q0 56.888889-56.888889 56.888889l-341.333334 0q-56.888889 0-56.888889-56.888889l0 0q0-56.888889 56.888889-56.888889Z",
      "fill": "#FFFFFF",
      "p-id": 5904
    }, null)]);
  }
  function SvgComponent$h(props) {
    return vue.createVNode("svg", vue.mergeProps({
      "viewBox": "0 0 1024 1024",
      "xmlns": "http://www.w3.org/2000/svg",
      "p-id": 5331,
      "width": "1em",
      "height": "1em"
    }, props), [vue.createVNode("path", {
      "d": "M398.208 170.656l-18.944 56.896H113.792v398.24l73.536-73.6a56.896 56.896 0 0 1 75.136-4.704l5.376 4.736 73.504 73.568 105.344-126.464 122.208 183.36L512 853.312H113.792a56.928 56.928 0 0 1-56.512-50.24l-0.384-6.656V227.52c0-29.216 21.984-53.216 50.24-56.512l6.656-0.384h284.416z m512 0c29.216 0 53.248 21.952 56.512 50.24l0.384 6.656V796.48c0 29.152-21.92 53.216-50.24 56.512l-6.656 0.384h-284.416l56.864-170.688-172.768-259.2 72.832-87.296c21.024-25.28 58.56-27.2 82.048-5.632l4.8 4.992 240.64 280.768V227.52H493.056L512 170.656h398.208zM312.96 284.416c15.872 0 30.72 4.352 43.488 11.904l-15.072 45.024 46.368 69.536a85.344 85.344 0 1 1-74.784-126.464z",
      "p-id": 5332,
      "fill": "#CCD1DA"
    }, null)]);
  }
  function SvgComponent$g(props) {
    return vue.createVNode("svg", vue.mergeProps({
      "viewBox": "0 0 1024 1024",
      "xmlns": "http://www.w3.org/2000/svg",
      "p-id": 5714,
      "width": "1em",
      "height": "1em"
    }, props), [vue.createVNode("path", {
      "d": "M312.928 284.416a85.376 85.376 0 0 0 0 170.688 85.376 85.376 0 0 0 0-170.688m356.64 51.104a56.832 56.832 0 0 0-86.848 0.64l-241.376 289.6-73.504-73.536a56.896 56.896 0 0 0-80.512 0l-73.536 73.568V227.52h796.416V616.32l-240.64-280.768z m240.64-164.864H113.792c-31.424 0-56.896 25.44-56.896 56.896V796.48c0 31.392 25.472 56.896 56.896 56.896h796.416c31.488 0 56.896-25.504 56.896-56.896V227.52c0-31.456-25.408-56.896-56.896-56.896z",
      "p-id": 5715,
      "fill": "#CCD1DA"
    }, null)]);
  }
  function SvgComponent$f(props) {
    return vue.createVNode("svg", vue.mergeProps({
      "viewBox": "0 0 1024 1024",
      "xmlns": "http://www.w3.org/2000/svg",
      "p-id": 5262,
      "width": "1em",
      "height": "1em"
    }, props), [vue.createVNode("path", {
      "d": "M739.555556 56.888889a227.555556 227.555556 0 0 1 227.555555 227.555555v455.111112a227.555556 227.555556 0 0 1-227.555555 227.555555H284.444444a227.555556 227.555556 0 0 1-227.555555-227.555555V284.444444a227.555556 227.555556 0 0 1 227.555555-227.555555h455.111112z",
      "fill": "#F5F6F7",
      "p-id": 5263
    }, null), vue.createVNode("path", {
      "d": "M739.555556 56.888889a227.555556 227.555556 0 0 1 227.555555 227.555555v455.111112a227.555556 227.555556 0 0 1-227.555555 227.555555H284.444444a227.555556 227.555556 0 0 1-227.555555-227.555555V284.444444a227.555556 227.555556 0 0 1 227.555555-227.555555h455.111112z m0 56.888889H284.444444a170.666667 170.666667 0 0 0-170.382222 160.654222L113.777778 284.444444v455.111112a170.666667 170.666667 0 0 0 160.654222 170.382222L284.444444 910.222222h455.111112a170.666667 170.666667 0 0 0 170.382222-160.654222L910.222222 739.555556V284.444444a170.666667 170.666667 0 0 0-160.654222-170.382222L739.555556 113.777778z",
      "fill": "#CCD1DA",
      "p-id": 5264
    }, null)]);
  }
  function SvgComponent$e(props) {
    return vue.createVNode("svg", vue.mergeProps({
      "viewBox": "0 0 1024 1024",
      "xmlns": "http://www.w3.org/2000/svg",
      "p-id": 5135,
      "width": "1em",
      "height": "1em"
    }, props), [vue.createVNode("path", {
      "d": "M739.555556 56.888889a227.555556 227.555556 0 0 1 227.555555 227.555555v455.111112a227.555556 227.555556 0 0 1-227.555555 227.555555H284.444444a227.555556 227.555556 0 0 1-227.555555-227.555555V284.444444a227.555556 227.555556 0 0 1 227.555555-227.555555h455.111112z m0 56.888889H284.444444a170.666667 170.666667 0 0 0-170.382222 160.654222L113.777778 284.444444v455.111112a170.666667 170.666667 0 0 0 160.654222 170.382222L284.444444 910.222222h455.111112a170.666667 170.666667 0 0 0 170.382222-160.654222L910.222222 739.555556V284.444444a170.666667 170.666667 0 0 0-160.654222-170.382222L739.555556 113.777778z",
      "fill": "#CCD1DA",
      "p-id": 5136
    }, null)]);
  }
  function SvgComponent$d(props) {
    return vue.createVNode("svg", vue.mergeProps({
      "viewBox": "0 0 1024 1024",
      "xmlns": "http://www.w3.org/2000/svg",
      "p-id": 6186,
      "width": "1em",
      "height": "1em"
    }, props), [vue.createVNode("path", {
      "d": "M486.7584 149.2992a332.8 332.8 0 0 1 260.096 540.4672l112.7936 120.2688a38.4 38.4 0 0 1-51.8144 56.4224l-4.1984-3.8912-111.4112-118.6304A332.8 332.8 0 1 1 486.7584 149.2992z m0 76.8a256 256 0 1 0 147.5072 465.2544l10.496-7.8336 23.4496-18.432 18.6368-23.296A254.3616 254.3616 0 0 0 742.4 495.616l0.3584-13.5168a256 256 0 0 0-256-256z",
      "fill": "#CCD1DA",
      "p-id": 6187
    }, null)]);
  }
  function SvgComponent$c(props) {
    return vue.createVNode("svg", vue.mergeProps({
      "viewBox": "0 0 1024 1024",
      "xmlns": "http://www.w3.org/2000/svg",
      "p-id": 5771,
      "width": "1em",
      "height": "1em"
    }, props), [vue.createVNode("path", {
      "d": "M512 512m-512 0a512 512 0 1 0 1024 0 512 512 0 1 0-1024 0Z",
      "fill": "#F5F6F7",
      "p-id": 5772
    }, null), vue.createVNode("path", {
      "d": "M512 0a512 512 0 1 1 0 1024A512 512 0 0 1 512 0z m0 56.888889a455.111111 455.111111 0 1 0 0 910.222222A455.111111 455.111111 0 0 0 512 56.888889z",
      "fill": "#CCD1DA",
      "p-id": 5773
    }, null)]);
  }
  function SvgComponent$b(props) {
    return vue.createVNode("svg", vue.mergeProps({
      "viewBox": "0 0 1024 1024",
      "xmlns": "http://www.w3.org/2000/svg",
      "p-id": 5517,
      "width": "1em",
      "height": "1em"
    }, props), [vue.createVNode("path", {
      "d": "M512 0a512 512 0 1 1 0 1024A512 512 0 0 1 512 0z m0 56.888889a455.111111 455.111111 0 1 0 0 910.222222A455.111111 455.111111 0 0 0 512 56.888889z",
      "fill": "#CCD1DA",
      "p-id": 5518
    }, null)]);
  }
  function SvgComponent$a(props) {
    return vue.createVNode("svg", vue.mergeProps({
      "viewBox": "0 0 1024 1024",
      "xmlns": "http://www.w3.org/2000/svg",
      "p-id": 9904,
      "width": "1em",
      "height": "1em"
    }, props), [vue.createVNode("path", {
      "d": "M402.944 93.090909a46.545455 46.545455 0 0 1 35.746909 16.756364l88.436364 106.123636a46.545455 46.545455 0 0 0 35.746909 16.756364h327.307636a93.090909 93.090909 0 0 1 93.090909 93.090909v512a93.090909 93.090909 0 0 1-93.090909 93.090909h-698.181818a93.090909 93.090909 0 0 1-93.090909-93.090909V186.181818a93.090909 93.090909 0 0 1 93.090909-93.090909h210.944z m-10.938182 69.818182H192a23.272727 23.272727 0 0 0-22.900364 19.083636L168.727273 186.181818v651.636364a23.272727 23.272727 0 0 0 19.083636 22.900363l4.189091 0.372364h698.181818a23.272727 23.272727 0 0 0 22.900364-19.083636l0.372363-4.189091V325.818182a23.272727 23.272727 0 0 0-19.083636-22.900364l-4.189091-0.372363h-327.307636a116.363636 116.363636 0 0 1-83.642182-35.467637l-5.725091-6.423273-81.501091-97.745454z",
      "fill": "#011949",
      "p-id": 9905
    }, null), vue.createVNode("path", {
      "d": "M471.272727 418.909091m34.909091 0l256 0q34.909091 0 34.909091 34.909091l0 0q0 34.909091-34.909091 34.909091l-256 0q-34.909091 0-34.909091-34.909091l0 0q0-34.909091 34.909091-34.909091Z",
      "fill": "#267EF0",
      "p-id": 9906
    }, null)]);
  }
  function SvgComponent$9(props) {
    return vue.createVNode("svg", vue.mergeProps({
      "viewBox": "0 0 1024 1024",
      "xmlns": "http://www.w3.org/2000/svg",
      "p-id": 5353,
      "width": "1em",
      "height": "1em"
    }, props), [vue.createVNode("path", {
      "d": "M402.944 93.090909a46.545455 46.545455 0 0 1 35.746909 16.756364l88.436364 106.123636a46.545455 46.545455 0 0 0 35.746909 16.756364h327.307636a93.090909 93.090909 0 0 1 93.090909 93.090909v512a93.090909 93.090909 0 0 1-93.090909 93.090909h-698.181818a93.090909 93.090909 0 0 1-93.090909-93.090909V186.181818a93.090909 93.090909 0 0 1 93.090909-93.090909h210.944z m370.874182 325.818182h-279.272727a23.272727 23.272727 0 0 0-23.272728 23.272727v23.272727a23.272727 23.272727 0 0 0 23.272728 23.272728h279.272727a23.272727 23.272727 0 0 0 23.272727-23.272728v-23.272727a23.272727 23.272727 0 0 0-23.272727-23.272727z",
      "fill": "#267EF0",
      "p-id": 5354
    }, null)]);
  }
  function SvgComponent$8(props) {
    return vue.createVNode("svg", vue.mergeProps({
      "viewBox": "0 0 1024 1024",
      "xmlns": "http://www.w3.org/2000/svg",
      "p-id": 10039,
      "width": "1em",
      "height": "1em"
    }, props), [vue.createVNode("path", {
      "d": "M388.980364 93.090909c27.461818 0 49.989818 20.759273 52.875636 47.383273l0.325818 5.818182v265.960727c0 27.461818-20.759273 49.989818-47.383273 52.875636L388.980364 465.454545H123.019636c-27.461818 0-49.989818-20.759273-52.875636-47.383272L69.818182 412.253091V146.292364c0-27.461818 20.759273-49.989818 47.383273-52.875637L123.019636 93.090909h265.960728zM372.363636 162.909091H139.636364v232.727273h232.727272v-232.727273zM388.980364 558.545455c27.461818 0 49.989818 20.759273 52.875636 47.383272l0.325818 5.818182v265.960727c0 27.461818-20.759273 49.989818-47.383273 52.875637L388.980364 930.909091H123.019636c-27.461818 0-49.989818-20.759273-52.875636-47.383273l-0.325818-5.818182v-265.960727c0-27.461818 20.759273-49.989818 47.383273-52.875636L123.019636 558.545455h265.960728zM372.363636 628.363636H139.636364v232.727273h232.727272v-232.727273zM854.434909 93.090909c27.461818 0 49.989818 20.759273 52.875636 47.383273l0.325819 5.818182v265.960727c0 27.461818-20.759273 49.989818-47.383273 52.875636l-5.818182 0.325818h-265.960727c-27.461818 0-49.989818-20.759273-52.875637-47.383272l-0.325818-5.818182V146.292364c0-27.461818 20.759273-49.989818 47.383273-52.875637L588.474182 93.090909h265.960727zM837.818182 162.909091h-232.727273v232.727273h232.727273v-232.727273z",
      "fill": "#011949",
      "p-id": 10040
    }, null), vue.createVNode("path", {
      "d": "M854.434909 558.545455c27.461818 0 49.989818 20.759273 52.875636 47.383272l0.325819 5.818182v265.960727c0 27.461818-20.759273 49.989818-47.383273 52.875637l-5.818182 0.325818h-265.960727c-27.461818 0-49.989818-20.759273-52.875637-47.383273l-0.325818-5.818182v-265.960727c0-27.461818 20.759273-49.989818 47.383273-52.875636l5.818182-0.325818h265.960727zM837.818182 628.363636h-232.727273v232.727273h232.727273v-232.727273z",
      "fill": "#267EF0",
      "p-id": 10041
    }, null)]);
  }
  function SvgComponent$7(props) {
    return vue.createVNode("svg", vue.mergeProps({
      "viewBox": "0 0 1024 1024",
      "xmlns": "http://www.w3.org/2000/svg",
      "p-id": 10438,
      "width": "1em",
      "height": "1em"
    }, props), [vue.createVNode("path", {
      "d": "M388.980364 93.090909H123.019636C93.649455 93.090909 69.818182 116.922182 69.818182 146.292364v265.960727C69.818182 441.623273 93.649455 465.454545 123.019636 465.454545h265.960728C418.350545 465.454545 442.181818 441.623273 442.181818 412.253091V146.292364C442.181818 116.922182 418.350545 93.090909 388.980364 93.090909zM388.980364 558.545455H123.019636c-29.370182 0-53.201455 23.831273-53.201454 53.201454v265.960727c0 29.370182 23.831273 53.201455 53.201454 53.201455h265.960728c29.370182 0 53.201455-23.831273 53.201454-53.201455v-265.960727C442.181818 582.376727 418.350545 558.545455 388.980364 558.545455zM854.434909 93.090909h-265.960727c-29.370182 0-53.201455 23.831273-53.201455 53.201455v265.960727c0 29.370182 23.831273 53.201455 53.201455 53.201454h265.960727c29.370182 0 53.201455-23.831273 53.201455-53.201454V146.292364C907.636364 116.922182 883.805091 93.090909 854.434909 93.090909z",
      "fill": "#267EF0",
      "p-id": 10439
    }, null), vue.createVNode("path", {
      "d": "M854.434909 558.545455c27.461818 0 49.989818 20.759273 52.875636 47.383272l0.325819 5.818182v265.960727c0 27.461818-20.759273 49.989818-47.383273 52.875637l-5.818182 0.325818h-265.960727c-27.461818 0-49.989818-20.759273-52.875637-47.383273l-0.325818-5.818182v-265.960727c0-27.461818 20.759273-49.989818 47.383273-52.875636l5.818182-0.325818h265.960727zM837.818182 628.363636h-232.727273v232.727273h232.727273v-232.727273z",
      "fill": "#267EF0",
      "p-id": 10440
    }, null)]);
  }
  function SvgComponent$6(props) {
    return vue.createVNode("svg", vue.mergeProps({
      "viewBox": "0 0 1024 1024",
      "xmlns": "http://www.w3.org/2000/svg",
      "p-id": 9768,
      "width": "1em",
      "height": "1em"
    }, props), [vue.createVNode("path", {
      "d": "M259.258182 93.090909h77.544727v155.136H259.258182zM699.764364 93.090909h77.591272v155.136h-77.591272z",
      "fill": "#011949",
      "p-id": 9769
    }, null), vue.createVNode("path", {
      "d": "M494.08 744.727273v-47.941818h-163.84c7.447273-16.756364 27.927273-36.305455 61.905455-58.647273 32.581818-21.876364 55.854545-39.563636 68.887272-53.527273 21.410909-23.738182 32.581818-49.803636 32.581818-78.661818 0-29.789091-10.24-53.527273-30.72-72.145455-20.945455-18.618182-47.476364-27.927273-79.592727-27.927272-35.84 0-64.698182 12.101818-86.574545 36.305454-21.410909 22.807273-32.116364 52.596364-32.581818 89.832727h54.458181c0.930909-26.065455 6.516364-46.08 16.756364-59.112727 10.24-13.963636 25.6-20.945455 46.08-20.945454 19.083636 0 33.512727 4.189091 43.287273 13.032727 9.309091 8.843636 14.429091 22.341818 14.429091 40.494545 0 18.618182-7.447273 36.305455-21.876364 52.596364-9.309091 9.774545-24.203636 22.341818-45.614545 37.236364-38.632727 26.530909-64.232727 47.010909-76.334546 60.974545-22.341818 25.134545-33.047273 54.458182-33.047273 88.436364h231.796364z m164.770909 6.516363c36.305455 0 65.629091-10.24 87.970909-30.254545 21.410909-19.549091 32.116364-44.683636 32.116364-75.403636 0-19.549091-5.585455-35.84-16.756364-48.407273-10.24-12.101818-25.6-20.945455-45.149091-26.996364 36.770909-12.101818 55.389091-36.305455 55.389091-72.610909 0-28.858182-10.24-51.2-30.254545-67.490909-20.48-16.290909-47.941818-24.203636-81.454546-24.203636-32.581818 0-59.578182 8.843636-80.523636 27.461818-22.341818 18.618182-34.443636 44.683636-37.236364 78.196363h53.527273c1.861818-20.014545 8.378182-34.909091 19.549091-44.683636 10.705455-9.774545 25.6-14.429091 45.149091-14.429091 19.083636 0 33.512727 4.189091 43.287273 12.567273 8.843636 8.378182 13.498182 20.48 13.498181 36.770909 0 16.290909-5.12 28.858182-14.894545 37.236364-10.24 8.378182-25.134545 12.567273-44.683636 12.567272h-23.272728v40.96h23.272728c21.410909 0 37.701818 4.189091 48.872727 13.498182 11.170909 8.843636 17.221818 22.807273 17.221818 41.890909 0 15.825455-5.585455 28.858182-16.290909 39.563637-12.101818 11.636364-28.858182 17.687273-49.803636 17.687272-19.083636 0-34.443636-5.585455-46.08-16.290909-13.032727-11.636364-19.549091-28.392727-20.48-49.803636h-55.389091c2.792727 37.236364 15.825455 66.094545 39.098181 85.643636 20.945455 17.687273 48.872727 26.530909 83.316364 26.530909z",
      "fill": "#267EF0",
      "p-id": 9770
    }, null), vue.createVNode("path", {
      "d": "M983.272727 186.181818v791.272727h-930.909091V186.181818h930.909091z m-69.818182 69.818182h-791.272727v651.636364h791.272727v-651.636364z",
      "fill": "#011949",
      "p-id": 9771
    }, null)]);
  }
  function SvgComponent$5(props) {
    return vue.createVNode("svg", vue.mergeProps({
      "viewBox": "0 0 1024 1024",
      "xmlns": "http://www.w3.org/2000/svg",
      "p-id": 5216,
      "width": "1em",
      "height": "1em"
    }, props), [vue.createVNode("path", {
      "d": "M983.272727 977.454545h-930.909091V186.181818h930.909091z",
      "fill": "#267EF0",
      "p-id": 5217
    }, null), vue.createVNode("path", {
      "d": "M259.258182 93.090909h77.544727v155.136H259.258182zM699.764364 93.090909h77.591272v155.136h-77.591272z",
      "fill": "#267EF0",
      "p-id": 5218
    }, null), vue.createVNode("path", {
      "d": "M259.258182 186.181818h77.544727v62.045091H259.258182zM699.764364 186.181818h77.591272v62.045091h-77.591272z",
      "fill": "#FEFFFF",
      "p-id": 5219
    }, null), vue.createVNode("path", {
      "d": "M494.08 744.727273v-47.941818h-163.84c7.447273-16.756364 27.927273-36.305455 61.905455-58.647273 32.581818-21.876364 55.854545-39.563636 68.887272-53.527273 21.410909-23.738182 32.581818-49.803636 32.581818-78.661818 0-29.789091-10.24-53.527273-30.72-72.145455-20.945455-18.618182-47.476364-27.927273-79.592727-27.927272-35.84 0-64.698182 12.101818-86.574545 36.305454-21.410909 22.807273-32.116364 52.596364-32.581818 89.832727h54.458181c0.930909-26.065455 6.516364-46.08 16.756364-59.112727 10.24-13.963636 25.6-20.945455 46.08-20.945454 19.083636 0 33.512727 4.189091 43.287273 13.032727 9.309091 8.843636 14.429091 22.341818 14.429091 40.494545 0 18.618182-7.447273 36.305455-21.876364 52.596364-9.309091 9.774545-24.203636 22.341818-45.614545 37.236364-38.632727 26.530909-64.232727 47.010909-76.334546 60.974545-22.341818 25.134545-33.047273 54.458182-33.047273 88.436364h231.796364z m164.770909 6.516363c36.305455 0 65.629091-10.24 87.970909-30.254545 21.410909-19.549091 32.116364-44.683636 32.116364-75.403636 0-19.549091-5.585455-35.84-16.756364-48.407273-10.24-12.101818-25.6-20.945455-45.149091-26.996364 36.770909-12.101818 55.389091-36.305455 55.389091-72.610909 0-28.858182-10.24-51.2-30.254545-67.490909-20.48-16.290909-47.941818-24.203636-81.454546-24.203636-32.581818 0-59.578182 8.843636-80.523636 27.461818-22.341818 18.618182-34.443636 44.683636-37.236364 78.196363h53.527273c1.861818-20.014545 8.378182-34.909091 19.549091-44.683636 10.705455-9.774545 25.6-14.429091 45.149091-14.429091 19.083636 0 33.512727 4.189091 43.287273 12.567273 8.843636 8.378182 13.498182 20.48 13.498181 36.770909 0 16.290909-5.12 28.858182-14.894545 37.236364-10.24 8.378182-25.134545 12.567273-44.683636 12.567272h-23.272728v40.96h23.272728c21.410909 0 37.701818 4.189091 48.872727 13.498182 11.170909 8.843636 17.221818 22.807273 17.221818 41.890909 0 15.825455-5.585455 28.858182-16.290909 39.563637-12.101818 11.636364-28.858182 17.687273-49.803636 17.687272-19.083636 0-34.443636-5.585455-46.08-16.290909-13.032727-11.636364-19.549091-28.392727-20.48-49.803636h-55.389091c2.792727 37.236364 15.825455 66.094545 39.098181 85.643636 20.945455 17.687273 48.872727 26.530909 83.316364 26.530909z",
      "fill": "#FFFFFF",
      "p-id": 5220
    }, null)]);
  }
  function SvgComponent$4(props) {
    return vue.createVNode("svg", vue.mergeProps({
      "viewBox": "0 0 1024 1024",
      "xmlns": "http://www.w3.org/2000/svg",
      "p-id": 10443,
      "width": "1em",
      "height": "1em"
    }, props), [vue.createVNode("path", {
      "d": "M596.945455 118.039273c87.691636-16.802909 154.903273 39.796364 174.405818 124.648727l1.861818 8.890182 2.141091 13.451636 0.930909 7.121455 0.837818 7.68 1.210182 14.522182 0.744727 14.754909 0.465455 14.941091 0.093091 14.848c0.186182 59.578182-25.227636 119.342545-69.632 162.257454l-5.213091 4.747636-0.046546 1.256728c-0.325818 11.031273 0.930909 31.976727 2.466909 42.821818l0.512 3.118545 2.792728 2.420364c11.776 9.402182 32.162909 16.942545 64.093091 23.970909l9.960727 2.094546 52.782545 10.100363 16.523637 3.723637 9.169454 2.327272 20.247273 5.445818 22.714182 6.56291 38.818909 11.962181 29.090909 9.355637c26.810182 8.843636 46.033455 31.232 48.64 57.856l0.279273 6.190545v91.042909c0 38.958545-12.939636 64.791273-49.431273 67.677091l-7.121455 0.279273h-48.407272v-55.854546l49.524363 0.139637-0.372363-7.959273-0.046546-95.325091c0-4.096-3.630545-8.704-10.472727-10.938182l-28.066909-9.076363-25.6-7.959273-22.946909-6.842182-20.433455-5.725091-17.826909-4.654545-7.912727-1.861818-13.963637-2.932364-23.13309-4.328727-22.900364-4.421818c-52.922182-10.705455-85.457455-22.760727-107.380364-45.614546l-4.887272-5.399273-4.189091-6.795636c-6.749091-15.639273-9.914182-61.533091-7.959273-79.220364a44.823273 44.823273 0 0 1 12.194909-29.416727l3.863273-3.584a172.078545 172.078545 0 0 0 58.181818-117.713454l0.232727-9.402182-0.093091-14.103273-0.372363-13.684364-0.698182-13.218909-1.582546-17.361454-0.930909-7.493818-1.954909-12.19491c-10.891636-58.647273-50.315636-95.837091-103.377454-89.413818l-7.307637 1.117091-10.519272-54.830545z",
      "fill": "#267EF0",
      "p-id": 10444
    }, null), vue.createVNode("path", {
      "d": "M441.762909 93.090909c92.951273 0 158.626909 55.994182 171.566546 136.098909l2.234181 15.825455c0.651636 5.352727 1.210182 10.798545 1.675637 16.337454l1.210182 16.849455 0.837818 17.314909 0.465454 17.687273 0.093091 18.059636c0.186182 66.839273-26.018909 135.866182-72.610909 182.690909a22.434909 22.434909 0 0 0-6.981818 15.685818c-0.279273 2.792727-0.418909 6.888727-0.465455 11.682909l0.279273 16.384 0.930909 18.338909c1.070545 15.36 2.885818 29.882182 5.352727 36.491637 17.035636 23.598545 47.662545 36.538182 83.176728 46.126545l19.781818 4.980364 24.157091 5.352727 24.529454 5.259637 14.522182 3.490909 8.192 2.187636 18.059637 5.352727 20.48 6.516364 22.853818 7.68 12.334545 4.328727 26.391273 9.541818 28.811636 10.705455a46.545455 46.545455 0 0 1 30.068364 43.566545V884.363636a46.545455 46.545455 0 0 1-46.545455 46.545455H46.545455a46.545455 46.545455 0 0 1-46.545455-46.545455v-117.666909a46.545455 46.545455 0 0 1 29.277091-43.194182l28.020364-11.031272 25.553454-9.681455 23.086546-8.378182 10.658909-3.630545 19.409454-6.330182 16.942546-4.980364a313.716364 313.716364 0 0 1 14.429091-3.630545l49.710545-10.426182 20.759273-4.654545c40.913455-9.728 76.939636-22.528 95.418182-48.500364 2.606545-6.469818 4.468364-20.898909 5.585454-36.119273l1.070546-18.245818c0.372364-8.843636 0.465455-16.989091 0.279272-22.807273l-0.232727-5.073454a22.248727 22.248727 0 0 0-6.888727-16.058182c-46.312727-46.359273-72.610909-114.548364-73.076364-180.782545l-0.093091-17.687273 0.279273-17.454546 0.232727-8.517818 0.837818-16.849454c0.325818-5.538909 0.744727-10.984727 1.256728-16.384l1.722181-15.825455C275.176727 154.437818 342.062545 93.090909 441.716364 93.090909z m0 69.818182c-59.531636 0-97.745455 30.254545-106.961454 77.777454l-1.163637 7.261091-1.629091 14.708364-0.558545 6.888727-1.210182 22.062546-0.232727 7.447272-0.279273 16.244364 0.046545 17.361455c0.372364 49.477818 20.386909 99.607273 51.432728 130.699636 16.197818 15.406545 26.158545 36.165818 28.16 58.228364l0.139636 2.606545c2.234182 26.530909-0.837818 78.568727-8.843636 106.356364l-2.513455 7.540363-3.118545 7.819637-4.887273 6.842182c-30.72 43.147636-71.540364 61.393455-145.314909 78.056727l-62.231273 13.218909-11.496727 2.885818-13.777455 4.002909-16.058181 5.213091-8.843637 3.025455-29.882182 10.798545-32.721454 12.520727V861.090909h740.072727v-77.358545l-36.445091-13.265455-23.272727-8.098909-20.712727-6.842182-18.152728-5.632c-2.792727-0.837818-5.492364-1.629091-8.098909-2.327273l-14.196363-3.723636-5.585455-1.303273-25.134545-5.399272-24.901819-5.538909c-65.582545-15.36-107.52-33.373091-137.774545-70.56291l-5.911273-7.68-5.445818-7.540363-3.258182-8.750546c-8.424727-22.388364-12.241455-74.472727-11.077818-101.841454l0.512-7.400727a90.949818 90.949818 0 0 1 27.322182-63.162182c30.161455-30.301091 49.524364-76.194909 51.991273-122.228364l0.279272-10.612364-0.093091-16.849454-0.418909-16.197818-0.698181-15.499637-1.582546-20.573091-0.837818-7.912727-2.001455-14.429091C536.762182 193.163636 499.432727 162.909091 441.716364 162.909091z",
      "fill": "#011949",
      "p-id": 10445
    }, null)]);
  }
  function SvgComponent$3(props) {
    return vue.createVNode("svg", vue.mergeProps({
      "viewBox": "0 0 1024 1024",
      "xmlns": "http://www.w3.org/2000/svg",
      "p-id": 10573,
      "width": "1em",
      "height": "1em"
    }, props), [vue.createVNode("path", {
      "d": "M596.945455 118.039273c87.691636-16.802909 154.903273 39.796364 174.405818 124.648727l1.861818 8.890182 2.141091 13.451636 0.930909 7.121455 0.837818 7.68 1.210182 14.522182 0.744727 14.754909 0.465455 14.941091 0.093091 14.848c0.186182 59.578182-25.227636 119.342545-69.632 162.257454l-5.213091 4.747636-0.046546 1.256728c-0.325818 11.031273 0.930909 31.976727 2.466909 42.821818l0.512 3.118545 2.792728 2.420364c11.776 9.402182 32.162909 16.942545 64.093091 23.970909l9.960727 2.094546 52.782545 10.100363 16.523637 3.723637 9.169454 2.327272 20.247273 5.445818 22.714182 6.56291 38.818909 11.962181 29.090909 9.355637c26.810182 8.843636 46.033455 31.232 48.64 57.856l0.279273 6.190545v91.042909c0 38.958545-12.939636 64.791273-49.431273 67.677091l-7.121455 0.279273h-48.407272v-55.854546l49.524363 0.139637-0.372363-7.959273-0.046546-95.325091c0-4.096-3.630545-8.704-10.472727-10.938182l-28.066909-9.076363-25.6-7.959273-22.946909-6.842182-20.433455-5.725091-17.826909-4.654545-7.912727-1.861818-13.963637-2.932364-23.13309-4.328727-22.900364-4.421818c-52.922182-10.705455-85.457455-22.760727-107.380364-45.614546l-4.887272-5.399273-4.189091-6.795636c-6.749091-15.639273-9.914182-61.533091-7.959273-79.220364a44.823273 44.823273 0 0 1 12.194909-29.416727l3.863273-3.584a172.078545 172.078545 0 0 0 58.181818-117.713454l0.232727-9.402182-0.093091-14.103273-0.372363-13.684364-0.698182-13.218909-1.582546-17.361454-0.930909-7.493818-1.954909-12.19491c-10.891636-58.647273-50.315636-95.837091-103.377454-89.413818l-7.307637 1.117091-10.519272-54.830545z",
      "fill": "#267EF0",
      "p-id": 10574
    }, null), vue.createVNode("path", {
      "d": "M833.163636 930.909091H46.545455a46.545455 46.545455 0 0 1-46.545455-46.545455v-117.666909a46.545455 46.545455 0 0 1 29.277091-43.194182c63.394909-25.367273 109.428364-41.239273 138.146909-47.662545l49.664-10.426182c49.152-10.472727 94.580364-22.807273 116.177455-53.154909 5.678545-14.196364 7.959273-66.978909 6.702545-82.245818a22.248727 22.248727 0 0 0-6.888727-16.058182c-46.312727-46.359273-72.610909-114.548364-73.076364-180.782545l-0.093091-17.687273 0.279273-17.454546 0.232727-8.517818 0.837818-16.849454c0.325818-5.538909 0.744727-10.984727 1.256728-16.384l1.722181-15.825455C275.176727 154.437818 342.062545 93.090909 441.716364 93.090909c92.951273 0 158.626909 55.994182 171.566545 136.098909l2.234182 15.825455c0.651636 5.352727 1.210182 10.798545 1.675636 16.337454l1.210182 16.849455 0.837818 17.314909 0.465455 17.687273 0.093091 18.059636c0.186182 66.839273-26.018909 135.866182-72.610909 182.690909a22.434909 22.434909 0 0 0-6.981819 15.685818c-1.442909 15.453091 0.651636 68.421818 6.05091 82.850909 20.154182 27.927273 59.345455 40.96 103.00509 51.153455l24.157091 5.352727 24.529455 5.259637c31.185455 6.749091 81.687273 23.365818 151.645091 49.803636a46.545455 46.545455 0 0 1 30.068363 43.566545V884.363636a46.545455 46.545455 0 0 1-46.545454 46.545455z",
      "fill": "#267EF0",
      "p-id": 10575
    }, null)]);
  }
  function SvgComponent$2(props) {
    return vue.createVNode("svg", vue.mergeProps({
      "viewBox": "0 0 1024 1024",
      "xmlns": "http://www.w3.org/2000/svg",
      "p-id": 10309,
      "width": "1em",
      "height": "1em"
    }, props), [vue.createVNode("path", {
      "d": "M1001.565091 461.172364l-227.886546-227.607273a79.592727 79.592727 0 0 0-112.453818 0L569.390545 325.352727l338.292364 337.92 93.882182-93.742545a76.567273 76.567273 0 0 0 0-108.311273zM183.296 738.210909l92.625455 92.532364a78.522182 78.522182 0 0 0 110.871272 0l92.625455-92.532364-148.107637-147.874909-148.014545 147.874909zM235.147636 272.290909L24.110545 475.322182a78.615273 78.615273 0 0 0-1.070545 112.267636l99.886545 99.746909 205.824-198.004363 379.950546 379.531636 148.014545-147.921455L321.442909 186.181818 235.194182 272.290909z",
      "fill": "#011949",
      "p-id": 10310
    }, null)]);
  }
  function SvgComponent$1(props) {
    return vue.createVNode("svg", vue.mergeProps({
      "viewBox": "0 0 1024 1024",
      "xmlns": "http://www.w3.org/2000/svg",
      "p-id": 10708,
      "width": "1em",
      "height": "1em"
    }, props), [vue.createVNode("path", {
      "d": "M1001.565091 461.172364l-227.886546-227.607273a79.592727 79.592727 0 0 0-112.453818 0L569.390545 325.352727l338.292364 337.92 93.882182-93.742545a76.567273 76.567273 0 0 0 0-108.311273zM183.296 738.210909l92.625455 92.532364a78.522182 78.522182 0 0 0 110.871272 0l92.625455-92.532364-148.107637-147.874909-148.014545 147.874909zM235.147636 272.290909L24.110545 475.322182a78.615273 78.615273 0 0 0-1.070545 112.267636l99.886545 99.746909 205.824-198.004363 379.950546 379.531636 148.014545-147.921455L321.442909 186.181818 235.194182 272.290909z",
      "fill": "#267EF0",
      "p-id": 10709
    }, null)]);
  }
  function SvgComponent(props) {
    return vue.createVNode("svg", vue.mergeProps({
      "viewBox": "0 0 1024 1024",
      "xmlns": "http://www.w3.org/2000/svg",
      "p-id": 5008,
      "width": "1em",
      "height": "1em"
    }, props), [vue.createVNode("path", {
      "d": "M877.714286 0h146.285714v658.285714a365.714286 365.714286 0 0 1-365.714286 365.714286H0v-146.285714C0 392.996571 392.996571 0 877.714286 0z",
      "fill": "#267EF0",
      "p-id": 5009
    }, null), vue.createVNode("path", {
      "d": "M243.126857 586.605714a20.772571 20.772571 0 0 1-2.194286-28.013714l16.091429-19.968a21.211429 21.211429 0 0 1 27.574857-4.461714l138.971429 91.282285c7.314286 4.827429 19.968 4.169143 26.843428-1.243428l367.177143-293.302857a22.235429 22.235429 0 0 1 28.452572 1.097143l8.996571 8.850285c7.899429 7.753143 7.314286 20.041143-0.950857 28.16L460.068571 756.370286a32.182857 32.182857 0 0 1-45.056-0.877715L243.126857 586.678857z",
      "fill": "#FFFFFF",
      "p-id": 5010
    }, null)]);
  }
  var iconList = ["addr", "arrow", "arrow_down", "arrow_left", "arrow_up", "arrow_up_bold", "back", "bold_arrow_up", "camera", "chat", "check", "close", "close_out_line", "down_arrow", "fail", "multiple_selected", "plus", "selected", "single_selected", "success", "underway_o", "warning", "add", "delete", "load_error", "load_loading", "multiple_disable", "multiple_un_selected", "search", "single_disable", "single_un_selected", "tabbar_mk", "tabbar_mk_active", "tabbar_setting", "tabbar_setting_active", "tabbar_todo", "tabbar_todo_active", "tabbar_user", "tabbar_user_active", "tabbar_workbench", "tabbar_workbench_active", "tag_selected"];
  var IconComponent = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    [Symbol.toStringTag]: "Module",
    iconList,
    addr: SvgComponent$F,
    arrow: SvgComponent$E,
    arrow_down: SvgComponent$D,
    arrow_left: SvgComponent$C,
    arrow_up: SvgComponent$B,
    arrow_up_bold: SvgComponent$A,
    back: SvgComponent$z,
    bold_arrow_up: SvgComponent$y,
    camera: SvgComponent$x,
    chat: SvgComponent$w,
    check: SvgComponent$v,
    close: SvgComponent$u,
    close_out_line: SvgComponent$t,
    down_arrow: SvgComponent$s,
    fail: SvgComponent$r,
    multiple_selected: SvgComponent$q,
    plus: SvgComponent$p,
    selected: SvgComponent$o,
    single_selected: SvgComponent$n,
    success: SvgComponent$m,
    underway_o: SvgComponent$l,
    warning: SvgComponent$k,
    add: SvgComponent$j,
    "delete": SvgComponent$i,
    load_error: SvgComponent$h,
    load_loading: SvgComponent$g,
    multiple_disable: SvgComponent$f,
    multiple_un_selected: SvgComponent$e,
    search: SvgComponent$d,
    single_disable: SvgComponent$c,
    single_un_selected: SvgComponent$b,
    tabbar_mk: SvgComponent$a,
    tabbar_mk_active: SvgComponent$9,
    tabbar_setting: SvgComponent$8,
    tabbar_setting_active: SvgComponent$7,
    tabbar_todo: SvgComponent$6,
    tabbar_todo_active: SvgComponent$5,
    tabbar_user: SvgComponent$4,
    tabbar_user_active: SvgComponent$3,
    tabbar_workbench: SvgComponent$2,
    tabbar_workbench_active: SvgComponent$1,
    tag_selected: SvgComponent
  });
  var [name$13, bem$B] = createNamespace("icon");
  var iconProps = {
    name: makeRequiredProp(String),
    color: String,
    size: [Number, String],
    classPrefix: String
  };
  var Icon$1 = vue.defineComponent({
    name: name$13,
    props: iconProps,
    setup(props, _ref) {
      var [name2, bem2] = createNamespace("icon");
      var style = {
        "font-size": props.size ? typeof props.size === "string" ? props.size : props.size + "px" : "inhert",
        color: props.color
      };
      return () => {
        var _props$name, _ref2;
        return vue.createVNode("span", {
          "class": bem2(),
          "style": style
        }, [props.name && !iconList.includes(props.name) ? vue.createVNode("img", {
          "style": style,
          "src": props.name
        }, null) : (_props$name = (_ref2 = IconComponent)[props.name]) == null ? void 0 : _props$name.call(_ref2)]);
      };
    }
  });
  var Icon = withInstall(Icon$1);
  var [name$12, bem$A] = createNamespace("button");
  var buttonProps = extend({}, routeProps, {
    type: makeStringProp("default"),
    size: makeStringProp("normal"),
    icon: String,
    rightIcon: String,
    block: Boolean,
    plain: Boolean,
    success: Boolean,
    warning: Boolean,
    danger: Boolean,
    round: Boolean,
    square: Boolean,
    loading: Boolean,
    hairline: Boolean,
    disabled: Boolean,
    nativeType: makeStringProp("button")
  });
  var _Button = vue.defineComponent({
    name: name$12,
    props: buttonProps,
    emits: ["click"],
    setup(props, _ref) {
      var {
        emit,
        slots
      } = _ref;
      var [name2, bem2] = createNamespace("button");
      var route2 = useRoute();
      var onClick = (event) => {
        if (props.loading) {
          event.preventDefault();
        } else if (!props.disabled) {
          emit("click", event);
          route2();
        }
      };
      return () => {
        var {
          type,
          size,
          block,
          round: round2,
          plain,
          loading,
          disabled,
          success,
          warning,
          danger,
          icon,
          rightIcon
        } = props;
        var {
          platform
        } = useConfigProvider();
        return vue.createVNode("button", {
          "class": bem2([type, size, {
            plain,
            success,
            warning,
            danger,
            disabled,
            loading,
            round: round2,
            block,
            pc: platform === "pc"
          }]),
          "type": props.nativeType,
          "onClick": onClick
        }, [icon && vue.createVNode(Icon, {
          "name": icon,
          "color": "currentColor",
          "size": "inhert"
        }, null), vue.createVNode("div", {
          "class": bem2("content")
        }, [slots.default == null ? void 0 : slots.default()]), rightIcon && vue.createVNode(Icon, {
          "name": rightIcon,
          "color": "currentColor",
          "size": "inhert"
        }, null)]);
      };
    }
  });
  var Button = withInstall(_Button);
  var [name$11, bem$z] = createNamespace("action-bar-button");
  var actionBarButtonProps = extend({}, routeProps, {
    type: String,
    text: String,
    icon: String,
    color: String,
    loading: Boolean,
    disabled: Boolean
  });
  var _ActionBarButton = vue.defineComponent({
    name: name$11,
    props: actionBarButtonProps,
    setup(props, _ref) {
      var {
        slots
      } = _ref;
      var route2 = useRoute();
      var {
        parent,
        index: index2
      } = useParent(ACTION_BAR_KEY);
      vue.computed(() => {
        if (parent) {
          var prev = parent.children[index2.value - 1];
          return !(prev && "isButton" in prev);
        }
      });
      vue.computed(() => {
        if (parent) {
          var next = parent.children[index2.value + 1];
          return !(next && "isButton" in next);
        }
      });
      useExpose({
        isButton: true
      });
      return () => {
        var {
          type,
          icon,
          text,
          color,
          loading,
          disabled
        } = props;
        return vue.createVNode(Button, {
          "type": type,
          "loading": loading,
          "disabled": disabled,
          "onClick": route2
        }, {
          default: () => [slots.default ? slots.default() : text]
        });
      };
    }
  });
  var ActionBarButton = withInstall(_ActionBarButton);
  var popupSharedProps = {
    show: Boolean,
    zIndex: numericProp,
    overlay: truthProp,
    duration: numericProp,
    teleport: [String, Object],
    lockScroll: truthProp,
    lazyRender: truthProp,
    beforeClose: Function,
    overlayStyle: Object,
    overlayClass: unknownProp,
    transitionAppear: Boolean,
    closeOnClickOverlay: truthProp
  };
  var popupSharedPropKeys = Object.keys(popupSharedProps);
  function useLazyRender(show) {
    var inited = vue.ref(false);
    vue.watch(show, (value) => {
      if (value) {
        inited.value = value;
      }
    }, {
      immediate: true
    });
    return (render) => () => inited.value ? render() : null;
  }
  var overflowScrollReg = /scroll|auto/i;
  var defaultRoot = inBrowser$1 ? window : void 0;
  function isElement$1(node) {
    var ELEMENT_NODE_TYPE = 1;
    return node.tagName !== "HTML" && node.tagName !== "BODY" && node.nodeType === ELEMENT_NODE_TYPE;
  }
  function getScrollParent$1(el, root) {
    if (root === void 0) {
      root = defaultRoot;
    }
    var node = el;
    while (node && node !== root && isElement$1(node)) {
      var {
        overflowY
      } = window.getComputedStyle(node);
      if (overflowScrollReg.test(overflowY)) {
        return node;
      }
      node = node.parentNode;
    }
    return root;
  }
  function useScrollParent(el, root) {
    if (root === void 0) {
      root = defaultRoot;
    }
    var scrollParent = vue.ref();
    vue.onMounted(() => {
      if (el.value) {
        scrollParent.value = getScrollParent$1(el.value, root);
      }
    });
    return scrollParent;
  }
  function onMountedOrActivated$1(hook) {
    var mounted;
    vue.onMounted(() => {
      hook();
      vue.nextTick(() => {
        mounted = true;
      });
    });
    vue.onActivated(() => {
      if (mounted) {
        hook();
      }
    });
  }
  var MIN_DISTANCE = 10;
  function getDirection(x, y) {
    if (x > y && x > MIN_DISTANCE) {
      return "horizontal";
    }
    if (y > x && y > MIN_DISTANCE) {
      return "vertical";
    }
    return "";
  }
  function useTouch() {
    var startX = vue.ref(0);
    var startY = vue.ref(0);
    var deltaX = vue.ref(0);
    var deltaY = vue.ref(0);
    var offsetX = vue.ref(0);
    var offsetY = vue.ref(0);
    var direction = vue.ref("");
    var isVertical = () => direction.value === "vertical";
    var isHorizontal = () => direction.value === "horizontal";
    var reset = () => {
      deltaX.value = 0;
      deltaY.value = 0;
      offsetX.value = 0;
      offsetY.value = 0;
      direction.value = "";
    };
    var start2 = (event) => {
      reset();
      startX.value = event.touches[0].clientX;
      startY.value = event.touches[0].clientY;
    };
    var move = (event) => {
      var touch = event.touches[0];
      deltaX.value = touch.clientX < 0 ? 0 : touch.clientX - startX.value;
      deltaY.value = touch.clientY - startY.value;
      offsetX.value = Math.abs(deltaX.value);
      offsetY.value = Math.abs(deltaY.value);
      if (!direction.value) {
        direction.value = getDirection(offsetX.value, offsetY.value);
      }
    };
    return {
      move,
      start: start2,
      reset,
      startX,
      startY,
      deltaX,
      deltaY,
      offsetX,
      offsetY,
      direction,
      isVertical,
      isHorizontal
    };
  }
  var totalLockCount = 0;
  function useLockScroll(rootRef, shouldLock) {
    var touch = useTouch();
    var onTouchMove = (event) => {
      touch.move(event);
      var direction = touch.deltaY.value > 0 ? "10" : "01";
      var el = getScrollParent$1(event.target, rootRef.value);
      var {
        scrollHeight,
        offsetHeight,
        scrollTop
      } = el;
      var status = "11";
      if (scrollTop === 0) {
        status = offsetHeight >= scrollHeight ? "00" : "01";
      } else if (scrollTop + offsetHeight >= scrollHeight) {
        status = "10";
      }
      if (status !== "11" && touch.isVertical() && !(parseInt(status, 2) & parseInt(direction, 2))) {
        preventDefault(event, true);
      }
    };
    var {
      BODY_LOCK_CLASS
    } = useGlobalClassName();
    var lock = () => {
      document.addEventListener("touchstart", touch.start);
      document.addEventListener("touchmove", onTouchMove, {
        passive: false
      });
      if (!totalLockCount) {
        document.body.classList.add(BODY_LOCK_CLASS);
      }
      totalLockCount++;
    };
    var unlock = () => {
      if (totalLockCount) {
        document.removeEventListener("touchstart", touch.start);
        document.removeEventListener("touchmove", onTouchMove);
        totalLockCount--;
        if (!totalLockCount) {
          document.body.classList.remove(BODY_LOCK_CLASS);
        }
      }
    };
    var init = () => shouldLock() && lock();
    var destroy = () => shouldLock() && unlock();
    onMountedOrActivated$1(init);
    vue.onDeactivated(destroy);
    vue.onBeforeUnmount(destroy);
    vue.watch(shouldLock, (value) => {
      value ? lock() : unlock();
    });
  }
  var [name$10, bem$y] = createNamespace("overlay");
  var overlayProps = {
    show: Boolean,
    zIndex: numericProp,
    duration: makeNumberProp(0.3),
    className: unknownProp,
    lockScroll: truthProp,
    customStyle: Object
  };
  var _Overlay = vue.defineComponent({
    name: name$10,
    props: overlayProps,
    setup(props, _ref) {
      var {
        slots
      } = _ref;
      var [name2, bem2] = createNamespace("overlay");
      var lazyRender = useLazyRender(() => props.show);
      var preventTouchMove = (event) => {
        preventDefault(event, true);
      };
      var renderOverlay = lazyRender(() => {
        var style = extend(getZIndexStyle(props.zIndex), props.customStyle);
        if (isDef(props.duration)) {
          style.animationDuration = props.duration + "s";
        }
        return vue.withDirectives(vue.createVNode("div", {
          "style": style,
          "class": [bem2(), props.className],
          "onTouchmove": props.lockScroll ? preventTouchMove : noop
        }, [slots.default == null ? void 0 : slots.default()]), [[vue.vShow, props.show]]);
      });
      return () => vue.createVNode(vue.Transition, {
        "name": "cf-fade",
        "appear": true
      }, {
        default: renderOverlay
      });
    }
  });
  var Overlay = withInstall(_Overlay);
  var [name$$, bem$x] = createNamespace("popup");
  var popupProps$2 = extend({}, popupSharedProps, {
    round: Boolean,
    position: makeStringProp("center"),
    closeIcon: makeStringProp("close"),
    closeable: Boolean,
    transition: String,
    iconPrefix: String,
    closeIconPosition: makeStringProp("top-right"),
    safeAreaInsetBottom: Boolean
  });
  var globalZIndex = 2e3;
  var _Popup = vue.defineComponent({
    name: name$$,
    inheritAttrs: false,
    props: popupProps$2,
    emits: ["open", "close", "click", "opened", "closed", "update:show", "click-overlay", "click-close-icon"],
    setup(props, _ref) {
      var {
        emit,
        attrs,
        slots
      } = _ref;
      var [name2, bem2] = createNamespace("popup");
      var {
        prefix: prefix2
      } = useConfigProvider();
      var opened;
      var zIndex = vue.ref();
      var popupRef = vue.ref();
      var lazyRender = useLazyRender(() => props.show || !props.lazyRender);
      useLockScroll(popupRef, () => props.show && props.lockScroll);
      var onClick = (event) => emit("click", event);
      var onOpened = () => emit("opened");
      var onClosed = () => emit("closed");
      var style = vue.computed(() => {
        var style2 = {
          zIndex: zIndex.value
        };
        return style2;
      });
      var open = () => {
        if (!opened) {
          if (props.zIndex !== void 0) {
            globalZIndex = +props.zIndex;
          }
          opened = true;
          zIndex.value = ++globalZIndex;
          emit("open");
        }
      };
      var close = () => {
        if (opened) {
          callInterceptor(props.beforeClose, {
            done() {
              opened = false;
              emit("close");
              emit("update:show", false);
            }
          });
        }
      };
      var onClickCloseIcon = (event) => {
        emit("click-close-icon", event);
        close();
      };
      var renderCloseIcon = () => {
        if (props.closeable) {
          return vue.createVNode(Icon, {
            "name": props.closeIcon,
            "size": 20,
            "class": [bem2("close", props.closeIconPosition)],
            "onClick": onClickCloseIcon
          }, null);
        }
      };
      var onClickOverlay = (event) => {
        emit("click-overlay", event);
        if (props.closeOnClickOverlay) {
          close();
        }
      };
      var renderPopup = lazyRender(() => {
        var {
          round: round2,
          position,
          safeAreaInsetBottom
        } = props;
        return vue.withDirectives(vue.createVNode("div", vue.mergeProps({
          "ref": popupRef,
          "style": style.value,
          "class": [bem2({
            round: round2,
            [position]: position
          }), {
            [prefix2 + "-safe-area-bottom"]: safeAreaInsetBottom
          }],
          "onClick": onClick
        }, attrs), [slots.default == null ? void 0 : slots.default(), renderCloseIcon()]), [[vue.vShow, props.show]]);
      });
      var renderOverlay = () => {
        if (props.overlay) {
          return vue.createVNode(Overlay, {
            "show": props.show,
            "class": props.overlayClass,
            "customStyle": props.overlayStyle,
            "zIndex": zIndex.value,
            "onClick": onClickOverlay
          }, {
            default: slots["overlay-content"]
          });
        }
      };
      var renderTransition = () => {
        var {
          position,
          transition,
          transitionAppear
        } = props;
        var name3 = position === "center" ? "cf-fade" : prefix2 + "-popup-slide-" + position;
        return vue.createVNode(vue.Transition, {
          "name": transition || name3,
          "appear": transitionAppear,
          "onAfterEnter": onOpened,
          "onAfterLeave": onClosed
        }, {
          default: renderPopup
        });
      };
      vue.watch(() => props.show, (value) => {
        if (value) {
          open();
        } else {
          close();
        }
      });
      useExpose({
        popupRef
      });
      vue.onMounted(() => {
        if (props.show) {
          open();
        }
      });
      return () => {
        if (props.teleport) {
          return vue.createVNode(vue.Teleport, {
            "to": props.teleport
          }, {
            default: () => [renderOverlay(), renderTransition()]
          });
        }
        return vue.createVNode(vue.Fragment, null, [renderOverlay(), renderTransition()]);
      };
    }
  });
  var Popup = withInstall(_Popup);
  var [name$_, bem$w] = createNamespace("divider");
  var dividerProps = {
    type: makeStringProp("horizontal"),
    dashed: Boolean,
    hairline: truthProp,
    contentPosition: makeStringProp("center")
  };
  var _Divider = vue.defineComponent({
    name: name$_,
    props: dividerProps,
    setup(props, _ref) {
      var {
        slots
      } = _ref;
      var [name2, bem2] = createNamespace("divider");
      var {
        type,
        dashed,
        hairline,
        contentPosition
      } = props;
      var isHorizontal = type === "horizontal";
      var classString = [type, {
        dashed,
        [type + "-hairline"]: hairline,
        [type + "-with-text-" + contentPosition]: !!slots.default && isHorizontal
      }];
      return () => vue.createVNode("div", {
        "class": bem2(classString)
      }, [isHorizontal && slots.default ? vue.createVNode("div", {
        "class": bem2([type + "-content"])
      }, [slots.default()]) : null]);
    }
  });
  var Divider = withInstall(_Divider);
  var [name$Z, bem$v] = createNamespace("action-sheet");
  var actionSheetProps = extend({}, popupSharedProps, {
    title: String,
    round: truthProp,
    actions: makeArrayProp(),
    oprationPosition: makeStringProp("bottom"),
    closeIcon: makeStringProp("close"),
    closeable: truthProp,
    closeOnClickOpration: truthProp,
    confirmText: String,
    cancelText: String,
    description: String,
    closeOnPopstate: truthProp,
    closeOnClickAction: Boolean,
    safeAreaInsetBottom: truthProp,
    headerBorder: Boolean
  });
  var OprationType;
  (function(OprationType2) {
    OprationType2["confirm"] = "confirm";
    OprationType2["cancel"] = "cancel";
  })(OprationType || (OprationType = {}));
  var popupInheritKeys$1 = [...popupSharedPropKeys, "round", "closeOnPopstate", "safeAreaInsetBottom"];
  var _ActionSheet = vue.defineComponent({
    name: name$Z,
    props: actionSheetProps,
    emits: ["select", "confirm", "cancel", "update:show"],
    setup(props, _ref) {
      var {
        slots,
        emit
      } = _ref;
      var [name2, bem2] = createNamespace("action-sheet");
      var {
        HAPTICS_FEEDBACK
      } = useGlobalClassName();
      var updateShow = (show) => emit("update:show", show);
      var onOpration = (type) => {
        callInterceptor(props.beforeClose, {
          done() {
            if (props.closeOnClickOpration) {
              updateShow(false);
            }
            emit(type);
          }
        });
      };
      var headerBorder = () => {
        if (props.headerBorder) {
          return vue.createVNode(Divider, {
            "style": "--margin-horizontal: 0px"
          }, null);
        }
      };
      var renderHeader = () => {
        if (props.title) {
          return vue.createVNode("div", {
            "class": bem2("header")
          }, [props.title, props.closeable && props.oprationPosition === "bottom" && vue.createVNode(Icon, {
            "name": props.closeIcon,
            "size": 20,
            "class": [bem2("close"), HAPTICS_FEEDBACK],
            "onClick": () => onOpration(OprationType.cancel)
          }, null), headerBorder()]);
        }
      };
      var oprationButtonView = (type) => {
        var key = type + "Text";
        if (props[key]) {
          if (props.oprationPosition === "top") {
            return [vue.createVNode("span", {
              "class": bem2(type + "-text"),
              "onClick": () => onOpration(type)
            }, [props[key]])];
          }
          return [vue.createVNode(Button, {
            "type": type === OprationType.confirm ? "primary" : "default",
            "class": bem2(type),
            "onClick": () => onOpration(type)
          }, {
            default: () => [props[key]]
          })];
        }
      };
      var renderOprationButton = () => {
        if (props.confirmText || props.cancelText) {
          var _props$actions;
          if ((_props$actions = props.actions) != null && _props$actions.length) {
            return [vue.createVNode("div", {
              "onClick": () => onOpration(OprationType.cancel),
              "class": [bem2("options-cancel")]
            }, [slots.cancel ? slots.cancel() : props.cancelText])];
          }
          return [vue.createVNode("div", {
            "class": [bem2("opration-button"), "" + (props.oprationPosition === "top" ? bem2("opration-text-button") : "")]
          }, [oprationButtonView(OprationType.cancel), oprationButtonView(OprationType.confirm)])];
        }
      };
      var renderOption = (item, index2) => {
        var {
          name: name3,
          color,
          subname,
          loading,
          callback,
          disabled,
          className
        } = item;
        var Content = [vue.createVNode("span", {
          "class": bem2("name")
        }, [name3]), subname && vue.createVNode("div", {
          "class": bem2("subname")
        }, [subname])];
        var onClick = () => {
          if (disabled || loading) {
            return;
          }
          if (callback) {
            callback(item);
          }
          if (props.closeOnClickAction) {
            updateShow(false);
          }
          vue.nextTick(() => emit("select", item, index2));
        };
        return vue.createVNode("button", {
          "type": "button",
          "style": {
            color
          },
          "class": [bem2("item", {
            loading,
            disabled
          }), className],
          "onClick": onClick
        }, [Content]);
      };
      var renderDescription = () => {
        if (props.description || slots.description) {
          var content = slots.description ? slots.description() : props.description;
          return vue.createVNode("div", {
            "class": bem2("description")
          }, [content]);
        }
      };
      return () => {
        var _props$actions2, _props$actions3;
        return vue.createVNode(Popup, vue.mergeProps({
          "class": [bem2(), (_props$actions2 = props.actions) != null && _props$actions2.length ? bem2("options-type") : "", (_props$actions3 = props.actions) != null && _props$actions3.length && props.cancelText ? bem2("options-type-cancel") : ""],
          "position": "bottom",
          "onUpdate:show": updateShow
        }, pick(props, popupInheritKeys$1)), {
          default: () => [renderHeader(), renderDescription(), vue.createVNode("div", {
            "class": bem2("content")
          }, [props.actions.map(renderOption), slots.default == null ? void 0 : slots.default()]), renderOprationButton()]
        });
      };
    }
  });
  var ActionSheet = withInstall(_ActionSheet);
  var [name$Y] = createNamespace("alert");
  var alertProps = {
    type: makeStringProp("info"),
    closable: Boolean,
    closeText: makeStringProp(""),
    message: makeStringProp("")
  };
  var _Alert = vue.defineComponent({
    name: name$Y,
    props: alertProps,
    emits: ["close"],
    setup(props, _ref) {
      var {
        attrs,
        emit,
        slots
      } = _ref;
      var bem2 = createNamespace("alert")[1];
      var closing = vue.ref(false);
      var closed = vue.ref(false);
      var alertNode = vue.ref();
      var {
        closable,
        type,
        message,
        closeText
      } = props;
      var handleClose = (e) => {
        e.preventDefault();
        var dom = alertNode.value;
        dom.style.height = dom.offsetHeight + "px";
        closing.value = true;
        emit("close", e);
      };
      var renderIcon = () => type === "warning" ? vue.createVNode(Icon, {
        "name": "warning",
        "color": "##F5A524",
        "size": "14px"
      }, null) : null;
      var renderCloseIcon = () => vue.createVNode("button", {
        "type": "button",
        "onClick": handleClose,
        "class": bem2("close-icon"),
        "tabindex": 0
      }, [closeText ? vue.createVNode("span", {
        "class": bem2("close-text")
      }, [closeText]) : vue.createVNode(Icon, {
        "name": "close",
        "color": "#D8D8D8",
        "size": "14px"
      }, null)]);
      var animationEnd = () => {
        closing.value = false;
        closed.value = true;
      };
      useExpose({
        animationEnd
      });
      return () => closed.value ? null : vue.createVNode(vue.Transition, {
        "name": "cf-fade",
        "appear": true
      }, {
        default: () => [vue.withDirectives(vue.createVNode("div", vue.mergeProps(attrs, {
          "class": bem2(["" + type, {
            ["closing"]: closing.value,
            ["closable"]: closable
          }]),
          "data-show": !closing.value,
          "ref": alertNode
        }), [renderIcon(), vue.createVNode("div", {
          "class": bem2("content")
        }, [vue.createVNode("div", {
          "class": bem2("message")
        }, [message])]), closable ? renderCloseIcon() : null]), [[vue.vShow, !closing.value]])]
      });
    }
  });
  var Alert = withInstall(_Alert);
  function _extends$9() {
    _extends$9 = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends$9.apply(this, arguments);
  }
  var [name$X, bem$u] = createNamespace("badge");
  var badgeProps = {
    content: numericProp,
    color: String,
    dot: Boolean,
    dotSize: numericProp,
    border: String,
    borderSize: Number,
    max: numericProp,
    showZero: truthProp
  };
  var _Badge = vue.defineComponent({
    name: name$X,
    props: badgeProps,
    emits: ["click"],
    setup(props, _ref) {
      var {
        emit,
        slots
      } = _ref;
      var isShow = vue.ref(true);
      var hide2 = () => {
        isShow.value = false;
      };
      var show = () => {
        isShow.value = true;
      };
      var toggle = () => {
        isShow.value = !isShow.value;
      };
      var handleBadgeClick = () => {
        emit("click");
      };
      useExpose({
        show,
        hide: hide2,
        toggle
      });
      var hasContent = () => {
        if (slots.content) {
          return true;
        }
        var {
          content,
          showZero
        } = props;
        return isDef(content) && content !== "" && (showZero || content !== 0);
      };
      var renderContent = () => {
        var {
          dot,
          max: max2,
          content
        } = props;
        if (!dot && hasContent()) {
          if (slots.content) {
            return slots.content();
          }
          if (isDef(max2) && isNumeric(content) && +content > max2) {
            return max2 + "+";
          }
          return content;
        }
      };
      var renderBadge = () => {
        var styles = {
          border: "",
          width: "auto",
          height: "auto"
        };
        if (props.border) {
          var _props$borderSize, _props$border;
          styles.border = ((_props$borderSize = props.borderSize) != null ? _props$borderSize : 2) + "px solid " + ((_props$border = props.border) != null ? _props$border : "#fff");
        }
        if (props.dot && props.dotSize) {
          styles.width = Number(props.dotSize) + "px";
          styles.height = Number(props.dotSize) + "px";
        }
        if (hasContent() || props.dot) {
          return vue.withDirectives(vue.createVNode("div", {
            "class": bem$u({
              dot: props.dot,
              fixed: !!slots.default,
              border: !!props.border
            }),
            "style": _extends$9({
              backgroundColor: slots.content ? "transparent" : props.color
            }, styles),
            "onClick": handleBadgeClick
          }, [renderContent()]), [[vue.vShow, isShow.value]]);
        }
      };
      return () => {
        if (slots.default) {
          return vue.createVNode("div", {
            "class": bem$u("wrapper")
          }, [slots.default(), renderBadge()]);
        }
        return renderBadge();
      };
    }
  });
  var Badge = withInstall(_Badge);
  var [name$W] = createNamespace("breadcrumb");
  var breadcrumbProps = {
    separator: makeStringProp("")
  };
  var BREADCRUMB_KEY = Symbol(name$W);
  var _Breadcrumb = vue.defineComponent({
    name: name$W,
    props: breadcrumbProps,
    emits: ["click"],
    setup(props, _ref) {
      var {
        slots
      } = _ref;
      var bem2 = createNamespace("breadcrumb")[1];
      vue.provide(BREADCRUMB_KEY, props);
      var {
        platform
      } = useConfigProvider();
      return () => vue.createVNode("div", {
        "class": bem2([{
          pc: platform === "pc"
        }])
      }, [slots.default == null ? void 0 : slots.default()]);
    }
  });
  var [name$V] = createNamespace("breadcrumb");
  var BreadcrumbItem = vue.defineComponent({
    name: name$V,
    emits: ["click"],
    setup(props, _ref) {
      var {
        slots,
        emit
      } = _ref;
      var bem2 = createNamespace("breadcrumb")[1];
      var {
        platform
      } = useConfigProvider();
      var {
        separator
      } = vue.inject(BREADCRUMB_KEY, {
        separator: ""
      });
      var clickItem = (e) => {
        e.preventDefault();
        emit("click", e);
      };
      return () => vue.createVNode("span", {
        "class": bem2("item", {
          pc: platform === "pc"
        })
      }, [vue.createVNode("a", {
        "role": "button",
        "class": bem2("inner", {
          pc: platform === "pc"
        }),
        "onClick": clickItem
      }, [slots.default == null ? void 0 : slots.default()]), vue.createVNode("span", {
        "class": bem2("separator")
      }, [separator || vue.createVNode(Icon, {
        "name": "arrow",
        "size": "14px"
      }, null)])]);
    }
  });
  var Breadcrumb = withInstall(_Breadcrumb);
  Breadcrumb.Item = BreadcrumbItem;
  var getToday = () => {
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    return today;
  };
  function compareMonth(date1, date2) {
    var year1 = date1.getFullYear();
    var year2 = date2.getFullYear();
    if (year1 === year2) {
      var month1 = date1.getMonth();
      var month2 = date2.getMonth();
      return month1 === month2 ? 0 : month1 > month2 ? 1 : -1;
    }
    return year1 > year2 ? 1 : -1;
  }
  function compareDay(day1, day2) {
    var compareMonthResult = compareMonth(day1, day2);
    if (compareMonthResult === 0) {
      var date1 = day1.getDate();
      var date2 = day2.getDate();
      return date1 === date2 ? 0 : date1 > date2 ? 1 : -1;
    }
    return compareMonthResult;
  }
  var cloneDate = (date) => new Date(date);
  var cloneDates = (dates) => Array.isArray(dates) ? dates.map(cloneDate) : cloneDate(dates);
  var isSameWeek = (date) => {
    var inDateStr = date.toLocaleDateString();
    var nowDate = new Date();
    var nowTime = nowDate.getTime();
    var nowDay = nowDate.getDay();
    for (var i = 0; i < 7; i++) {
      if (inDateStr === new Date(nowTime + (i - nowDay) * 24 * 3600 * 1e3).toLocaleDateString())
        return true;
    }
    return false;
  };
  var [name$U, bem$t] = createNamespace("calendar-header");
  var CalendarHeaderProps = {
    firstDayOfWeek: Number,
    showMonth: Number,
    isWeekView: Boolean,
    currentViewDate: Date
  };
  var CalendarHeader = vue.defineComponent({
    name: name$U,
    props: CalendarHeaderProps,
    emits: [],
    setup(props) {
      var [name2, bem2] = createNamespace("calendar-header");
      var renderWeekDays = () => {
        var weekdays = ["\u65E5", "\u4E00", "\u4E8C", "\u4E09", "\u56DB", "\u4E94", "\u516D"];
        var weekMap = {
          \u65E5: 7,
          \u4E00: 1,
          \u4E8C: 2,
          \u4E09: 3,
          \u56DB: 4,
          \u4E94: 5,
          \u516D: 6
        };
        var now = new Date();
        var day = now.getDay();
        var month = now.getMonth() + 1;
        var {
          firstDayOfWeek,
          showMonth
        } = props;
        var isSelectDay = vue.computed(() => {
          if (props.currentViewDate && props.currentViewDate instanceof Date) {
            if (!props.isWeekView) {
              if (props.currentViewDate.getMonth() + 1 === month) {
                return true;
              }
              return false;
            }
            if (props.isWeekView) {
              return isSameWeek(props.currentViewDate);
            }
          }
          return showMonth === month;
        });
        var renderWeekDays2 = [...weekdays.slice(firstDayOfWeek, 7), ...weekdays.slice(0, firstDayOfWeek)];
        return vue.createVNode("div", {
          "class": bem2("weekdays")
        }, [renderWeekDays2.map((text) => vue.createVNode("span", {
          "class": bem2("weekdays", {
            weekday: true,
            weekend: ["\u65E5", "\u516D"].includes(text),
            today: weekMap[text] === day && isSelectDay.value
          })
        }, [text]))]);
      };
      return () => vue.createVNode("div", {
        "class": bem2()
      }, [renderWeekDays()]);
    }
  });
  var TouchAreaHeightType;
  (function(TouchAreaHeightType2) {
    TouchAreaHeightType2[TouchAreaHeightType2["close"] = 20] = "close";
    TouchAreaHeightType2[TouchAreaHeightType2["open"] = 24] = "open";
  })(TouchAreaHeightType || (TouchAreaHeightType = {}));
  var TouchAreaPaddingType;
  (function(TouchAreaPaddingType2) {
    TouchAreaPaddingType2[TouchAreaPaddingType2["close"] = 8] = "close";
    TouchAreaPaddingType2[TouchAreaPaddingType2["open"] = 0] = "open";
  })(TouchAreaPaddingType || (TouchAreaPaddingType = {}));
  var [name$T, bem$s] = createNamespace("calendar-box");
  var CalendarDayProps = {
    item: makeRequiredProp(Object),
    slotOfDays: makeArrayProp()
  };
  var CalendarDay = vue.defineComponent({
    name: name$T,
    props: CalendarDayProps,
    emits: ["click-day"],
    setup(props, _ref) {
      var {
        slots,
        emit
      } = _ref;
      var [name2, bem2] = createNamespace("calendar-box");
      var renderLunar = () => {
        var {
          item
        } = props;
        var {
          lunar,
          isSelect,
          today
        } = item;
        return vue.createVNode("div", {
          "class": bem2("lunar", {
            "selected-day": today && !isSelect
          })
        }, [lunar == null ? void 0 : lunar.dayStr]);
      };
      var renderCustomCard = () => {
        var {
          jsMonthDay
        } = props.item;
        var date = jsMonthDay;
        var showSlot = props.slotOfDays.every((day) => compareDay(day, date) === 0);
        if (slots.customCard && showSlot && props.slotOfDays.length) {
          return vue.createVNode("div", {
            "class": bem2("slot")
          }, [slots.customCard({
            date: jsMonthDay
          })]);
        }
      };
      var onClickDay = (item) => {
        emit("click-day", item);
      };
      var renderDay = () => {
        var {
          day,
          type,
          today,
          isSelect
        } = props.item;
        return vue.createVNode("div", {
          "class": bem2("detail", {
            "other-month": type !== "normal",
            today,
            select: isSelect
          }),
          "onClick": () => {
            onClickDay(props.item);
          }
        }, [vue.createVNode("div", {
          "class": bem2("date")
        }, [today ? "\u4ECA" : day]), renderLunar(), renderCustomCard()]);
      };
      return () => renderDay();
    }
  });
  const lunarInfo = [
    19416,
    19168,
    42352,
    21717,
    53856,
    55632,
    91476,
    22176,
    39632,
    21970,
    19168,
    42422,
    42192,
    53840,
    119381,
    46400,
    54944,
    44450,
    38320,
    84343,
    18800,
    42160,
    46261,
    27216,
    27968,
    109396,
    11104,
    38256,
    21234,
    18800,
    25958,
    54432,
    59984,
    28309,
    23248,
    11104,
    100067,
    37600,
    116951,
    51536,
    54432,
    120998,
    46416,
    22176,
    107956,
    9680,
    37584,
    53938,
    43344,
    46423,
    27808,
    46416,
    86869,
    19872,
    42448,
    83315,
    21200,
    43432,
    59728,
    27296,
    44710,
    43856,
    19296,
    43748,
    42352,
    21088,
    62051,
    55632,
    23383,
    22176,
    38608,
    19925,
    19152,
    42192,
    54484,
    53840,
    54616,
    46400,
    46496,
    103846,
    38320,
    18864,
    43380,
    42160,
    45690,
    27216,
    27968,
    44870,
    43872,
    38256,
    19189,
    18800,
    25776,
    29859,
    59984,
    27480,
    21952,
    43872,
    38613,
    37600,
    51552,
    55636,
    54432,
    55888,
    30034,
    22176,
    43959,
    9680,
    37584,
    51893,
    43344,
    46240,
    47780,
    44368,
    21977,
    19360,
    42416,
    86390,
    21168,
    43312,
    31060,
    27296,
    44368,
    23378,
    19296,
    42726,
    42208,
    53856,
    60005,
    54576,
    23200,
    30371,
    38608,
    19415,
    19152,
    42192,
    118966,
    53840,
    54560,
    56645,
    46496,
    22224,
    21938,
    18864,
    42359,
    42160,
    43600,
    111189,
    27936,
    44448,
    84835,
    37744,
    18936,
    18800,
    25776,
    92326,
    59984,
    27424,
    108228,
    43744,
    41696,
    53987,
    51552,
    54615,
    54432,
    55888,
    23893,
    22176,
    42704,
    21972,
    21200,
    43448,
    43344,
    46240,
    46758,
    44368,
    21920,
    43940,
    42416,
    21168,
    45683,
    26928,
    29495,
    27296,
    44368,
    84821,
    19296,
    42352,
    21732,
    53600,
    59752,
    54560,
    55968,
    92838,
    22224,
    19168,
    43476,
    41680,
    53584,
    62034,
    54560
  ];
  const minYear = 1900;
  const maxYear = 2100;
  const solarMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  const monthName = [
    "\u6B63\u6708",
    "\u4E8C\u6708",
    "\u4E09\u6708",
    "\u56DB\u6708",
    "\u4E94\u6708",
    "\u516D\u6708",
    "\u4E03\u6708",
    "\u516B\u6708",
    "\u4E5D\u6708",
    "\u5341\u6708",
    "\u51AC\u6708",
    "\u814A\u6708"
  ];
  const weekday = [
    "\u661F\u671F\u65E5",
    "\u661F\u671F\u4E00",
    "\u661F\u671F\u4E8C",
    "\u661F\u671F\u4E09",
    "\u661F\u671F\u56DB",
    "\u661F\u671F\u4E94",
    "\u661F\u671F\u516D"
  ];
  const solarTerm = [
    "\u5C0F\u5BD2",
    "\u5927\u5BD2",
    "\u7ACB\u6625",
    "\u96E8\u6C34",
    "\u60CA\u86F0",
    "\u6625\u5206",
    "\u6E05\u660E",
    "\u8C37\u96E8",
    "\u7ACB\u590F",
    "\u5C0F\u6EE1",
    "\u8292\u79CD",
    "\u590F\u81F3",
    "\u5C0F\u6691",
    "\u5927\u6691",
    "\u7ACB\u79CB",
    "\u5904\u6691",
    "\u767D\u9732",
    "\u79CB\u5206",
    "\u5BD2\u9732",
    "\u971C\u964D",
    "\u7ACB\u51AC",
    "\u5C0F\u96EA",
    "\u5927\u96EA",
    "\u51AC\u81F3"
  ];
  const termInfo = [
    0,
    21208,
    42467,
    63836,
    85337,
    107014,
    128867,
    150921,
    173149,
    195551,
    218072,
    240693,
    263343,
    285989,
    308563,
    331033,
    353350,
    375494,
    397447,
    419210,
    440795,
    462224,
    483532,
    504758
  ];
  function _checkYear(year) {
    if (year < minYear) {
      throw new RangeError("\u5E74\u4EFD\u4E0D\u80FD\u5C0F\u4E8E" + minYear + "\u5E74");
    } else if (year > maxYear) {
      throw new RangeError("\u5E74\u4EFD\u4E0D\u80FD\u5927\u4E8E" + maxYear + "\u5E74");
    }
    return true;
  }
  function _checkMonth(month) {
    if (month < 1) {
      throw new RangeError("\u6708\u4EFD\u4E0D\u80FD\u5C0F\u4E8E1");
    } else if (month > 12) {
      throw new RangeError("\u6708\u4EFD\u4E0D\u80FD\u5927\u4E8E12");
    }
    return true;
  }
  function _checkDay(day) {
    if (day < 0) {
      throw new RangeError("\u65E5\u671F\u4E0D\u80FD\u5C0F\u4E8E1");
    } else if (day > 31) {
      throw new RangeError("\u65E5\u671F\u4E0D\u80FD\u5927\u4E8E31");
    }
    return true;
  }
  function getLunarLeapMonth(year) {
    if (_checkYear(year)) {
      return lunarInfo[year - minYear] & 15;
    }
  }
  function getLeapMonthDaysCount(year) {
    if (getLunarLeapMonth(year)) {
      return lunarInfo[year - minYear] & 65536 ? 30 : 29;
    }
    return 0;
  }
  function getLunarYearDaysCount(year) {
    if (_checkYear(year)) {
      let sum = 348;
      for (let i = 32768; i > 8; i >>= 1) {
        sum += lunarInfo[year - minYear] & i ? 1 : 0;
      }
      return sum + getLeapMonthDaysCount(year);
    }
  }
  function getLunarYearMonthDaysCount(year, month) {
    if (_checkYear(year) && _checkMonth(month)) {
      return lunarInfo[year - minYear] & 65536 >> month ? 30 : 29;
    }
  }
  function getLunarDayString(day) {
    day = Math.floor(day);
    if (_checkDay(day)) {
      const nStr1 = [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D",
        "\u4E03",
        "\u516B",
        "\u4E5D",
        "\u5341"
      ];
      const nStr2 = ["\u521D", "\u5341", "\u5EFF", "\u5345"];
      let str;
      switch (day) {
        case 10:
          str = "\u521D\u5341";
          break;
        case 20:
          str = "\u4E8C\u5341";
          break;
        case 30:
          str = "\u4E09\u5341";
          break;
        default:
          str = nStr2[Math.floor(day / 10)];
          str += nStr1[day % 10];
          break;
      }
      return str;
    }
  }
  function getSolarDayNumber(year, month, day) {
    if (_checkYear(year) && _checkMonth(month) && _checkDay(day)) {
      const date = new Date(year, month - 1, day);
      const d = date.getDate();
      const m = month - 1;
      let sum = d;
      for (let i = 0; i < m; i++) {
        sum += solarMonth[i];
      }
      if (m > 1 && year % 4 === 0 && year % 100 !== 0 || year % 400 === 0) {
        sum += 1;
      }
      return sum;
    }
  }
  function getLunar24Days(year, month, day) {
    if (_checkYear(year) && _checkMonth(month) && _checkDay(day)) {
      const baseDate = new Date(1900, 0, 6, 2, 5, 0);
      let str = false;
      for (let i = 1; i <= 24; i++) {
        const num = 525948.76 * (year - 1900) + termInfo[i];
        const timestamp = baseDate.getTime() + num * 60 * 1e3;
        const newDate = new Date(timestamp);
        if (getSolarDayNumber(newDate.getFullYear(), newDate.getMonth() + 1, newDate.getDate()) === getSolarDayNumber(year, month, day)) {
          str = solarTerm[i];
          break;
        }
      }
      return str;
    }
  }
  function solarToLunar(year, month, day) {
    if (_checkYear(year) && _checkMonth(month) && _checkDay(day)) {
      const baseDate = new Date(minYear, 0, 31);
      const objDate = new Date(year, month - 1, day);
      let offset2 = (objDate - baseDate) / 864e5;
      let temp = 0;
      let i;
      for (i = minYear; i < maxYear && offset2 > 0; i++) {
        temp = getLunarYearDaysCount(i);
        if (offset2 < temp) {
          break;
        } else {
          offset2 -= temp;
        }
      }
      const lunarYear = i;
      const leap = getLunarLeapMonth(lunarYear);
      let isLeapMonth = false;
      for (i = 1; i <= 12 && offset2 > 0; i++) {
        if (leap > 0 && i === leap + 1 && !isLeapMonth) {
          --i;
          isLeapMonth = true;
          temp = getLeapMonthDaysCount(lunarYear);
        } else {
          isLeapMonth = false;
          temp = getLunarYearMonthDaysCount(lunarYear, i);
        }
        if (offset2 < temp) {
          break;
        } else {
          offset2 -= temp;
        }
      }
      const lunarMonth = i;
      const lunarDay = offset2 + 1;
      let monthStr;
      if (isLeapMonth) {
        monthStr = "\u95F0" + monthName[lunarMonth - 1];
      } else {
        monthStr = monthName[lunarMonth - 1];
      }
      return {
        year: lunarYear,
        ncWeek: weekday[objDate.getDay()],
        month: lunarMonth,
        day: Math.floor(lunarDay),
        isLeap: isLeapMonth,
        Terms: getLunar24Days(year, month, day - 1),
        monthStr,
        dayStr: getLunarDayString(lunarDay)
      };
    }
  }
  function _extends$8() {
    _extends$8 = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends$8.apply(this, arguments);
  }
  var [name$S, bem$r] = createNamespace("calendar-body");
  var CalendarBodyProps = {
    isWeekView: Boolean,
    date: makeRequiredProp(Date),
    defaultDate: {
      type: [Date],
      default: getToday
    },
    currentDate: [Date, Array],
    slotOfDays: makeArrayProp()
  };
  var CalendarBody = vue.defineComponent({
    name: name$S,
    props: CalendarBodyProps,
    emits: ["select", "touch", "onWeek", "changeView"],
    setup(props, _ref) {
      var {
        emit,
        slots
      } = _ref;
      var [name2, bem2] = createNamespace("calendar-body");
      var contentRef = vue.ref();
      var allDataArr = vue.reactive([]);
      var isSelectedCurrentDate = false;
      var selectData = {
        year: 0,
        month: 0,
        day: 0
      };
      var isDelay = true;
      var dataArr = vue.ref([]);
      var touchAreaHeight = vue.ref(TouchAreaHeightType.open);
      var itemHeight = 61;
      var isTouching = vue.ref(false);
      var needAnimation = vue.ref(true);
      var needHeightAnimation = false;
      var transDurationTime = 0.2;
      var touchAreaPadding = vue.ref(TouchAreaPaddingType.open);
      var isClicked = false;
      var lastWeek = [];
      var nextWeek = [];
      var offsetY = vue.ref(0);
      var touchStartPositionX = null;
      var touchStartPositionY = null;
      var translateIndex = vue.ref(0);
      var isShow = vue.ref(true);
      var isWeekView = vue.reactive({
        value: props.isWeekView
      });
      var touch = vue.reactive({
        x: 0,
        y: 0
      });
      var lineNum = vue.ref(0);
      var bodyStyle = vue.computed(() => {
        var height2 = (isWeekView.value ? itemHeight + touchAreaHeight.value : lineNum.value * itemHeight + touchAreaHeight.value) + "px";
        var transitionDuration = (needHeightAnimation ? transDurationTime : 0) + "s";
        return {
          height: height2,
          transitionDuration
        };
      });
      var markStyle = vue.computed(() => {
        var height2 = lineNum.value * itemHeight + touchAreaHeight.value + 33;
        var top2 = height2 / 2 - 120 + "px";
        return {
          top: top2
        };
      });
      var touchStyle = vue.computed(() => {
        var height2 = touchAreaHeight.value - touchAreaPadding.value + "px";
        var paddingTop = touchAreaPadding.value + "px";
        return {
          height: height2,
          paddingTop
        };
      });
      var touchContainerStyle = vue.computed(() => {
        var height2 = touchAreaHeight.value - touchAreaPadding.value + "px";
        return {
          height: height2
        };
      });
      var touchMonthContainerStyle = vue.computed(() => {
        var transform = "translateX(" + -(translateIndex.value + 1) * 100 + "%)";
        var transitionDuration = (needAnimation.value ? transDurationTime : 0) + "s";
        return {
          transform,
          transitionDuration
        };
      });
      var touchBannerStyle = vue.computed(() => {
        var transform = "translateY(" + offsetY.value + "px)";
        var transitionDuration = (needHeightAnimation ? transDurationTime : 0) + "s";
        return {
          transform,
          transitionDuration
        };
      });
      var touchMonthBoxStyle = vue.computed(() => {
        var transform = "translateX(" + touch.x * 100 + "%)";
        var transitionDuration = (isTouching.value ? 0 : transDurationTime) + "s";
        return {
          transform,
          transitionDuration,
          visibility: "visible"
        };
      });
      var getSelectedDay = (day) => {
        var {
          currentDate
        } = props;
        return compareDay(day, currentDate) === 0;
      };
      var getPreMonth = function(appointDay, date) {
        if (appointDay === void 0) {
          appointDay = 1;
        }
        var {
          year,
          month
        } = date || selectData;
        if (month === 1) {
          year -= 1;
          month = 12;
        } else {
          month -= 1;
        }
        return {
          year,
          month,
          day: appointDay
        };
      };
      var getNextMonth = function(appointDay) {
        if (appointDay === void 0) {
          appointDay = 1;
        }
        var {
          year,
          month
        } = selectData;
        if (month === 12) {
          year += 1;
          month = 1;
        } else {
          month += 1;
        }
        return {
          year,
          month,
          day: appointDay
        };
      };
      var setDayInfo = (dateInfo) => {
        var lunar = solarToLunar(dateInfo.year, dateInfo.month, dateInfo.day);
        var date = new Date(dateInfo.year, dateInfo.month, dateInfo.day);
        var jsMonthDay = new Date(dateInfo.year, dateInfo.month - 1, dateInfo.day);
        var today = compareDay(jsMonthDay, new Date()) === 0;
        var isSelect = getSelectedDay(jsMonthDay);
        return {
          lunar,
          date,
          today,
          isSelect,
          jsMonthDay,
          selectedForLine: isSelect
        };
      };
      var getMonthData = (date) => {
        var {
          year,
          month
        } = date;
        var dataChildArr = [];
        var daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        if (year % 4 === 0 && year % 100 !== 0 || year % 400 === 0) {
          daysInMonth[1] = 29;
        }
        var monthStartWeekDay = new Date(year, month - 1, 1).getDay();
        var monthEndWeekDay = new Date(year, month, 1).getDay() || 7;
        var preInfo = getPreMonth(0, date);
        var nextInfo = getNextMonth();
        for (var i = 0; i < monthStartWeekDay; i++) {
          var preObj = {
            type: "pre",
            day: daysInMonth[preInfo.month - 1] - (monthStartWeekDay - i - 1),
            month: preInfo.month,
            year: preInfo.year,
            lunar: "",
            today: false,
            date: new Date(),
            isSelect: false,
            jsMonthDay: new Date(),
            selectedForLine: false
          };
          var info = setDayInfo(preObj);
          preObj = _extends$8({}, preObj, info);
          dataChildArr.push(preObj);
        }
        for (var _i = 0; _i < daysInMonth[month - 1]; _i++) {
          var itemObj = {
            type: "normal",
            day: _i + 1,
            month,
            year,
            lunar: "",
            today: false,
            date: new Date(),
            isSelect: false,
            jsMonthDay: new Date(),
            selectedForLine: false
          };
          var _info = setDayInfo(itemObj);
          itemObj = _extends$8({}, itemObj, _info);
          dataChildArr.push(itemObj);
        }
        for (var _i2 = 0; _i2 < 7 - monthEndWeekDay; _i2++) {
          var nextObj = {
            type: "next",
            day: _i2 + 1,
            month: nextInfo.month,
            year: nextInfo.year,
            lunar: "",
            today: false,
            date: new Date(),
            isSelect: false,
            jsMonthDay: new Date(),
            selectedForLine: false
          };
          var _info2 = setDayInfo(nextObj);
          nextObj = _extends$8({}, nextObj, _info2);
          dataChildArr.push(nextObj);
        }
        return dataChildArr;
      };
      var dealMonthData = function(appointDay, type) {
        if (appointDay === void 0) {
          appointDay = 1;
        }
        isSelectedCurrentDate = false;
        switch (type) {
          case "PRE_MONTH":
            selectData = getPreMonth(appointDay);
            break;
          case "NEXT_MONTH":
            selectData = getNextMonth(appointDay);
            break;
        }
        dataArr.value = getMonthData(selectData);
        emit("onWeek", selectData);
        lineNum.value = Math.ceil(dataArr.value.length / 7);
      };
      var getCurrentDate = () => {
        var _props$defaultDate, _props$defaultDate2, _props$defaultDate3;
        selectData.year = (_props$defaultDate = props.defaultDate) == null ? void 0 : _props$defaultDate.getFullYear();
        selectData.month = ((_props$defaultDate2 = props.defaultDate) == null ? void 0 : _props$defaultDate2.getMonth()) + 1;
        selectData.day = (_props$defaultDate3 = props.defaultDate) == null ? void 0 : _props$defaultDate3.getDate();
      };
      var checkoutCurrentDate = () => {
        isDelay = true;
        getCurrentDate();
        dealMonthData();
      };
      checkoutCurrentDate();
      var getInfoOfWeekView = (selectedIndex, length) => {
        var indexOfLine = Math.ceil((selectedIndex + 1) / 7);
        var totalLine = Math.ceil(length / 7);
        var sliceStart = (indexOfLine - 1) * 7;
        var sliceEnd = sliceStart + 7;
        return {
          indexOfLine,
          totalLine,
          sliceStart,
          sliceEnd
        };
      };
      var dealWeekViewSliceStart = () => {
        var {
          year,
          month,
          day
        } = selectData;
        var needSelectedDate = new Date(year, month, day);
        var selectedIndex = dataArr.value.findIndex((item) => {
          if (item.selectedForLine) {
            item.selectedForLine = false;
          }
          var {
            year: itemYear,
            month: itemMonth,
            day: itemDay
          } = item;
          var date = new Date(itemYear, itemMonth, itemDay);
          if (compareDay(date, needSelectedDate) === 0) {
            item.selectedForLine = true;
          }
          return item.selectedForLine;
        });
        if (selectedIndex === -1) {
          selectedIndex = 1;
        }
        var {
          indexOfLine,
          totalLine,
          sliceStart,
          sliceEnd
        } = getInfoOfWeekView(selectedIndex, dataArr.value.length);
        offsetY.value = -((indexOfLine - 1) * itemHeight);
        if (indexOfLine === 1) {
          var preInfo = getPreMonth();
          var preDataArr = getMonthData(preInfo);
          var preDay = dataArr.value[0].day - 1 || preDataArr[preDataArr.length - 1].day;
          var preIndex = preDataArr.findIndex((item) => item.day === preDay && item.type === "normal");
          var {
            sliceStart: preSliceStart,
            sliceEnd: preSliceEnd
          } = getInfoOfWeekView(preIndex, preDataArr.length);
          lastWeek = preDataArr.slice(preSliceStart, preSliceEnd);
        } else {
          lastWeek = dataArr.value.slice(sliceStart - 7, sliceEnd - 7);
        }
        if (indexOfLine >= totalLine) {
          var nextInfo = getNextMonth();
          var nextDataArr = getMonthData(nextInfo);
          var nextDay = dataArr.value[dataArr.value.length - 1].type === "normal" ? 1 : dataArr.value[dataArr.value.length - 1].day + 1;
          var nextIndex = nextDataArr.findIndex((item) => item.day === nextDay);
          var {
            sliceStart: nextSliceStart,
            sliceEnd: nextSliceEnd
          } = getInfoOfWeekView(nextIndex, nextDataArr.length);
          nextWeek = nextDataArr.slice(nextSliceStart, nextSliceEnd);
        } else {
          nextWeek = dataArr.value.slice(sliceStart + 7, sliceEnd + 7);
        }
        return sliceStart;
      };
      var dealWeekViewData = () => {
        var sliceStart = dealWeekViewSliceStart();
        allDataArr[0].splice(sliceStart, 7, ...lastWeek);
        allDataArr[2].splice(sliceStart, 7, ...nextWeek);
      };
      var dealWeekData = (type) => {
        var {
          year,
          month,
          day
        } = type === "PRE_WEEK" ? lastWeek.find((item) => item.type === "normal") : nextWeek[0];
        selectData = {
          year,
          month,
          day
        };
        dataArr.value = getMonthData(selectData);
        offsetY.value -= itemHeight;
        lineNum.value = Math.ceil(dataArr.value.length / 7);
        dealWeekViewData();
        emit("onWeek", selectData);
      };
      var handlePreWeek = () => {
        dealWeekData("PRE_WEEK");
      };
      var handleNextWeek = () => {
        dealWeekData("NEXT_WEEK");
      };
      var handlePreMonth = () => {
        dealMonthData(1, "PRE_MONTH");
      };
      var handleNextMonth = () => {
        dealMonthData(1, "NEXT_MONTH");
      };
      var onTouchStart = (event) => {
        isShow.value = true;
        event.stopPropagation();
        isTouching.value = true;
        needAnimation.value = true;
        isClicked = false;
        touchStartPositionX = event.touches[0].clientX;
        touchStartPositionY = event.touches[0].clientY;
        touch.x = 0;
        touch.y = 0;
      };
      var onTouchMove = (event) => {
        event.stopPropagation();
        if (!contentRef.value) {
          return;
        }
        var moveX = event.touches[0].clientX - touchStartPositionX;
        var moveY = event.touches[0].clientY - touchStartPositionY;
        var {
          offsetHeight,
          offsetWidth
        } = contentRef.value;
        if (Math.abs(moveX) > Math.abs(moveY)) {
          needHeightAnimation = false;
          touch.x = moveX / offsetWidth;
        } else {
          needHeightAnimation = true;
          touch.y = moveY / offsetHeight;
        }
      };
      var onTouchEnd = (event) => {
        isShow.value = false;
        event.stopPropagation();
        if (!contentRef.value) {
          return;
        }
        isTouching.value = false;
        var {
          x,
          y
        } = touch;
        var {
          offsetHeight
        } = contentRef.value;
        if (Math.abs(x) > Math.abs(y) && Math.abs(x) > 0.1) {
          if (x > 0) {
            translateIndex.value -= 1;
            isWeekView.value ? handlePreWeek() : handlePreMonth();
          } else if (x < 0) {
            translateIndex.value += 1;
            isWeekView.value ? handleNextWeek() : handleNextMonth();
          }
          emit("touch", dataArr.value);
        }
        if (Math.abs(y) > Math.abs(x) && Math.abs(y * offsetHeight) > 50) {
          if (y > 0) {
            isWeekView.value = false;
            offsetY.value = 0;
          } else if (y < 0) {
            isWeekView.value = true;
            dealWeekViewData();
          }
        }
        emit("changeView", isWeekView.value);
        touch.x = 0;
        touch.y = 0;
      };
      var changeAllData = (val) => {
        if (isSelectedCurrentDate && !isWeekView.value)
          return;
        var preDate = getPreMonth();
        var preDataArr = getMonthData(preDate);
        var nextDate = getNextMonth();
        var nextDataArr = getMonthData(nextDate);
        if (isWeekView.value) {
          var sliceStart = dealWeekViewSliceStart();
          preDataArr.splice(sliceStart, 7, ...lastWeek);
          nextDataArr.splice(sliceStart, 7, ...nextWeek);
        }
        var delayHandle = (delay) => {
          allDataArr = [preDataArr, val, nextDataArr];
          needAnimation.value = false;
          translateIndex.value = 0;
          if (delay)
            isDelay = false;
        };
        if (isDelay) {
          delayHandle(true);
          return;
        }
        setTimeout(() => {
          delayHandle(false);
        }, isClicked && isWeekView.value ? 0 : transDurationTime * 1e3);
      };
      var setOldUnSelected = () => {
        dataArr.value.forEach((item) => {
          item.isSelect = false;
          item.selectedForLine = false;
        });
      };
      var setNewSelected = (val) => {
        var newSelectIndex = dataArr.value.findIndex((item) => item.day === val.day && item.type === "normal");
        if (dataArr.value[newSelectIndex]) {
          dataArr.value[newSelectIndex].isSelect = true;
          dataArr.value[newSelectIndex].selectedForLine = true;
        }
      };
      var checkoutDate = (val) => {
        isSelectedCurrentDate = true;
        isClicked = true;
        if (isWeekView.value && val.type !== "normal") {
          needAnimation.value = false;
          needHeightAnimation = false;
        }
        if (val.type === "next") {
          translateIndex.value += 1;
          dealMonthData(val.day, "NEXT_MONTH");
        }
        if (val.type === "pre") {
          translateIndex.value -= 1;
          dealMonthData(val.day, "PRE_MONTH");
        }
        selectData.day = val.day;
        setOldUnSelected();
        setNewSelected(val);
      };
      var onClickDay = (item) => {
        emit("select", item);
        checkoutDate(item);
      };
      vue.watch(() => props.isWeekView, () => {
        isWeekView.value = props.isWeekView;
        offsetY.value = 0;
        if (!isWeekView.value) {
          isSelectedCurrentDate = false;
          changeAllData(dataArr.value);
        }
      });
      var haveInitView = false;
      var monthChanceAllData = (newVal, oldVal) => {
        if (oldVal && isWeekView.value) {
          var newDayStr = newVal.map((item) => item.selectedForLine).join();
          var oldDayStr = oldVal.map((item) => item.selectedForLine).join();
          if (newDayStr === oldDayStr) {
            return;
          }
        }
        if (!oldVal && isWeekView.value && !haveInitView) {
          haveInitView = true;
          changeAllData(newVal);
        } else if (newVal && oldVal || !haveInitView) {
          changeAllData(newVal);
        }
      };
      vue.watch(() => dataArr.value, (newVal, oldVal) => monthChanceAllData(newVal, oldVal), {
        deep: true,
        immediate: true
      });
      vue.watch(() => isWeekView.value, (newVal) => {
        if (newVal) {
          touchAreaHeight.value = TouchAreaHeightType.close;
          touchAreaPadding.value = TouchAreaPaddingType.close;
        } else {
          touchAreaHeight.value = TouchAreaHeightType.open;
          touchAreaPadding.value = TouchAreaPaddingType.open;
        }
      }, {
        immediate: true
      });
      var renderMark = () => {
        if (!isWeekView.value) {
          return vue.createVNode("div", {
            "class": bem2("mark"),
            "style": markStyle.value
          }, [dataArr.value[8].month]);
        }
      };
      var renderDay = (item) => vue.createVNode(CalendarDay, {
        "item": item,
        "slotOfDays": props.slotOfDays,
        "onClick-day": () => {
          onClickDay(item);
        }
      }, pick(slots, ["customCard"]));
      var renderDays = (dataArr2, index2) => {
        var styleObj = JSON.parse(JSON.stringify(touchMonthBoxStyle.value));
        if (isWeekView.value) {
          if (index2 === 1 || isShow.value) {
            styleObj.visibility = "visible";
          } else {
            styleObj.visibility = "hidden";
          }
          styleObj.transitionDuration = 0;
        }
        return vue.createVNode("div", {
          "class": bem2("days"),
          "style": styleObj
        }, [dataArr2.map(renderDay)]);
      };
      var renderTouchArea = () => vue.createVNode("div", {
        "class": bem2("touch"),
        "style": touchStyle.value
      }, [vue.createVNode("div", {
        "class": bem2("touch-container"),
        "style": touchContainerStyle.value
      }, [isWeekView.value ? vue.createVNode("div", {
        "class": bem2("touch-month")
      }, null) : vue.createVNode("div", {
        "class": bem2("touch-week")
      }, [vue.createVNode(Icon, {
        "name": "bold_arrow_up",
        "color": "#CCD1DA",
        "size": 16
      }, null)])])]);
      return () => vue.createVNode("section", {
        "ref": contentRef,
        "class": bem2("month"),
        "style": bodyStyle.value,
        "onTouchstart": onTouchStart,
        "onTouchmove": onTouchMove,
        "onTouchend": onTouchEnd
      }, [vue.createVNode("section", {
        "class": bem2("container"),
        "style": touchMonthContainerStyle.value
      }, [vue.createVNode("div", {
        "class": bem2("content"),
        "style": touchBannerStyle.value
      }, [renderMark(), allDataArr.map(renderDays)])]), renderTouchArea()]);
    }
  });
  var [name$R, bem$q] = createNamespace("calendar");
  var calendarProps = {
    modelValue: {
      type: [Date],
      default: getToday
    },
    isWeekView: {
      type: Boolean,
      default: false
    },
    slotOfDays: makeArrayProp()
  };
  var _Calendar = vue.defineComponent({
    name: name$R,
    props: calendarProps,
    emits: ["select", "update:modelValue", "touch", "changeView"],
    setup(props, _ref) {
      var {
        emit,
        slots
      } = _ref;
      var [name2, bem2] = createNamespace("calendar");
      var dayOffset = vue.computed(() => 0);
      var currentDate = vue.ref(props.modelValue);
      var showMonth = vue.ref(-1);
      var lastDataArr = [];
      var getCurrentShowMonth = () => {
        showMonth.value = new Date().getMonth() + 1;
      };
      getCurrentShowMonth();
      var setSelectDate = (date) => {
        currentDate.value = date;
      };
      var currentViewDate = vue.ref(props.modelValue);
      var onSelectDay = (item) => {
        if (!item.date) {
          return;
        }
        var {
          jsMonthDay
        } = item;
        setSelectDate(jsMonthDay);
        emit("update:modelValue", cloneDates(jsMonthDay));
        emit("select", cloneDates(jsMonthDay));
      };
      var onTouchFn = (date) => {
        var {
          length
        } = lastDataArr;
        var isChange = false;
        if (length && date[8].month !== lastDataArr[8].month) {
          isChange = true;
          lastDataArr = date;
        }
        showMonth.value = date[8].month;
        if (!props.isWeekView) {
          var currentM = [date[8].year, date[8].month, date[8].day];
          currentViewDate.value = new Date(currentM.join("/"));
        }
        emit("touch", {
          date,
          isChange
        });
      };
      var onChangeView = (val) => {
        emit("changeView", val);
      };
      var onSelectWeek = (date) => {
        var {
          year,
          month,
          day
        } = date;
        if (props.isWeekView) {
          currentViewDate.value = new Date([year, month, day].join("/"));
        }
      };
      var renderCalendarBody = () => vue.createVNode(CalendarBody, {
        "date": new Date(),
        "isWeekView": props.isWeekView,
        "defaultDate": props.modelValue,
        "slotOfDays": props.slotOfDays,
        "currentDate": currentDate.value,
        "onSelect": onSelectDay,
        "onTouch": onTouchFn,
        "onOnWeek": onSelectWeek,
        "onChangeView": onChangeView
      }, pick(slots, ["customCard"]));
      return () => vue.createVNode("div", {
        "class": bem2()
      }, [vue.createVNode(CalendarHeader, {
        "isWeekView": props.isWeekView,
        "firstDayOfWeek": dayOffset.value,
        "showMonth": showMonth.value,
        "currentViewDate": currentViewDate.value
      }, null), renderCalendarBody()]);
    }
  });
  var Calendar = withInstall(_Calendar);
  var [name$Q, bem$p] = createNamespace("card");
  var cardProps = {
    header: String,
    shadow: truthProp,
    round: truthProp,
    padding: truthProp,
    margin: truthProp
  };
  var _Card = vue.defineComponent({
    name: name$Q,
    props: cardProps,
    emits: ["click"],
    setup(props, _ref) {
      var {
        emit,
        slots
      } = _ref;
      var {
        round: round2,
        shadow,
        padding,
        margin
      } = props;
      var renderBody = () => vue.createVNode("div", {
        "class": bem$p("body", [{
          padding
        }])
      }, [slots.default == null ? void 0 : slots.default()]);
      return () => vue.createVNode("div", {
        "class": bem$p([{
          round: round2,
          shadow,
          margin
        }])
      }, [renderBody()]);
    }
  });
  var Card = withInstall(_Card);
  var current = 0;
  function useId() {
    var vm = vue.getCurrentInstance();
    var {
      name: name2 = "unknown"
    } = (vm == null ? void 0 : vm.type) || {};
    return name2 + "-" + ++current;
  }
  var TAB_STATUS_KEY = Symbol();
  var useTabStatus = () => vue.inject(TAB_STATUS_KEY, null);
  function useRefs() {
    var refs = vue.ref([]);
    vue.onBeforeUpdate(() => {
      refs.value = [];
    });
    var setRefs = (index2) => (el) => {
      refs.value[index2] = el;
    };
    return [refs, setRefs];
  }
  function useEventListener$1(type, listener, options) {
    if (options === void 0) {
      options = {};
    }
    if (!inBrowser$1) {
      return;
    }
    var {
      target = window,
      passive: passive2 = false,
      capture = false
    } = options;
    var attached;
    var add = (target2) => {
      var element = vue.unref(target2);
      if (element && !attached) {
        element.addEventListener(type, listener, {
          capture,
          passive: passive2
        });
        attached = true;
      }
    };
    var remove = (target2) => {
      var element = vue.unref(target2);
      if (element && attached) {
        element.removeEventListener(type, listener, capture);
        attached = false;
      }
    };
    vue.onUnmounted(() => remove(target));
    vue.onDeactivated(() => remove(target));
    onMountedOrActivated$1(() => add(target));
    if (vue.isRef(target)) {
      vue.watch(target, (val, oldVal) => {
        remove(oldVal);
        add(val);
      });
    }
  }
  function useVisibilityChange(target, onChange) {
    if (!inBrowser$1 || !window.IntersectionObserver) {
      return;
    }
    var observer = new IntersectionObserver((entries) => {
      onChange(entries[0].intersectionRatio > 0);
    }, {
      root: document.body
    });
    var observe = () => {
      if (target.value) {
        observer.observe(target.value);
      }
    };
    var unobserve = () => {
      if (target.value) {
        observer.unobserve(target.value);
      }
    };
    vue.onDeactivated(unobserve);
    vue.onBeforeUnmount(unobserve);
    onMountedOrActivated$1(observe);
  }
  var [name$P, bem$o] = createNamespace("sticky");
  var stickyProps = {
    zIndex: numericProp,
    position: makeStringProp("top"),
    container: Object,
    offsetTop: makeNumericProp(0),
    offsetBottom: makeNumericProp(0)
  };
  var _Sticky = vue.defineComponent({
    name: name$P,
    props: stickyProps,
    emits: ["scroll", "change"],
    setup(props, _ref) {
      var {
        emit,
        slots
      } = _ref;
      var [name2, bem2] = createNamespace("sticky");
      var root = vue.ref();
      var scrollParent = useScrollParent(root);
      var state = vue.reactive({
        fixed: false,
        width: 0,
        height: 0,
        transform: 0
      });
      var offset2 = vue.computed(() => unitToPx(props.position === "top" ? props.offsetTop : props.offsetBottom));
      var rootStyle = vue.computed(() => {
        var {
          fixed,
          height: height2,
          width: width2
        } = state;
        if (fixed) {
          return {
            width: width2 + "px",
            height: height2 + "px"
          };
        }
      });
      var stickyStyle = vue.computed(() => {
        if (!state.fixed) {
          return;
        }
        var style = extend(getZIndexStyle(props.zIndex), {
          width: state.width + "px",
          height: state.height + "px",
          [props.position]: offset2.value + "px"
        });
        if (state.transform) {
          style.transform = "translate3d(0, " + state.transform + "px, 0)";
        }
        return style;
      });
      var emitScroll = (scrollTop) => emit("scroll", {
        scrollTop,
        isFixed: state.fixed
      });
      var onScroll = () => {
        if (!root.value || isHidden(root)) {
          return;
        }
        var {
          container,
          position
        } = props;
        var rootRect = useRect(root);
        var scrollTop = getScrollTop(window);
        state.width = rootRect.width;
        state.height = rootRect.height;
        if (position === "top") {
          if (container) {
            var containerRect = useRect(container);
            var difference = containerRect.bottom - offset2.value - state.height;
            state.fixed = offset2.value > rootRect.top && containerRect.bottom > 0;
            state.transform = difference < 0 ? difference : 0;
          } else {
            state.fixed = offset2.value > rootRect.top;
          }
        } else {
          var {
            clientHeight
          } = document.documentElement;
          if (container) {
            var _containerRect = useRect(container);
            var _difference = clientHeight - _containerRect.top - offset2.value - state.height;
            state.fixed = clientHeight - offset2.value < rootRect.bottom && clientHeight > _containerRect.top;
            state.transform = _difference < 0 ? -_difference : 0;
          } else {
            state.fixed = clientHeight - offset2.value < rootRect.bottom;
          }
        }
        emitScroll(scrollTop);
      };
      vue.watch(() => state.fixed, (value) => emit("change", value));
      useEventListener$1("scroll", onScroll, {
        target: scrollParent
      });
      useVisibilityChange(root, onScroll);
      return () => vue.createVNode("div", {
        "ref": root,
        "style": rootStyle.value
      }, [vue.createVNode("div", {
        "class": bem2({
          fixed: state.fixed
        }),
        "style": stickyStyle.value
      }, [slots.default == null ? void 0 : slots.default()])]);
    }
  });
  var [name$O, bem$n] = createNamespace("tab-item");
  var TabsTitle = vue.defineComponent({
    name: name$O,
    props: {
      dot: Boolean,
      type: String,
      color: String,
      title: String,
      badge: numericProp,
      isActive: Boolean,
      scrollable: Boolean,
      renderTitle: Function
    },
    emits: ["click"],
    setup(props, _ref) {
      var {
        emit
      } = _ref;
      var [name2, bem2] = createNamespace("tab-item");
      var handleClick = () => {
        emit("click");
      };
      var renderText = () => {
        var Text = vue.createVNode("span", {
          "class": bem2("text", {
            ellipsis: !props.scrollable
          })
        }, [props.renderTitle ? props.renderTitle() : props.title]);
        if (props.dot) {
          return vue.createVNode("div", {
            "class": bem2("badge__wrapper")
          }, [Text, vue.createVNode("span", {
            "class": [bem2("badge", "dot"), bem2("badge__" + props.type)]
          }, null)]);
        }
        return Text;
      };
      return () => {
        var {
          platform
        } = useConfigProvider();
        return vue.createVNode("div", {
          "role": "tab",
          "onClick": handleClick,
          "class": [bem2({
            active: props.isActive,
            pc: platform === "pc"
          })],
          "aria-selected": props.isActive
        }, [renderText()]);
      };
    }
  });
  var [name$N, bem$m] = createNamespace("tab");
  var TabsContent = vue.defineComponent({
    name: name$N,
    props: {
      count: makeRequiredProp(Number),
      inited: Boolean,
      duration: makeRequiredProp(numericProp),
      currentIndex: makeRequiredProp(Number)
    },
    emits: ["change"],
    setup(props, _ref) {
      var {
        emit,
        slots
      } = _ref;
      var [name2, bem2] = createNamespace("tab");
      return () => vue.createVNode("div", {
        "class": bem2("content")
      }, [slots.default == null ? void 0 : slots.default()]);
    }
  });
  var inBrowser = typeof window !== "undefined";
  function raf$1(fn) {
    return inBrowser ? requestAnimationFrame(fn) : -1;
  }
  function scrollLeftTo(scroller, to, duration) {
    var count = 0;
    var from = scroller.scrollLeft;
    var frames = duration === 0 ? 1 : Math.round(duration * 1e3 / 16);
    function animate() {
      scroller.scrollLeft += (to - from) / frames;
      if (++count < frames) {
        raf$1(animate);
      }
    }
    animate();
  }
  function scrollTopTo(scroller, to, duration, callback) {
    var current2 = getScrollTop(scroller);
    var isDown = current2 < to;
    var frames = duration === 0 ? 1 : Math.round(duration * 1e3 / 16);
    var step = (to - current2) / frames;
    function animate() {
      current2 += step;
      if (isDown && current2 > to || !isDown && current2 < to) {
        current2 = to;
      }
      setScrollTop(scroller, current2);
      if (isDown && current2 < to || !isDown && current2 > to) {
        raf$1(animate);
      } else if (callback) {
        raf$1(callback);
      }
    }
    animate();
  }
  var TABS_KEY = Symbol("tab");
  var tabsProps = {
    type: makeStringProp("line"),
    mode: makeStringProp(""),
    active: makeNumericProp(0),
    duration: makeNumericProp(0.3),
    ellipsis: truthProp,
    swipeThreshold: makeNumericProp(5),
    sticky: Boolean,
    offsetTop: makeNumericProp(0),
    scrollspy: Boolean,
    beforeChange: Function,
    showPageButton: Boolean
  };
  var [name$M, bem$l] = createNamespace("tab");
  var _Tab = vue.defineComponent({
    name: name$M,
    props: tabsProps,
    emits: ["click", "change", "scroll", "click-tab", "update:active"],
    setup(props, _ref) {
      var {
        emit,
        slots
      } = _ref;
      var [name2, bem2] = createNamespace("tab");
      var tabHeight;
      var stickyFixed;
      var lockScroll;
      var root = vue.ref();
      var navRef = vue.ref();
      var wrapRef = vue.ref();
      var id = useId();
      var scroller = useScrollParent(root);
      var [titleRefs, setTitleRefs] = useRefs();
      var {
        children,
        linkChildren
      } = useChildren(TABS_KEY);
      var state = vue.reactive({
        inited: false,
        lineStyle: {},
        currentIndex: -1,
        maskOpacity: {
          showLeft: false,
          showRight: false
        }
      });
      var scrollable = vue.computed(() => children.length > props.swipeThreshold || !props.ellipsis);
      vue.computed(() => ({}));
      var getTabName = (tab, index2) => {
        var _tab$name;
        return (_tab$name = tab.name) != null ? _tab$name : index2;
      };
      var currentName = vue.computed(() => {
        var activeTab = children[state.currentIndex];
        if (activeTab) {
          return getTabName(activeTab, state.currentIndex);
        }
      });
      var offsetTopPx = vue.computed(() => unitToPx(props.offsetTop));
      var scrollOffset = vue.computed(() => {
        if (props.sticky) {
          return offsetTopPx.value + tabHeight;
        }
        return 0;
      });
      var setMaskOpacity = (immediate) => {
        setTimeout(() => {
          if (!navRef.value)
            return;
          var {
            scrollLeft,
            offsetWidth,
            scrollWidth
          } = navRef.value;
          var showLeft = scrollLeft > 0;
          var showRight = scrollLeft + offsetWidth < scrollWidth;
          state.maskOpacity = {
            showLeft,
            showRight
          };
        }, immediate ? 0 : +props.duration * 1e3);
      };
      var scrollIntoView = (immediate) => {
        var nav = navRef.value;
        var titles = titleRefs.value;
        if (!scrollable.value || !nav || !titles || !titles[state.currentIndex]) {
          return;
        }
        var title = titles[state.currentIndex].$el;
        var to = title.offsetLeft - (nav.offsetWidth - title.offsetWidth) / 2;
        scrollLeftTo(nav, to, immediate ? 0 : +props.duration);
        setMaskOpacity();
      };
      var setLine = () => {
        vue.nextTick(() => {
          var titles = titleRefs.value;
          if (!titles || !titles[state.currentIndex]) {
            return;
          }
          var title = titles[state.currentIndex].$el;
          var left2 = title.offsetLeft + title.offsetWidth / 2;
          var lineStyle = {
            transform: "translateX(" + left2 + "px) translateX(-50%)"
          };
          if (props.type === "pills") {
            lineStyle.width = title.offsetWidth + "px";
          }
          state.lineStyle = lineStyle;
        });
      };
      var findAvailableTab = (index2) => {
        var diff = index2 < state.currentIndex ? -1 : 1;
        while (index2 >= 0 && index2 < children.length) {
          if (!children[index2].disabled) {
            return index2;
          }
          index2 += diff;
        }
      };
      var setCurrentIndex = (currentIndex) => {
        var newIndex = findAvailableTab(currentIndex);
        if (!isDef(newIndex)) {
          return;
        }
        var newTab = children[newIndex];
        var newName = getTabName(newTab, newIndex);
        var shouldEmitChange = state.currentIndex !== null;
        state.currentIndex = newIndex;
        if (newName !== props.active) {
          emit("update:active", newName);
          if (shouldEmitChange) {
            emit("change", newName, newTab.title);
          }
        }
      };
      var setCurrentIndexByName = (name3) => {
        var matched = children.find((tab, index3) => getTabName(tab, index3) === name3);
        var index2 = matched ? children.indexOf(matched) : 0;
        setCurrentIndex(index2);
      };
      var scrollToCurrentContent = function(immediate) {
        if (immediate === void 0) {
          immediate = false;
        }
        if (props.scrollspy) {
          var target = children[state.currentIndex].$el;
          if (target && scroller.value) {
            var to = getElementTop(target, scroller.value) - scrollOffset.value;
            lockScroll = true;
            scrollTopTo(scroller.value, to, immediate ? 0 : +props.duration, () => {
              lockScroll = false;
            });
          }
        }
      };
      var getCurrentIndexOnScroll = () => {
        for (var index2 = 0; index2 < children.length; index2++) {
          var {
            top: top2
          } = useRect(children[index2].$el);
          if (top2 > scrollOffset.value) {
            return index2 === 0 ? 0 : index2 - 1;
          }
        }
        return children.length - 1;
      };
      var onScroll = () => {
        if (props.scrollspy && !lockScroll) {
          var index2 = getCurrentIndexOnScroll();
          setCurrentIndex(index2);
        }
      };
      var onClickTab = (item, index2, event) => {
        var {
          title
        } = children[index2];
        var name3 = getTabName(children[index2], index2);
        callInterceptor(props.beforeChange, {
          args: [name3],
          done: () => {
            setCurrentIndex(index2);
            scrollToCurrentContent();
          }
        });
        route(item);
        emit("click-tab", {
          name: name3,
          title,
          event
        });
      };
      var onStickyScroll = (params) => {
        stickyFixed = params.isFixed;
        emit("scroll", params);
      };
      var scrollTo = (name3) => {
        vue.nextTick(() => {
          setCurrentIndexByName(name3);
          scrollToCurrentContent(true);
        });
      };
      var renderNav = () => children.map((item, index2) => vue.createVNode(TabsTitle, vue.mergeProps({
        "ref": setTitleRefs(index2),
        "type": props.type,
        "style": item.titleStyle,
        "class": item.titleClass,
        "isActive": index2 === state.currentIndex,
        "scrollable": scrollable.value,
        "renderTitle": item.$slots.title,
        "onClick": (event) => onClickTab(item, index2, event)
      }, pick(item, ["title", "dot", "badge"])), null));
      var clickPage = (_event, position) => {
        var nav = navRef.value;
        if (!nav) {
          return;
        }
        var {
          scrollLeft,
          offsetWidth
        } = nav;
        var to = position === "right" ? scrollLeft + offsetWidth : scrollLeft - offsetWidth;
        scrollLeftTo(nav, to, +props.duration);
        setMaskOpacity();
      };
      var renderPageMask = () => {
        if (!(props.type === "line" && navRef.value && navRef.value.scrollWidth > navRef.value.clientWidth)) {
          return;
        }
        var {
          maskOpacity: {
            showRight,
            showLeft
          }
        } = state;
        var children2 = ["left", "right"];
        return children2.map((item, index2) => {
          var active = item === "left" ? showLeft : showRight;
          return vue.createVNode("div", {
            "onClick": (event) => clickPage(event, item),
            "class": [bem2("mask", {
              active
            }), bem2("mask-" + item)]
          }, [vue.createVNode(Icon, {
            "name": "arrow",
            "color": "white",
            "size": 18
          }, null)]);
        });
      };
      var renderHeader = () => {
        var _slots$fixedNavLeft, _slots$navLeft, _slots$navRight, _slots$fixedNavRigh;
        var {
          type,
          mode,
          showPageButton
        } = props;
        var {
          platform
        } = useConfigProvider();
        return vue.createVNode("div", {
          "ref": wrapRef,
          "class": [bem2("wrap", {
            scrollable: scrollable.value,
            pc: platform === "pc"
          })]
        }, [showPageButton && renderPageMask(), (_slots$fixedNavLeft = slots["fixed-nav-left"]) == null ? void 0 : _slots$fixedNavLeft.call(slots), vue.createVNode("div", {
          "ref": navRef,
          "role": "tablist",
          "class": bem2("nav", [type, mode, {
            complete: scrollable.value
          }]),
          "aria-orientation": "horizontal"
        }, [["line", "pills"].includes(type) && vue.createVNode("div", {
          "class": bem2(type),
          "style": state.lineStyle
        }, null), (_slots$navLeft = slots["nav-left"]) == null ? void 0 : _slots$navLeft.call(slots), renderNav(), (_slots$navRight = slots["nav-right"]) == null ? void 0 : _slots$navRight.call(slots)]), (_slots$fixedNavRigh = slots["fixed-nav-right"]) == null ? void 0 : _slots$fixedNavRigh.call(slots)]);
      };
      vue.watch(() => props.active, (value) => {
        if (value !== currentName.value) {
          setCurrentIndexByName(value);
        }
      });
      vue.watch(() => children.length, () => {
        if (state.inited) {
          setCurrentIndexByName(props.active);
          setLine();
          vue.nextTick(() => {
            scrollIntoView(true);
          });
        }
      });
      vue.watch(() => state.currentIndex, () => {
        scrollIntoView();
        setLine();
        if (stickyFixed && !props.scrollspy) {
          setRootScrollTop(Math.ceil(getElementTop(root.value) - offsetTopPx.value));
        }
      });
      var init = () => {
        setCurrentIndexByName(props.active);
        vue.nextTick(() => {
          state.inited = true;
          if (wrapRef.value) {
            tabHeight = useRect(wrapRef.value).height;
          }
          scrollIntoView(true);
        });
      };
      useExpose({
        resize: setLine,
        scrollTo
      });
      vue.onActivated(setLine);
      onMountedOrActivated$1(init);
      useEventListener$1("scroll", onScroll, {
        target: scroller
      });
      linkChildren({
        id,
        props,
        setLine,
        currentName,
        scrollIntoView
      });
      return () => vue.createVNode("div", {
        "ref": root,
        "class": bem2([props.type])
      }, [props.sticky ? vue.createVNode(_Sticky, {
        "container": root.value,
        "offsetTop": offsetTopPx.value,
        "onScroll": onStickyScroll
      }, {
        default: () => [renderHeader()]
      }) : renderHeader(), vue.createVNode(TabsContent, {
        "count": children.length,
        "duration": props.duration,
        "currentIndex": state.currentIndex,
        "onChange": setCurrentIndex
      }, {
        default: () => [slots.default == null ? void 0 : slots.default()]
      })]);
    }
  });
  var [name$L, bem$k] = createNamespace("tab-item");
  var tabProps = extend({}, routeProps, {
    dot: Boolean,
    name: numericProp,
    title: String,
    titleClass: unknownProp
  });
  var _TabItem = vue.defineComponent({
    name: name$L,
    props: tabProps,
    setup(props, _ref) {
      var {
        emit,
        slots
      } = _ref;
      var [name2, bem2] = createNamespace("tab-item");
      useId();
      var {
        parent,
        index: index2
      } = useParent(TABS_KEY);
      if (!parent) {
        return;
      }
      var getName = () => {
        var _props$name;
        return (_props$name = props.name) != null ? _props$name : index2.value;
      };
      var active = vue.computed(() => {
        var isActive = getName() === parent.currentName.value;
        return isActive;
      });
      vue.watch(() => props.title, () => {
        parent.setLine();
        parent.scrollIntoView();
      });
      vue.provide(TAB_STATUS_KEY, active);
      return () => {
        if (!slots.default) {
          return;
        }
        var {
          scrollspy
        } = parent.props;
        var show = scrollspy || active.value;
        return vue.withDirectives(vue.createVNode("div", {
          "role": "tabpanel",
          "class": bem2("pane")
        }, [slots.default == null ? void 0 : slots.default()]), [[vue.vShow, show]]);
      };
    }
  });
  var TabItem = withInstall(_TabItem);
  var Tab = withInstall(_Tab);
  var [name$K, bem$j] = createNamespace("cascader");
  var cascaderProps = {
    title: String,
    options: makeArrayProp(),
    showHeader: truthProp,
    modelValue: numericProp,
    fieldNames: Object,
    placeholder: String
  };
  var _Cascader = vue.defineComponent({
    name: name$K,
    props: cascaderProps,
    emits: ["change", "finish", "click-tab", "update:modelValue"],
    setup(props, _ref) {
      var {
        slots,
        emit
      } = _ref;
      useGlobalClassName();
      var tabs = vue.ref([]);
      var activeTab = vue.ref(0);
      var {
        text: textKey,
        value: valueKey,
        children: childrenKey
      } = extend({
        text: "text",
        value: "value",
        children: "children"
      }, props.fieldNames);
      var getSelectedOptionsByValue = (options, value) => {
        for (var i = 0; i < options.length; i++) {
          if (options[i][valueKey] === value) {
            return [options[i]];
          }
          if (options[i][childrenKey]) {
            var selectedOptions = getSelectedOptionsByValue(options[i][childrenKey], value);
            if (selectedOptions) {
              return [options[i], ...selectedOptions];
            }
          }
        }
      };
      var updateTabs = () => {
        var {
          options,
          modelValue
        } = props;
        if (modelValue !== void 0) {
          var selectedOptions = getSelectedOptionsByValue(options, modelValue);
          if (selectedOptions) {
            var optionsCursor = options;
            tabs.value = selectedOptions.map((option) => {
              var tab = {
                options: optionsCursor,
                selected: option
              };
              var next = optionsCursor.find((item) => item[valueKey] === option[valueKey]);
              if (next) {
                optionsCursor = next[childrenKey];
              }
              return tab;
            });
            if (optionsCursor) {
              tabs.value.push({
                options: optionsCursor,
                selected: null
              });
            }
            vue.nextTick(() => {
              activeTab.value = tabs.value.length - 1;
            });
            return;
          }
        }
        tabs.value = [{
          options,
          selected: null
        }];
      };
      var onSelect = (option, tabIndex) => {
        if (option.disabled) {
          return;
        }
        tabs.value[tabIndex].selected = option;
        if (tabs.value.length > tabIndex + 1) {
          tabs.value = tabs.value.slice(0, tabIndex + 1);
        }
        if (option[childrenKey]) {
          var nextTab = {
            options: option[childrenKey],
            selected: null
          };
          if (tabs.value[tabIndex + 1]) {
            tabs.value[tabIndex + 1] = nextTab;
          } else {
            tabs.value.push(nextTab);
          }
          vue.nextTick(() => {
            activeTab.value++;
          });
        }
        var selectedOptions = tabs.value.map((tab) => tab.selected).filter(Boolean);
        emit("update:modelValue", option[valueKey]);
        var params = {
          value: option[valueKey],
          tabIndex,
          selectedOptions
        };
        emit("change", params);
        if (!option[childrenKey]) {
          emit("finish", params);
        }
      };
      var onClickTab = (_ref2) => {
        var {
          name: name2,
          title
        } = _ref2;
        return emit("click-tab", name2, title);
      };
      var renderHeader = () => props.showHeader ? vue.createVNode("div", {
        "class": bem$j("header")
      }, [vue.createVNode("h2", {
        "class": bem$j("title")
      }, [slots.title ? slots.title() : props.title])]) : null;
      var renderOption = (option, selectedOption, tabIndex) => {
        var {
          disabled
        } = option;
        var selected = !!(selectedOption && option[valueKey] === selectedOption[valueKey]);
        var Text = slots.option ? slots.option({
          option,
          selected
        }) : vue.createVNode("span", null, [option[textKey]]);
        return vue.createVNode("li", {
          "role": "menuitemradio",
          "class": [bem$j("option", {
            selected,
            disabled
          }), option.className],
          "tabindex": disabled ? void 0 : selected ? 0 : -1,
          "aria-checked": selected,
          "aria-disabled": disabled || void 0,
          "onClick": () => onSelect(option, tabIndex)
        }, [Text, selected ? vue.createVNode(Icon, {
          "name": "success",
          "size": 16,
          "class": bem$j("selected-icon")
        }, null) : null]);
      };
      var renderOptions = (options, selectedOption, tabIndex) => vue.createVNode("ul", {
        "role": "menu",
        "class": bem$j("options")
      }, [options.map((option) => renderOption(option, selectedOption, tabIndex))]);
      var renderTab = (tab, tabIndex) => {
        var _slots$optionsTop, _slots$optionsBottom;
        var {
          options,
          selected
        } = tab;
        var placeholder = props.placeholder || "\u8BF7\u9009\u62E9";
        var title = selected ? selected[textKey] : placeholder;
        return vue.createVNode(TabItem, {
          "title": title,
          "titleClass": bem$j("tab", {
            unselected: !selected
          })
        }, {
          default: () => [(_slots$optionsTop = slots["options-top"]) == null ? void 0 : _slots$optionsTop.call(slots, {
            tabIndex
          }), renderOptions(options, selected, tabIndex), (_slots$optionsBottom = slots["options-bottom"]) == null ? void 0 : _slots$optionsBottom.call(slots, {
            tabIndex
          })]
        });
      };
      var renderTabs = () => vue.createVNode(Tab, {
        "active": activeTab.value,
        "onUpdate:active": ($event) => activeTab.value = $event,
        "class": bem$j("tabs"),
        "onClick-tab": onClickTab
      }, {
        default: () => [tabs.value.map(renderTab)]
      });
      updateTabs();
      vue.watch(() => props.options, updateTabs, {
        deep: true
      });
      vue.watch(() => props.modelValue, (value) => {
        if (value !== void 0) {
          var values = tabs.value.map((tab) => {
            var _tab$selected;
            return (_tab$selected = tab.selected) == null ? void 0 : _tab$selected[valueKey];
          });
          if (values.includes(value)) {
            return;
          }
        }
        updateTabs();
      });
      return () => vue.createVNode("div", {
        "class": bem$j()
      }, [renderHeader(), renderTabs()]);
    }
  });
  var Cascader = withInstall(_Cascader);
  var [name$J] = createNamespace("cell");
  var cellSharedProps = {
    icon: String,
    size: String,
    title: numericProp,
    value: numericProp,
    label: numericProp,
    center: Boolean,
    isLink: Boolean,
    border: truthProp,
    required: Boolean,
    iconPrefix: String,
    valueClass: unknownProp,
    labelClass: unknownProp,
    titleClass: unknownProp,
    titleStyle: null,
    arrowDirection: String,
    clickable: {
      type: Boolean,
      default: null
    },
    noHalf: Boolean
  };
  var cellProps = extend({}, cellSharedProps, routeProps);
  var _Cell = vue.defineComponent({
    name: name$J,
    props: cellProps,
    setup(props, _ref) {
      var {
        slots
      } = _ref;
      var bem2 = createNamespace("cell")[1];
      var route2 = useRoute();
      var renderCombo = () => {
        if (slots.combo) {
          return vue.createVNode("div", {
            "class": bem2("combo")
          }, [slots.combo(), vue.createVNode("div", {
            "class": bem2("vertical")
          }, null)]);
        }
      };
      var renderLabel = () => {
        var showLabel = slots.label || isDef(props.label);
        if (showLabel) {
          return vue.createVNode("div", {
            "class": [bem2("label"), props.labelClass]
          }, [slots.label ? slots.label() : props.label]);
        }
      };
      var renderTitle = () => {
        if (slots.title || isDef(props.title)) {
          return vue.createVNode("div", {
            "class": [bem2("title"), props.titleClass],
            "style": props.titleStyle
          }, [slots.title ? slots.title() : vue.createVNode("span", null, [props.title]), renderLabel()]);
        }
      };
      var renderValue = () => {
        var slot = slots.value || slots.default;
        var hasValue = slot || isDef(props.value);
        if (hasValue) {
          var hasTitle = slots.title || isDef(props.title);
          return vue.createVNode("div", {
            "class": [bem2("value", {
              alone: !hasTitle
            }), props.valueClass]
          }, [slot ? slot() : vue.createVNode("span", null, [props.value])]);
        }
      };
      var renderLeftIcon = () => {
        if (slots.icon) {
          return slots.icon();
        }
        if (props.icon) {
          return vue.createVNode(Icon, {
            "name": props.icon,
            "class": bem2("left-icon"),
            "classPrefix": props.iconPrefix
          }, null);
        }
      };
      var renderRightIcon = () => {
        if (slots["right-icon"]) {
          return slots["right-icon"]();
        }
        if (props.isLink) {
          var _name = props.arrowDirection ? "arrow_" + props.arrowDirection : "arrow";
          return vue.createVNode(Icon, {
            "name": _name,
            "class": bem2("right-icon")
          }, null);
        }
      };
      return () => {
        var _props$clickable;
        var {
          size,
          center,
          border,
          isLink,
          noHalf
        } = props;
        var clickable = (_props$clickable = props.clickable) != null ? _props$clickable : isLink;
        var classes = {
          center,
          clickable,
          borderless: !border,
          "no-half": noHalf
        };
        if (size) {
          classes[size] = !!size;
        }
        return vue.createVNode("div", {
          "class": bem2(classes),
          "role": clickable ? "button" : void 0,
          "tabindex": clickable ? 0 : void 0,
          "onClick": route2
        }, [renderCombo(), renderLeftIcon(), renderTitle(), renderValue(), renderRightIcon(), slots.extra == null ? void 0 : slots.extra()]);
      };
    }
  });
  var Cell = withInstall(_Cell);
  var [name$I] = createNamespace("cell-group");
  var cellGroupProps = {
    title: String,
    inset: Boolean,
    border: truthProp
  };
  var _CellGroup = vue.defineComponent({
    name: name$I,
    inheritAttrs: false,
    props: cellGroupProps,
    setup(props, _ref) {
      var {
        slots,
        attrs
      } = _ref;
      var bem2 = createNamespace("cell-group")[1];
      var {
        BORDER_TOP_BOTTOM
      } = useGlobalClassName();
      var renderGroup = () => vue.createVNode("div", vue.mergeProps({
        "class": [bem2({
          inset: props.inset
        }), {
          [BORDER_TOP_BOTTOM]: props.border && !props.inset
        }]
      }, attrs), [slots.default == null ? void 0 : slots.default()]);
      var renderTitle = () => vue.createVNode("div", {
        "class": bem2(["title"], {
          inset: props.inset
        })
      }, [slots.title ? slots.title() : props.title]);
      return () => {
        if (props.title || slots.title) {
          return vue.createVNode(vue.Fragment, null, [renderTitle(), renderGroup()]);
        }
        return renderGroup();
      };
    }
  });
  var CellGroup = withInstall(_CellGroup);
  var [name$H] = createNamespace("checkbox-group");
  var checkboxGroupProps = {
    max: numericProp,
    disabled: Boolean,
    iconSize: numericProp,
    direction: String,
    modelValue: makeArrayProp(),
    checkedColor: String
  };
  var CHECKBOX_GROUP_KEY = Symbol(name$H);
  var _CheckboxGroup = vue.defineComponent({
    name: name$H,
    props: checkboxGroupProps,
    emits: ["change", "update:modelValue"],
    setup(props, _ref) {
      var {
        emit,
        slots
      } = _ref;
      var bem2 = createNamespace("checkbox-group")[1];
      var {
        children,
        linkChildren
      } = useChildren(CHECKBOX_GROUP_KEY);
      var updateValue = (value) => emit("update:modelValue", value);
      var toggleAll = function(options) {
        if (options === void 0) {
          options = {};
        }
        if (typeof options === "boolean") {
          options = {
            checked: options
          };
        }
        var {
          checked,
          skipDisabled
        } = options;
        var checkedChildren = children.filter((item) => {
          if (!item.props.bindGroup) {
            return false;
          }
          if (item.props.disabled && skipDisabled) {
            return item.checked.value;
          }
          return checked != null ? checked : !item.checked.value;
        });
        var names = checkedChildren.map((item) => item.name);
        updateValue(names);
      };
      vue.watch(() => props.modelValue, (value) => emit("change", value), {
        deep: true
      });
      useExpose({
        toggleAll
      });
      linkChildren({
        props,
        updateValue
      });
      return () => vue.createVNode("div", {
        "class": bem2([props.direction])
      }, [slots.default == null ? void 0 : slots.default()]);
    }
  });
  var checkerProps = {
    name: unknownProp,
    disabled: Boolean,
    modelValue: unknownProp,
    checkedColor: String,
    labelDisabled: Boolean,
    icon: String
  };
  var Checker = vue.defineComponent({
    props: extend({}, checkerProps, {
      bem: makeRequiredProp(Function),
      role: String,
      parent: Object,
      checked: Boolean,
      bindGroup: truthProp
    }),
    emits: ["click", "toggle"],
    setup(props, _ref) {
      var {
        emit,
        slots
      } = _ref;
      var iconRef = vue.ref();
      var iconName;
      var getParentProp = (name2) => {
        if (props.parent && props.bindGroup) {
          return props.parent.props[name2];
        }
      };
      var disabled = vue.computed(() => getParentProp("disabled") || props.disabled);
      var direction = vue.computed(() => getParentProp("direction"));
      var iconStyle = vue.computed(() => {
        var checkedColor = props.checkedColor || getParentProp("checkedColor");
        if (checkedColor && props.checked && !disabled.value) {
          return {
            color: checkedColor
          };
        }
      });
      var onClick = (event) => {
        var {
          target
        } = event;
        var icon = iconRef.value;
        var iconClicked = icon === target || (icon == null ? void 0 : icon.contains(target));
        if (!disabled.value && (iconClicked || !props.labelDisabled)) {
          emit("toggle");
        }
        emit("click", event);
      };
      var defaultIcon = () => {
        var {
          checked,
          role
        } = props;
        iconName = "" + (role === "radio" ? "single" : "multiple") + (checked ? "_selected" : disabled.value ? "_" : "_un_") + (checked ? "" : disabled.value ? "disable" : "selected");
      };
      var isChecked = () => {
        if (!props.icon) {
          defaultIcon();
        } else {
          iconName = props.icon;
        }
      };
      var renderIcon = () => {
        var {
          bem: bem2,
          checked,
          role
        } = props;
        var {
          platform
        } = useConfigProvider();
        isChecked();
        return vue.createVNode("div", {
          "ref": iconRef,
          "class": bem2("icon", [platform, iconName, {
            disabled: disabled.value,
            checked
          }])
        }, [slots.icon ? slots.icon({
          checked,
          disabled: disabled.value
        }) : vue.createVNode(Icon$1, {
          "name": iconName,
          "style": iconStyle.value
        }, null)]);
      };
      var renderLabel = () => {
        if (slots.default) {
          return vue.createVNode("span", {
            "class": props.bem("label", [{
              disabled: disabled.value
            }])
          }, [slots.default()]);
        }
      };
      return () => {
        var nodes = [renderIcon(), renderLabel()];
        return vue.createVNode("div", {
          "role": props.role,
          "class": props.bem([{
            disabled: disabled.value,
            "label-disabled": props.labelDisabled
          }, direction.value]),
          "tabindex": disabled.value ? -1 : 0,
          "aria-checked": props.checked,
          "onClick": onClick
        }, [nodes]);
      };
    }
  });
  var [name$G] = createNamespace("checkbox");
  var checkboxProps = extend({}, checkerProps, {
    bindGroup: truthProp
  });
  var _Checkbox = vue.defineComponent({
    name: name$G,
    props: checkboxProps,
    emits: ["change", "update:modelValue"],
    setup(props, _ref) {
      var {
        emit,
        slots
      } = _ref;
      var bem2 = createNamespace("checkbox")[1];
      var {
        parent
      } = useParent(CHECKBOX_GROUP_KEY);
      var setParentValue = (checked2) => {
        var {
          name: name2
        } = props;
        var {
          max: max2,
          modelValue
        } = parent.props;
        var value = modelValue.slice();
        if (checked2) {
          var overlimit = max2 && value.length >= max2;
          if (!overlimit && !value.includes(name2)) {
            value.push(name2);
            if (props.bindGroup) {
              parent.updateValue(value);
            }
          }
        } else {
          var index2 = value.indexOf(name2);
          if (index2 !== -1) {
            value.splice(index2, 1);
            if (props.bindGroup) {
              parent.updateValue(value);
            }
          }
        }
      };
      var checked = vue.computed(() => {
        if (parent && props.bindGroup) {
          return parent.props.modelValue.indexOf(props.name) !== -1;
        }
        return !!props.modelValue;
      });
      var toggle = function(newValue) {
        if (newValue === void 0) {
          newValue = !checked.value;
        }
        if (parent && props.bindGroup) {
          setParentValue(newValue);
        } else {
          emit("update:modelValue", newValue);
        }
      };
      vue.watch(() => props.modelValue, (value) => emit("change", value));
      useExpose({
        toggle,
        props,
        checked
      });
      return () => vue.createVNode(Checker, vue.mergeProps({
        "bem": bem2,
        "role": "checkbox",
        "parent": parent,
        "checked": checked.value,
        "onToggle": toggle
      }, props), pick(slots, ["default", "icon"]));
    }
  });
  var Checkbox = withInstall(_Checkbox);
  var CheckboxGroup = withInstall(_CheckboxGroup);
  var [name$F] = createNamespace("checkbox-list");
  var checkboxListProps = {
    modal: makeStringProp("list"),
    option: makeArrayProp(),
    modelValue: makeArrayProp()
  };
  var CheckboxList = vue.defineComponent({
    name: name$F,
    props: checkboxListProps,
    emits: ["click", "change", "update:modelValue"],
    setup(props, _ref) {
      var {
        emit
      } = _ref;
      var bem2 = createNamespace("checkbox-list")[1];
      var check = vue.ref(props.modelValue);
      vue.watch(() => props.modelValue, (value) => {
        check.value = value;
      });
      var handleClick = (event, item) => {
        if (!item.disabled) {
          var index2 = check.value.indexOf(item.value);
          if (index2 > -1) {
            check.value.splice(index2, 1);
          } else {
            check.value = [...check.value, item.value];
          }
          emit("click", event);
        }
      };
      var handleCheckClick = (event, item) => {
        event.stopPropagation();
        emit("click", event);
      };
      var renderCheckbox = (item) => vue.createVNode(Checkbox, {
        "name": item.value,
        "disabled": item.disabled,
        "onClick": (event) => handleCheckClick(event)
      }, null);
      var renderCell = (item, index2) => {
        var {
          platform
        } = useConfigProvider();
        return vue.createVNode(Cell, vue.mergeProps({
          "class": bem2("", {
            disabled: item.disabled,
            checked: !item.disabled && check.value.indexOf(item.value) > -1,
            pc: platform === "pc"
          }),
          "center": true,
          "clickable": true
        }, item.desc ? {
          label: item.desc
        } : {}, {
          "title": item.label,
          "onClick": (event) => handleClick(event, item)
        }), {
          icon: renderCheckbox(item)
        });
      };
      var renderCellGroup = () => vue.createVNode(CellGroup, {
        "inset": true
      }, {
        default: () => [props.option.map(renderCell)]
      });
      var updateValue = (value) => emit("update:modelValue", value);
      var handleChange = (name2) => {
        updateValue(name2);
        emit("change", name2);
      };
      var renderCheckboxGroup = () => vue.createVNode(CheckboxGroup, {
        "modelValue": check.value,
        "onUpdate:modelValue": ($event) => check.value = $event,
        "onChange": handleChange
      }, {
        default: () => [renderCellGroup()]
      });
      return () => vue.createVNode("div", {
        "class": bem2()
      }, [renderCheckboxGroup()]);
    }
  });
  var checkboxListPropKeys = Object.keys(checkboxListProps);
  var actionSheetPropsKeys$1 = Object.keys(actionSheetProps);
  var checkboxActionSheetProps = extend({}, checkboxListProps, actionSheetProps, {
    title: makeStringProp("\u6807\u9898"),
    show: Boolean,
    modelValue: makeArrayProp()
  });
  var [name$E] = createNamespace("checkbox-action-sheet");
  var CheckboxActionSheet = vue.defineComponent({
    name: name$E,
    props: checkboxActionSheetProps,
    emits: ["click", "change", "update:show", "update:modelValue"],
    setup(props, _ref) {
      var {
        attrs,
        slots,
        emit
      } = _ref;
      var bem2 = createNamespace("checkbox-action-sheet")[1];
      var updateShow = (show) => emit("update:show", show);
      var updateValue = (value) => emit("update:modelValue", value);
      vue.watch(() => props.show, (val) => {
        updateShow(val);
      });
      vue.watch(() => props.modelValue, (val) => {
        updateValue(val);
      });
      var handleClick = (event) => emit("click", event);
      var handleChange = (name2) => emit("change", name2);
      var renderContent = () => vue.createVNode(CheckboxList, vue.mergeProps({
        "onClick": handleClick,
        "onChange": handleChange,
        "onUpdate:modelValue": updateValue
      }, pick(props, checkboxListPropKeys)), null);
      return () => vue.createVNode(ActionSheet, vue.mergeProps({
        "class": bem2(),
        "onUpdate:show": updateShow
      }, attrs, pick(props, actionSheetPropsKeys$1)), {
        default: () => [renderContent()]
      });
    }
  });
  var [name$D, bem$i] = createNamespace("checkbox-pro");
  var checkboxActionSheetPropKeys = Object.keys(checkboxActionSheetProps);
  var checkboxProProps = extend({}, CheckboxList.props, CheckboxActionSheet.props, {
    modelValue: numericProp,
    show: Boolean
  });
  var _CheckboxPro = vue.defineComponent({
    name: name$D,
    props: checkboxProProps,
    setup(props, _ref) {
      var {
        attrs,
        slots
      } = _ref;
      return () => {
        var isCheckboxList = props.modal === "list";
        var Component = isCheckboxList ? CheckboxList : CheckboxActionSheet;
        var inheritProps = pick(props, isCheckboxList ? checkboxListPropKeys : checkboxActionSheetPropKeys);
        return vue.createVNode(Component, vue.mergeProps({
          "class": bem$i()
        }, inheritProps, attrs), null);
      };
    }
  });
  var CheckboxPro = withInstall(_CheckboxPro);
  var [name$C] = createNamespace("collapse");
  var COLLAPSE_KEY = Symbol(name$C);
  var collapseProps = {
    border: truthProp,
    accordion: Boolean,
    modelValue: {
      type: [String, Number, Array],
      default: ""
    }
  };
  var _Collapse = vue.defineComponent({
    name: name$C,
    props: collapseProps,
    emits: ["change", "update:modelValue"],
    setup(props, _ref) {
      var {
        emit,
        slots
      } = _ref;
      var bem2 = createNamespace("collapse")[1];
      var {
        BORDER_TOP_BOTTOM
      } = useGlobalClassName();
      var {
        linkChildren
      } = useChildren(COLLAPSE_KEY);
      var updateName = (name2) => {
        emit("change", name2);
        emit("update:modelValue", name2);
      };
      var toggle = (name2, expanded) => {
        var {
          accordion,
          modelValue
        } = props;
        if (accordion) {
          updateName(name2 === modelValue ? "" : name2);
        } else if (expanded) {
          updateName(modelValue.concat(name2));
        } else {
          updateName(modelValue.filter((activeName) => activeName !== name2));
        }
      };
      var isExpanded = (name2) => {
        var {
          accordion,
          modelValue
        } = props;
        return accordion ? modelValue === name2 : modelValue.includes(name2);
      };
      linkChildren({
        toggle,
        isExpanded
      });
      return () => vue.createVNode("div", {
        "class": [bem2(), {
          [BORDER_TOP_BOTTOM]: props.border
        }]
      }, [slots.default == null ? void 0 : slots.default()]);
    }
  });
  var Collapse = withInstall(_Collapse);
  function raf(fn) {
    return inBrowser$1 ? requestAnimationFrame(fn) : -1;
  }
  function doubleRaf(fn) {
    raf(() => raf(fn));
  }
  var [name$B] = createNamespace("collapse-item");
  var CELL_SLOTS = ["icon", "title", "value", "label", "right-icon"];
  var collapseItemProps = extend({}, cellSharedProps, {
    name: numericProp,
    isLink: truthProp,
    disabled: Boolean,
    readonly: Boolean,
    arrowDirection: {
      type: String,
      default: "down"
    }
  });
  var _CollapseItem = vue.defineComponent({
    name: name$B,
    props: collapseItemProps,
    setup(props, _ref) {
      var {
        slots
      } = _ref;
      var bem2 = createNamespace("collapse-item")[1];
      var wrapperRef = vue.ref();
      var contentRef = vue.ref();
      var {
        parent,
        index: index2
      } = useParent(COLLAPSE_KEY);
      if (!parent) {
        return;
      }
      var name2 = vue.computed(() => {
        var _props$name;
        return (_props$name = props.name) != null ? _props$name : index2.value;
      });
      var expanded = vue.computed(() => parent.isExpanded(name2.value));
      var show = vue.ref(expanded.value);
      var lazyRender = useLazyRender(show);
      var onTransitionEnd = () => {
        if (!expanded.value) {
          show.value = false;
        } else if (wrapperRef.value) {
          wrapperRef.value.style.height = "";
        }
      };
      vue.watch(expanded, (value, oldValue) => {
        if (oldValue === null) {
          return;
        }
        if (value) {
          show.value = true;
        }
        var tick = value ? vue.nextTick : raf$1;
        tick(() => {
          if (!contentRef.value || !wrapperRef.value) {
            return;
          }
          var {
            offsetHeight
          } = contentRef.value;
          if (offsetHeight) {
            var contentHeight = offsetHeight + "px";
            wrapperRef.value.style.height = value ? "0" : contentHeight;
            doubleRaf(() => {
              if (wrapperRef.value) {
                wrapperRef.value.style.height = value ? contentHeight : "0";
              }
            });
          } else {
            onTransitionEnd();
          }
        });
      });
      var toggle = function(newValue) {
        if (newValue === void 0) {
          newValue = !expanded.value;
        }
        parent.toggle(name2.value, newValue);
      };
      var onClickTitle = () => {
        if (!props.disabled && !props.readonly) {
          toggle();
        }
      };
      var renderTitle = () => {
        var {
          border,
          disabled,
          readonly
        } = props;
        var attrs = pick(props, Object.keys(cellSharedProps));
        if (readonly) {
          attrs.isLink = false;
        }
        if (disabled || readonly) {
          attrs.clickable = false;
        }
        return vue.createVNode(Cell, vue.mergeProps({
          "class": bem2("title", {
            disabled,
            expanded: expanded.value,
            borderless: !border
          }),
          "aria-expanded": String(expanded.value),
          "onClick": onClickTitle
        }, attrs), pick(slots, CELL_SLOTS));
      };
      var renderContent = lazyRender(() => vue.withDirectives(vue.createVNode("div", {
        "ref": wrapperRef,
        "class": bem2("wrapper"),
        "onTransitionend": onTransitionEnd
      }, [vue.createVNode("div", {
        "ref": contentRef,
        "class": bem2("content")
      }, [slots.default == null ? void 0 : slots.default()])]), [[vue.vShow, show.value]]));
      useExpose({
        toggle
      });
      return () => vue.createVNode("div", {
        "class": [bem2({
          border: index2.value && props.border
        })]
      }, [renderTitle(), renderContent()]);
    }
  });
  var CollapseItem = withInstall(_CollapseItem);
  var ConfigProvider = withInstall(_ConfigProvider);
  var DEFAULT_DURATION = 200;
  var MOMENTUM_LIMIT_TIME = 300;
  var MOMENTUM_LIMIT_DISTANCE = 15;
  var [name$A] = createNamespace("picker-column");
  var PICKER_KEY = Symbol(name$A);
  var isObject = (val) => val !== null && typeof val === "object";
  var isOptionDisabled = (option) => isObject(option) && option.disabled;
  function getElementTranslateY(element) {
    var {
      transform
    } = window.getComputedStyle(element);
    var translateY = transform.slice(7, transform.length - 1).split(", ")[5];
    return Number(translateY);
  }
  var Column = vue.defineComponent({
    name: name$A,
    props: {
      textKey: makeRequiredProp(String),
      readonly: Boolean,
      allowHtml: Boolean,
      className: unknownProp,
      itemHeight: makeRequiredProp(Number),
      defaultIndex: makeNumberProp(0),
      swipeDuration: makeRequiredProp(numericProp),
      initialOptions: makeArrayProp(),
      visibleItemCount: makeRequiredProp(numericProp)
    },
    emits: ["change"],
    setup(props, _ref) {
      var {
        emit,
        slots
      } = _ref;
      var bem2 = createNamespace("picker-column")[1];
      var moving;
      var startOffset;
      var touchStartTime;
      var momentumOffset;
      var transitionEndTrigger;
      var wrapper = vue.ref();
      var state = vue.reactive({
        index: props.defaultIndex,
        offset: 0,
        duration: 0,
        options: JSON.parse(JSON.stringify(props.initialOptions))
      });
      var touch = useTouch();
      var count = () => state.options.length;
      var baseOffset = () => props.itemHeight * (+props.visibleItemCount - 1) / 2;
      var adjustIndex = (index2) => {
        index2 = clamp(index2, 0, count());
        for (var i = index2; i < count(); i++) {
          if (!isOptionDisabled(state.options[i]))
            return i;
        }
        for (var _i = index2 - 1; _i >= 0; _i--) {
          if (!isOptionDisabled(state.options[_i]))
            return _i;
        }
      };
      var setIndex = (index2, emitChange) => {
        index2 = adjustIndex(index2) || 0;
        var offset2 = -index2 * props.itemHeight;
        var trigger = () => {
          if (index2 !== state.index) {
            state.index = index2;
            if (emitChange) {
              emit("change", index2);
            }
          }
        };
        if (moving && offset2 !== state.offset) {
          transitionEndTrigger = trigger;
        } else {
          trigger();
        }
        state.offset = offset2;
      };
      var setOptions = (options) => {
        if (JSON.stringify(options) !== JSON.stringify(state.options)) {
          state.options = JSON.parse(JSON.stringify(options));
          setIndex(props.defaultIndex);
        }
      };
      var getOptionText = (option) => {
        if (isObject(option) && props.textKey in option) {
          return option[props.textKey];
        }
        return option;
      };
      var setValue = (value) => {
        var {
          options
        } = state;
        for (var i = 0; i < options.length; i++) {
          if (getOptionText(options[i]) === value) {
            return setIndex(i);
          }
        }
      };
      var getValue2 = () => state.options[state.index];
      var onClickItem = (index2) => {
        if (moving || props.readonly) {
          return;
        }
        transitionEndTrigger = null;
        state.duration = DEFAULT_DURATION;
        setIndex(index2, true);
      };
      var getIndexByOffset = (offset2) => clamp(Math.round(-offset2 / props.itemHeight), 0, count() - 1);
      var onMousewheel = (e) => {
        moving = true;
        if (state.index !== count() - 1) {
          if (e.deltaY < -2) {
            state.offset += e.deltaY / 10;
          }
        }
        if (state.index !== 0) {
          if (e.deltaY > 2) {
            state.offset += e.deltaY / 10;
          }
        }
        touchStartTime = Date.now();
        setTimeout(() => {
          if (Date.now() - touchStartTime >= 180) {
            moving = false;
            var index2 = getIndexByOffset(state.offset);
            setIndex(index2, true);
          }
        }, 180);
      };
      var momentum = (distance, duration) => {
        var speed = Math.abs(distance / duration);
        distance = state.offset + speed / 3e-3 * (distance < 0 ? -1 : 1);
        var index2 = getIndexByOffset(distance);
        state.duration = +props.swipeDuration;
        setIndex(index2, true);
      };
      var stopMomentum = () => {
        moving = false;
        state.duration = 0;
        if (transitionEndTrigger) {
          transitionEndTrigger();
          transitionEndTrigger = null;
        }
      };
      var onTouchStart = (event) => {
        if (props.readonly) {
          return;
        }
        touch.start(event);
        if (moving) {
          var translateY = getElementTranslateY(wrapper.value);
          state.offset = Math.min(0, translateY - baseOffset());
          startOffset = state.offset;
        } else {
          startOffset = state.offset;
        }
        state.duration = 0;
        touchStartTime = Date.now();
        momentumOffset = startOffset;
        transitionEndTrigger = null;
      };
      var onTouchMove = (event) => {
        if (props.readonly) {
          return;
        }
        touch.move(event);
        if (touch.isVertical()) {
          moving = true;
          preventDefault(event, true);
        }
        state.offset = clamp(startOffset + touch.deltaY.value, -(count() * props.itemHeight), props.itemHeight);
        var now = Date.now();
        if (now - touchStartTime > MOMENTUM_LIMIT_TIME) {
          touchStartTime = now;
          momentumOffset = state.offset;
        }
      };
      var onTouchEnd = () => {
        if (props.readonly) {
          return;
        }
        var distance = state.offset - momentumOffset;
        var duration = Date.now() - touchStartTime;
        var allowMomentum = duration < MOMENTUM_LIMIT_TIME && Math.abs(distance) > MOMENTUM_LIMIT_DISTANCE;
        if (allowMomentum) {
          momentum(distance, duration);
          return;
        }
        var index2 = getIndexByOffset(state.offset);
        state.duration = DEFAULT_DURATION;
        setIndex(index2, true);
        setTimeout(() => {
          moving = false;
        }, 0);
      };
      var renderOptions = () => {
        var optionStyle = {
          height: props.itemHeight + "px"
        };
        return state.options.map((option, index2) => {
          var text = getOptionText(option);
          var disabled = isOptionDisabled(option);
          var data = {
            role: "button",
            style: optionStyle,
            tabindex: disabled ? -1 : 0,
            class: bem2("item", {
              disabled,
              selected: index2 === state.index
            }),
            onClick: () => onClickItem(index2)
          };
          var childData = {
            class: "",
            [props.allowHtml ? "innerHTML" : "textContent"]: text
          };
          return vue.createVNode("li", data, [slots.option ? slots.option(option) : vue.createVNode("div", childData, null)]);
        });
      };
      setIndex(state.index);
      useParent(PICKER_KEY);
      useExpose({
        state,
        setIndex,
        getValue: getValue2,
        setValue,
        setOptions,
        stopMomentum
      });
      vue.watch(() => props.initialOptions, setOptions);
      vue.watch(() => props.defaultIndex, (value) => setIndex(value));
      return () => vue.createVNode("div", {
        "class": [bem2()],
        "onTouchstart": onTouchStart,
        "onTouchmove": onTouchMove,
        "onTouchend": onTouchEnd,
        "onTouchcancel": onTouchEnd
      }, [vue.createVNode("ul", {
        "ref": wrapper,
        "style": {
          transform: "translate3d(0, " + (state.offset + baseOffset()) + "px, 0)",
          transitionDuration: state.duration + "ms",
          transitionProperty: state.duration ? "all" : "none"
        },
        "class": bem2("wrapper"),
        "onTransitionend": stopMomentum,
        "onWheel": onMousewheel
      }, [renderOptions()])]);
    }
  });
  function _extends$7() {
    _extends$7 = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends$7.apply(this, arguments);
  }
  var [name$z] = createNamespace("picker");
  var pickerSharedProps = {
    title: String,
    loading: Boolean,
    readonly: Boolean,
    allowHtml: Boolean,
    itemHeight: makeNumericProp(44),
    showToolbar: truthProp,
    swipeDuration: makeNumericProp(1e3),
    visibleItemCount: makeNumericProp(6),
    cancelButtonText: String,
    confirmButtonText: String
  };
  var pickerProps = _extends$7({}, pickerSharedProps, {
    columns: makeArrayProp(),
    valueKey: String,
    defaultIndex: makeNumericProp(0),
    toolbarPosition: makeStringProp("top"),
    columnsFieldNames: Object
  });
  var _Picker = vue.defineComponent({
    name: name$z,
    props: pickerProps,
    emits: ["confirm", "cancel", "change"],
    setup(props, _ref) {
      var {
        emit,
        slots
      } = _ref;
      var bem2 = createNamespace("picker")[1];
      var formattedColumns = vue.ref([]);
      var {
        text: textKey,
        values: valuesKey,
        children: childrenKey
      } = _extends$7({
        text: props.valueKey || "text",
        values: "values",
        children: "children"
      }, props.columnsFieldNames);
      var {
        children,
        linkChildren
      } = useChildren(PICKER_KEY);
      linkChildren();
      var itemHeight = vue.computed(() => Number(props.itemHeight));
      var dataType = vue.computed(() => {
        var firstColumn = props.columns[0];
        if (typeof firstColumn === "object") {
          if (childrenKey in firstColumn) {
            return "cascade";
          }
          if (valuesKey in firstColumn) {
            return "object";
          }
        }
        return "plain";
      });
      var formatCascade = () => {
        var formatted = [];
        var cursor = {
          [childrenKey]: props.columns
        };
        while (cursor && cursor[childrenKey]) {
          var _cursor$defaultIndex;
          var _children = cursor[childrenKey];
          var defaultIndex = (_cursor$defaultIndex = cursor.defaultIndex) != null ? _cursor$defaultIndex : +props.defaultIndex;
          while (_children[defaultIndex] && _children[defaultIndex].disabled) {
            if (defaultIndex < _children.length - 1) {
              defaultIndex++;
            } else {
              defaultIndex = 0;
              break;
            }
          }
          formatted.push({
            [valuesKey]: cursor[childrenKey],
            className: cursor.className,
            defaultIndex
          });
          cursor = _children[defaultIndex];
        }
        formattedColumns.value = formatted;
      };
      var format = () => {
        var {
          columns
        } = props;
        if (dataType.value === "plain") {
          formattedColumns.value = [{
            [valuesKey]: columns
          }];
        } else if (dataType.value === "cascade") {
          formatCascade();
        } else {
          formattedColumns.value = columns;
        }
      };
      var getIndexes = () => children.map((child) => child.state.index);
      var setColumnValues = (index2, options) => {
        var column = children[index2];
        if (column) {
          column.setOptions(options);
        }
      };
      var onCascadeChange = (columnIndex) => {
        var cursor = {
          [childrenKey]: props.columns
        };
        var indexes = getIndexes();
        for (var i = 0; i <= columnIndex; i++) {
          cursor = cursor[childrenKey][indexes[i]];
        }
        while (cursor && cursor[childrenKey]) {
          columnIndex++;
          setColumnValues(columnIndex, cursor[childrenKey]);
          cursor = cursor[childrenKey][cursor.defaultIndex || 0];
        }
      };
      var getChild = (index2) => children[index2];
      var getColumnValue = (index2) => {
        var column = getChild(index2);
        if (column) {
          return column.getValue();
        }
      };
      var setColumnValue = (index2, value) => {
        var column = getChild(index2);
        if (column) {
          column.setValue(value);
          if (dataType.value === "cascade") {
            onCascadeChange(index2);
          }
        }
      };
      var getColumnIndex = (index2) => {
        var column = getChild(index2);
        if (column) {
          return column.state.index;
        }
      };
      var setColumnIndex = (columnIndex, optionIndex) => {
        var column = getChild(columnIndex);
        if (column) {
          column.setIndex(optionIndex);
          if (dataType.value === "cascade") {
            onCascadeChange(columnIndex);
          }
        }
      };
      var getColumnValues = (index2) => {
        var column = getChild(index2);
        if (column) {
          return column.state.options;
        }
      };
      var getValues = () => children.map((child) => child.getValue());
      var setValues = (values) => {
        values.forEach((value, index2) => {
          setColumnValue(index2, value);
        });
      };
      var setIndexes = (indexes) => {
        indexes.forEach((optionIndex, columnIndex) => {
          setColumnIndex(columnIndex, optionIndex);
        });
      };
      var emitAction = (event) => {
        if (dataType.value === "plain") {
          emit(event, getColumnValue(0), getColumnIndex(0));
        } else {
          emit(event, getValues(), getIndexes());
        }
      };
      var onChange = (columnIndex) => {
        if (dataType.value === "cascade") {
          onCascadeChange(columnIndex);
        }
        if (dataType.value === "plain") {
          emit("change", getColumnValue(0), getColumnIndex(0));
        } else {
          emit("change", getValues(), columnIndex);
        }
      };
      var confirm = () => {
        children.forEach((child) => child.stopMomentum());
        emitAction("confirm");
      };
      var cancel = () => emitAction("cancel");
      var renderTitle = () => {
        if (slots.title) {
          return slots.title();
        }
        if (props.title) {
          return vue.createVNode("div", {
            "class": bem2("title")
          }, [props.title]);
        }
      };
      var renderCancel = () => {
        var text = props.cancelButtonText || "\u53D6\u6D88";
        return vue.createVNode("button", {
          "type": "button",
          "class": [bem2("cancel")],
          "onClick": cancel
        }, [slots.cancel ? slots.cancel() : text]);
      };
      var renderConfirm = () => {
        var text = props.confirmButtonText || "\u786E\u5B9A";
        return vue.createVNode("button", {
          "type": "button",
          "class": [bem2("confirm")],
          "onClick": confirm
        }, [slots.confirm ? slots.confirm() : text]);
      };
      var renderToolbar = () => {
        if (props.showToolbar) {
          var slot = slots.toolbar || slots.default;
          return vue.createVNode("div", {
            "class": bem2("toolbar")
          }, [slot ? slot() : [renderCancel(), renderTitle(), renderConfirm()]]);
        }
      };
      var renderColumnItems = () => formattedColumns.value.map((item, columnIndex) => {
        var _item$defaultIndex;
        return vue.createVNode(Column, {
          "textKey": textKey,
          "readonly": props.readonly,
          "allowHtml": props.allowHtml,
          "className": item.className,
          "itemHeight": itemHeight.value,
          "defaultIndex": (_item$defaultIndex = item.defaultIndex) != null ? _item$defaultIndex : +props.defaultIndex,
          "swipeDuration": props.swipeDuration,
          "initialOptions": item[valuesKey],
          "visibleItemCount": props.visibleItemCount,
          "onChange": () => onChange(columnIndex)
        }, {
          option: slots.option
        });
      });
      var renderColumns = () => {
        var wrapHeight = itemHeight.value * +props.visibleItemCount;
        var frameStyle = {
          height: itemHeight.value + "px"
        };
        var columnsStyle = {
          height: wrapHeight + "px"
        };
        var maskStyle = {
          backgroundSize: "100% " + (wrapHeight - itemHeight.value) / 2 + "px"
        };
        return vue.createVNode("div", {
          "class": bem2("columns"),
          "style": columnsStyle,
          "onTouchmove": preventDefault
        }, [renderColumnItems(), vue.createVNode("div", {
          "class": bem2("mask"),
          "style": maskStyle
        }, null), vue.createVNode("div", {
          "class": [bem2("frame")],
          "style": frameStyle
        }, null)]);
      };
      vue.watch(() => props.columns, format, {
        immediate: true
      });
      useExpose({
        confirm,
        getValues,
        setValues,
        getIndexes,
        setIndexes,
        getColumnIndex,
        setColumnIndex,
        getColumnValue,
        setColumnValue,
        getColumnValues,
        setColumnValues
      });
      return () => {
        var _slots$columnsTop, _slots$columnsBottom;
        return vue.createVNode("div", {
          "class": bem2()
        }, [props.toolbarPosition === "top" ? renderToolbar() : null, (_slots$columnsTop = slots["columns-top"]) == null ? void 0 : _slots$columnsTop.call(slots), renderColumns(), (_slots$columnsBottom = slots["columns-bottom"]) == null ? void 0 : _slots$columnsBottom.call(slots), props.toolbarPosition === "bottom" ? renderToolbar() : null]);
      };
    }
  });
  function _extends$6() {
    _extends$6 = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends$6.apply(this, arguments);
  }
  var sharedProps = _extends$6({}, pickerSharedProps, {
    filter: Function,
    columnsOrder: Array,
    formatter: {
      type: Function,
      default: (type, value) => value
    }
  });
  var pickerInheritKeys = Object.keys(pickerSharedProps);
  function times(n, iteratee) {
    var index2 = -1;
    var result = Array(n);
    while (++index2 < n) {
      result[index2] = iteratee(index2);
    }
    return result;
  }
  function getTrueValue(value) {
    if (!value) {
      return 0;
    }
    while (Number.isNaN(parseInt(value, 10))) {
      if (value.length > 1) {
        value = value.slice(1);
      } else {
        return 0;
      }
    }
    return parseInt(value, 10);
  }
  var getMonthEndDay = (year, month) => 32 - new Date(year, month - 1, 32).getDate();
  var getYearWeek = (date) => {
    var chooseDate = date;
    var firstDay = new Date(chooseDate.getFullYear(), 0, 1);
    var d = Math.round((chooseDate.valueOf() - firstDay.valueOf()) / (24 * 60 * 60 * 1e3));
    var day = firstDay.getDay();
    if (day === 0) {
      day = 7;
    }
    var week = Math.ceil((d + (day + 1 - 1)) / 7);
    return week;
  };
  var addDate = (date, days) => {
    var d = new Date(date.valueOf());
    d.setDate(d.getDate() + days);
    return d;
  };
  var formatMonth = (date) => padZero(date.getMonth() + 1) + "." + padZero(date.getDate());
  var weekDate = (year, weekNo) => {
    var oneDay = new Date(year, 0, 1).getDay();
    if (oneDay === 0) {
      oneDay = 7;
    }
    var oneFirstDay;
    var oneLastDay;
    if (oneDay === 1) {
      oneFirstDay = new Date(year, 0, 1);
      oneLastDay = new Date(year, 0, 7);
    } else {
      var jj = 8 - oneDay;
      oneFirstDay = new Date(year - 1, 11, 31 - oneDay + 2);
      oneLastDay = new Date(year, 0, jj);
    }
    var firstDay;
    var lastDay;
    if (weekNo === 1) {
      firstDay = oneFirstDay;
      lastDay = oneLastDay;
    } else {
      firstDay = addDate(oneFirstDay, (weekNo - 1) * 7);
      lastDay = addDate(firstDay, 6);
    }
    return [firstDay, lastDay];
  };
  function getBoundary(type, value, boundary) {
    var year = boundary.getFullYear();
    var month = 1;
    var week = 1;
    var date = 1;
    var hour = 0;
    var minute = 0;
    if (type === "min") {
      week = getYearWeek(new Date(value.getFullYear(), value.getMonth(), 1));
    }
    if (type === "max") {
      var monthEndDay = getMonthEndDay(value.getFullYear(), value.getMonth() + 1);
      month = 12;
      week = getYearWeek(new Date(value.getFullYear(), value.getMonth(), monthEndDay));
      date = monthEndDay;
      hour = 23;
      minute = 59;
    }
    if (value.getFullYear() === year) {
      month = boundary.getMonth() + 1;
      if (value.getMonth() + 1 === month) {
        date = boundary.getDate();
        week = getYearWeek(new Date(year, month - 1, date));
        if (value.getDate() === date) {
          hour = boundary.getHours();
          if (value.getHours() === hour) {
            minute = boundary.getMinutes();
          }
        }
      }
    }
    return {
      [type + "Year"]: year,
      [type + "Month"]: month,
      [type + "Week"]: week,
      [type + "Date"]: date,
      [type + "Hour"]: hour,
      [type + "Minute"]: minute
    };
  }
  var getValue = (type, originColumns, indexes) => {
    var index2 = 0;
    originColumns.forEach((column, columnIndex) => {
      if (type === column.type) {
        index2 = columnIndex;
      }
    });
    var {
      values
    } = originColumns[index2];
    return getTrueValue(values[indexes[index2]]);
  };
  var getWeekValue = function(year, month, originColumns, indexes, isMoveWeek) {
    if (isMoveWeek === void 0) {
      isMoveWeek = true;
    }
    var index2 = 0;
    var currentDay;
    originColumns.forEach((column, columnIndex) => {
      if (column.type === "week") {
        index2 = columnIndex;
      }
    });
    var {
      values
    } = originColumns[index2];
    var weekRangeStr = values[indexes[index2]];
    var weekStartDate = weekRangeStr.split("-")[0];
    var weekEndDate = weekRangeStr.split("-")[1];
    var currentMonth = Number(weekStartDate.split(".")[0]);
    if (month === currentMonth) {
      currentDay = Number(weekStartDate.split(".")[1]);
    } else {
      currentDay = Number(weekEndDate.split(".")[1]);
    }
    if (!isMoveWeek) {
      var currentWeekNo = getYearWeek(new Date(year, month - 1, 1));
      var currentWeekRange = weekDate(year, currentWeekNo);
      var _weekStartDate = currentWeekRange[0];
      var _weekEndDate = currentWeekRange[1];
      if (month === _weekStartDate.getMonth() + 1) {
        currentDay = _weekStartDate.getDate();
      } else {
        currentDay = _weekEndDate.getDate();
      }
      return {
        month,
        day: currentDay
      };
    }
    return {
      month: currentMonth,
      day: currentDay
    };
  };
  var Picker = withInstall(_Picker);
  function _extends$5() {
    _extends$5 = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends$5.apply(this, arguments);
  }
  var [name$y] = createNamespace("date-picker");
  var currentYear = new Date().getFullYear();
  var datePickerProps = _extends$5({}, sharedProps, {
    type: makeStringProp("datetime"),
    modelValue: Date,
    minDate: {
      type: Date,
      default: () => new Date(currentYear - 10, 0, 1),
      validator: isDate
    },
    maxDate: {
      type: Date,
      default: () => new Date(currentYear + 10, 11, 31),
      validator: isDate
    }
  });
  var DatePicker = vue.defineComponent({
    name: name$y,
    props: datePickerProps,
    emits: ["confirm", "cancel", "change", "update:modelValue"],
    setup(props, _ref) {
      var {
        attrs,
        slots,
        emit,
        expose
      } = _ref;
      var formatValue = (value) => {
        if (isDate(value)) {
          var timestamp = clamp(value.getTime(), props.minDate.getTime(), props.maxDate.getTime());
          return new Date(timestamp);
        }
        return void 0;
      };
      var picker = vue.ref();
      var currentDate = vue.ref(formatValue(props.modelValue));
      var ranges = vue.computed(() => {
        var {
          maxYear: maxYear2,
          maxDate,
          maxMonth,
          maxHour,
          maxMinute,
          maxWeek
        } = getBoundary("max", currentDate.value || props.minDate, props.maxDate);
        var {
          minYear: minYear2,
          minDate,
          minMonth,
          minHour,
          minMinute,
          minWeek
        } = getBoundary("min", currentDate.value || props.minDate, props.minDate);
        var result = [{
          type: "year",
          range: [minYear2, maxYear2]
        }, {
          type: "month",
          range: [minMonth, maxMonth]
        }, {
          type: "day",
          range: [minDate, maxDate]
        }, {
          type: "hour",
          range: [minHour, maxHour]
        }, {
          type: "minute",
          range: [minMinute, maxMinute]
        }, {
          type: "week",
          range: [minWeek, maxWeek]
        }];
        switch (props.type) {
          case "date":
            result = result.slice(0, 3);
            break;
          case "year-month":
            result = result.slice(0, 2);
            break;
          case "dateweek":
            result = [...result.slice(0, 2), result[5]];
            break;
          case "month-day":
            result = result.slice(1, 3);
            break;
          case "datehour":
            result = result.slice(0, 4);
            break;
          case "datetime":
            result = result.slice(0, 5);
            break;
        }
        if (props.columnsOrder) {
          var columnsOrder = props.columnsOrder.concat(result.map((column) => column.type));
          result.sort((a, b) => columnsOrder.indexOf(a.type) - columnsOrder.indexOf(b.type));
        }
        return result;
      });
      var turnWeekToDateStr = (currentYear2, week) => {
        var dateArr = weekDate(currentYear2, week);
        return formatMonth(dateArr[0]) + "-" + formatMonth(dateArr[1]);
      };
      var originColumns = vue.computed(() => ranges.value.map((_ref2) => {
        var {
          type,
          range: rangeArr
        } = _ref2;
        var values;
        if (type === "week") {
          var _currentDate$value;
          var _currentYear = (_currentDate$value = currentDate.value) == null ? void 0 : _currentDate$value.getFullYear();
          values = times(rangeArr[1] - rangeArr[0] + 1, (index2) => padZero(rangeArr[0] + index2));
          values = values.map((item) => turnWeekToDateStr(_currentYear, Number(item)));
        } else {
          values = times(rangeArr[1] - rangeArr[0] + 1, (index2) => padZero(rangeArr[0] + index2));
        }
        if (props.filter) {
          values = props.filter(type, values);
        }
        return {
          type,
          values
        };
      }));
      var columns = vue.computed(() => originColumns.value.map((column) => ({
        values: column.values.map((value) => props.formatter(column.type, value))
      })));
      var updateColumnValue = () => {
        var value = currentDate.value || props.minDate;
        var {
          formatter
        } = props;
        var values = originColumns.value.map((column) => {
          switch (column.type) {
            case "year":
              return formatter("year", "" + value.getFullYear());
            case "month":
              return formatter("month", padZero(value.getMonth() + 1));
            case "day":
              return formatter("day", padZero(value.getDate()));
            case "hour":
              return formatter("hour", padZero(value.getHours()));
            case "minute":
              return formatter("minute", padZero(value.getMinutes()));
            case "week":
              return formatter("week", turnWeekToDateStr(value == null ? void 0 : value.getFullYear(), getYearWeek(value)));
            default:
              return "";
          }
        });
        vue.nextTick(() => {
          var _picker$value;
          (_picker$value = picker.value) == null ? void 0 : _picker$value.setValues(values);
        });
      };
      var updateInnerValue = () => {
        var {
          type
        } = props;
        var indexes = picker.value.getIndexes();
        var year;
        var month;
        var day;
        if (type === "month-day") {
          year = (currentDate.value || props.minDate).getFullYear();
          month = getValue("month", originColumns.value, indexes);
          day = getValue("day", originColumns.value, indexes);
        } else if (type === "dateweek") {
          var _currentDate$value2, _currentDate$value3;
          var isMoveWeek = true;
          var _currentYear2 = (_currentDate$value2 = currentDate.value) == null ? void 0 : _currentDate$value2.getFullYear();
          var currentMonth = ((_currentDate$value3 = currentDate.value) == null ? void 0 : _currentDate$value3.getMonth()) + 1;
          year = getValue("year", originColumns.value, indexes);
          month = getValue("month", originColumns.value, indexes);
          isMoveWeek = month === currentMonth && year === _currentYear2;
          ({
            day
          } = getWeekValue(year, month, originColumns.value, indexes, isMoveWeek));
        } else {
          year = getValue("year", originColumns.value, indexes);
          month = getValue("month", originColumns.value, indexes);
          day = type === "year-month" ? 1 : getValue("day", originColumns.value, indexes);
        }
        var maxDay = getMonthEndDay(year, month);
        day = day > maxDay ? maxDay : day;
        var hour = 0;
        var minute = 0;
        if (type === "datehour") {
          hour = getValue("hour", originColumns.value, indexes);
        }
        if (type === "datetime") {
          hour = getValue("hour", originColumns.value, indexes);
          minute = getValue("minute", originColumns.value, indexes);
        }
        var value = new Date(year, month - 1, day, hour, minute);
        currentDate.value = formatValue(value);
      };
      var onConfirm = () => {
        emit("update:modelValue", currentDate.value);
        emit("confirm", currentDate.value);
      };
      var onCancel = () => emit("cancel");
      var onChange = () => {
        updateInnerValue();
        vue.nextTick(() => {
          vue.nextTick(() => emit("change", currentDate.value));
        });
      };
      vue.onMounted(() => {
        updateColumnValue();
        vue.nextTick(updateInnerValue);
      });
      vue.watch(columns, updateColumnValue);
      vue.watch(currentDate, (value, oldValue) => emit("update:modelValue", oldValue ? value : null));
      vue.watch(() => [props.filter, props.maxDate], updateInnerValue);
      vue.watch(() => props.minDate, () => {
        vue.nextTick(updateInnerValue);
      });
      vue.watch(() => props.modelValue, (value) => {
        var _currentDate$value4;
        value = formatValue(value);
        if (value && value.valueOf() !== ((_currentDate$value4 = currentDate.value) == null ? void 0 : _currentDate$value4.valueOf())) {
          currentDate.value = value;
        }
      });
      var getYearWeekNo = () => getYearWeek(currentDate.value);
      var getWeekRanges = () => weekDate(currentDate.value.getFullYear(), getYearWeekNo());
      useExpose({
        getPicker: () => picker.value,
        getYearWeekNo,
        getWeekRanges
      });
      return () => vue.createVNode(Picker, vue.mergeProps({
        "ref": picker,
        "columns": columns.value,
        "onChange": onChange,
        "onCancel": onCancel,
        "onConfirm": onConfirm
      }, pick(props, pickerInheritKeys)), slots);
    }
  });
  var [name$x, bem$h] = createNamespace("datetime-picker");
  var datePickerPropKeys = Object.keys(DatePicker.props);
  var datetimePickerProps = extend({}, DatePicker.props, {
    modelValue: [String, Date]
  });
  var _DatetimePicker = vue.defineComponent({
    name: name$x,
    props: datetimePickerProps,
    setup(props, _ref) {
      var {
        attrs,
        slots
      } = _ref;
      var bem2 = createNamespace("datetime-picker")[1];
      var root = vue.ref();
      useExpose({
        getPicker: () => {
          var _root$value;
          return (_root$value = root.value) == null ? void 0 : _root$value.getPicker();
        },
        getYearWeekNo: () => {
          var _root$value2;
          return (_root$value2 = root.value) == null ? void 0 : _root$value2.getYearWeekNo();
        },
        getWeekRanges: () => {
          var _root$value3;
          return (_root$value3 = root.value) == null ? void 0 : _root$value3.getWeekRanges();
        }
      });
      return () => {
        var Component = DatePicker;
        var inheritProps = pick(props, datePickerPropKeys);
        return vue.createVNode(Component, vue.mergeProps({
          "ref": root,
          "class": bem2()
        }, inheritProps, attrs), slots);
      };
    }
  });
  var DatetimePicker = withInstall(_DatetimePicker);
  function usePopupState() {
    var state = vue.reactive({
      show: false
    });
    var toggle = (show) => {
      state.show = show;
    };
    var open = (props) => {
      Object.assign(state, props, {
        transitionAppear: true
      });
      toggle(true);
    };
    var close = () => toggle(false);
    useExpose({
      open,
      close,
      toggle
    });
    return {
      open,
      close,
      state,
      toggle
    };
  }
  function mountComponent(RootComponent) {
    var app = vue.createApp(RootComponent);
    var root = document.createElement("div");
    document.body.appendChild(root);
    return {
      instance: app.mount(root),
      unmount() {
        app.unmount();
        document.body.removeChild(root);
      }
    };
  }
  var [name$w, bem$g] = createNamespace("dialog");
  var dialogProps = extend({}, popupSharedProps, {
    title: String,
    theme: String,
    width: numericProp,
    message: [String, Function],
    callback: Function,
    allowHtml: Boolean,
    className: unknownProp,
    transition: makeStringProp("cf-bounce"),
    messageAlign: String,
    showCancelButton: truthProp,
    cancelButtonText: makeStringProp("\u53D6\u6D88"),
    cancelButtonColor: String,
    confirmButtonText: makeStringProp("\u786E\u8BA4"),
    confirmButtonColor: String,
    showConfirmButton: truthProp,
    closeOnClickOverlay: Boolean,
    teleport: [String, Object]
  });
  var popupInheritKeys = [
    ...popupSharedPropKeys,
    "transition"
  ];
  var CfDialog = vue.defineComponent({
    name: name$w,
    props: dialogProps,
    emits: ["confirm", "cancel", "update:show"],
    setup(props, _ref) {
      var {
        emit,
        slots
      } = _ref;
      var [name2, bem2] = createNamespace("dialog");
      var {
        BORDER_LEFT,
        BORDER_TOP
      } = useGlobalClassName();
      var loading = vue.reactive({
        confirm: false,
        cancel: false
      });
      var updateShow = (value) => emit("update:show", value);
      var close = (action) => {
        updateShow(false);
        props.callback == null ? void 0 : props.callback(action);
      };
      var getActionHandler = (action) => () => {
        if (!props.show) {
          return;
        }
        emit(action);
        if (props.beforeClose) {
          loading[action] = true;
          callInterceptor(props.beforeClose, {
            args: [action],
            done() {
              close(action);
              loading[action] = false;
            },
            canceled() {
              loading[action] = false;
            }
          });
        } else {
          close(action);
        }
      };
      var onCancel = getActionHandler("cancel");
      var onConfirm = getActionHandler("confirm");
      var renderTitle = () => {
        var title = slots.title ? slots.title() : props.title;
        if (title) {
          return vue.createVNode("div", {
            "class": bem2("header")
          }, [vue.createVNode("div", {
            "class": bem2("title", {
              "has-message": props.message || slots.default
            })
          }, [title])]);
        }
      };
      var renderMessage = (hasTitle) => {
        var {
          message,
          allowHtml,
          messageAlign
        } = props;
        var classNames = bem2("message", {
          "has-title": hasTitle,
          [messageAlign]: messageAlign
        });
        var content = isFunction(message) ? message() : message;
        if (allowHtml && typeof content === "string") {
          return vue.createVNode("div", {
            "class": classNames,
            "innerHTML": content
          }, null);
        }
        return vue.createVNode("div", {
          "class": classNames
        }, [content]);
      };
      var renderContent = () => {
        if (slots.default) {
          return vue.createVNode("div", {
            "class": bem2("body")
          }, [slots.default()]);
        }
        var {
          title,
          message,
          allowHtml
        } = props;
        if (message) {
          var hasTitle = !!(title || slots.title);
          return vue.createVNode("div", {
            "key": allowHtml ? 1 : 0,
            "class": bem2("body", {
              isolated: !hasTitle
            })
          }, [renderMessage(hasTitle)]);
        }
      };
      var renderButtons = () => vue.createVNode("div", {
        "class": [BORDER_TOP, bem2("footer")]
      }, [props.showCancelButton && vue.createVNode("div", {
        "class": [bem2("button", {
          "only-one": !props.showConfirmButton
        }), bem2("cancel")],
        "style": {
          color: props.cancelButtonColor
        },
        "onClick": onCancel
      }, [props.cancelButtonText]), props.showConfirmButton && vue.createVNode("div", {
        "class": [bem2("button", {
          "only-one": !props.showCancelButton
        }), bem2("confirm"), {
          [BORDER_LEFT]: props.showCancelButton
        }],
        "style": {
          color: props.confirmButtonColor
        },
        "onClick": onConfirm
      }, [props.confirmButtonText])]);
      var renderRoundButtons = () => vue.createVNode(ActionBar, {
        "class": bem2("footer")
      }, {
        default: () => [props.showCancelButton && vue.createVNode(ActionBarButton, {
          "text": props.cancelButtonText,
          "class": bem2("cancel"),
          "color": props.cancelButtonColor,
          "loading": loading.cancel,
          "onClick": onCancel
        }, null), props.showConfirmButton && vue.createVNode(ActionBarButton, {
          "text": props.confirmButtonText,
          "class": bem2("confirm"),
          "color": props.confirmButtonColor,
          "loading": loading.confirm,
          "onClick": onConfirm
        }, null)]
      });
      var renderFooter = () => {
        if (slots.footer) {
          return slots.footer();
        }
        return props.theme === "round-button" ? renderRoundButtons() : renderButtons();
      };
      console.log(props.show);
      return () => {
        var {
          width: width2,
          title,
          theme,
          message,
          className
        } = props;
        console.log(props.show);
        return vue.createVNode(Popup, vue.mergeProps({
          "class": [bem2(), className],
          "style": {
            width: addUnit(width2)
          },
          "onUpdate:show": updateShow
        }, pick(props, popupInheritKeys)), {
          default: () => [renderTitle(), renderContent(), renderFooter()]
        });
      };
    }
  });
  var Dialog = withInstall(CfDialog);
  var instance$1;
  function initInstance$1() {
    var Wrapper = {
      setup() {
        var {
          state,
          toggle
        } = usePopupState();
        return () => vue.createVNode(CfDialog, vue.mergeProps(state, {
          "onUpdate:show": toggle
        }), null);
      }
    };
    ({
      instance: instance$1
    } = mountComponent(Wrapper));
  }
  function DialogFunction(options) {
    if (!inBrowser$1) {
      return Promise.resolve();
    }
    return new Promise((resolve, reject) => {
      if (!instance$1) {
        initInstance$1();
      }
      instance$1.open(extend({}, Dialog.currentOptions, options, {
        callback: (action) => {
          (action === "confirm" ? resolve : reject)(action);
        }
      }));
    });
  }
  Dialog.defaultOptions = {
    title: "",
    width: "",
    theme: null,
    message: "",
    overlay: true,
    callback: null,
    teleport: "body",
    className: "",
    allowHtml: false,
    lockScroll: true,
    transition: void 0,
    beforeClose: null,
    overlayClass: "",
    overlayStyle: void 0,
    messageAlign: "",
    cancelButtonText: "\u53D6\u6D88",
    cancelButtonColor: null,
    confirmButtonText: "\u786E\u5B9A",
    confirmButtonColor: null,
    showConfirmButton: true,
    showCancelButton: true,
    closeOnClickOverlay: false
  };
  Dialog.currentOptions = extend({}, Dialog.defaultOptions);
  Dialog.alert = DialogFunction;
  Dialog.confirm = (options) => DialogFunction(extend({
    showCancelButton: true
  }, options));
  Dialog.close = () => {
    if (instance$1) {
      instance$1.toggle(false);
    }
  };
  Dialog.setDefaultOptions = (options) => {
    extend(Dialog.currentOptions, options);
  };
  Dialog.resetDefaultOptions = () => {
    Dialog.currentOptions = extend({}, Dialog.defaultOptions);
  };
  Dialog.install = (app) => {
    app.use(Dialog.Component);
    app.config.globalProperties.$dialog = Dialog;
  };
  var activity_over = "data:image/png;base64,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";
  var activity_to_start = "data:image/png;base64,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";
  var error_data = "data:image/png;base64,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";
  var error_file = "data:image/png;base64,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";
  var error_image = "data:image/png;base64,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";
  var error_net = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALQAAAC0CAYAAAA9zQYyAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAtKADAAQAAAABAAAAtAAAAABW1ZZ5AAAzxElEQVR4Ae1dB3gVVfa/d2ZeSQOVhEBCCx1SALGhKEloYm9Y14L+V5NQhF0rqPss6FqwAQHX3bWvBXRdG9KSILroIgJJaAkkQEJIoaXnlZn7/90HwUfyXvL6e0lmvu99b2ZuO/fMmTPnnnYJUQ8VAyoGVAyoGFAxoGJAxYCKARUDKgZUDKgYUDGgYkDFgIoBFQMqBlQMqBhQMeA7DIi+61rt2RMMpNz2ZHzciIu/GJwwvqRox49FnvTVldoKXWmy/pzr9OmfiYwx6u6YVDZfSgg9jzLhiLt9dMV2KkH74KlPnW445yjZmpt684Lb3Ol+4vTHRzKFPoW2u9d8tnC7O3101TYqQfvgyctELzPCziFESb/nHoPelSE4V1cIuY8Q1hsP5wNKKXOlfVevqxK0Dyhg3YrHqgVCZxNGLyppMN7iyhBWAqYkmlJykAriKlfaqnUJUQnaR1QgiMJ+3jVjZM7997+lcXaYabPf1KHRWYSRX9Z9+twuZ9up9U5iQCVoH1GCFBWdhxVhFkSIc/cdP5Ds7DDykcNxaBcBVpPlbBu13u8YUAn6d1x49WzV4jlGKpLZ6DSHEeVlZzUeAyIG7IMYXUwVVXZ254G4rVZyZ7Cu2GbS9AXjZaa8TQX2Yw+mn7dihaGuPTxcfZshcuwwcsJgMFjaq6uWn4kB6cxL9crbGBCJZiejxleYQu49opH7o/8d7Y3x9ceGI1+3V8lO+bQ7DN10GiJ8+a7hhJ1i9ZaKAe9hgOumnRU73BkVuutxqdMfPzpx+vzJ7rTvLG1UkaODP8nJty44z6KwGZSxa6FTWRt2tn7m138zNHTwabkNvkrQbqMusA1Tb5k/jcnsz4BiAiXsGB7k0wqV1meveG5PYCEL7OgqQQcW/y6PnnrLY1OIQg0wH44BV6aM0kpCSVr2Zy9853JnnbCBuijsYA8Vzko9FaIMoURIpxr6W3hI9+Kv/vlobQebhgquioHfMeDLxeXvo6hnKgZUDKgYUDGgYkDFgIoBFQMOMKBqORwgxt7tZINBqt10IkpWTNEyY5FQMUhwxBeYIFt9YkQqnFAE4YhWpzty9diIYzBdw7VZPfyJAZWg7WB72rTZulKTci5RlERQZBJcOZPgnzwMi7EoVIcvBq2A7reKEWrBfQXunlYnfFyfhfuRuIgklGpxXgyf6J3w0d8F4t8J9drPudnLurSe2A66vXpLJehT6IxPmT2KMvMkECJMx+xSEPFBnG8HQeYxgeRSIu7UhfU4vOVr56xwydMzwo8fV4YoFmEktMUjEcESD6K+GP8WEHaOQIVsSRS+3bp2SZlXn2gX76xLE3TipPSBzMLuBGf9A4gsFMhYBz/ktSE6um7zd5nl3qYNrm4bNTU9XrHQFPD1VHDySeDiv0Kn/EmISFf+b/3So94es6v11+UImkdj7z6SfQs4ZQYedgKCdj4HUb2fm5X5g7/j9zgXP1pFrgUHRzAtS8HX4Csm0ld3rM/c3NUI0Vvz7TIEPW76vJC6qqZ7IfA+BMI9KlC6KKyH7stNK15r9BYyPeln7NV/jmyqb0gD556JfvYKIlmUuy7zP/5+yTyZQzC07fQEbeXIVdlpyJDxFLhyniDSv+atW7YuGJBvD4bp0w3a3Ucrb2cKewScu1ag4sN5WUt/sFdXvdcaA52aoJNS01IVhb6BadcJEpmXu27Zz61REJx3TolG9ymMGbA43SwJwsPb1y8tCE5ogweqTknQSVPSeipmmolF1ziozB7LW7/sQ399uhNTM/5IFNaPCaxAYGIBC1UK8r5ddtzdR5405aEwxdLwMGHKXKgLF46ITHl1xYqbZXf76+ztOl2QbMLEtKsUM8nFgyuLiqTD8rOW+zVZC9TS+yDe6KCZvlFhyjtKAytPTMmY5y4h5a55pT4/K9NARGEcVIk37DyS/VPCpIwR7vbX2dt1Gg499mpDqLG2YhHk5GuhgpuxI3v56mB4eFx0iI/fyWythgkpM29GfqShok56N3fV4lJn4UQfwsqccrwc9Akq0Hl5WZnvOtu2q9TrFAQ9KnVerEVp+ppQdjBMEO8Ldn3umImzR5oVy6Pg4jeA0H6EOPT2TRN6fmlL9G0RYMLkWecxiwXqRvKNbsiYuVv+9oC5rfpdqazDE3RiSvpYmKe/Ehj5Z2525lP+kpW9QSQXTpvdraFRvg3ajAyYz2EqF54bHpX8iTMy8gUTZ/ZokOWPAUe4JkRz7dZVi6u8AVNH76NDE3TixPTrmEz+SUQyJx8Lv476MLgFMWlSxrWKTJ6CuBQmCORRLGS/bG8+VhFkQ/liiCATiYZOzl+TWdJem85e3mEJOjE1fbrCyDJCxGt3ZC/5qbM8KP6SKjJ7jRKaL+l1s7d9//r+9uaWkJphYEyZIQni5K6u2uuQGfzjU9JuhP/FcpEIV+ZnL93U3gPvSOWVxb/u7pd41duyuX64YpH/HjXwfGNV8a9t6s8rizfn9Bp4AbIZKO9ED73om8p9/+uySdI7HIdOSJ15PbjR26JIrupIhhJ3XqpRKTPjZSZ/jMju4m5a/YxNq1871lY/8anpcyGLz5NoyMXbs1471FbdzlrWofTQo1JnXwAf5X9g4XdNZydmTnDbs5fuiIgKuRBpGytrTI1bEyamJ7VFiDuylr0O/+wPLKxpdeKV6We3VbezlnUYDp00bXYfudH8PywA/7Rj/fJPOusDcTQvvmYAsZbnrl+20VGd5vsJKWnLsc4cGZUcnZrTxRI+dgiCthpN6so3MiJ8uwOqueYHp/7bx0AyQsWqciqyoZffDAPTn+zX6px3O4TI0VRbvhSqqf35WUv/0jkfg3dnxblyaCidDpzdwhfQ3u09uHsLeoLmaix8RiZJ3XX3dSSjSaAf+8mIG/FmwPG3hNTZgwINj7/GD2qCTpj4YDTyKr8Fn+B7tn35uprz2EWq4Pp56LOXE8XytotNO2z1oCZoppj+hs/mJ7nZS9d3WAwHGPC+eukZmNajE5Iz7gswKH4ZPmgJOill5kSoq8ZEROoe8wsmOukgq1YtNkpUMwNE/eL5V2T06qTTPD2toNVyJCSn/w/c+a38nMx/nIZWPSHcHXXXsZ8iKZV7UsUSJVOCf9ITPiA94b3XEyjqCUbA/6GHpjrum41z/jsb941wr62H+s+IMiP8q43QhCCmknLHJp5rBJHutALn+Cd7tOHRu5xN24D6QXEEJUEnpGTArZI9j+iMeGc8z4ICk14Ggq8fqGIaDoKEMz8bjojw4YjAGY5h+oIQG0CUlbiu4kYXEHMl9M5VAv5RVok8IlUICDhGFNlERdFk/ddIJo0iyorZrFVA5DJR9HAf0AmMhihMRgIdIRrjRIOoozFWLAh9BP774/8A6u3Agnwr5PEs7eCkTcHsrhp0BG3lQFXZPJj1qdz1mSu9TCdB1x0PF5MtwoWCwkYiIn04iIYT7XAQkhZEWoAHtJsIdA8CAnZLlOxhQngBj2Lxx0SSsa1z1YGjwwRiiYeL7sWnUi30Q1jbD4hz/D6UCv8KNt/zoCNoWMRmIOI5Iy972QWdTU3HDR5HN1SMAhe9CDLtOHzex4HLxiIT/2/gsltBJLtxb49O0Oz+de3rJcE4f/7lEJg5FVvV3YKXbxJerG+wH+Pfc9dmrg8GeIOKoHlOuYNN5gLscf1/+euXrvUHF/LlGFaxgZjGwc31IhAtCJich883FxPgIUh/Rm6Qn4dFRm3F3oUmX8Lhq77HTJsdZW6Ub+cBCphfjSgJ87avy/zRV+M5029QETR8EO7Fg74rP3tZsjPAB1udkyb6ihRw3WngwlMh5/YGjL9CDgbxkp/1OvqzL1KMBRoP1i/PD5Uz4AX5F/6i6rS62VtWv344EHAFGUGn5wCgv0Hc+FcgkOHOmIlTZg0nZmUaHuY0PMzxEB2QZZR9z5i0KmpC5C/cDO1Ovx2xzansVM+DY09ngnB9IFKaBQ1Bj0md2d/M5O268F4xwawq4vnojh1hqRAjpkEFdjnk3ggsltaAG69CMpvVuWuWV3ZEYvQmzPET024lMlmMlzsNzlGfe7Pv9voKGoKGc/oTkC0HQtyA2BFcB/ctVhrJjdD33gLILoEIkQuZcRVM8t/fMCFqs0FNbN7qgSVOnDmOycp3RCNOzl+75NdWFXx0I3gIOiV9D3SmD+SvW5Ljo7m61O3JPB+VV+PzeTuiQFLAibOpQFaEEmFVsKmqXJqYHysjIOEP0Fgt1IeHjd3y9SK/hIUFBUHDzH0hFP2fIkNQXCBVP2Pvf0tjKsydzAhW7oRejmf/EyfiMK301S+rFtf4kRacHsqatIbJ04C3GIhAMIAIK4HH/zrdgY8rxqekvwvYjgCmh3w8lLV7yR+DtDcGLFVcFv0mEMRsTUI+KWM8UgjcbizcdgO48XYkPf8gXCdlBCsRc3xecs0jEdW1NasIk7sJRFgKC99hhQmJIOoVCSCimyZEPxkMohCisF9A8O4vo6+b+5w/PCaDgqD588F2DX712eDZ+4nMHkDeudswfh22/nmf6jRjXUnNxQkrUEd1Te37UA8WTk/udZ8N4X41buq8ZbWmxqzPf6jcD9gC7jbK95SBX062XGP6A+BZ4mt8Bdzbjpu68WAuEgWdzxXynBsjh8UUIPgr7HTyK8YNFwXppvycZSPzspb/taMQM0/WyHHWL0STZkPMVlrhkeFQmf1RUZSnOW59TUBO9S+wNcD9eKfqelgp4By68EROIkyoR3wZdm/9PNfV3oNUt8iOz+qZQJeJUtht/vKJ8PAZtW4uK9jYiHzPXUNbFxLC9b/xyWmaPXUbuWGn1F4df94TBLpVlq07E/h82IATNCbKjRE+4c7c6KGYLDOra2t5KNK3IpXu2p61GG6pHfyg1ITVPJh0m0cdMzOeyiDgBE1loZYQJbxNaL1UGHCRAwuGiyE/ey2VFz7BQlJK+jUJyWlrQMxZWGgejtDqR3D9dqcgZjx47PRZyB2c+Fzt0UHSlFlxYBLdhp992U575QG5B5nDH+MGnEPDmDKESOyfnk6WOzaVGM33rsypeBh91SN/8qsjekR/5G3HH27erT3SNBePB6Zu+GpQtgMEtiIvJ/MjT+fgbHsekgZ1WM3nGyqQ1Z+8atvupPtt1lsQ4/4ZLL7ksiDHUYUesIXTV+cBJ2i8trGCTErcnSA3gDTVV9x/sMnyMF6OAhhC0puTnee526mDdmMmz4qpOdLEdbzbYeZ+RoR+1SLDFZQpjyJdwJX99JoZjuRaB126fVsrSPeaZPO3WOCOgL/0O5JWWyYbzSN3VWU/CZ+Sxsjk6MdJjtvde7UhlWk8ngtcY31/BJSgrdzkSFZPTXi0ywR9co8/NtNYV/EnEHIutkG7NXf98o2+QhnXkEDF9zk+5e/tyF72F5txtuGlet9YW/5taaOFc8wXbcp8drp1/eKdyBF9Xj20GdCd/8vc1HQO/EkKIZBkjohKfneFIXj2YQExXwHG9abPkGHTcUAthdbM+6wxFxy1hw1MbZ7ybc92Ha14ADLkE6jIneKf8YdlLH5ixvlUYZ9gG4jB9gxAJxMrKht1Q0dHB3OIUpvI9UEh9wknimmfTuwWu2Xdi9U+GOKMLgPKoQmxxOKNcoo7cw4JE/ntu6oqnsXbXiqIwnV56/2XShfEnAzFwlp7xMwxyhMrwp/bpOzNjcGlX+RFPm7QH8ycjue10h/EzHERUIJWqCUGO6e2626ZMHHmZOiQX4GXmwiO/OCOrMyv/f0goYmpwfghbY0L/w/Zgly2bdXpSmXWLenM9ekiFfgC2qsHGByWMFRu2aldtU/LSj67ZkTTVt9c/YRFz78RtfwOuOMbIyNTRgWCmDmMChXywWkmcG2KPZhHT84YDX8KlrdmiV8WP/ZgCLZ7iqXuccC0MTdr6W/ehI1/rfcWl11ZUHRo9t795am2fQeWoCkxg+u1goFrLhKT05+VzfI2cL3dgiZ8WH728oCqoU6m1WIHEPP4AkeoLRI5JzKb2TuQ61+zvd+Vz7mvDNA0GwG0j3gbD1zsGzIw9iuRhbwPDVPSvpLKIcXFTM/HCajIAc8whCdhbW5z8I0zsd8g3wV2B7YDPj+o9gwRdDcTxZiVkJqeBF/fdwF5OXLvjVBM9Q8DyWthvFlkM5Uue3pKe/U+Hu3L2Fe9yFeIGDTonGowlzcKisveprRsPcb5OLAErRAzIj+sHPpkBLHlTYTuXAKf3tnYO+U/vkKEu/3mr3+jArkqxh45WPFH7L4Fn2nSC0S9l0jiXcESmODu3LzZbufR7MehShUgIr6wg+/r5MODc2tw6BctJvM7xcXHV53BHX04rt2uef46hchPwTDwNju589PK7t0iHvnpq5dg+1ePjoiBpIkZl8uy8oEg0Qt9yZ1tccMXiIVFhw4IonRXYDm0qFAm0/FQicVSSZqucjnbx+T4PMpQGV5N5H5UUWKhJQqB6KY9mWmJYcEqaLGAxg8HoyeQ+6NaYaxSG6oprl8QXeG4V89LuDMY1j0fgphv9Rcxc6i5tqOgqPQtxuTxAePQ3C8Z8Wbv4ZO9Qhce/VgwR3p7/qhd7yHMUNnLYjGdhwxFw6Ey7Aei7Y8Hh3/SD8qUc1zvkbegPFEjPALYz+hrY6Qkfl9miGlwr68zW53aA2ejIAiLYHzyuSP/maMjs2TRoSV4eff6naB53B5CnRbiwdwr4oeIhq9aAtfVrkPnV/WWBeNYWWFjwWnHQlsyFjjgBhrfHpQ2gAD+QwThZfOzsVvdHcy6/mmyYA8c+lkg9sCByCEUFpd9B4esD/1K0PwtVhotX8AfwqwTtbdtWffGQVeRyFVmSakZl+E7E6dQpambFLKmvf37XB3D1/VDFhzqa2HKVLzUU0HAl4CAuSN+QA9w7k9Dw7ulVz9+1nFXALGatmXjWhDT+rycZfNcaeutuoXFhydAfffMkLiYZL8RNM/ToMjy51gAvh91WfQTOW5kFLJGhzNlOZcXgcBf4cI5EBMYi40pX+EbCuEzChoJvqPPqyUhVcfIBMiyUwHdVMA9IvigtMqiB0SNlNxk6L3fGfjGTnqwX5Ns4u4AX/srqtseXDCwvAk62APdNIKF/XDAbH0PHPkXwW49w10Rg1sNFZP8C/ycH8ldv/S9ZuLlLp1ms/w5TB1b4AU3yw/TcWqIEENpH7OZ3EyYwtMhXIafXQujU535sRI49a5YTd9z9xtoU1vDjpk4e6RJMa8SCP0HUrc901ZdX5YV7i87Fwlt7gIxc1uA2acEzSMqVmyoeBkTuhX2/Ks9MYEiAuULxAL+ht1Sn2uJILhR9qhX5AKtoLmUu1W2LPfXdfcXTpzdUF97EzQPd+BTASI+06LoEhxcvmWkCD0chEn9IMTEg4LIDiiKeFCkrApuLSbKzCYxTDJpTVpjaLcGc00NCTER7VmybIpCmzhFIYMx5nngveOwkOzp7PggjNnmhX0dLuy4bw1TlI/xQXwyP2u5bxXNbQC9p+RILDU3/YAERdcM6d97B6/qM7VdMnIhr9hQ/j5Eg3hBL13oSUS1Nc1uo3kSpdp0e/PjmYyQi+JTs2K5EuV+JegBBqYvMx+6GuLE7fV1NVdAHj6pMrMHqKN7Jxdn29B2C9YGW5BO+NdrE3vtXnFza+cb3gXMq62OU5uAN6KAn3Lr3C/Nlfi6Q/NE2TgQ+R04n4EXLaS5zN4/XsYbcd8uQcNKmsYUeaEoCHdgV9vv7bX3x72ioopoi8m4GiLsE83EzMf1CUFbfZZzKj7Fmx7SPSJivKeGklLBEooXQ+KWujaQVQLZOraNcq8WaRaUXgSXpQdKzSVITkO6WTt3VoKnpAbMm8c7rgbxbrRHvCu8CC3G4ZD9l//CFlY8Y2owLQZhT3c4BLNy9jOKrdn895cvA6e/VNSQCblrMvPPqODHC/6CwpDyI9yAMrEQ/Nh2aK+LHDzmrqaq6Qs+SL8Q6TpvhSSBA9cRDR2RvybTrv80vPI+xuJwI9RGmbYT9OZ5soFJ/zWX3ciIgphCBoJ28qCIqCPsN8inqxUqrR4v9t6UY6D2GK2THXpeTbug9Fmsa3iQRKsDzCPf/HzfxOYC7mikWMjnIJYS6SzdXf7IgNQ8tr3/gn1lywhVDoVoYhf17Uv5V+n04VUOzXXMtQVb/8PfksgBva5Z9a7Bbt6I06O7cAIW8y41KwvQJK1lM26hYiZ5ql7UPNqyzBvXXDaur6v940/m0lkg5L5O9Qkixqc9izLhI71G+KbWEHM6WWGOUx34tpJpYZ8npQUlF4PjptoZKbf5HrLC/h9cyF7Cy/gyDCZ/PcXtm4v9/l9QVPYcvoxRQwf2sSt+epWgYTB5CwsQKSJKf2XOu4Y2V8muYkKrl542NVk2Ixj11ahI4amcFZl1vA+ERqUwM3ZKFeh8d/TabcGhM5QOVczkwfra2rtBnGHOSBR48L/C/PyRhuk+bXg+6jDv39zWIAEsExl9VSatCRrOYZ/xPQ0bG9nfscAdiJS4U3hKXEoDtv4jBcWlo2ExvQ9flUHDBvW5whHavCZyJKakPakweoM+IvoSX5mxx17950hjbcM7WPlPxid8Bwgskk8MRPQEVtsfOJqkq/d1T1QMUojxKabQO0DIMGi2fYBrHQAi36Ma+pHR0Keg7drBUxqyoCTWzFipLUTA5a5hP7/0NJMtS2AA+yCqf6/53mZOtuM5cw55+RosuuF9SX8SztJfMaRHjxpH7bxC0NaM7QpdotHpztv2/ev7HQ3mrfvc4kialGEyEY6MjOyxy1u5N/gDhmD7NF6Uu/EpbvfrBUL+L+TN168dFfuFI42Et+bsi370hoqB0BTsa+5bsDSSuNz3NkjG4wOgCrsnGJzF9hYfugUuAdCWkUzomh8FztvcYMljgubWIqPFtA0bPd7SUXeuijGUhSLBxiPYZuJhEHJo8wN28G8GUlcifdFr5mf7bXZQp0Pc1j5RehOSOloVKt2O7CTRRd/Xi7LxszC9NDfQqYTh23yWWWl8AQvw+0CkNwwd1OcbZ5DaLhdqqxOuPkGuinfxaXq5oxKz9smDt1aa5VdAyO2o/GijIJAlSJX6RuPCvofawktHKVMUdoeuvpL0LF5DNMbaJiIJN+evW/ZdoOEvPFgxyGxugIjBtKJA7xwcF+sUMXO4PSLoxJSZc0DMPbCF8Uv5Po5M8DaS9YbDAyxmS6Yis2lAXBvdI+8PJe8AUYbG5zoHIfPJdp/1U2p40eprux3ZQY7HXHCkvO+5oxsXDgvoi1pSUn1Og7l+AbNYHgRdraIh4r2De/euauPhWIv2llQOHty3515+4bbIwTfSYQ2sGKlSr4bFaGN7gwZTuWZBySyQ8IvtiheU/lvQiPNNhpjdwQS/J7BY3RF+OJqhUPG12h5DpSP9Uw4S3dnJTc/1KvakX0/blpSwkEbzoWy4oPL9xv8+JC72eYh2bXEa65DFCI41KWWPDxsU+xd+w20OrTQQpL2i33YkYuZO80az8R2IStxhyOGBhd5mqE7mmBf2+dlhpQ5YwLM7rcip+NCs6xZzeNh1UlN4n3yNVj+1wRBVFqjplJeXh9U2yg81mg7Nw342meE6+mpMTOxpnX17cJmUw/NgMTydItktgsZ+GWdZThjnEEE6r70Bg6Vc/1RpitFk/BTiRZRjmGgtkLpggdRnqcHADSOd54Cl9UoLkd+v6Zn00+HBV44GM1obFhFxi6v+z97EyN79h1NqGmSYrlk5uPGd4Mpfu9L/vgOlE2UL+8OQgb3HNLdzi6DN1abb8TXIzc9afFrl09xhMP5rniidZ5HZS0Ccw/mCK2+QtOJdjYaYg4ZgnIQHMCHc7SF4xz1aFTf502O9L0gTKHnp2lF95gdK1XjgwImzjXLDa7IiTxGIOEtgurU8JYErU+ScvabeMg/rm0xbVZ7DB9xW55QoV6KTd9uqEwxlBgMTFppLluJhtjKX/w4fPNpgmFmg6fNSZ+PKSVPSesLSyUWs/qVJd6+sj+gzXaDsBtNz/b70pvPT77hs+wxwaPYWl19rtNRh+2T6ZvdQaWavXr3q225lv7S6Xn4YTKhSJ2n/bVvD5UXhyYTfjUe6R3Tr5akXnS0g3j6PNzBtgankA6wqbnbYN/I7SyK9uemZPtkO6/iggPtvNxF2PlI3DAJ8A5ButjvMuiF4sWoxXCkj4gaeqcmToU+mE2DvMFHz1d4L5vZSBI1Oy/Qzms3xnvTtalsQsri36PCt0Clj4UbzJSqlDxzofgQ6zOBp0BgnC93197e0GrpM0EmT0i+CqmslUnP1cXVi/qp/kjOXfgJEOnSRxNtdIFJxStPCmAO+hotzSiILlyFfxQQgfAKIOAFjtol7FP4bkSA3OrPSt4X/ZLCDsgjtp9WeM+zZsuE33gZtzj9MC/u+42pftv26e75vX3miTGW+BV1fZBSaAWufS3Jyy3HhnIToGDYuRBN+S9++3U+5gf9ey2WRAxtU9sDbUfx7F8F3ttBUsgQIdEzMlPymC5Mur5vfvo7T3dlxwmpg8s3wB7ldNiEQFukeeV+Ay6kD9a4fPfFPPPLbad1wfErGXQ2y8grkym+KRqVlmsN6nKvTSNfXGXpV0uedGtZrlfbtK+tnocpzMpGn4Av0L70Q/mz//q4F4NoCA+aEBI3lN8I56WKJ0HvtETOv7zJBw4n+HHA3p5FsC5Q/zjXzS+/Bp82uayEfnzvf6MOEKbXzex/1BTw8C6nFwubUy/Jt6F/vPAmfCQ3g3L5t/atllL52ZoGdq1Gpsy+wKJZFSKvWo7pX0iPlg64aC7FlvWVhzI/+9vSzhkWZjK+AmCdAjHo/RBsT19Jn2c4U2ry1b9+x7giE3YhvWg+9FJ7Q1ovhOkErgglJT3yfM6LNKdov1BlKBoMbLrFfirtcZibC1Nr5sV4nZogVCYqJPms2K9c5HN/ZAkqPUo14a3siwujL5w6wNBlfsDDzFKYJW7T3vIwGJmmaTM/0mdNeW2dBcbWeYDEPRuxnjqSEpLmqubA3FjeDy5YG5NugJ0Qm3tEWMfP2LhO0RhTzzLJluL3BA31PNhOumgtzBAf8MO5qfD62xFG5O/d5Kl3ZXP+MYmYP4kVv19W0vTHw4HZB1rw+d82SPY7q8q08ZNb0qNlovJtQ8R/FY+97zKLrUTdE0/fzHQbsYfiso5a+vz8krvcGjMJ/Hh+F+0rTYQb/C6SNQkGnv31Qnx6l7XVqlevaq2RbzoNfqzZU1IWG0AGbv8ssty0L5DlEjdEQNbY6ggET/cz8fL9bHJW7cx/7IQ6Dn+6XkHc9fsEhYsjo501RE/6kox1urZ6Nsukx5PW4E4T/afnwq9fVRCaYYqQ+3+1vJ+2AO/MLVJvCo0e7KSea/oxnlgb13odD43o/hi+OU9KTyxw6BwlieIQ1ohnmYMLzAzXpluNi8/nbkavZ4SEI4lMOC90o4PttQ2vxI5q6mWfOZlBKv4L/8RPwP86zuXv6ND5l9ijCzHObLMYbiSB+eLTvxROPDUypuXZk70JuHNl/umbHP+GORnJ1I+IXKTb+FVKHnkpP4OzMXObQvGNrDJ/Z8jMNpXF53y477uxgvqynmV/yMz75F9obA9xvi3lhP6+Z6a0OPhsqcqEOi7c3nlP3KDUC+Z8KVHjDXr4SPsbnG6quRkbNuYjQSVJE7XvVfS/+sHpwyiFfZxF1Cn4vV4IWQ1tQfPhuyhQkjBHnD47r9R9nubItKC5zaN6Y7yOCHZ9WKw3sRVzeb9thwM4p6eVYJ0a3exOulT8cjXOXmEHEmxD/+LFGJ32yddXiVq6R1kxQFvmelRsq7oMI0qjowv9+aOQNfxSjh1cdf8w187A35+zLvvjCD1qMf4PxNAh6OnFwbG+31zluETSfHLhzGqknPyWmpD8VyFRQpxHNCJfn+5++tj1hzCn5y7ZJW+cjely6f1dV1loQ3OS26vEyvsjD3wYmsg16Sb9hy+rXrYGztu2sGVn35l6FtGH3Ia3ZJeDIyAhK/2/6pUs38HrNJnmIeg/jcie2vvjWtn1HPt+z79ALzGJ+AG7Ib0SEiK+4awpvxoFbIkdz4zGpM/ubFHkT3qy/wnL4ZvP9QPxrnyh5CREY/IG3OkBUm5Fn4oJWBR7e4DsQyES5DEiMRVfh+Gw2wluvGj69++G8tRe72/4vd83ySnvD8H1I9hzNmiAzegu+LNeg/m/YnOODbueE/GfTitca7bXh5myETP0dbgcjgtntwB7sju7xAFgaKv48uFcvu3hy1M7RfY8Imndq1b+aEWPH2E5dRNj9W75e5LQvqyOg3LkfaqiKMZmb9gCOcLvtKZlgWdjvB7tlfrrJOXHTvu3YsUC5CUMiYQ05ADnxQ0fihz2wIOrBBVYoz8/OfNBeeVe/5zFBcwTybdiwc9UiPKDrkNPhwZsmRK3EoqYNnYNv0K6bX3ol8kzwWLTW+mBKDksa3fgmQ3SRb0a336t1ezOFIYUuvRwvWwpkEMiHdCV2+PrInR2+xk6d29toNO5ApvxJ9haT9qHoOne9QtDN6OJO5Dh/HoSth3FgUY/+0e/7O6eDtODgZSCYf4F4uBhw5kHJCaR/nWV8rs+/wBkBpvePU7unJkP8uBy9T4U41hPwrMO+p6sJ0aze4UaS95ZQIj0xMjgp0yHmTWhZFojrqqqqiOO1pjTgfBei//cNHRDD1w0BObxK0M0zQHajqXiIj6BzeJXRT0BEX2mGJP3gr03d+aY6x82mOUAwwsRaR6hAps4Hp3xbq9F9Vm/o6bZxiIsQ5r25idgr5nw44OAnILWWPIhQzW5ZCslRNKFfx5xPcnLcSO7ejEt7/1yl9+8fy0dtX7fcoSHJXjtf3EOeuduRZw5WUh62xjZTRTALGiF3cL9e+b4Yr70+fULQzYOectRB0m9yNSbLc8KthkgCbiVs7SvRPG8lcmwer+U/T664yVI6Bfk2rgcMl0FPPfTMOnCfoQwBsHQTOOp+xKaVIGwe/shISihp+OJO4CmYNQ0ndBEVv/aVmioHUmaJF82mkRpTzSDR3NCPUfEIfI63yoJ+u5Y2rhUUabMjS9+ZY3f8q5OuoZa3BUGaP6h/9I/46pkCPSufErTt5E5m4FeugXl6PD7DY0Bg/VC+Gw5D26CmKoCnWBnkwjJwuUMhOOc5n23bO3POI9FpA+kJG1OULONTT1lPCBY9wT1hzRNOWKSwusaz+upN2rMjZX1EJIgwDPvK9QCRhlFLkyDIJkG0GPm/CGLVSsZqpBOvDUXylXB4r1UTSToIOAqpYs4TmLJZGxa6OVCLYGfw4cs6YACawqKyrdj6+M4hA9zfcMjbMPqNoFsCPnbSo91NSt0ofK7HEEGJg9k6Fm94DBAVA3EgBoCJWEhBfcWacN4Ebmn9B5Fi3Ud0XE4HZ9WjTIe+9eC+/NwClluF8kqEwlehn0rUq4Q8fxwvSneisGhcR+KFCuF9oFwDv4gGcGkeKVKH/mrxAljPFYEchTNTEWoUaXS9inyVr68lXly95sngD8nm7o7Ug67252x9vhUEAj1eGjowZrKv1iPOwmJbDzQQfAeImp43+bFuRtak1zCLHnv16WUi6UWi6LFVJ3ZkYEaqYUaJCk0WQWyCSsPYPVxubM5I6o8Z8eycFibK9qx9/hi/eYzE1JmXYYH4TmT/6Hh/LsDLysoiaxuVLGQCTWqGxfYfDv7j4RN94bCBfRbZ3vf1uUNLIUyRk7GRoTg4LuZ7XwPRsv9TbzyPAnYpErhlP768bmpgM09tDvGkL8dpr++8rKU/xCen7zlysJwnL+c/vxzYwZMfg/YeOHTJ4P6xreIfLYT9GV9CaHb8e+Br3PqA9eY+fJL/ITOxlZm2de0ue6cOQVVnB8PsRa04E89rFnca8xc8sOydgLi2BiF5b+/fXx5nOy7PGIpPf+rZ4bqPbO/747wVhwZnno1P/iOCVpvSnC/MH4B0tDGYwGqgI+kWDHAjGKAYNoAXmVleDniS/QETuLMZuTH+gHQCa4yyZTd8Ml4V+G5dVEDwAbtJFIVbo6Ki+HrEr8cZHLpwf+k4vHWvCqJ4l0rMbT8HEDPUeqR727X8V6obMvoVLIyjkpLT7/bXqNyRCItC7OorPA1tlRYL8usxthKmZZcMHtB7lb/gsDsOT5YH7ryhoLhM9RGwi6EzbyZMTLsKeydmn3k3sFdJE9MvxeZJleOmzvM86CCwU3F79NMcusl06B5uuhwaF/OG2711oYawfnLDS9BwaI56a+JMpDCoNTUhtrJrHlaC5jkU4EmUrhG0hq6JBtdnLStSDfTXQSFD20IfKgjYhYBcE58y6xLb+13l3ErQiqCkwb8hLy7Ofb+GroKw5nlqdGI11htBxaE5bNzCCp/sR2F/Ws59TZrh7Sr/As8ECV+HB2CR+7irTNob8wxhtAaWxqDj0Hxuuesz38WC9bipYNufvDHXjtSHYJbqw2HuPYacY35XgnckRLWEVTeuO7Y3Jlq+ZXDLsrauoV57PDE5AwzEdwdUaticREoDUT/Gk9H4bqTg6xneZKwPFjcDDh6sth/pEXwwBwVE3CUUlrCGY2XlLnFpqPugq2U3+HoSW9cv3okvyDKL0bjE12MFU/+CQkRYu5hk0ja2MrIEE6BBCQsjq4VQvUsuk/pQsh74Hs+dinw9p4hI/bP4ioxMSMnw+Qvk67k43T+sgto9RYeOFBQfesTpRmpFjzAA/XUu39LZo06cbJyYmj4N45UkT8/oEl9g+B8hFxphr2HF/si+ksohTuLJo2oF+0qvKiw+9JfCosM3FRVVROOlah0D6NEIwd0YAQ4PwjS83x9Q5mUtWwVZ+uejVexZf4wX6DGsaruzwrVvQLb7zGI2b4KlcI6vgcJLhL2bCYJWWL6FyeN9PV6w9b9jfWY297/wF1xajYQQKXL3qElpY/w1ZlCMA9P3y+CeJ/YUHb6Lb8riK6DgyGJAZkm7KiWeC7jwwOF4X43tzX6RUuDehMmzznOnT2g7PuG7ibnXNu1bnhPFlbYJyRkPItbzFx6P6Eq7jlb3jMkNHRj7MMKXUrAp0NiaevmHU74d93ubuKEdGIwVOML5Wx8ybZiNPJwzbEu4w3/h4cNRPIbNH18Q27HbPhcuIRbLxW3XcVDKWLRSa5rkoLTN2/iaFpgZe6rNSi0KR0QlL4FLp7RiQ2Vai6JOddlKs3EqPmxrZWVleHWdOQVbAEyvaWBphUWlefhshUFcyCUKKSUC6Qu5+78SkXKVUMYGRUcfQ5nFOexQhEqxQvt16QRoARbblhUWl/2E6wsRe1WMMKmFtmWBPEd8ZDU4gpvWQmGdrLDJgH+lq3OAX9sLULcWjJ4856/b1r7pAI9n9rpixc0yviYP4AVcjWibL4IpFfKZkHp2dQaHtu2qZ8+edXyDF4TQ3AXOfS4RxZewglwBZinBTRAR1DzIld1kofJ1SoMyZ29x2TSuMbHtw9456khwc7wIL05ey3KUIcaPTcLLcgb3FkLF66gkDT0rQjt6aFzsOy3bBeoaEew1wIdLeuhmWIHLdeCYbnHok/GDNNNsMT3d3J8z//lrl/wKN8+3mxrZNc7U74h1WnFoR5MYcjJP7w5H5c7e37f/8CRoVU6Am8st2+w9diwED/kQ6R+z07bsVN4zr+Q+s+3X03NYWKsR4xjjTj/DIif8uqsq+xyeWSlv3bIiV/ugoeRlUk/3JU6alZjnIK+0vT53ZC17zN79znLPIYf21QSh3WgAVzNDjJi7p6hiFE9w3TyWWN3UG+fbhyB3cvO9YP6HyFUDpy63ODQXAfCFyyaye1ya5+WGhfs1ZpGfCWYc+Rs2vxO0hkoF8CX+Als5PEeJeZNiNhcUFJU2YP+5dy2MvABx5rC/keDueMgu6pnHnUDWAg9cjnbr6BbR7XWIb+Pd1bS4NWiQN/I7QXMX1SGDYl5DIEF3bFaOBC7SGITwzIVm5RBybpwDUaSVbB2sOMTXBj7R7nvcSaJ2HbQ9qe6q0nhKXSoILxKL/Fyw4kiFqwNhgO+qG5+S7lEON7Tf7wmH5VtVxyenlfHwK3dQl5SalupOu2Bt43cOHayIcAcuBWFYWBi6JUM3j4dF8DoqW9zSdvA+eHJ0iHALkezdLS6tKPSNhNS0O5vh6ej/VoI+eLAqBplwQjv6ZPwNv4YK1cjL56YeuhlaYQ0Wl25x1+YehkdFvw0X4P4JE2e6LI9DZJpFGH2F5wVs7q8j/1sJGtuFzahrVILGYNFRENr9LKUGsPKtKMBo3Tvys5d+pqFihnutT7ZascLAHcyeYYrrsjT2x9kAm8KqUxtAeQJGULS1ErSGhi0FNFfDGjg9KKDqIEA059K76Io5EZ6AvDVr6QFP2vO2kRN6vQ/f57OxGajLRhN9eOhDaHt9QmqGe2Z8T4H3YnsrQcfFnX1CopobEPn9OndQ4i6dXhyjU3cFGboGKVI9kqO9gSAeQQPrI98H5FlXvxg8JTByYz9GFGV5MnYK9gY8gerDStB88IEDo3MlFjoSn58EC7EUITN75r59pS0ShAcKzJPj4kFpeUKcwv2HxpSWlvYILDSnYKKkmjYpHsrR3pnJjROiPwGnFRJTZt7sao952Uv/CTm8+siGinmutg2m+q1kPxCNZt+B8kmKrNwJyXAcZLMtwNFv8FtYLzGlPC6u90HoikH3vjkKGdMJpVX9iEk+C85IM+AANAD+B5AR4RRFlTJ4msGvRHjjlCneN0C40CuPPsG2xg/krV+6yYVmPqsKYr4COLsJexne6+og1h3NTHSjTtKO2uKFvWBcHd8b9VsRdMtO4Rt9AUy0UCspw0FMU1EO2mLF+N+GbX1XQV10ETaJLMLNPQhQbJBxk0lSqcZsDDcT2hMJ/IaG6enHvF+TSdPdqFj6Coxhc0kFRhWBJy+3vhwwrPRHz1ilIz0AI7tx80p8PuZirDqq0f6GxGkN/fpFlfF+gulAKtuNokgXInWA39MO+wIP8anpf6UKGZmfs8xlWdwX8LjaZ7sEbdshV+01mNhohdHzkXR8MNRN54DgYvCpOh9pxLhrKUQ4kD/DFpKgXxCnEWqhUBBnE+ofBsEeAtf/DQQbyTku7kGVS40KkX4kRO4mCKyue6im8ES9aTC88XKb+7OFIdjO4eT/LTYbeI9rK4INNnfg4Vv0NdWW7wDuZ3XEHWtdWgDExMQ0AEn/PfU7jS/uO11fH2WRpBp4Rpv0FospIi4upgDecxFQB0UIobR2SI8eXMXl7LHN2YoBr4eEM/gmBYUM7Q1c8K034lNmX0dFMJsOeLhE0I7mx32nT5U1tajDidgVQm7RvANcUlaNfWICruXwJqZ2ZC/e7s3+/NnXaS2HPwftTGNBZoO1EBsSqUdQYEAlaA8fA5YL8LhTOhWH9hAlAW2uErSH6EemT4gcnvpzeAiE2vw0BlSCPo0K905O+kS7F7Xi3ohqq7YwoBJ0W9hxouxkJv/Oo+VwYspBXUUlaA8fD9IxVGFhqPGwG7W5ioHgwUDSlId8lmUqeGapQqJiQMWAioGOiAG+33ZHhLszwqzK0B4+Vb4xj6LIOR3dj9hDNARNc5WgPXwUW/72AJwKqalhY5VqLfQQl95orhK0F7DIo1aaRFUX7QVUetyFStAeoxDusvDnEFhwRK14YToduguVoL3w+BDAUyPLKof2Aio97kIlaI9RyDug+Uyk3FdcPVQMqBhQMaBiQMWAigEVAyoGVAyoGFAxoGJAxYCKARUDKgZUDKgYUDGgYkDFgIqBToyB/wcyao4zT7TEdQAAAABJRU5ErkJggg==";
  var error_page = "data:image/png;base64,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";
  var error_video = "data:image/png;base64,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";
  var no_account = "data:image/png;base64,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";
  var no_address = "data:image/png;base64,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";
  var no_collection = "data:image/png;base64,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";
  var no_conversation = "data:image/png;base64,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";
  var no_customer = "data:image/png;base64,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";
  var no_data = "data:image/png;base64,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";
  var no_decorate = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALQAAAC0CAYAAAA9zQYyAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAtKADAAQAAAABAAAAtAAAAABW1ZZ5AAAgGUlEQVR4Ae1dCXyTRdqfed8cLWcR2tI20LtF2yK74L2rFFgQxVsuBRXXdWmBRdRPXY/drhdeKx5AcdVd8VoVVv1U5C7giu63iiBUpC1tSulJuWxpmyZ53/n+UxpM2yRN0rRN0pnfL7+8ed85nvnP/508M/PMM4SIIBAQCAgEBAICAYGAQEAgIBAQCAgEBAICAYGAQEAgIBAQCAgEBAICAYGAQEAgIBAQCAgEBAICAYGAQEAgIBAQCAgEBAICAYGAQEAgIBAQCAgEBAICAYGAQEAgIBAQCAgEBAICAYGAQEAgIBAQCAgEBAICAYGAQEAgIBAQCAgEBAICAYGAQEAgIBAQCAgEBAICAYGAQEAgIBAQCAQnAnJwVqtv1So9M/v6iLhxtx8p/XazNzVnjNG1X9TeNzxu3Bjk8Y03efhLGslfBBFydAUBdSYjbOFFU5ac5U0uo6dlhxHC7lMp+01OTk5AcyKghfem8YIxDZU1j1NCTXUW0y2e1m/spPsHqw3kHUpYmCRrHgGhVU/z8Kf4gtD+1BpeykK19AQjRENUcoOnWZjUuunonacSRj/ft2X5Pk/T+1t8QWh/axFv5FH0J9DDnqSEXDg6c8EFHmXByBhKyU9Eoss9SuenkQWh/bRhPBFr76bnGqgkPQI92kqYOsrdtKd1bsbjb8zPW7nJ3XT+HE8Q2p9bxwPZ9uWtfINS+o5Kybzxt+WEuJO0wWxOhu4dTmX6qjvxAyGOIHQgtJKbMkLlyGOMDKotrX7WnSSU6soJY2ZC5Bp34gdCHEHoQGglN2UcNSxyrSzRZ9HratyZfvs+b1kFkbSzgmEw6CZEIppAQCAgEBAICAQEAoGDwOhJWRemTczO9EeJNf4olJDJ/xAYPfne/kw1JRDVeqVqJXdKEnnU/6Tkq0siCARcIJAxaWGGqirXqJZT12E1cQijVMJCzOejhka864/LipjpEUEg0BGB9IlZc7CUnoVpvfP4sjqIYmWUrA2R9Q/ohki1X69Z1tQxVe/fET1077eBf0qgkpFYeRwlSdLdVCUWIrEyfdKYLbv+9nuLfwospBIIdILA+Jwc0eF1gpF4LBAQCAgEBAICAYFAn0Qg6GY5dA8fvl5V2XxULKZPtmj7SlNah1mK9eeONCzd9Xsa9AO6oFL6dQ+XXQsy/4u3KRpRBI4AzO8QLtxbVj4S33fwH8EcgsraTmWYNxXBIQLg9W2G5w+HOnwYRDeDitCU0bggahsfV4XJtceJwceZ+l12QUVov0PX3wTSYNE6yIMgdJA3cF+rniB0X2vxIK+vIHSQN3Bfq54gdF9r8SCvb3ARGrtDvWkvbP/HNn661uO0lK5D2pc8TYeh2S5C6Z/xsXqSFtU7iDT3Q9YGT9L1pbhBtbDiXcPRB84K0y4fqI+0Hqo+fBjLEEvcyQdEfi1Fa1hQRY6H1FubDsCD53IsYnTeQVCyJUwbcp1Zr9Oa6uu/USheJMb6dVYmXoLv9FrtVFkfYmlsrN/BFLoOqyZDO0vX15533gCBhAgMeN0WF70jJdK8UJ38+vETlm2lNYc/CdOF/Am93wOd5YHtR0/EaA2LCizl79WbG3dqGPsE2zhmIl2zq7Qg5ftxkSOmnTSbcxpO1e1XZVqJXnciet3jrtLhed7gQaHjTRbrnIb6OqPMSKikk3+Fl+qwy3R98GFA9dAZmQuuUYkykzKSjt0THXxbH7Q2hSkad5wG0SaZ0hlUK+ebzNadeA9S+Ktw0tycB4JfYTKrNYyyV9FztsMHSzcSWdx/QP83K+rLN+L5pfwNshK6UyJ0ikYjTbUq6sfIa1B7LoG4L6NHv7ewpvw1lDeXl8cUdQeUpKslrfbXqtm6EXccLHzQtQatYW5lfXkOyoO6gfJUtkGyKjdptPRiq5ltRFbntC+vr/72SufsDbDSMrP4X/otEiW5TKL7iNLR0KbgovuWgnHxnch3glB5miSp9arCNiButH18EK9QpvJkRtUMRWUfgGSnl4spMaNnvlWjhO6wENMGkHK0fTr0okcB5pVEkixMUdbjWeTPz6WHI3TSsiMWhasXU3++jytKTKjTbJnJu6xM3YR8z/imQ4++KkU7YnGhpWIVY+q8NukIhbZCs0O1bG2ThayDynNh2+cdf8k6KbU5x1DY8Unw3AkIQp/umdU3tRrtuD2bXypyBr/2wcMFLb2tswiElsMH8uUqYWdh9/In6CXh6NthqJRkermqSgPRjX4Gsmo1VLqOEfWQytAjMuLkpaENMmE3EEl/UGXNiEfjAPD8kAH0I1MD+8w56UBOW7xTbB3qcAFUmEcjhpKnqo+x9yHnVQ6l5DcpeSRCq3ne4cvSLlFfIHS7v9R2CPjJT0aUm9BzrnBF5hZREYn/lTsKeHRAo5OnKBb1F4Qo7yGeK90kGlZ7X8DF7NUS0f4aBAtRkClTyE58hTvK//Q91h/xPpWYeZ6un/4Sa0PzGInK+00Nyr/xEpztIh3UYvJqUwONGDpEO/HET5Yp/TQD8mqO1W+CnL9yng5PGHms1qxEpOoM1xZayv+Ol+Zml/GD/GFADAoZoWn4+93dpbaQyCqrVZ2qMvVfnZD5dDG891atm/AZJSlKBFOV7WCPCzKfkU4Lq7+3mpua56hEU2th6leuyXwmHbJXn8AA9Qn01vsaLKe+QDrXZG5NihduUaG5YjXVsqfscuuTlwHRQ6NltPj75p2k64CWdRaBqewF3p15FNCLQz05PT/tUVIMWVXyHMNw0dOAKixWVLLY83TqLPgRneVpumCLHyiEDjbcg64+RWU1iarVuhwzUN8Tmf6Xybr/60eGHh8xgjb1ZGUDQuXoSUBEWd4hkDQiwghV6XlCWQOmI++gFlN+k7niREFxxb+LiiuyKysrh3mXs2epRA/tGV4ithMEMIXIT8/a3PohWHMNNVmrL6CMJalUPedUE9kIcjdhLPQ1laU3kmOjfnCSVZduC0J3CT6R2BkCrarGdjznH0y/M1paWh2LufZ7VCwoFZZU/CBr6D2JI6O/5c99FYTK4SskRT4uEUAPzuLjo0qTE2IWaQkdi8HvIauVrS0qKV9dZKzudFHIZeZ2D4OL0JSctKubuGyHgFYnn2h3q1d+JiREH0pNMNyil+RMdNwDGVO2FpVU3egLYQKD0Ki1O5WFfsaXnEVwgACw2XXqwahaB4967VZc3HBjckL0LOgjr2IV9oPC4oqnuypMYBAaf1fuVDRaY3gKFnTvYT3Yrfju5BkMcSRVKcCKpV+uIEIVMackGu5Cj3Utmu0PhcbKO7uCeVANCktzqAlgzA7LOZHVSExtjI66ApI7aUfseeNJRuVj5efO/as78XsijrapTmvY/fqeEKXh6u+3rvBroyTo1p8cNFbchpXcNwpKq8pT46I+9wajoCK0DYCTOUO4Lt2j+nRoZtZPKPOYOSdqv02O3v6+ZnqObr+5DscQdrC07W3RHJafFB/zPgaJo5mqflBw+Ghq6ohhFQ4jurgZGCqHiwqIR8GFgFbSw0yY6HVWi9abmglCe4OaSNNtCMTGDquGzeRqM1Eu86aQwFA5+CwHhumBHjKuzBrCGsiTaLDJsKSLQH12Y9PA0n15ud0yO5OWRqz7t9Mv+2l0RwMFOz5fXWSsegtqx62QebWncgcGoTESxq4OvaeV86f4Y6+6Z1hzfeN3WDMrxu6xu3FmSS0WFyZgBW1tRmb2w/u2rVzma3lxPDJfjv61r/Pt7vxoKP1RbYS9ohchIAiNvjlfUdWLUb9/elFHv0gCMi9Dz7wfvfFU3gu1CvXV6Anzv0Ld1v1ySvan321cedCXwvLl5owJ2a8PHjhw8c5Pnqn3Zd7dmRecNETiD3k25M8CVhZPygoIHVqW6XJU6g40/gRPKudncaehHo/bkblFvL15q/Iwb/6tpZlN8bW8M2b8BXbkbN6phoYoX+fdnfkpROH7Mbd6SmYuU0AQ+vstK7/EG3u/qpIN6ZlZH6RPnD8tkE5oOu+K7OFQL8L6yXrHU3rouVXqaouWd/QpGRLV8k8ga5hXf9/eldr1VNhZz/+Nv/Amp4AgNK9Y/rZVLxGNdC6mdI6heVbXbq+uShs//+XRmQsu8KbiPZnGbNK3TAQ3hTomFlQqbJLtfHmfH0+cMWHBpenjs2dmTF54Zne4s7rwMwWpJF9/9UURJc7i+Nv9Isb0GDCPHRBC3/BGtoDQoW0Vy9+y8kdcZ02fnrP4wPGaK0CPOQpRd4DYZdgl/Tajmnfy814utsUPpu+MiVnXqpaGV9DT41RXWsMs1pT08Vnriay7I3/rizXO6pqft+KjfCg1gRJYac0YDJzN0dExXs3MBEwPbd8ga9bkmPdtzf04f1vujdrB+uE47fRZNPRExqyF6ePnf5WWmZ19/sQFPeomC8O84/h/51NxHYKVWYeBhE1hY8JOdXiIG+ibK6FHO10Vy5i44CKoW+9Bp3z4h22rhuZvzz0nNFQyIKWeKea1mM1w2o5Q0Z4Ze1VOp67GHMnV0/eg70vYWr+IUOnf3pYd+JO7djX/xYQFsdhlfRPIPQcES8ZB6+sx3ff20JGRn25/I4fbeXRbyJiQNR0bcZ+XdANG7d30XIN9QXjJ4JiR/AZqk1u7uO3T8uv0zPk7QPgv8QI/ZP9s7KT7B5usdQckmWTxF9z+Gb/GP5luf211s0aWU/3dloPLW2ismIfJukl6Tf+FsbFhXpm6On2zeQGBFnbnrTiERl+KXixNkmQYjbNi9GwvHT1UXY2e6rX0SQvH86ms7qjX0EsjP0K+1aq54W2+gGIrI23i/FnouR9AD92GjLbnnX1Pn/4B17/HyXLr7nO7BLu2PP0TKrMFVfLqRbHLqtcvjUYWAjLfg3+h9d6SmVciqAht3yp781Z8B2LffU54pgGEmsntA4iifIZFjENp47OXnpu5IM0+flevt+fkWIlOuh4vURhrZOVwXfaftMz5h+ATKVci0h37tuWil/U8HGjcNgiDpH5EDT3iJHU1XtIe2YDqpHyf3Laqlbfjn7UsKT7qna5kGFCDQm8qumbNDO7PA44QyUY+S8DMjdzudi4Gk/+TNj5rH2YX3tbrQ97dtfGFKm/yt0+Tv2nlYZBrQvqkBeNgtH4uXDtWDdSHfP31xmUuvYtmjM96jEmM5uetetg+v75ybTQeGW5h5ltg3vBC+3l6TzEIekLbA9Kq2/Ie4B0+N9xoYtgtQeY2m01PQ8/Ng6PHt8OHkQ+3r1npcPBmn5ez69YG+QbP+cetACVoKORomTNun0DW6jGZ063qf/sie/y3hVhnwMnlM6lx0R92tfA+RWh7sL75fGU1fr/AP+mTss8mCpsDdeHRo0dZLtSFj1sGk5dGbm5RJewTimufIlBQUvk7qFRNqfFdJzMXLGh1aE9Q5/PbfAYhP29lPKUy3N3CWYpK3j26o6YiPTP7xfTfLBznSX4irnsIcFWDx0yJj3rdWQpOeDiqud3dwXyf7aEdAdiqLnyBZ19Mnbpo0WGTciV04bnMat2JWRIjVIO3ZY38zt5Ny42O0ot77iNQaCwfY9XKR1MNEa86SgUCa4tKK+cA/yXQxXYXGStnIs39KfGGPY7i2+4JQtuQaPe9fv3L/HgJrtN92DIN10BnAOQ5ikX5CwaTX8Fj/9ukP/tg37pcr+ZL2xXX535qSf/SeEPLVjmHdT94erPsi5i/n5scH7220Fh1G3wz/W8RemzsFN/kMBFuCkI7Q8bufitpX8GtV0ZPXhivWJWbQe4lmJ57CcvPn2N0/taIEHld60tgl9K9SywCNcN6KMxRbK3ZHMLtJ9VQU6Oj54F6Lz7eOZmLqqrCWaPyBMj851BNzMf45+QQvFpYWvkl9yJbVFyemJQQ8zrum9vXX+jQ7RHp5DdXN37Iy30cOvcoqtFcAjKXQefOPdxkrca889+48ZC7+t7PRdFvsfBygaN0jU0qyiBlwfBPgPp1uk8QTh37sSblM/gEL0qOj3nS3ntpSlz0j0MG6m5UJZKMVUVjgbFi1s8Ynr4ShG6PiAe/8zcv/zZ/28rFwy6LjIHJ401Ynu4PL0DrYVS/h9tfuJ1Vf/Y5Zu3CcPTGg/Zp+NQiiP4MPvzfIeDDQTcmIepN7BkYt8TpZXlG65imTb3Dw8PrU+Ji7sVi1Tw4gryhoKRiRUFJzbm2SN1C6IKSqvOh68xtWc60lRTE33xqj+8L/GFb7s3DhkncOH0d9sRtTstcdAZoV9XnvS96+5tw8tYSDD63c9sPfkgSemfuoXPP2cMyu+xRyFX5PfUsmVI+LnEa4MLgCQwCF4D3t3OvSs4igugqVhTzqESflBjf0mbdVWSs+BOP73Md+uChiktURXlewoJFfEKL4xdncgXl/dZFmQdByKEA+glUcpo7Fc3fsnx7+sTFaVRtvhOj+l9gBfMITuu6o8X8k+Q6zQIbH3Zj5XOw0wgB8gB+OGKYxZRFJWkxpvHWdSY2SG1FnN38A29LCtQZvj9T6zNCc/2vqLTqTtXKfkdk6cnEuOjCzoQK5ufw7fIPxUo2c1wQwNHOQ6td82Odx/w5BmxE3v35V2BeHayujlAam7nJ6F9T4qM9OmqaawEWVjGAxsdwFcXiE0IbjSfC4O8XwNJwSR9ybbJhaHlgQus7qcFgGBOxARfPuDsEuTb5Lufgy0ltUP+CgW8ExiEeb0WwsopH0Kv/y6bOdFmHPlhacbFFbfweo/1ESauZJcgcfITr7holJ0T9AUTke0bhL9p9t7olJZWxKpE2JMdFwz3E6dAlQmPqZDbO83uLz8OGyP0vTB4ZGZTbn2xg+eP36KmLDHCBkOSPsrkrE1cV4KxxBdGGnK8yJQtudf9x5MiRAa7S8+c4XVefmhDdZneL14QuKq5cAv1wuaTRXJOSEP1wV4yyXQkunrlGQGm2LmxuVr3aPOA6555/yp0zpiYaJqKDrDhZby7HcvddzqTA9F1DQkJMhw7Ua0ITvX6NlmjPSRo5PN9ZoeJ+9yOA5WAZBOiWXTjdL73jEngHiam7bPz7P4Sx2bO1tbUD28fkA218uK17m9BhUNhibE3M1xKVPghF/SgGN3/HGP1AqC56p/2qjdCV2+AofvgYgZTE6HeLjh37TD1pWn2ivnlLUfmxGzjn+EpidHS0UzOANj10UUnFVRZmeROmk9MlDZkts9DMswbqVuMgxUE4ouv8vrJQ4uO2Edl5iUDy0KF16K2vx8xnHmtualktjYqKcjljdKaHPlhWna5YrEtw1NYjITI5YDDEHLOT40N+cKKi1PHt8MG9fcKu0uKy9xHgqgWk+CN3QMOlaf3tVLAWQvMR44lTljUaopmRGDt8n6PY6Oa9cvzhKC9xTyDgKQK2eebO0rWoHCfqLQ/B0GNDYqJjMrfPBLMbbVSV9s/Fb4GAuwhAzf0t35HibvzO4p1WOSR056q8pbPIds95ug62qHbPxWUPIYBdNI3ojAY5Ku5AY01/fl+nZzhoxb/Caa3AnAs78HFaqhnvK+laelpoKf0lmbpUtm0F8oFhTU1Np3attvjiu3sRwHzdfzF/dQG2jLXomPalsUaaCa2zunVDsP2jXr3m47WT9Zb9OIJPwYLcxQkJkU5983kqaKvqIB2BhdxkdxLDEOStOpPqc1/G7pQt4nREYFhs5FbcPVFmsr409s5XznQ0GZOyEnCY5TLMUD/fMVXv3ME03CBsen1QsVo34UV7ADMYt/l6Qa6F0DAuT8acc6eELi8vH4oh5wQtC/XYiKR3IOy9UpkKJ6E9ELjPPg2R4BmKZZqK9uTDbPUVeGNdwxSyFz3glhsvi/SLcxOLymoS2UkTeMN+p6PyxXyeuTvgaQHdaKyKszDlO8qkx5ITo5c5KqjFPNRY+Ql2ExyGMNmO4gTjPe6bDqtxfLrSo4CeMQLGNkthhJ4Fsnk83sAm3KN7t+V+4m6hF01fElp/tGk2ti79EmmOSVTaui9vxRfupu/OeEWl5dx76mcg29Z+OpJlMBjsp4R9WvSZXgS7TG6BK9NXKZWe1tKoJ+PjfzbOB5llbCm/B8707sU667jExOgyn0rhx5nB82c5HKHE9LSIaJhv87evOq+ny/VleeCNFsb3y1CXG/G5k58W68v8HeV1ZmElNSHqTZAacZRXoCdPLiwpX4e/rFKeCOvpszGhraFazUWJIyP7DJl53UXwDoHC4vJphSWVfwRvtibHRxnwzXeYdHs4Q2heEic1RqDfMYtyKfTqiYyqfPtQmSxrnkuMjdzW2SpNt0srCvB7BIqLy1OslD6KfzW9rCH3JcVG7+xJodsQmhfcaj3HLehW9qQgoqzARqC6urp/faOyTGE48IeyTVKovDQpKqq2p2vVgdA9LYAoL7ARgJ6sOVha+dBPDdaHMFO2R0PkeYnxUW57XvV17QWhfY1oH8mvZdartHIW3Acs5lXGoU03YND3aW9XXxC6t1sgwMrnPTIGe4/ABmM2TN+SGJFv42Mvf6mGILS/tISfy9FivllaeTmI/Czm2A2ESatlrebKxBERRf4kuiB0J62BhYoC6IYn20RjLBK9kw73Dre578UPOJSJx4zAT8jveLvkHfbLtXveYz8LjOW3spLK+/iKMma6VoUN0D4YERHh9SkH3Sn4mYWV7iwk2PJOnzD/cWxRS8R5gbO7Wjfu+gvGYWv2bc9d0dW8fJme+1rBAudIK7E8gtXhyTgD5nUdkf4WHx99wJfl+Dov0UP7GtEAzw86sgRfzL+1sIbbUZUxsN1Zo5d1o+Liwvmqm98Hh4Tmin9paVWSv7+Nfo9ugAnIvXhiwLcS88jcJ8Zx2INclxQfvSGQquGQ0HyZsqystg6+Nx6QSEhuQsKQetyDLbYIwYZAy/Rb2ZF4ZrW8RpgVThGkJ1Ljoj4P1Ho6JDSvzMiR4ZVYxvxQpaZHioxVjbCYWh8ix+yxd2UQqJUWcuPIW6zsnWpWxsDt8bsY9L4PIr+MY9U+CnRsnBKaVywx0VCIN/iPqPT7qkInNikV+2Cg/Q7cnX7Ne/FAr3xflJ+7raUW0211DdZ5mFkpwTloKwaFyiuGDx/eEAx4uCQ0ryCIy8+3uJ57rzlZZ4EzavVREPwEPKfnwQ3YeuHPzv9pgE5JW3yo8jxFwSYOc/Mk2GhvJhrNlGBsu04JbWsufhQArp/iH+710ULUx6B33VFQXI5VT4I5VPo9LtYrTK5KiY/Y3/oi2JKL7x5GgJMYiyBT0DahcKr5Iqbe9kOteD4ldvijwTwecpvQ9u2RkBB9CL9vAWgyeu7Qn+ott2DS/S6VERziYomAkz0VNtRbsGjwLVb5f1S1um0phqG1ANLjnRv25Ypr9xDgx4GgDW7E5tla7JYZrtGQuQkjo7n5b9AP7L0itA1WAMSd5fEVI25quhIEpyUlFckKJWNxOQ6rNuFweTqdmk1/ws4FLdQUnLHBwnEfK2z0EOL8JzUxeqktP/HdNQROHwdClqpEPYQtXJtgMZSHA3Z+7FqugZW6S4RuX1UQnLttKmz9/NP2HETn5SilpbWRqmROU2ABzv3lIfYwWxzx7T0C6Cz+gPP75qoKgzmytFMKlZ5K7gVbZO9r4LuUPiW0M7FAdNuMCD8wnn9E6CICWCO4WaVsCMYtGsLUyn56cnl3bj7torg9lrxHCN1jtQnygoqLq85j/aGqNSjTQOPvNVZWn5gQw/8RRWhFQBDaj6nAxyQH4cmLOyosKamJVHSaqqTIs07iH+/vfix2r4omCN2r8LsunI9JECzcFjkevjbsVDfXCfvwU8ndunM3Tu7GFfG8R4DjDBLLthxAYpX30ILMNkRcf7tNaO5N3XVW4mlnCGRkzn86Y3z279vGg/9Qu8BxBnk7nB1iF0VcukDAbULb8jh8mIXarsW3Zwhg90ss5uENbVO1THW2vSV+eY2Ax4Tm1nanz4hrmVv2umCRUCDQHQh4TGibEAcPVWZgoSTK9lt8CwT8AQGvZjlaN0juNhorRxUay6dQQkdqSPQz1riWXZRY3hZBINA7CHhFaJuorVu0DmADwGUWUnUrMbIriorLN8DmtEJi7IBGM6C2Xz+LtdVSz5ZMfAsEug2BLhHaJhW8S+7A9Y6iqqoP1UZ1IWHkGYzdNypKw6+a6+lrMGM04nktJzk/zrYnR/GtU2BqScmJQaqeDZTN1rMUDWkIRltgW3v05W+fENoGYKtBzJ9BokdxT4WePQZGM7+C34lLYLU0RMV8KjZhJsJVL4xoaL5EWA2jUhlPj4NujzHKzoK5IzdaaqQy2aMqcDQusSSJSNWw2tMizXA4OCnBLC3TKKRWpepoLKadxBYimEmScKxDmFUiDZGIkorNy0OQ6YUoL6klfxg8kGZaZ6FEwZaFbZDxt3ixuDGVCEGEgE8JbcPFrgfejXv80ybAxDRVpWQM7KcnUJVVoDePA7NGEFUdAHVlskrY2aBdPeyp6+D/YiCIy526NIGE2I2saHGvFCaqVSB/OO7r8MIcwTfX3XdRpjbh0LkDIPlgTJH9F5Q9qpP1u2Jjh9VArqC3BwYGfTp0C6E7QxRqRwHi8M/77eOCtLrimpqwpOHDOUlbAu6Bi6d7U74VDL+Zv3ruscksvnsHgV4htKuqgrh8V8sZMvO4NjLzazHA5CiI4AwBr+ehnWUo7gsEehMBQejeRF+U7XMEBKF9DqnLDM2q1DJ4tYvU1jjJ7oG49AIBv9OhvahDwCQZqAu5y6wbbAoYgQNQUEHoHmy0rzcua+8DGqWLuXBfNoFQOXyJpsir1xEQhO71JhAC+BIBQWhfoiny6nUEhA7tbRPAZjYnJ6fLHcLaHdXYgtVmF5a3Eol0QEAQ2hsaqFITI+rMNdurZ3qTvEMaylZ3uCdueIWAILQXsJ0dHvHswePHfOIc3EIVdvaQ8YX5ZJUXkogkAgGBgEBAICAQEAgIBAQCAgGBgEBAICAQEAgIBAQCAgGBgEBAICAQEAgIBAQCAgGBgEBAICAQEAgIBAQCAgGBgEBAICAQEAgIBAQCAoE+jcD/Aw2BwF0hcZgiAAAAAElFTkSuQmCC";
  var no_file = "data:image/png;base64,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";
  var no_goods = "data:image/png;base64,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";
  var no_image = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALQAAAC0CAYAAAA9zQYyAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAtKADAAQAAAABAAAAtAAAAABW1ZZ5AAAmt0lEQVR4Ae19CXxU1b3/OffOTDZIgLBlAbIQUAkoAqIFNAHUUi36WtBXbatWi4Bo3f6vFvW9tFb76mvdWKLWWutSF2qtK4JkA9wFhAQQQjayAmFJQjLJzNx7/t8zIZBMZrlz585kEs79fJK595zf+Z1zvvd3z/2d3/md3yVEHAIBgYBAQCAgEBAICAQEAgIBgYBAQCAgEBAICAQEAgIBgYBAQCAgEBAICAQEAgIBgYBAQCAgEBAICAQEAgIBgYBAQCAgEBAICAQEAgIBgYBAQCAgEBAICAQEAgIBgYBAQCAgEBAICAQEAgIBgYBAQCAgEBAICAQEAgIBgYBAQCAgEBAICAQEAgIBgYBAQCAgEBAICAQEAgIBgYBAQCAgEBAICAQEAgIBgYBAQCAgEBAICAQEAgIBgYBAQCAgEBAICAQEAgIBgYBAQCAgEBAIDBQE6EDpiOiHbwQWL84ZdIx0LBlGRuSuW3ev1XeJ3hRX/nRlgsQsretfy2nundv3KVLfN0G0IFQIHGUdbzPGfjFpUnOHnjpzcnIke4da0G7rKFq8+C1ZD49glxECHWyEw4k/ZZsJoalb9tky9TSraI/tZkZoEmV0zbp11yl6eAS7jBDoYCMcTvwlaT2DNKp2tsTfZs27bmU2YepqQlgjjWbv+Fs+VPRCoEOFdBjUE6la6pzNoGThzTfnRPrVJJVAoEmUROmTeS//4ahfZUNILAQ6hGD3dVUXTSKNlNANlLDE6taOqVrbw3VnVWJpUFfyJCnin1rL9QWdEOi+QL2P6oRgOmgUuY0wuptRcpfWZny6p+MSyth0ibB/ffJGTucor7VwiOmEQIcY8L6uzqkuSCwX6sOMeYt/s0hLeyiT6zAZtFIqVWmh70saIdB9iX4f1Y154WZUvY4RslBLE+LIlIOUssc3rXvsQy30gkYgEHIErr05Z8j8Gx5IC3nFokKBgEBAICAQCAMEFtyYE4u/5FA2JSyXL0MJgKjLWASwtE6/Ke0YOm5S9rl2h/0DRXEkVOzZ+rGxtXjmZvKcJXIEAtoR4As1NW3ts+dd95sbYa8eSYj9Mti8P5PlyMe1cwmcUnjbBY7hWc0he/ED0ygjNxJKrsfgDEFmJkrJPomSFapJLs3/x6MhNfWJEfqsFkcDOs/ojxhh92BU/iuRaAeEu9pMIp7f8FbOMQO4CxYCgdAisODOZyLmL84ZG9paRW0CgbMEAaFDnyU32l03p83/dVwHa5pDVMpKCnIHxCqg0KHd3ekBmnZagJmURRjLalea4XFHG+D/8By6PCAEWozQA1R4ebecAqw0z4YjUhasD1mwREyFk9EhnBdJhBZKklS4M2/N/oEEgRDoAXQ3Zy64M7a13TGnhwAzchiCXDhQBdj19gmBdkWkH10LAe59s4RA98YkbFM8CTBW5IqwmFEwEFUIf2+GEGh/EQshPRfgtnZ1NiMqJnHQgym7kEGFcAowdGD4KBfuKsjdF8ImhX1VQqDD6BYJAQ78ZgiBDhxD3RzcCzA9gptSiFFYjMA6kBUCrQM0vUVmLfyvwc0trXN6qhAQYEqKsC2qQKgQepE9U04I9BksDD9zCvDJFtiBWZZKSBbAngaPNKcAc1MaNcmFxRtXf2d4xQYwvGjeHfFtTBpSkr+qzAB2IWMhVgoNhNpVgJtamk8JsNMK8TcI8E0lYSrArjC0qco1jCi3I32ma144X4sROoC74yrAfAQGu0YsJxeG+wjsq9sXXH5XhsNh2xshx8Vv2/THJl/04ZIvBNqPO9FLgBm9EKY0HhariFDowGGsQvjRzdOkmdlLa6hEVxTn5f77dGKYnwiVw8sN4gLc0npylgIdmNuBm5pbpnUJMCZyLxGZ3lyyKXevFxb9Ogt+H5uISuaiE0Kg++OdzFq8fNCxY2S2qwDjNYYRmPydyNItA1mAe98zmg+LzK97p4dvylmtcrgKMLYPYQQm2DrEnDowgTdayaa1A3YE9iWWmVcsH8NsahWVIxJK8p6Gl174H2eVQHsWYD4Cs4KzXYDdiWtm9rLvICS/Ky7I/Ye7/HBLG9A6NBfgI43qLAKHdoSQzWo8wqbzEZirENAPXzbL8i925K3aE243JczaA7WDzkObhECH+sa4E2BK6TGMvlyAX7FI8q1CgP27K9jRnQdV7P/8K9V31P1a5XAVYMDoHIHxywW4EAJcKAQ4MOGa9sP7hre3tB6WTHR88abc8sC4Bb90vxLoKVfcH6PYT2IpuVOFADzT8Xccowh0YKlACHBwBGZS1rLtkkRzi/PX/iU4NRjHNax1aC7AqqMNOjC3A8MfwtY6gxIKAVaL8PuqRKXbdhas2W0cHIKTOwQw6uUxlXF7tBBodwB5SnMnwKB1jsDYE/caBPiX3+av3gO9GLG6xREqBKhE8hGE8W/e6ttXXrsan61I5SumoNtJLZF7xycNa8C9cngrZ3Ren6sc589fOlVR6GLnKOxUIegJrkI4N3VSqVAIsNG33H9+fK7SeEQ9JlnIhbs2PlvijsOBhoaRKnbXUJVl4/7x7yDOxOqqDValTwihz5tp9NepqUNPuCtrZFqfCzT0s/VYRk7EmPs8RmAhwEbeXQN54T5tgZr3z5LCtU9rYVtZeSTBQRznQFVJxugOdYXNwui9D6P4RyQi6v2M5PgaLXz8pelzHRogbUWHZ5cU5q7hjafU+eNvPwR9sBGgJB9vUW6P1iTQKSkj6kHL//jxSnU1i7La67A/kt7COqxP7S+vfZbGRT6cER9v6DfDpc76+u6/ZGJ5qH12Vk5Onz9cfYdC+NeMt2ce7PmX6v3G95gx1DohLemTCelJN0CvvhoPRzprsm6GYL96+PDhQUYh0OcCPWz2qG94Z45vPXyxUZ0KFz48mn24tCXQdiRHSF/i+4aWfY1F3FQa0NEp2MlX4yF5AHr2nBMtts/LyuoMiWDa5wJdyD8GiU2hikPlr7N+fUQ9WJ1kebj6BvOD1c/jb7/loZo7+3WHujV+/fpVHZjgbVGJcfdpfGrix3DB/T5MVocdVN0BoZ7drUpdp2HxmscrKF9l5D/Qg9/q6kUfFeICrEjkMqaSLDQhy85YBlF6NIY/pM/0SOnHF9B/oR6qV6ALjxnVjQkpiXsrKthVNlb3koIv1ZaX181IS0us0ss/LF6JmfOWTYFQfBU7PHLo5+uetOrtTLDLuQowVIoMH3U2/ccFY+LXXUd7irmPQuGanXn5iunErmweE2Ua6hyxDWwosDSXlteuglXg0kGR9NLExERsZfP/6HOVgze5eNPaYvycbG60Xup/F4JXIjrnSGJ3FQIjcI2qsNcA/i81CDNvWNy/d9bwfYYD4lg0a/h2dKTjoE35ntEdwlvaHmVJugeRoUa0tqt/1ss/XFQOhv1reJ053RQ36O1MoOW4ADvs1svwanVuubLZrBMC5Yl5IVc7vgqUTziUz8nJUTOzlhbAlsz7xFcEDT2Sk0n7gUqyijEpTS/jsBBo3njYo/MwOViityN6ynkWYLTEqIOqc8HqD0ax62s+VJLysVhyI9rxkNFtwSjNKiqOP2NnrV/r5R0WOjRvfObcO9MJs+8zxUUO//bfTwVliTR6JVavqDWrawTGEm3AI7Bv4Kk1ZXTy0AN30Q7ftOFPkTl/+bnEwXbFxQ4e9ul7j7cEo8WwTW+A/8gDGSlJO/zlHzYjNI/Qg9dZvaPZno1OvONvR9zRuwqwjUCFcA6+Bo7A7irukcaiahpruc5Z0CO5n17wPZZYBm9sam2+DF34IBjdgB79OVGkRPAOT4G+ZPE9US1HHYk+w0pR+gljTjunLoGOzake1q6wK5gCMxqlWTZmnRh6Ae59i1XFGQpgQAg07x00gzyqOOcGQRFojM5j4Puh6zuHIbFytByzzoM64XuyBzfFUxOO3lKhIaXDQS6C8LyO8fd2WCEmaigSEhK0hU+iQnJMW/KcefJVy4YGszLounlYA+Vzg6AcwGs6Atxs0sM8JDp01zYe2WJK37VxdYWnhk69fEWize6ojYyITNy24akuxxZP5L3SR+QcHnTc1s6fbHOvzD5IMGG4mJpoIbNSIpXU4ZbUF1f+ttlGmuOjzabGL9evMtQpp6t7mXOXLcWkLRfDaB1ubjHeUMVoRgl2tBcPGztiT+FLOe1dtHp/p869Y5xNVSosUeZRO9avOqKXj7ty5eWHRtmJo2hiWtI57vJ9pYVEoHkjoHftgCVjNdwP/+qtUZlZy/YQmTxWkpf7qjc6T3nmBw9ugQ4W8BKqJ/5a0i9NjSB3XRJDrsiIIioa8021lax8/HVbU+l2S1d5jHKtyKqH6+w2JrF/R9K49UbFkDt/7j1JjHZMVlU2GfVNRj3wT2bnoi4zJsRlnYLOijHKlsRaogo+3/Ck3693mFkPECKvLClY81ZXn4z4PVBZvwBq55SM1KQ/6uEXskkhXiF5p/RjrwINkPOJ4nxF6xJo5+sQ7qh6wAi0zFXnRJJH5g0iKcPM5OXtrST7hcPk23o7URBLd5h9qGVEtwrwWo3B5XgI23gsl1/fQZrsk7KWvitZTA8HGmJ3Z/6TteDN/z7uqpJ7yX3XtDlDUtRMBYIOoT4fo/d9LTbrP0CztItO6++pZXCuShkm0Nzr7vhJ+1OSJVK3ihY6gcZ2eHT+b74Ao3BTRBjXp3zRecrHiJiPvP/xlB+M9CGRlDx91WCycNIg8vuCFvL8V0dJSwc0+W5H25CUble9T0HN1aRFzKZcOyl72YuymT2M3SGHe1PqS1m37joFJXksav73zwuuvXuIo6mjhsjyG3o4IkB7PqHqo3rKuiuDB9x0oKIuGxs9WrB1iz+Muo6QTAp5y2IHDd4K98P487PvmOStpYPNliLMo5MvvHL5eG90nvImmsd8Af2xzVO+0emZo8xk112jSHKciUxddYj8eUtLL2HmdbZHjyKKKcpn9bCNm+ArvESx0x2T5i2f4bOATgJHs+02qCEHSjatLtTDQrKoBXi7pPFwYXrKu5aprKznb6ufwMLxCF9gcc3Xeh0ygXYa4Sn7UiGK19cJ1+fwOtxhtzl3GWvtx2m63TnUhhu19XRCEE+mJZlJ3q3x5NVv28i8F4+RyuN8EPR8tMWleM50zWEsEbrK5ilzl//ENSvQa65+YERcgbeh7jchf3tA8Iqpg80PtD28vI3Ri/DTDt353UD4hUygeSMZwbJpp7+G1zYjbBfUjkBMXdzNMbjHlNFmsvGW4WT1561k5UZtBou2IeP8bVSkoqqvTZm3fJG/Bb3R72nMvxaDRlRyhPy6NzpfeRhH+W5wrwOULx4837ljhSkvyCb2mhZ6bzQhFWipM6zUpXBy8Vov5lDQg2kWwALu/h9UkoMq0NFmSl6/fgh54Zs28gh0Zq1HW1yqVtLudFRV1b/z3fHdEwM6Z/RuvNOfDdQFlMl84KHZgbSFCzN2rLwJNfHe9HHJAd83r4IVSEPdlU2ONH2B9Ih3Nh/1uo1HNg/aihF6yOT5y7nZye/jQTlhB7ydguIPwhuz6upY0tSukgc3NvnVNlvkUOKwxPpVhhNDt4xWHPRdPpHzu7BLgcnZy3jQ9ouio2iuS5bflzEW82a8TUc5/Tv8Lt1ZoMmqjION/F3YnVfrZNGjWEgFunNEYFtVYp/boxUuF7s2/qkVQ/MXVHUur7rk+r7MyaEY5J0BT3wT+0kxe5yFLJoSQ2586wRxoBZ/j1Z/9OhuzPGAj1Ga2n/TLUnXKUbmX2E94I2vP1rboItBt0LOxSFGv4Ye7fV+divS4xQO/QuZoi6YkJr4fI+MAC5CKtC8nU43US2CyvWzAPRo7m8QAC4eiz6cFQOzXCup8DEB9MRAhx59mhW2qd0ViFVhxg+Wjwam12Nz6tOnmQZ6Iumf70ChjMGG2T/5agJUTz6JlX3R8fyQCzQzO/XbWQsW3BnhrYGyCfZopn/bPCUm6OHGHjPHWMj3UqPJn7dq15tdW+CXpcO1MCGRzM4e6p2sLaXNSpbDdPrlrvw127WV8E0FAXLOd3zNi9xxykhJXOcu3TVtf0Xd06UVtZ+WVtWf55rneh1ygT53yKXQb5mt2s4ucW1M9+sJQ0d+haVa+btjRdyc4/dh+33iXrwO/PYH8VbRz6ZGkzd3tZKGFh26xinGDstgYouK91aNjzy2KEtHDBM+gMDxa6kk+V7c8tGAHtnDxo7+DKN+1NtFh/yetMLs5+jBzOWirq4uen95DV+JhHMbfYg5lA37y+secSHrcRlygXauWPHPADu826PXrcuxwcixmSn69DPeS6g3ho7S3x9vIR/u6+gBoJ6Ltji/zXdnqmFk2JEth+ecSdB2Vt1BkvGKj4B/x4vwwziBv21Yal83ae6y/8VEccmU7Dvm8a/HauN2hsrp7ETpZ6oGc+yZUtrOTnaQ22BF+QFUpKUIULNpUJQ0Fe4T0/hmWry93cqu20Rt1QVAxaNZatCPuf8H5vj67ZwG6tETh5tI0hALyTsQsLMaadVnvjsNOGXqNacvNJ5wX/TdBblx3JOREdNVWBN4GtupdmP6nISJ4k0KU95pU1RNKoBrlZjA58Haof8+uTLEtTPwjMoelCn9aUZqQhEn4TvBoXNfCxNfGVSQN0orGi52LRoUga6oODzataLu12Zq4hO26TyqZfd013NEIOWCf0nWzTmRrnlarmVmnB59YZKF7G2wkmYXHw0t7XClsTpHaIiBzgNvLl3mTF4dd8vdXbD6090Fa18uyV+bg5iCP0Mg89kQknpG6T/1NEkiCBNG2OzFi3NOexPq4dNVBnE6IhXKPoZqWpGekvBeVzr/hZpiG5+S8DSC3r/JVMdfoJI8iNHa1EVjqEA3NDTEYD/Yu3bVMaurAne/zs9E4OM9jY3sMnf5XWk/unTEt1AbrMeqjnjl10Xv+tv+aGIV9PAy13Q916MGSaSuRdFTtFcZxRRJ2mNG9UrXmgBdmG9PMuw4f+7yH0Igh0cOGvmSHqYTh1/2DVQDx3dHj/QaMfXws6v1T2BZOV6KNi2EAPeasCCNTUhPfJvK0k2od0Zped1b+8rrfsnrMkygy8pqJjS1Kq8yysoy0hL+5asjaAjf5T3XGx3fNg9FOD+w8FPGLIOPGiST+pPeWutfXkDWDkoS/KvNO7VK2H148HO3vZ+jy6mLz4uwDF6Et6nX++m9FZ25+8pqczAyL0GIsGXjR4/26m0IK8n2GAu7lcn0Fag8y0rLax41RKChz1yjUPIKdN6Po01JD/InyFfjub+GFr0Lgg+1w7vge6urUw/3RqEtLxYuoi1wezLqaB2SopsVVg5j9ZjJ3FXIoyEB34ujIqUAV+owQKmB6dEHDx5JhCK2CBaNnyNEmM9BkfcnOTn56GAL2YA3TBnu9YcBCTR0FwoV4xmE8XqZEukvWPF5jodNdQeca5pkNhXgxkzxNbOWOwV/+swFd8a68tBybYmSC6B5+XzAfPHiproE7pJv0GEdPAbN0gc/1LBG59vLiLbYlfvA77VAVw6pScrHADWTf1ZET7O4T4fV0YHg9/RjqBN804Hmo00xJcKC88H4lKTP9CGKqqqqTgzFyPwFdJ25cEO8NSMt8QXNLQAh31uIxldYmTMQi8eiuwpy92GUPmRtd2R5JPKScXJlwhE89cVeSDRl1TQpJDlWN1y96mCymbQNTu6VrimBsjpNdD6Ips3/1ViMbD+WzOwJH6Q+s3d9sqoEM7bjRGmb45PYDcGJVtt4POGxGCQT8Wd2Q+I2yTmBtDuWTUhJcnoO6rpD3FzS4Wj9jjLpDZlEzYLOrGt2DJ2Lrwb6NPdAIPNUGoB+Rp27WNwCojWxtlkhSXDiD/SwWBvJkIbtJHHfOySyTd/ns/FiNESg2xXbryCE+Z6+m+JPX51qJtwVEPvP5/10x3dCavK3JhZ1AeZMKt76H/NPWrijc01T1dqxFmr6P9TvVAj13SFVvQSTiJUYlf/qWoFf19werdBHfJWRGASa0ft90XnK59HnFabe7SlfS/rew3anHXr0YMmvlUIuwNFNVfg7SKKbDxLZ3qqlOq80EmWfeyXQkMlVuJPtjtvg6bZIA7kmEuiw+Vi4WaaJ2A1Revow7r740wMVtdfblI6N+ytqH8PE7w3nw+KGnielpyfv756Fwa/nUVZ9OEOx25fgyT0gq2Q33AeKT1XUk9CAq8x5vxrFlI56Oco8dtf6VTWeWPJXY7ujo1K2kNF69tkNyzka22xvOwo/TH0P8KmGfX77MPLaLhuc+j2bO04LMISXC7ERAuyKi2QyTSnetDogNQpRqu4D35tKCp+d4spf7/Xk+cvSEBelNNYSOULPTvLu9SKcwRSEM3gPAlpnkSw/PvXNlu4kbs9PC/T+qkNpVHE8gE2mF2NE2wjduBbhBIrwClloInRTenriVrccAkwEsLuwYvUEjPsveWOFZdr9aM9/7857VtemTkTU/xzqTUB20rtnDSKLzrOQ2X85drqpPQSYj8C2wEfg08zdnGC0Ki8pyE13k+VXEnDfiNf7XFgU6jBnPohZ80EMYgcllVSrEj0oR8g7vA0ynirDBt9K6OX37S549m1PNFrTnZ+Ka1WeBL8pVKY/1xLrzjli8ZU9u2J/Gx18Q5LlpzLGJezpVun2bufGn3K1w/nZL/KSN+ZQcRDewOkfrUuguTsprCoBCfS6YitZOj1SGdW4Q5aPVXaqEEEW4F6YMPpirzQdCcNTRi88XnUkXZXUsRDqMRBq/JKxmNfMhE1orNru2Aa21/nLGhaTPAjgXJQLWKBP2aFv5CoIQi98WFpRd0tGaiJMdJ4PE59R8nVxfMv5Dm728EwanBz4FMAerfrcPYGRiQvkH/W2QpKkPGxletDf8qh3H25QARz/ChvbzUW3rbj/5NBG9QDaon+pz99GnKGvlyzRuje2nmGDj9p0RlCCSsnVSuMOvr4Aq9R/G8cRwUtSk97ESmAdHJN+Cr5eBRp25JqH0IAEbIG5w8hGaOU1bf6v4zqUpqPUbMr0FmBl6oI7R9is9kP4QH3qjvw1VVr5d9GNf4ZFVB6qPoFRyKtfiFOAGSukMik0y5GFrTkjG7p4dP1Oyl4Ov2J1Tdd1qH7hM7G0uHDtc6GqT089fBNBW5tab5Kikk8FvPHIBoMp3V9RP9tCE/CVWdrukdCPDJjt6EXQmbnPaZ8cPPwVHqhvVLt3e3RnDDW6067q2zbvjM/M6KeuneQCjInEc5JMfhJhiUywPzrmHPtjY5faHhn7hjth5uVHXDbyeeC2xZVXMK/RxsJzRmT5ZesPZns88XYu0FCyRyFWrnZ4PDrXMerWY6J+r0ciHRnQodmImAhm6GvH33bgZnG9i9sv13otCz36lL+ATnMhzYMungwQ3Y7AWle2C/EpOrwxfow3xldob4rXNhuQiYeuPBrmtVPRjwzgGFwWXI+GSsbv5yvuatpfVnM11jFwr9lH0pCo/0qNN2Z05nUhsgCtb+sg091V7Jq2r6LmCW5OcU0P9BqvUi6oWb78E5xuiliZ1Fuf/dGk/9UyAmvhz98YMJ8thGVAW1AOLUzd0OABbJKJtPCrvDVH3WSHZRJW9BEWufd9gophKq2oeQxvN66u/WJCevJS4z+NTFmSqhKfDuPchEJU+jM0RN/ylhfoh40bAVWAxvxr85ELvJCR2MEx+IA6Ge4rnJgnHhjpAvbp6M6b24ItkokvMpV1TzfwvBRzi4t3Fqzp0zeov/2RB0cUwrci6YLL78roKstXl7FQUgW1+cJBUXQa34HSlWfkL3zoyd8YVa85cLAh0xtj1qY8DIH4MC1tlOECfWrG/anaGb3fYzM6w4mRr5TOD/F4pAtlBvftHmyJuggjdb6R9eK1vUmKoTO9TZSNrM9IXvwbOfDZ3u5Q7FztIPsrapaqqqMIsvZmbLT8Y73fINTSRgnG6ucw6n2mOJS3y8oaJrsrVFpWdyNUgtsQqfJ37vKNSOPRLKF3+VQnMIHU5P9hRJu08uCrYtj9MR8qETcrVWot546O68uyJN1QXLD2iuIPc4+7o+kPaejH6yOHxiVjU+tLuK/L4MB2+cTU5HtHjx7dGsz2Q5YJqampiYce/TJGmSuhqOdIMi0wMbnORtRI7Be4Ffa/a6DH3RKs1ULehinzl12MZdNNERkXDN32/O12nubuyJy/Ios4lHcWZY2KN8yF0l1FOtP4NqS9Rw/dTlTyMwwCfG7ixNgHOzyn5GtYm145J37k83yDsA/6sM6GriwdKK//Cfr/G0alx+Oi6dvBFuQuQE6DjUbIByrr7odvMzye2Pc5AVA+DIIXosyJq7X6OXcx9vcXM0LTkcKGY7JMr9qVl7vFU3m+Hb/a6jiOXQqX7c5b+7UnunBI55H0Yb5aiLnHhcAUbpGUO7DHQ5E/CnW+zrnsLJFtZll+b8cnqw3xoOvrfiMCf7aqKv+J53icZDavGD9m5IG+bpOz/lLGIrjhO5SNweco3oePwf/4qpP7IUyeu/QBX3QiP3QIlFbWToU57sn9ZbUH95XXrghdzT1rknpenrnKoLTDaKvAGe7uzxBpgS+bOicS7ik6U7lZCG8Sn/q2Nx4izxgE8OXXIRDkt7H9CmsJdFyUZdAFRgVe1NNCjwKth1mgZZwOSJTNnPbDnGhvvFT4N0PnnGXUtnlvdYk89wggqtFwOOL/Pxtr+xYqVBRCt10BU9yPxoyJO+a+RGhSw0qgizetLYa1o6n9ZMMcb90/b1gW9wC07z3e+D1vdCLPeAR4ABiMyM+etLJtWHFdgl0m509MT/5B+tjEb4yvzX+OYSXQThUHy9uwwXpVO/gSMEaFQoRiFWqH//dcVwm+iRUhBn6rEP45OHoNVMNnpRjTrGBt/tDVSBQKaAeH3kq9lcMslIctWOKNhudB+PMwQmA2TQx1VfRV79mWX3r0aKza1P4Youxfwy0EjMp3Sqmj3+RzrHDEIqxGaA4QQ5gwCPRUX5/3lZmUD4Ge4SucWDiC3h/axP0u9pfV3QBh/ho+zgsQpuKJIYMt505MS3g5XIU5bHGdlL20KjN7+Y98NRARNBsmZ9/xA190Il87AhUV9SncgQh+8sf2ldfUITbzEr5Qop1D31KGZUOd7ocawkpBj8sLLExY34IfTrXzNQce+NCuql8xld4Ine6dSHnQJP65CKh3aji11Vtb3OrQ3KdDJcoMkpb4Wl+8XmDpgE1Tfchbw3me0/+DsD4z4vtqX3/IhyDL2Kt3LzzhFsMUunVwJD0vmM5DwcbE40ogd/dDuNKb4TH9BZXNW7CEWR6qhZZpV96d0N7RXmcxm5K8LQlPuWJFqmJzlMXI8oj+5C8c7Juqhf++6sYkYu9YiVlLLIaGJgs1/z41tfd2My28wonGo0DzRsKZf5SDOD5Gp/mM9gMqy++MHzt6TygEG8vgexC24LGSvNxXvQEGunKsHP66OD93nTc6kYe7yJ2GKuquhvfb9RiNp8J5aBuc0J5JT08Ia58Yf+6dW5Wji8Ep3+eppTVHk1mH9X6mKC8gFm85wpa+a5YitmgN/tHFz59fgJ1HFOc2Hq8CDZ6IeulcBhcC7QFgHqbCRpULoVrcDY+zI9jhv04mCbemGrQx1UO1fZLsVaC7WpSRHF+D87v5E152sH6q4mCPIFTTw1j6bMFjfxxP+xcIR4B9enLthHGjyrvKBfKLr8HCP1rxuWWff80Ugv+7QOoaiGWxojcbcaKsqoNhomebgUneH2VGb4ML8MGB2N+uPnlVObqI3P1CuC1VVY3xdmZbojJyE3YoDIP9OA4MOyDgH6DMTqgmu8zU8tW4ccMb/FVTuB1abSONERY6cfuGtR5dELWGE3PXh4GYtq/80PnwCrgPE2YTfCWjJUoLLVL038eNG9JvNwv4c590C7RrJXy2XFZ96FzFoV4CW+BEXCfADHExTGsO0OKTYoQHhBuBCP9VOK+GoX5rRnrik658ul/DTRRGfekFX7EooEcXo84/7SrM/Xv38mfTOV+aPt5i30Ak9qXEqBkTvffHpyZ84u9A0t8x06RyaOkkgFNAV3Lq73QRCDbAJcr+mqMJ1N5xHkYODOQ0DsI+5DSRhxPufceI01/De3AVfM0U0Um5/8dZJ9CIKDQHkaceOX7SNhRvxp2EyW8gvDEPr3BWHoYJtCf0IOhd26lqQcP/NB/YvpNHVPYqHgqw8bxjGyMSvsPCvMf00Fxr+BM6TarMMZ+b2/AGbMLO81tSUkZXhH/Lg9/CoAt0IF2IiBm5Fa6kcZlz75oCPjs98TLLsUUIJzZ6SvayiTzivye6/p6OB9tUWt5wJZzp4VZm/kfG2JGVeND7zSpef8ffkPbDX6Nocvbye3wxg//Hl86Yc74I+3E+BJp/xN2weU8/hsJj0zGXCu/jlF+HV/9o3gNOB6+wueHdm8Bah9FY8aZ6BcZ9YJQOe4FGrIu38YKt9AU3DxOGxZhsX+HEfPER+f0bgQHz+uKfTz5SdeiETKXv7cpfw7doieMsRCDsR2it94SHE4Md5DNYOwa02qEVj7OVbsAIdOcNRJiwAL9merYKwkDpt26BLq2vH4EZt+7ywQAQH5bJx2LMnGlLnuOLOeI4CxHQLZDUIceVVtbdhJ3Af4Bgw6/jxNC+xi9+zoiv0RbVUb5zZl+3RdTfNwgEPCk8UFU3DfGlp+ObI/8JE+kX8Opqga3/IxMzw+CvNKWlJVaFsmuZ2cs+gAfg1/j+3m9DWa+oKzwQCHilcPy4RP75r20YGV/AiP1zLFXfAaFOx0cT58Fv4yOEUz2GVesWScUubRKxPy1t6EluTw1W91Hn+5gYXszVocrKhrGoiyoKGcQkNQku7nFwbrdmpCW9F6z6Bd++RSDgEdpT87mOTaxsKkbuTBUfJYduGwNhmgqnpHNRKT70SE/gexjb8TsY6cewMjKcbwdCnhXWim/BNwo+1hlUYvUY+U1YNBkNB6QKvoICPekwbM5YDqcncF0Lp/Ux4NGKB4erPefgLw68ZiA/kju0wx+qAb/wI3HGkthlkRL/kDoAnds93YuzKT1oAu0JRD5yllbVT6QKyyYSLcNoOpSq1A73oxhKlIUIzHERyjY7BRXfgIGgRuNhaHGOroQOg2BW43o3FltGQfAteECO4KGwI20b0qyEmfaCD7z51GbJQo+mJybWY5DmLqziEAgIBAQCAgGBgEBAICAQEAgIBAQCAgGBgEBAICAQEAgIBAQCAgGBgEBAICAQEAgIBAQCAgGBgEBAICAQEAgIBAQCAgGBgEBAICAQEAgIBAQCAgGBQNgi8P8BwPnZXXBZxo0AAAAASUVORK5CYII=";
  var no_message = "data:image/png;base64,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";
  var no_order = "data:image/png;base64,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";
  var no_task = "data:image/png;base64,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";
  var no_video = "data:image/png;base64,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";
  var open_browser = "data:image/png;base64,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";
  var images = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    [Symbol.toStringTag]: "Module",
    activity_over,
    activity_to_start,
    error_data,
    error_file,
    error_image,
    error_net,
    error_page,
    error_video,
    no_account,
    no_address,
    no_collection,
    no_conversation,
    no_customer,
    no_data,
    no_decorate,
    no_file,
    no_goods,
    no_image,
    no_message,
    no_order,
    no_task,
    no_video,
    open_browser
  });
  var emptyTypeData = {
    no_data: "\u6682\u65E0\u6570\u636E",
    no_video: "\u6682\u65E0\u89C6\u9891",
    no_image: "\u6682\u65E0\u56FE\u7247",
    no_file: "\u6682\u65E0\u6587\u4EF6",
    no_conversation: "\u6682\u65E0\u4F1A\u8BDD",
    no_message: "\u6682\u65E0\u6D88\u606F",
    no_collection: "\u6682\u65E0\u6536\u85CF",
    no_order: "\u6682\u65E0\u8BA2\u5355",
    no_goods: "\u6682\u65E0\u5546\u54C1",
    no_task: "\u6682\u65E0\u4EFB\u52A1",
    no_address: "\u6682\u65E0\u5730\u5740",
    no_customer: "\u6682\u65E0\u5BA2\u6237",
    no_account: "\u672A\u627E\u5230\u60A8\u7684\u8D26\u6237",
    no_decorate: "\u5E97\u94FA\u672A\u88C5\u4FEE",
    activity_over: "\u6D3B\u52A8\u5DF2\u7ED3\u675F",
    activity_to_start: "\u6D3B\u52A8\u672A\u5F00\u59CB",
    open_browser: "\u6253\u5F00\u6D4F\u89C8\u5668"
  };
  var errorTypeData = {
    error_page: "\u627E\u4E0D\u5230\u9875\u9762",
    error_net: "\u6682\u65E0\u7F51\u7EDC",
    error_data: "\u6570\u636E\u52A0\u8F7D\u5931\u8D25",
    error_video: "\u89C6\u9891\u52A0\u8F7D\u5931\u8D25",
    error_image: "\u56FE\u7247\u52A0\u8F7D\u5931\u8D25",
    error_file: "\u6587\u4EF6\u52A0\u8F7D\u5931\u8D25"
  };
  var emptyShareData = extend(emptyTypeData, errorTypeData);
  var [name$v] = createNamespace("empty");
  var emptyProps = {
    type: makeStringProp("no_data"),
    description: String
  };
  var _Empty = vue.defineComponent({
    name: name$v,
    props: emptyProps,
    emit: ["click"],
    setup(props, _ref) {
      var {
        slots,
        emit
      } = _ref;
      var bem2 = createNamespace("empty")[1];
      var desc = vue.computed(() => emptyShareData[props.type]);
      var renderImage = () => {
        if (slots.image) {
          return slots.image();
        }
        return vue.createVNode("img", {
          "src": images["" + props.type]
        }, null);
      };
      var renderDescription = () => {
        var description = slots.description ? slots.description() : props.description;
        if (description) {
          return vue.createVNode("p", {
            "class": bem2("description")
          }, [description]);
        }
        return vue.createVNode("p", {
          "class": bem2("description")
        }, [desc.value]);
      };
      var handleClick = () => {
        emit("click");
      };
      var renderBottom = () => {
        if (slots.default) {
          return vue.createVNode("div", {
            "class": bem2("bottom")
          }, [slots.default()]);
        }
        if (props.type in errorTypeData) {
          return vue.createVNode("div", {
            "class": bem2("bottom"),
            "onClick": handleClick
          }, [vue.createTextVNode("\u91CD\u8BD5")]);
        }
      };
      return () => vue.createVNode("div", {
        "class": bem2()
      }, [vue.createVNode("div", {
        "class": bem2("image")
      }, [renderImage()]), renderDescription(), renderBottom()]);
    }
  });
  var Empty = withInstall(_Empty);
  function isEmptyValue(value) {
    if (Array.isArray(value)) {
      return !value.length;
    }
    if (value === 0) {
      return false;
    }
    return !value;
  }
  function runSyncRule(value, rule) {
    if (rule.required && isEmptyValue(value)) {
      return false;
    }
    if (rule.pattern && !rule.pattern.test(String(value))) {
      return false;
    }
    return true;
  }
  function runRuleValidator(value, rule) {
    return new Promise((resolve) => {
      var returnVal = rule.validator(value, rule);
      if (isPromise(returnVal)) {
        return returnVal.then(resolve);
      }
      resolve(returnVal);
    });
  }
  function getRuleMessage(value, rule) {
    var {
      message
    } = rule;
    if (isFunction(message)) {
      return message(value, rule);
    }
    return message || "";
  }
  function startComposing(_ref) {
    var {
      target
    } = _ref;
    target.composing = true;
  }
  function endComposing(_ref2) {
    var {
      target
    } = _ref2;
    if (target.composing) {
      target.composing = false;
      target.dispatchEvent(new Event("input"));
    }
  }
  function resizeTextarea(input, autosize) {
    var scrollTop = getRootScrollTop();
    input.style.height = "auto";
    var height2 = input.scrollHeight;
    if (isObject$1(autosize)) {
      var {
        maxHeight,
        minHeight
      } = autosize;
      if (maxHeight !== void 0) {
        height2 = Math.min(height2, maxHeight);
      }
      if (minHeight !== void 0) {
        height2 = Math.max(height2, minHeight);
      }
    }
    if (height2) {
      input.style.height = height2 + "px";
      setRootScrollTop(scrollTop);
    }
  }
  function mapInputType(type) {
    if (type === "number") {
      return {
        type: "text",
        inputmode: "decimal"
      };
    }
    if (type === "digit") {
      return {
        type: "tel",
        inputmode: "numeric"
      };
    }
    return {
      type
    };
  }
  var CUSTOM_FIELD_INJECTION_KEY = Symbol("cf-field");
  function useCustomFieldValue(customValue) {
    var field = vue.inject(CUSTOM_FIELD_INJECTION_KEY, null);
    if (field && !field.customValue.value) {
      field.customValue.value = customValue;
      vue.watch(customValue, () => {
        field.resetValidation();
        field.validateWithTrigger("onChange");
      });
    }
  }
  var [name$u, bem$f] = createNamespace("field");
  var fieldSharedProps = {
    id: String,
    name: String,
    leftIcon: String,
    rightIcon: String,
    autofocus: Boolean,
    clearable: Boolean,
    maxlength: numericProp,
    formatter: Function,
    clearIcon: makeStringProp("close_out_line"),
    modelValue: makeNumericProp(""),
    inputAlign: String,
    placeholder: String,
    autocomplete: String,
    errorMessage: String,
    clearTrigger: makeStringProp("focus"),
    formatTrigger: makeStringProp("onChange"),
    error: {
      type: Boolean,
      default: null
    },
    disabled: {
      type: Boolean,
      default: null
    },
    readonly: {
      type: Boolean,
      default: null
    }
  };
  var fieldProps = extend({}, cellSharedProps, fieldSharedProps, {
    rows: numericProp,
    type: makeStringProp("text"),
    rules: Array,
    autosize: [Boolean, Object],
    labelWidth: numericProp,
    labelClass: unknownProp,
    labelAlign: String,
    showWordLimit: Boolean,
    errorMessageAlign: String,
    colon: {
      type: Boolean,
      default: null
    },
    pcBorder: truthProp
  });
  var _Field = vue.defineComponent({
    name: name$u,
    props: fieldProps,
    emits: ["blur", "focus", "clear", "keypress", "click-input", "click-left-icon", "click-right-icon", "update:modelValue"],
    setup(props, _ref) {
      var {
        emit,
        slots
      } = _ref;
      var [name2, bem2] = createNamespace("field");
      var state = vue.reactive({
        focused: false,
        validateFailed: false,
        validateMessage: ""
      });
      var inputRef = vue.ref();
      var customValue = vue.ref();
      var {
        parent: form
      } = useParent(FORM_KEY);
      var getModelValue = () => {
        var _props$modelValue;
        return String((_props$modelValue = props.modelValue) != null ? _props$modelValue : "");
      };
      var getProp = (key) => {
        if (isDef(props[key])) {
          return props[key];
        }
        if (form && isDef(form.props[key])) {
          return form.props[key];
        }
      };
      var showClear = vue.computed(() => {
        var readonly = getProp("readonly");
        if (props.clearable && !readonly) {
          var hasValue = getModelValue() !== "";
          var trigger = props.clearTrigger === "always" || props.clearTrigger === "focus" && state.focused;
          return hasValue && trigger;
        }
        return false;
      });
      var formValue = vue.computed(() => {
        if (customValue.value && slots.input) {
          return customValue.value();
        }
        return props.modelValue;
      });
      vue.computed(() => state.focused);
      var runRules = (rules) => rules.reduce((promise, rule) => promise.then(() => {
        if (state.validateFailed) {
          return;
        }
        var {
          value
        } = formValue;
        if (rule.formatter) {
          value = rule.formatter(value, rule);
        }
        if (!runSyncRule(value, rule)) {
          state.validateFailed = true;
          state.validateMessage = getRuleMessage(value, rule);
          return;
        }
        if (rule.validator) {
          return runRuleValidator(value, rule).then((result) => {
            if (result && typeof result === "string") {
              state.validateFailed = true;
              state.validateMessage = result;
            } else if (result === false) {
              state.validateFailed = true;
              state.validateMessage = getRuleMessage(value, rule);
            }
          });
        }
      }), Promise.resolve());
      var resetValidation = () => {
        if (state.validateFailed) {
          state.validateFailed = false;
          state.validateMessage = "";
        }
      };
      var validate = function(rules) {
        if (rules === void 0) {
          rules = props.rules;
        }
        return new Promise((resolve) => {
          resetValidation();
          if (rules) {
            runRules(rules).then(() => {
              if (state.validateFailed) {
                resolve({
                  name: props.name,
                  message: state.validateMessage
                });
              } else {
                resolve();
              }
            });
          } else {
            resolve();
          }
        });
      };
      var validateWithTrigger = (trigger) => {
        if (form && props.rules) {
          var defaultTrigger = form.props.validateTrigger === trigger;
          var rules = props.rules.filter((rule) => {
            if (rule.trigger) {
              return rule.trigger === trigger;
            }
            return defaultTrigger;
          });
          if (rules.length) {
            validate(rules);
          }
        }
      };
      var limitValueLength = (value) => {
        var {
          maxlength
        } = props;
        if (isDef(maxlength) && value.length > maxlength) {
          var modelValue = getModelValue();
          if (modelValue && modelValue.length === +maxlength) {
            return modelValue;
          }
          return value.slice(0, +maxlength);
        }
        return value;
      };
      var updateValue = function(value, trigger) {
        if (trigger === void 0) {
          trigger = "onChange";
        }
        value = limitValueLength(value);
        if (props.type === "number" || props.type === "digit") {
          var isNumber = props.type === "number";
          value = formatNumber(value, isNumber, isNumber);
        }
        if (props.formatter && trigger === props.formatTrigger) {
          value = props.formatter(value);
        }
        if (inputRef.value && inputRef.value.value !== value) {
          inputRef.value.value = value;
        }
        if (value !== props.modelValue) {
          emit("update:modelValue", value);
        }
      };
      var onInput = (event) => {
        if (!event.target.composing) {
          updateValue(event.target.value);
        }
      };
      var blur2 = () => {
        var _inputRef$value;
        return (_inputRef$value = inputRef.value) == null ? void 0 : _inputRef$value.blur();
      };
      var focus2 = () => {
        var _inputRef$value2;
        return (_inputRef$value2 = inputRef.value) == null ? void 0 : _inputRef$value2.focus();
      };
      var adjustTextareaSize = () => {
        var input = inputRef.value;
        if (props.type === "textarea" && props.autosize && input) {
          resizeTextarea(input, props.autosize);
        }
      };
      var onFocus = (event) => {
        state.focused = true;
        emit("focus", event);
        vue.nextTick(adjustTextareaSize);
        var readonly = getProp("readonly");
        if (readonly) {
          blur2();
        }
      };
      var onBlur = (event) => {
        state.focused = false;
        updateValue(getModelValue(), "onBlur");
        emit("blur", event);
        validateWithTrigger("onBlur");
        vue.nextTick(adjustTextareaSize);
        resetScroll();
      };
      var onClickInput = (event) => emit("click-input", event);
      var onClickLeftIcon = (event) => emit("click-left-icon", event);
      var onClickRightIcon = (event) => emit("click-right-icon", event);
      var onClear = (event) => {
        preventDefault(event);
        emit("update:modelValue", "");
        emit("clear", event);
      };
      var showError = vue.computed(() => {
        if (typeof props.error === "boolean") {
          return props.error;
        }
        if (form && form.props.showError && state.validateFailed) {
          return true;
        }
      });
      var labelStyle = vue.computed(() => {
        var labelWidth = getProp("labelWidth");
        if (labelWidth) {
          return {
            width: addUnit(labelWidth)
          };
        }
      });
      var onKeypress = (event) => {
        var ENTER_CODE = 13;
        if (event.keyCode === ENTER_CODE || event.code === "Enter") {
          var submitOnEnter = form && form.props.submitOnEnter;
          if (!submitOnEnter && props.type !== "textarea") {
            preventDefault(event);
          }
          if (props.type === "search") {
            blur2();
          }
        }
        emit("keypress", event);
      };
      var {
        platform
      } = useConfigProvider();
      var renderInput = () => {
        var inputAlign = getProp("inputAlign") || "";
        var controlClass = bem2("control", [inputAlign, {
          ["" + platform]: platform,
          error: showError.value,
          custom: !!slots.input,
          "min-height": props.type === "textarea" && !props.autosize,
          border: platform === "pc" && props.pcBorder,
          "no-border": platform === "pc" && !props.pcBorder
        }]);
        if (slots.input) {
          return vue.createVNode("div", {
            "class": controlClass,
            "onClick": onClickInput
          }, [slots.input()]);
        }
        var inputAttrs = {
          id: props.id,
          ref: inputRef,
          name: props.name,
          rows: props.rows !== void 0 ? +props.rows : void 0,
          class: controlClass,
          value: props.modelValue,
          disabled: getProp("disabled"),
          readonly: getProp("readonly"),
          autofocus: props.autofocus,
          placeholder: props.placeholder,
          autocomplete: props.autocomplete,
          onBlur,
          onFocus,
          onInput,
          onClick: onClickInput,
          onChange: endComposing,
          onKeypress,
          onCompositionend: endComposing,
          onCompositionstart: startComposing
        };
        if (props.type === "textarea") {
          return vue.createVNode("textarea", inputAttrs, null);
        }
        return vue.createVNode("input", vue.mergeProps(mapInputType(props.type), inputAttrs), null);
      };
      var renderLeftIcon = () => {
        var leftIconSlot = slots["left-icon"];
        if (props.leftIcon || leftIconSlot) {
          var _props$leftIcon;
          return vue.createVNode("div", {
            "class": bem2("left-icon"),
            "onClick": onClickLeftIcon
          }, [leftIconSlot ? leftIconSlot() : vue.createVNode(Icon, {
            "name": (_props$leftIcon = props.leftIcon) != null ? _props$leftIcon : "",
            "classPrefix": props.iconPrefix
          }, null)]);
        }
      };
      var renderRightIcon = () => {
        var rightIconSlot = slots["right-icon"];
        if (props.rightIcon || rightIconSlot) {
          var _props$rightIcon;
          return vue.createVNode("div", {
            "class": bem2("right-icon"),
            "onClick": onClickRightIcon
          }, [rightIconSlot ? rightIconSlot() : vue.createVNode(Icon, {
            "name": (_props$rightIcon = props.rightIcon) != null ? _props$rightIcon : "",
            "classPrefix": props.iconPrefix
          }, null)]);
        }
      };
      var renderWordLimit = () => {
        if (props.showWordLimit && props.maxlength) {
          var count = getModelValue().length;
          return vue.createVNode("div", {
            "class": bem2("word-limit")
          }, [vue.createVNode("span", {
            "class": bem2("word-num")
          }, [count]), vue.createTextVNode("/"), props.maxlength]);
        }
      };
      var renderMessage = () => {
        if (form && form.props.showErrorMessage === false) {
          return;
        }
        var message = props.errorMessage || state.validateMessage;
        var slotMessage = slots["error-message"];
        var slotOperation = slots["extra-operation"];
        if (message) {
          var errorMessageAlign = getProp("errorMessageAlign");
          return vue.createVNode("div", {
            "class": bem2("error-message", errorMessageAlign)
          }, [slotMessage ? slotMessage({
            message
          }) : message]);
        }
        if (slotOperation) {
          return vue.createVNode("div", {
            "class": bem2("extra-operation")
          }, [slotOperation == null ? void 0 : slotOperation()]);
        }
      };
      var renderCombo = () => {
        if (slots.combo) {
          return slots.combo();
        }
      };
      var renderLabel = () => {
        var colon = getProp("colon") ? ":" : "";
        if (slots.label) {
          return [slots.label(), colon];
        }
        if (props.label) {
          return vue.createVNode("label", {
            "for": props.id
          }, [props.label + colon]);
        }
      };
      var renderFieldBody = (Label) => {
        var _props$clearIcon, _props$clearIcon2;
        var hasTitle = Label;
        return vue.createVNode("div", {
          "class": [bem2("value", {
            alone: !hasTitle
          }), props.valueClass]
        }, [vue.createVNode("div", {
          "class": bem2("body")
        }, [renderInput(), showClear.value && vue.createVNode(Icon, {
          "name": (_props$clearIcon = props.clearIcon) != null ? _props$clearIcon : "",
          "color": (_props$clearIcon2 = props.clearIcon) != null ? _props$clearIcon2 : "#CCD1DA",
          "class": bem2("clear"),
          "onTouchstart": onClear
        }, null), renderRightIcon(), slots.button && vue.createVNode("div", {
          "class": bem2("button")
        }, [slots.button()])]), renderWordLimit(), renderMessage()]);
      };
      useExpose({
        blur: blur2,
        focus: focus2,
        validate,
        formValue,
        resetValidation
      });
      vue.provide(CUSTOM_FIELD_INJECTION_KEY, {
        customValue,
        resetValidation,
        validateWithTrigger
      });
      vue.watch(() => props.modelValue, () => {
        updateValue(getModelValue());
        resetValidation();
        validateWithTrigger("onChange");
        vue.nextTick(adjustTextareaSize);
      });
      vue.onMounted(() => {
        updateValue(getModelValue(), props.formatTrigger);
        vue.nextTick(adjustTextareaSize);
      });
      return () => {
        var disabled = getProp("disabled");
        var labelAlign = getProp("labelAlign") || "";
        var Combo = renderCombo();
        var Label = renderLabel();
        var LeftIcon = renderLeftIcon();
        return vue.createVNode(Cell, {
          "size": props.size,
          "icon": props.leftIcon,
          "class": bem2([{
            error: showError.value,
            disabled,
            ["label-" + labelAlign]: labelAlign,
            "extra-operation-pendding": slots["extra-operation"],
            ["" + platform]: platform
          }]),
          "center": props.center,
          "border": props.border,
          "isLink": props.isLink,
          "clickable": props.clickable,
          "titleStyle": labelStyle.value,
          "valueClass": bem2("value"),
          "titleClass": [bem2("label", [labelAlign, {
            required: props.required
          }]), props.labelClass],
          "arrowDirection": props.arrowDirection
        }, {
          combo: Combo ? () => Combo : null,
          icon: LeftIcon ? () => LeftIcon : null,
          title: Label ? () => Label : null,
          value: renderFieldBody,
          extra: slots.extra
        });
      };
    }
  });
  var Field = withInstall(_Field);
  var [name$t, bem$e] = createNamespace("form");
  var formProps = {
    colon: Boolean,
    disabled: Boolean,
    readonly: Boolean,
    showError: Boolean,
    labelWidth: numericProp,
    labelAlign: String,
    inputAlign: String,
    scrollToError: Boolean,
    validateFirst: Boolean,
    submitOnEnter: truthProp,
    validateTrigger: makeStringProp("onBlur"),
    showErrorMessage: truthProp,
    errorMessageAlign: String
  };
  var _Form = vue.defineComponent({
    name: name$t,
    props: formProps,
    emits: ["submit", "failed"],
    setup(props, _ref) {
      var {
        emit,
        slots
      } = _ref;
      var [name2, bem2] = createNamespace("form");
      var {
        children,
        linkChildren
      } = useChildren(FORM_KEY);
      var getFieldsByNames = (names) => {
        if (names) {
          return children.filter((field) => names.includes(field.name));
        }
        return children;
      };
      var validateNoPassStop = (names) => new Promise((resolve, reject) => {
        var errors = [];
        var fields = getFieldsByNames(names);
        fields.reduce((promise, field) => promise.then(() => {
          if (!errors.length) {
            return field.validate().then((error) => {
              if (error) {
                errors.push(error);
              }
            });
          }
        }), Promise.resolve()).then(() => {
          if (errors.length) {
            reject(errors);
          } else {
            resolve();
          }
        });
      });
      var validateAll = (names) => new Promise((resolve, reject) => {
        var fields = getFieldsByNames(names);
        Promise.all(fields.map((item) => item.validate())).then((errors) => {
          errors = errors.filter(Boolean);
          if (errors.length) {
            reject(errors);
          } else {
            resolve();
          }
        });
      });
      var validateField = (name3) => {
        var matched = children.find((item) => item.name === name3);
        if (matched) {
          return new Promise((resolve, reject) => {
            matched.validate().then((error) => {
              if (error) {
                reject(error);
              } else {
                resolve();
              }
            });
          });
        }
        return Promise.reject();
      };
      var validate = (name3) => {
        if (typeof name3 === "string") {
          return validateField(name3);
        }
        return props.validateFirst ? validateNoPassStop(name3) : validateAll(name3);
      };
      var resetValidation = (name3) => {
        if (typeof name3 === "string") {
          name3 = [name3];
        }
        var fields = getFieldsByNames(name3);
        fields.forEach((item) => {
          item.resetValidation();
        });
      };
      var scrollToField = (name3, options) => {
        children.some((item) => {
          if (item.name === name3) {
            item.$el.scrollIntoView(options);
            return true;
          }
          return false;
        });
      };
      var getValues = () => children.reduce((form, field) => {
        form[field.name] = field.formValue.value;
        return form;
      }, {});
      var submit = () => {
        var values = getValues();
        validate().then(() => emit("submit", values)).catch((errors) => {
          emit("failed", {
            values,
            errors
          });
          if (props.scrollToError && errors[0].name) {
            scrollToField(errors[0].name);
          }
        });
      };
      var onSubmit = (event) => {
        event.preventDefault();
        submit();
      };
      linkChildren({
        props
      });
      useExpose({
        submit,
        validate,
        scrollToField,
        resetValidation
      });
      return () => vue.createVNode("form", {
        "class": bem2(),
        "onSubmit": onSubmit
      }, [slots.default == null ? void 0 : slots.default()]);
    }
  });
  var Form = withInstall(_Form);
  var useCloneElement = (element, data, zIndex) => {
    var clone;
    var domStyle = window.getComputedStyle(element);
    if (data.image) {
      clone = document.createElement("img");
      clone.src = data.image;
    } else {
      clone = element.cloneNode(true);
      element.style.zIndex = String(Number(zIndex) + 1);
      element.style.pointerEvents = "none";
    }
    if (domStyle.position !== "static" && domStyle.position !== "inherit" && domStyle.position !== "initial" && domStyle.position) {
      clone.style.position = domStyle.position;
    } else {
      clone.style.position = "relative";
      element.style.position = "relative";
    }
    var rectObject = element.getBoundingClientRect();
    var {
      width: setWidth,
      height: setHeight,
      offsetX = 0,
      offsetY = 0
    } = data;
    var {
      width: width2,
      height: height2,
      x,
      y
    } = rectObject;
    clone.style.width = setWidth || width2 + "px";
    clone.style.height = setHeight || height2 + "px";
    clone.style.left = x + offsetX + "px";
    clone.style.top = y + offsetY + "px";
    clone.style.margin = "0";
    clone.style.opacity = "0";
    return clone;
  };
  var top = "top";
  var bottom = "bottom";
  var right = "right";
  var left = "left";
  var auto = "auto";
  var basePlacements = [top, bottom, right, left];
  var start = "start";
  var end = "end";
  var clippingParents = "clippingParents";
  var viewport = "viewport";
  var popper = "popper";
  var reference = "reference";
  var variationPlacements = /* @__PURE__ */ basePlacements.reduce(function(acc, placement) {
    return acc.concat([placement + "-" + start, placement + "-" + end]);
  }, []);
  var placements = /* @__PURE__ */ [].concat(basePlacements, [auto]).reduce(function(acc, placement) {
    return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
  }, []);
  var beforeRead = "beforeRead";
  var read = "read";
  var afterRead = "afterRead";
  var beforeMain = "beforeMain";
  var main = "main";
  var afterMain = "afterMain";
  var beforeWrite = "beforeWrite";
  var write = "write";
  var afterWrite = "afterWrite";
  var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];
  function getNodeName(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
  }
  function getWindow(node) {
    if (node == null) {
      return window;
    }
    if (node.toString() !== "[object Window]") {
      var ownerDocument = node.ownerDocument;
      return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
  }
  function isElement(node) {
    var OwnElement = getWindow(node).Element;
    return node instanceof OwnElement || node instanceof Element;
  }
  function isHTMLElement(node) {
    var OwnElement = getWindow(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
  }
  function isShadowRoot(node) {
    if (typeof ShadowRoot === "undefined") {
      return false;
    }
    var OwnElement = getWindow(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
  }
  function applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name2) {
      var style = state.styles[name2] || {};
      var attributes = state.attributes[name2] || {};
      var element = state.elements[name2];
      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }
      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function(name3) {
        var value = attributes[name3];
        if (value === false) {
          element.removeAttribute(name3);
        } else {
          element.setAttribute(name3, value === true ? "" : value);
        }
      });
    });
  }
  function effect$2(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
      popper: {
        position: state.options.strategy,
        left: "0",
        top: "0",
        margin: "0"
      },
      arrow: {
        position: "absolute"
      },
      reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) {
      Object.assign(state.elements.arrow.style, initialStyles.arrow);
    }
    return function() {
      Object.keys(state.elements).forEach(function(name2) {
        var element = state.elements[name2];
        var attributes = state.attributes[name2] || {};
        var styleProperties = Object.keys(state.styles.hasOwnProperty(name2) ? state.styles[name2] : initialStyles[name2]);
        var style = styleProperties.reduce(function(style2, property) {
          style2[property] = "";
          return style2;
        }, {});
        if (!isHTMLElement(element) || !getNodeName(element)) {
          return;
        }
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(attribute) {
          element.removeAttribute(attribute);
        });
      });
    };
  }
  var applyStyles$1 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: applyStyles,
    effect: effect$2,
    requires: ["computeStyles"]
  };
  function getBasePlacement(placement) {
    return placement.split("-")[0];
  }
  var max = Math.max;
  var min = Math.min;
  var round = Math.round;
  function getBoundingClientRect(element, includeScale) {
    if (includeScale === void 0) {
      includeScale = false;
    }
    var rect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (isHTMLElement(element) && includeScale) {
      var offsetHeight = element.offsetHeight;
      var offsetWidth = element.offsetWidth;
      if (offsetWidth > 0) {
        scaleX = round(rect.width) / offsetWidth || 1;
      }
      if (offsetHeight > 0) {
        scaleY = round(rect.height) / offsetHeight || 1;
      }
    }
    return {
      width: rect.width / scaleX,
      height: rect.height / scaleY,
      top: rect.top / scaleY,
      right: rect.right / scaleX,
      bottom: rect.bottom / scaleY,
      left: rect.left / scaleX,
      x: rect.left / scaleX,
      y: rect.top / scaleY
    };
  }
  function getLayoutRect(element) {
    var clientRect = getBoundingClientRect(element);
    var width2 = element.offsetWidth;
    var height2 = element.offsetHeight;
    if (Math.abs(clientRect.width - width2) <= 1) {
      width2 = clientRect.width;
    }
    if (Math.abs(clientRect.height - height2) <= 1) {
      height2 = clientRect.height;
    }
    return {
      x: element.offsetLeft,
      y: element.offsetTop,
      width: width2,
      height: height2
    };
  }
  function contains(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode();
    if (parent.contains(child)) {
      return true;
    } else if (rootNode && isShadowRoot(rootNode)) {
      var next = child;
      do {
        if (next && parent.isSameNode(next)) {
          return true;
        }
        next = next.parentNode || next.host;
      } while (next);
    }
    return false;
  }
  function getComputedStyle(element) {
    return getWindow(element).getComputedStyle(element);
  }
  function isTableElement(element) {
    return ["table", "td", "th"].indexOf(getNodeName(element)) >= 0;
  }
  function getDocumentElement(element) {
    return ((isElement(element) ? element.ownerDocument : element.document) || window.document).documentElement;
  }
  function getParentNode(element) {
    if (getNodeName(element) === "html") {
      return element;
    }
    return element.assignedSlot || element.parentNode || (isShadowRoot(element) ? element.host : null) || getDocumentElement(element);
  }
  function getTrueOffsetParent(element) {
    if (!isHTMLElement(element) || getComputedStyle(element).position === "fixed") {
      return null;
    }
    return element.offsetParent;
  }
  function getContainingBlock(element) {
    var isFirefox = navigator.userAgent.toLowerCase().indexOf("firefox") !== -1;
    var isIE = navigator.userAgent.indexOf("Trident") !== -1;
    if (isIE && isHTMLElement(element)) {
      var elementCss = getComputedStyle(element);
      if (elementCss.position === "fixed") {
        return null;
      }
    }
    var currentNode = getParentNode(element);
    while (isHTMLElement(currentNode) && ["html", "body"].indexOf(getNodeName(currentNode)) < 0) {
      var css = getComputedStyle(currentNode);
      if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || ["transform", "perspective"].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") {
        return currentNode;
      } else {
        currentNode = currentNode.parentNode;
      }
    }
    return null;
  }
  function getOffsetParent(element) {
    var window2 = getWindow(element);
    var offsetParent = getTrueOffsetParent(element);
    while (offsetParent && isTableElement(offsetParent) && getComputedStyle(offsetParent).position === "static") {
      offsetParent = getTrueOffsetParent(offsetParent);
    }
    if (offsetParent && (getNodeName(offsetParent) === "html" || getNodeName(offsetParent) === "body" && getComputedStyle(offsetParent).position === "static")) {
      return window2;
    }
    return offsetParent || getContainingBlock(element) || window2;
  }
  function getMainAxisFromPlacement(placement) {
    return ["top", "bottom"].indexOf(placement) >= 0 ? "x" : "y";
  }
  function within(min$1, value, max$1) {
    return max(min$1, min(value, max$1));
  }
  function withinMaxClamp(min2, value, max2) {
    var v = within(min2, value, max2);
    return v > max2 ? max2 : v;
  }
  function getFreshSideObject() {
    return {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    };
  }
  function mergePaddingObject(paddingObject) {
    return Object.assign({}, getFreshSideObject(), paddingObject);
  }
  function expandToHashMap(value, keys) {
    return keys.reduce(function(hashMap, key) {
      hashMap[key] = value;
      return hashMap;
    }, {});
  }
  var toPaddingObject = function toPaddingObject2(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
      placement: state.placement
    })) : padding;
    return mergePaddingObject(typeof padding !== "number" ? padding : expandToHashMap(padding, basePlacements));
  };
  function arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name2 = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets2 = state.modifiersData.popperOffsets;
    var basePlacement = getBasePlacement(state.placement);
    var axis = getMainAxisFromPlacement(basePlacement);
    var isVertical = [left, right].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets2) {
      return;
    }
    var paddingObject = toPaddingObject(options.padding, state);
    var arrowRect = getLayoutRect(arrowElement);
    var minProp = axis === "y" ? top : left;
    var maxProp = axis === "y" ? bottom : right;
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets2[axis] - state.rects.popper[len];
    var startDiff = popperOffsets2[axis] - state.rects.reference[axis];
    var arrowOffsetParent = getOffsetParent(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2;
    var min2 = paddingObject[minProp];
    var max2 = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset2 = within(min2, center, max2);
    var axisProp = axis;
    state.modifiersData[name2] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset2, _state$modifiersData$.centerOffset = offset2 - center, _state$modifiersData$);
  }
  function effect$1(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) {
      return;
    }
    if (typeof arrowElement === "string") {
      arrowElement = state.elements.popper.querySelector(arrowElement);
      if (!arrowElement) {
        return;
      }
    }
    if (!contains(state.elements.popper, arrowElement)) {
      return;
    }
    state.elements.arrow = arrowElement;
  }
  var arrow$1 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: arrow,
    effect: effect$1,
    requires: ["popperOffsets"],
    requiresIfExists: ["preventOverflow"]
  };
  function getVariation(placement) {
    return placement.split("-")[1];
  }
  var unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
  };
  function roundOffsetsByDPR(_ref) {
    var x = _ref.x, y = _ref.y;
    var win = window;
    var dpr = win.devicePixelRatio || 1;
    return {
      x: round(x * dpr) / dpr || 0,
      y: round(y * dpr) / dpr || 0
    };
  }
  function mapToStyles(_ref2) {
    var _Object$assign2;
    var popper2 = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _ref3 = roundOffsets === true ? roundOffsetsByDPR(offsets) : typeof roundOffsets === "function" ? roundOffsets(offsets) : offsets, _ref3$x = _ref3.x, x = _ref3$x === void 0 ? 0 : _ref3$x, _ref3$y = _ref3.y, y = _ref3$y === void 0 ? 0 : _ref3$y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = left;
    var sideY = top;
    var win = window;
    if (adaptive) {
      var offsetParent = getOffsetParent(popper2);
      var heightProp = "clientHeight";
      var widthProp = "clientWidth";
      if (offsetParent === getWindow(popper2)) {
        offsetParent = getDocumentElement(popper2);
        if (getComputedStyle(offsetParent).position !== "static" && position === "absolute") {
          heightProp = "scrollHeight";
          widthProp = "scrollWidth";
        }
      }
      offsetParent = offsetParent;
      if (placement === top || (placement === left || placement === right) && variation === end) {
        sideY = bottom;
        var offsetY = isFixed && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
        y -= offsetY - popperRect.height;
        y *= gpuAcceleration ? 1 : -1;
      }
      if (placement === left || (placement === top || placement === bottom) && variation === end) {
        sideX = right;
        var offsetX = isFixed && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
        x -= offsetX - popperRect.width;
        x *= gpuAcceleration ? 1 : -1;
      }
    }
    var commonStyles = Object.assign({
      position
    }, adaptive && unsetSides);
    if (gpuAcceleration) {
      var _Object$assign;
      return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
  }
  function computeStyles(_ref4) {
    var state = _ref4.state, options = _ref4.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
      placement: getBasePlacement(state.placement),
      variation: getVariation(state.placement),
      popper: state.elements.popper,
      popperRect: state.rects.popper,
      gpuAcceleration,
      isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) {
      state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive,
        roundOffsets
      })));
    }
    if (state.modifiersData.arrow != null) {
      state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets
      })));
    }
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
      "data-popper-placement": state.placement
    });
  }
  var computeStyles$1 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: computeStyles,
    data: {}
  };
  var passive = {
    passive: true
  };
  function effect(_ref) {
    var state = _ref.state, instance2 = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window2 = getWindow(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) {
      scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance2.update, passive);
      });
    }
    if (resize) {
      window2.addEventListener("resize", instance2.update, passive);
    }
    return function() {
      if (scroll) {
        scrollParents.forEach(function(scrollParent) {
          scrollParent.removeEventListener("scroll", instance2.update, passive);
        });
      }
      if (resize) {
        window2.removeEventListener("resize", instance2.update, passive);
      }
    };
  }
  var eventListeners = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {
    },
    effect,
    data: {}
  };
  var hash$1 = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
  };
  function getOppositePlacement(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
      return hash$1[matched];
    });
  }
  var hash = {
    start: "end",
    end: "start"
  };
  function getOppositeVariationPlacement(placement) {
    return placement.replace(/start|end/g, function(matched) {
      return hash[matched];
    });
  }
  function getWindowScroll(node) {
    var win = getWindow(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
      scrollLeft,
      scrollTop
    };
  }
  function getWindowScrollBarX(element) {
    return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
  }
  function getViewportRect(element) {
    var win = getWindow(element);
    var html = getDocumentElement(element);
    var visualViewport = win.visualViewport;
    var width2 = html.clientWidth;
    var height2 = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
      width2 = visualViewport.width;
      height2 = visualViewport.height;
      if (!/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
        x = visualViewport.offsetLeft;
        y = visualViewport.offsetTop;
      }
    }
    return {
      width: width2,
      height: height2,
      x: x + getWindowScrollBarX(element),
      y
    };
  }
  function getDocumentRect(element) {
    var _element$ownerDocumen;
    var html = getDocumentElement(element);
    var winScroll = getWindowScroll(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width2 = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height2 = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
    var y = -winScroll.scrollTop;
    if (getComputedStyle(body || html).direction === "rtl") {
      x += max(html.clientWidth, body ? body.clientWidth : 0) - width2;
    }
    return {
      width: width2,
      height: height2,
      x,
      y
    };
  }
  function isScrollParent(element) {
    var _getComputedStyle = getComputedStyle(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
  }
  function getScrollParent(node) {
    if (["html", "body", "#document"].indexOf(getNodeName(node)) >= 0) {
      return node.ownerDocument.body;
    }
    if (isHTMLElement(node) && isScrollParent(node)) {
      return node;
    }
    return getScrollParent(getParentNode(node));
  }
  function listScrollParents(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) {
      list = [];
    }
    var scrollParent = getScrollParent(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = getWindow(scrollParent);
    var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat(listScrollParents(getParentNode(target)));
  }
  function rectToClientRect(rect) {
    return Object.assign({}, rect, {
      left: rect.x,
      top: rect.y,
      right: rect.x + rect.width,
      bottom: rect.y + rect.height
    });
  }
  function getInnerBoundingClientRect(element) {
    var rect = getBoundingClientRect(element);
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
  }
  function getClientRectFromMixedType(element, clippingParent) {
    return clippingParent === viewport ? rectToClientRect(getViewportRect(element)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
  }
  function getClippingParents(element) {
    var clippingParents2 = listScrollParents(getParentNode(element));
    var canEscapeClipping = ["absolute", "fixed"].indexOf(getComputedStyle(element).position) >= 0;
    var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;
    if (!isElement(clipperElement)) {
      return [];
    }
    return clippingParents2.filter(function(clippingParent) {
      return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== "body" && (canEscapeClipping ? getComputedStyle(clippingParent).position !== "static" : true);
    });
  }
  function getClippingRect(element, boundary, rootBoundary) {
    var mainClippingParents = boundary === "clippingParents" ? getClippingParents(element) : [].concat(boundary);
    var clippingParents2 = [].concat(mainClippingParents, [rootBoundary]);
    var firstClippingParent = clippingParents2[0];
    var clippingRect = clippingParents2.reduce(function(accRect, clippingParent) {
      var rect = getClientRectFromMixedType(element, clippingParent);
      accRect.top = max(rect.top, accRect.top);
      accRect.right = min(rect.right, accRect.right);
      accRect.bottom = min(rect.bottom, accRect.bottom);
      accRect.left = max(rect.left, accRect.left);
      return accRect;
    }, getClientRectFromMixedType(element, firstClippingParent));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
  }
  function computeOffsets(_ref) {
    var reference2 = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? getBasePlacement(placement) : null;
    var variation = placement ? getVariation(placement) : null;
    var commonX = reference2.x + reference2.width / 2 - element.width / 2;
    var commonY = reference2.y + reference2.height / 2 - element.height / 2;
    var offsets;
    switch (basePlacement) {
      case top:
        offsets = {
          x: commonX,
          y: reference2.y - element.height
        };
        break;
      case bottom:
        offsets = {
          x: commonX,
          y: reference2.y + reference2.height
        };
        break;
      case right:
        offsets = {
          x: reference2.x + reference2.width,
          y: commonY
        };
        break;
      case left:
        offsets = {
          x: reference2.x - element.width,
          y: commonY
        };
        break;
      default:
        offsets = {
          x: reference2.x,
          y: reference2.y
        };
    }
    var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;
    if (mainAxis != null) {
      var len = mainAxis === "y" ? "height" : "width";
      switch (variation) {
        case start:
          offsets[mainAxis] = offsets[mainAxis] - (reference2[len] / 2 - element[len] / 2);
          break;
        case end:
          offsets[mainAxis] = offsets[mainAxis] + (reference2[len] / 2 - element[len] / 2);
          break;
      }
    }
    return offsets;
  }
  function detectOverflow(state, options) {
    if (options === void 0) {
      options = {};
    }
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? clippingParents : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? popper : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = mergePaddingObject(typeof padding !== "number" ? padding : expandToHashMap(padding, basePlacements));
    var altContext = elementContext === popper ? reference : popper;
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary);
    var referenceClientRect = getBoundingClientRect(state.elements.reference);
    var popperOffsets2 = computeOffsets({
      reference: referenceClientRect,
      element: popperRect,
      strategy: "absolute",
      placement
    });
    var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets2));
    var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect;
    var overflowOffsets = {
      top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
      bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
      left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
      right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset;
    if (elementContext === popper && offsetData) {
      var offset2 = offsetData[placement];
      Object.keys(overflowOffsets).forEach(function(key) {
        var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
        var axis = [top, bottom].indexOf(key) >= 0 ? "y" : "x";
        overflowOffsets[key] += offset2[axis] * multiply;
      });
    }
    return overflowOffsets;
  }
  function computeAutoPlacement(state, options) {
    if (options === void 0) {
      options = {};
    }
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
    var variation = getVariation(placement);
    var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function(placement2) {
      return getVariation(placement2) === variation;
    }) : basePlacements;
    var allowedPlacements = placements$1.filter(function(placement2) {
      return allowedAutoPlacements.indexOf(placement2) >= 0;
    });
    if (allowedPlacements.length === 0) {
      allowedPlacements = placements$1;
    }
    var overflows = allowedPlacements.reduce(function(acc, placement2) {
      acc[placement2] = detectOverflow(state, {
        placement: placement2,
        boundary,
        rootBoundary,
        padding
      })[getBasePlacement(placement2)];
      return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
      return overflows[a] - overflows[b];
    });
  }
  function getExpandedFallbackPlacements(placement) {
    if (getBasePlacement(placement) === auto) {
      return [];
    }
    var oppositePlacement = getOppositePlacement(placement);
    return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
  }
  function flip(_ref) {
    var state = _ref.state, options = _ref.options, name2 = _ref.name;
    if (state.modifiersData[name2]._skip) {
      return;
    }
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = getBasePlacement(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
    var placements2 = [preferredPlacement].concat(fallbackPlacements).reduce(function(acc, placement2) {
      return acc.concat(getBasePlacement(placement2) === auto ? computeAutoPlacement(state, {
        placement: placement2,
        boundary,
        rootBoundary,
        padding,
        flipVariations,
        allowedAutoPlacements
      }) : placement2);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements2[0];
    for (var i = 0; i < placements2.length; i++) {
      var placement = placements2[i];
      var _basePlacement = getBasePlacement(placement);
      var isStartVariation = getVariation(placement) === start;
      var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
      var len = isVertical ? "width" : "height";
      var overflow = detectOverflow(state, {
        placement,
        boundary,
        rootBoundary,
        altBoundary,
        padding
      });
      var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;
      if (referenceRect[len] > popperRect[len]) {
        mainVariationSide = getOppositePlacement(mainVariationSide);
      }
      var altVariationSide = getOppositePlacement(mainVariationSide);
      var checks = [];
      if (checkMainAxis) {
        checks.push(overflow[_basePlacement] <= 0);
      }
      if (checkAltAxis) {
        checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
      }
      if (checks.every(function(check) {
        return check;
      })) {
        firstFittingPlacement = placement;
        makeFallbackChecks = false;
        break;
      }
      checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
      var numberOfChecks = flipVariations ? 3 : 1;
      var _loop = function _loop2(_i2) {
        var fittingPlacement = placements2.find(function(placement2) {
          var checks2 = checksMap.get(placement2);
          if (checks2) {
            return checks2.slice(0, _i2).every(function(check) {
              return check;
            });
          }
        });
        if (fittingPlacement) {
          firstFittingPlacement = fittingPlacement;
          return "break";
        }
      };
      for (var _i = numberOfChecks; _i > 0; _i--) {
        var _ret = _loop(_i);
        if (_ret === "break")
          break;
      }
    }
    if (state.placement !== firstFittingPlacement) {
      state.modifiersData[name2]._skip = true;
      state.placement = firstFittingPlacement;
      state.reset = true;
    }
  }
  var flip$1 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: flip,
    requiresIfExists: ["offset"],
    data: {
      _skip: false
    }
  };
  function getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) {
      preventedOffsets = {
        x: 0,
        y: 0
      };
    }
    return {
      top: overflow.top - rect.height - preventedOffsets.y,
      right: overflow.right - rect.width + preventedOffsets.x,
      bottom: overflow.bottom - rect.height + preventedOffsets.y,
      left: overflow.left - rect.width - preventedOffsets.x
    };
  }
  function isAnySideFullyClipped(overflow) {
    return [top, right, bottom, left].some(function(side) {
      return overflow[side] >= 0;
    });
  }
  function hide(_ref) {
    var state = _ref.state, name2 = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = detectOverflow(state, {
      elementContext: "reference"
    });
    var popperAltOverflow = detectOverflow(state, {
      altBoundary: true
    });
    var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name2] = {
      referenceClippingOffsets,
      popperEscapeOffsets,
      isReferenceHidden,
      hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
      "data-popper-reference-hidden": isReferenceHidden,
      "data-popper-escaped": hasPopperEscaped
    });
  }
  var hide$1 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: ["preventOverflow"],
    fn: hide
  };
  function distanceAndSkiddingToXY(placement, rects, offset2) {
    var basePlacement = getBasePlacement(placement);
    var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset2 === "function" ? offset2(Object.assign({}, rects, {
      placement
    })) : offset2, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [left, right].indexOf(basePlacement) >= 0 ? {
      x: distance,
      y: skidding
    } : {
      x: skidding,
      y: distance
    };
  }
  function offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name2 = _ref2.name;
    var _options$offset = options.offset, offset2 = _options$offset === void 0 ? [0, 0] : _options$offset;
    var data = placements.reduce(function(acc, placement) {
      acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset2);
      return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
      state.modifiersData.popperOffsets.x += x;
      state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name2] = data;
  }
  var offsetModifier = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: ["popperOffsets"],
    fn: offset
  };
  function popperOffsets(_ref) {
    var state = _ref.state, name2 = _ref.name;
    state.modifiersData[name2] = computeOffsets({
      reference: state.rects.reference,
      element: state.rects.popper,
      strategy: "absolute",
      placement: state.placement
    });
  }
  var popperOffsets$1 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: popperOffsets,
    data: {}
  };
  function getAltAxis(axis) {
    return axis === "x" ? "y" : "x";
  }
  function preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name2 = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = detectOverflow(state, {
      boundary,
      rootBoundary,
      padding,
      altBoundary
    });
    var basePlacement = getBasePlacement(state.placement);
    var variation = getVariation(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = getMainAxisFromPlacement(basePlacement);
    var altAxis = getAltAxis(mainAxis);
    var popperOffsets2 = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
      placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
      mainAxis: tetherOffsetValue,
      altAxis: tetherOffsetValue
    } : Object.assign({
      mainAxis: 0,
      altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
      x: 0,
      y: 0
    };
    if (!popperOffsets2) {
      return;
    }
    if (checkMainAxis) {
      var _offsetModifierState$;
      var mainSide = mainAxis === "y" ? top : left;
      var altSide = mainAxis === "y" ? bottom : right;
      var len = mainAxis === "y" ? "height" : "width";
      var offset2 = popperOffsets2[mainAxis];
      var min$1 = offset2 + overflow[mainSide];
      var max$1 = offset2 - overflow[altSide];
      var additive = tether ? -popperRect[len] / 2 : 0;
      var minLen = variation === start ? referenceRect[len] : popperRect[len];
      var maxLen = variation === start ? -popperRect[len] : -referenceRect[len];
      var arrowElement = state.elements.arrow;
      var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
        width: 0,
        height: 0
      };
      var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : getFreshSideObject();
      var arrowPaddingMin = arrowPaddingObject[mainSide];
      var arrowPaddingMax = arrowPaddingObject[altSide];
      var arrowLen = within(0, referenceRect[len], arrowRect[len]);
      var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
      var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
      var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
      var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
      var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
      var tetherMin = offset2 + minOffset - offsetModifierValue - clientOffset;
      var tetherMax = offset2 + maxOffset - offsetModifierValue;
      var preventedOffset = within(tether ? min(min$1, tetherMin) : min$1, offset2, tether ? max(max$1, tetherMax) : max$1);
      popperOffsets2[mainAxis] = preventedOffset;
      data[mainAxis] = preventedOffset - offset2;
    }
    if (checkAltAxis) {
      var _offsetModifierState$2;
      var _mainSide = mainAxis === "x" ? top : left;
      var _altSide = mainAxis === "x" ? bottom : right;
      var _offset = popperOffsets2[altAxis];
      var _len = altAxis === "y" ? "height" : "width";
      var _min = _offset + overflow[_mainSide];
      var _max = _offset - overflow[_altSide];
      var isOriginSide = [top, left].indexOf(basePlacement) !== -1;
      var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
      var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
      var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
      var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
      popperOffsets2[altAxis] = _preventedOffset;
      data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name2] = data;
  }
  var preventOverflow$1 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: preventOverflow,
    requiresIfExists: ["offset"]
  };
  function getHTMLElementScroll(element) {
    return {
      scrollLeft: element.scrollLeft,
      scrollTop: element.scrollTop
    };
  }
  function getNodeScroll(node) {
    if (node === getWindow(node) || !isHTMLElement(node)) {
      return getWindowScroll(node);
    } else {
      return getHTMLElementScroll(node);
    }
  }
  function isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = round(rect.width) / element.offsetWidth || 1;
    var scaleY = round(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
  }
  function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) {
      isFixed = false;
    }
    var isOffsetParentAnElement = isHTMLElement(offsetParent);
    var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
    var documentElement = getDocumentElement(offsetParent);
    var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled);
    var scroll = {
      scrollLeft: 0,
      scrollTop: 0
    };
    var offsets = {
      x: 0,
      y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
      if (getNodeName(offsetParent) !== "body" || isScrollParent(documentElement)) {
        scroll = getNodeScroll(offsetParent);
      }
      if (isHTMLElement(offsetParent)) {
        offsets = getBoundingClientRect(offsetParent, true);
        offsets.x += offsetParent.clientLeft;
        offsets.y += offsetParent.clientTop;
      } else if (documentElement) {
        offsets.x = getWindowScrollBarX(documentElement);
      }
    }
    return {
      x: rect.left + scroll.scrollLeft - offsets.x,
      y: rect.top + scroll.scrollTop - offsets.y,
      width: rect.width,
      height: rect.height
    };
  }
  function order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
      map.set(modifier.name, modifier);
    });
    function sort(modifier) {
      visited.add(modifier.name);
      var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
      requires.forEach(function(dep) {
        if (!visited.has(dep)) {
          var depModifier = map.get(dep);
          if (depModifier) {
            sort(depModifier);
          }
        }
      });
      result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
      if (!visited.has(modifier.name)) {
        sort(modifier);
      }
    });
    return result;
  }
  function orderModifiers(modifiers) {
    var orderedModifiers = order(modifiers);
    return modifierPhases.reduce(function(acc, phase) {
      return acc.concat(orderedModifiers.filter(function(modifier) {
        return modifier.phase === phase;
      }));
    }, []);
  }
  function debounce(fn) {
    var pending;
    return function() {
      if (!pending) {
        pending = new Promise(function(resolve) {
          Promise.resolve().then(function() {
            pending = void 0;
            resolve(fn());
          });
        });
      }
      return pending;
    };
  }
  function mergeByName(modifiers) {
    var merged = modifiers.reduce(function(merged2, current2) {
      var existing = merged2[current2.name];
      merged2[current2.name] = existing ? Object.assign({}, existing, current2, {
        options: Object.assign({}, existing.options, current2.options),
        data: Object.assign({}, existing.data, current2.data)
      }) : current2;
      return merged2;
    }, {});
    return Object.keys(merged).map(function(key) {
      return merged[key];
    });
  }
  var DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
  };
  function areValidElements() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return !args.some(function(element) {
      return !(element && typeof element.getBoundingClientRect === "function");
    });
  }
  function popperGenerator(generatorOptions) {
    if (generatorOptions === void 0) {
      generatorOptions = {};
    }
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers2 = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions2 = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper2(reference2, popper2, options) {
      if (options === void 0) {
        options = defaultOptions2;
      }
      var state = {
        placement: "bottom",
        orderedModifiers: [],
        options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions2),
        modifiersData: {},
        elements: {
          reference: reference2,
          popper: popper2
        },
        attributes: {},
        styles: {}
      };
      var effectCleanupFns = [];
      var isDestroyed = false;
      var instance2 = {
        state,
        setOptions: function setOptions(setOptionsAction) {
          var options2 = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
          cleanupModifierEffects();
          state.options = Object.assign({}, defaultOptions2, state.options, options2);
          state.scrollParents = {
            reference: isElement(reference2) ? listScrollParents(reference2) : reference2.contextElement ? listScrollParents(reference2.contextElement) : [],
            popper: listScrollParents(popper2)
          };
          var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers2, state.options.modifiers)));
          state.orderedModifiers = orderedModifiers.filter(function(m) {
            return m.enabled;
          });
          runModifierEffects();
          return instance2.update();
        },
        forceUpdate: function forceUpdate() {
          if (isDestroyed) {
            return;
          }
          var _state$elements = state.elements, reference3 = _state$elements.reference, popper3 = _state$elements.popper;
          if (!areValidElements(reference3, popper3)) {
            return;
          }
          state.rects = {
            reference: getCompositeRect(reference3, getOffsetParent(popper3), state.options.strategy === "fixed"),
            popper: getLayoutRect(popper3)
          };
          state.reset = false;
          state.placement = state.options.placement;
          state.orderedModifiers.forEach(function(modifier) {
            return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
          });
          for (var index2 = 0; index2 < state.orderedModifiers.length; index2++) {
            if (state.reset === true) {
              state.reset = false;
              index2 = -1;
              continue;
            }
            var _state$orderedModifie = state.orderedModifiers[index2], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name2 = _state$orderedModifie.name;
            if (typeof fn === "function") {
              state = fn({
                state,
                options: _options,
                name: name2,
                instance: instance2
              }) || state;
            }
          }
        },
        update: debounce(function() {
          return new Promise(function(resolve) {
            instance2.forceUpdate();
            resolve(state);
          });
        }),
        destroy: function destroy() {
          cleanupModifierEffects();
          isDestroyed = true;
        }
      };
      if (!areValidElements(reference2, popper2)) {
        return instance2;
      }
      instance2.setOptions(options).then(function(state2) {
        if (!isDestroyed && options.onFirstUpdate) {
          options.onFirstUpdate(state2);
        }
      });
      function runModifierEffects() {
        state.orderedModifiers.forEach(function(_ref3) {
          var name2 = _ref3.name, _ref3$options = _ref3.options, options2 = _ref3$options === void 0 ? {} : _ref3$options, effect2 = _ref3.effect;
          if (typeof effect2 === "function") {
            var cleanupFn = effect2({
              state,
              name: name2,
              instance: instance2,
              options: options2
            });
            var noopFn = function noopFn2() {
            };
            effectCleanupFns.push(cleanupFn || noopFn);
          }
        });
      }
      function cleanupModifierEffects() {
        effectCleanupFns.forEach(function(fn) {
          return fn();
        });
        effectCleanupFns = [];
      }
      return instance2;
    };
  }
  var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offsetModifier, flip$1, preventOverflow$1, arrow$1, hide$1];
  var createPopper = /* @__PURE__ */ popperGenerator({
    defaultModifiers
  });
  var [name$s, bem$d] = createNamespace("guide");
  var guideProps = {
    steps: makeArrayProp(),
    step: makeNumberProp(1),
    nextText: makeStringProp("\u4E0B\u4E00\u6B65"),
    okText: makeStringProp("\u6211\u77E5\u9053\u4E86"),
    zIndex: numericProp,
    showSkip: falseProp,
    skipPlacement: makeStringProp("right-start"),
    handleSkip: Function
  };
  var _Guide = vue.defineComponent({
    name: name$s,
    props: guideProps,
    emits: ["change"],
    setup(props, _ref) {
      var [name2, bem2] = createNamespace("guide");
      if (props.step < 1) {
        return;
      }
      if (!Array.isArray(props.steps) || props.steps.length === 0) {
        return;
      }
      var show = vue.ref(false);
      var guideRef = vue.ref();
      var stepIndex = vue.ref(props.step);
      var popoverRef = vue.ref();
      var stepText = vue.ref("");
      var currentStep = vue.ref(props.steps[stepIndex.value]);
      var selector = null;
      var popper2;
      var copySelector;
      var createPopperInstance = () => {
        if (selector && popoverRef.value) {
          return createPopper(selector, popoverRef.value, {
            placement: "auto",
            modifiers: [{
              name: "computeStyles",
              options: {
                adaptive: false,
                gpuAcceleration: false
              }
            }, {
              name: "offset",
              options: {
                offset: [0, 20]
              }
            }, {
              name: "preventOverflow",
              options: {
                padding: 15
              }
            }]
          });
        }
        return null;
      };
      var close = () => {
        guideRef.value && document.body.removeChild(guideRef.value);
        if (popper2) {
          popper2.destroy();
          popper2 = null;
        }
        document.body.style.overflow = "auto";
      };
      var resetStyle = (currentStep2) => {
        var curentIndex = currentStep2 ? currentStep2 - 1 : stepIndex.value - 2;
        var beforeSteps = props.steps[curentIndex];
        var {
          className: beforeClassName
        } = beforeSteps;
        var deforeDom = document.querySelector("." + beforeClassName);
        deforeDom.style.position = copySelector.position || "static";
        deforeDom.style.zIndex = copySelector.zIndex || "0";
        deforeDom.style.pointerEvents = "auto";
      };
      var startStep = () => {
        var _guideRef$value3;
        if (stepIndex.value <= props.steps.length) {
          var stepsData = props.steps[stepIndex.value - 1];
          stepsData.presentStep ? stepsData.presentStep(stepIndex.value) : "";
        }
        if (selector) {
          var _guideRef$value, _guideRef$value2;
          resetStyle();
          (_guideRef$value = guideRef.value) == null ? void 0 : _guideRef$value.removeChild((_guideRef$value2 = guideRef.value) == null ? void 0 : _guideRef$value2.children[props.showSkip ? 2 : 1]);
        }
        if (stepIndex.value > props.steps.length) {
          close();
          return;
        }
        stepText.value = stepIndex.value < props.steps.length ? props.nextText : props.okText;
        currentStep.value = props.steps[stepIndex.value - 1];
        var {
          className,
          image,
          width: width2,
          height: height2,
          offsetX,
          offsetY
        } = currentStep.value;
        if (typeof className === "string") {
          selector = document.querySelector("." + className);
        } else {
          selector = className;
        }
        if (!selector)
          return;
        var domStyle = window.getComputedStyle(selector);
        copySelector = {
          position: domStyle.position,
          zIndex: domStyle.zIndex
        };
        var distanceBottom = window.innerHeight - (selector.offsetTop - window.pageYOffset) - selector.offsetHeight;
        if (distanceBottom < 1) {
          selector.scrollIntoView();
        }
        var {
          zIndex: zIndex2 = "1"
        } = props;
        (_guideRef$value3 = guideRef.value) == null ? void 0 : _guideRef$value3.appendChild(useCloneElement(selector, {
          image,
          width: width2,
          height: height2,
          offsetX,
          offsetY
        }, zIndex2));
        popper2 = createPopperInstance();
      };
      var nextStep = () => {
        stepIndex.value += 1;
        startStep();
      };
      var skipStep = () => {
        resetStyle(stepIndex.value);
        props.handleSkip ? props.handleSkip() : "";
        close();
      };
      vue.onMounted(() => {
        document.body.style.overflow = "hidden";
        vue.nextTick(() => {
          startStep();
        });
      });
      var {
        zIndex = "1"
      } = props;
      return () => vue.createVNode(vue.Teleport, {
        "to": "body"
      }, {
        default: () => [vue.withDirectives(vue.createVNode("div", {
          "ref": guideRef,
          "class": bem2(""),
          "style": {
            zIndex: Number(zIndex)
          }
        }, [props.showSkip && vue.createVNode("div", {
          "class": bem2("skip-btn", props.skipPlacement),
          "onClick": skipStep
        }, [vue.createTextVNode("\u8DF3\u8FC7")]), vue.createVNode("div", {
          "ref": popoverRef,
          "class": bem2("popover")
        }, [vue.createVNode("div", {
          "data-popper-arrow": true,
          "class": bem2("popover-arrow")
        }, null), currentStep.value.title && vue.createVNode("div", {
          "class": bem2("popover-title")
        }, [currentStep.value.title]), currentStep.value.content && vue.createVNode("div", {
          "class": bem2("popover-content")
        }, [currentStep.value.content]), vue.createVNode("div", {
          "class": bem2("popover-footer")
        }, [vue.createVNode("span", {
          "class": bem2("popover-footer-process")
        }, [stepIndex.value, vue.createTextVNode("/"), props.steps.length]), vue.createVNode("div", {
          "class": bem2("popover-footer-button"),
          "onClick": nextStep
        }, [stepText.value])])])]), [[vue.vShow, show]])]
      });
    }
  });
  function _extends$4() {
    _extends$4 = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends$4.apply(this, arguments);
  }
  var Guide = withInstall(_Guide);
  var GuideShow = (options) => {
    var container = document.createElement("div");
    var vm = vue.createVNode(_Guide, _extends$4({}, options));
    vue.render(vm, container);
    return vm;
  };
  Guide.show = (options) => {
    GuideShow(options);
  };
  var [name$r] = createNamespace("image");
  var imageProps = {
    src: String,
    alt: String,
    fit: String,
    round: Boolean,
    width: numericProp,
    height: numericProp,
    radius: makeNumberProp(4),
    iconSize: makeNumberProp(32),
    showError: truthProp,
    errorIcon: makeStringProp("load_error"),
    showLoading: truthProp,
    loadingIcon: makeStringProp("load_loading")
  };
  var _Image = vue.defineComponent({
    name: name$r,
    props: imageProps,
    emits: ["load", "error"],
    setup(props, _ref) {
      var {
        emit,
        slots
      } = _ref;
      var bem2 = createNamespace("image")[1];
      var error = vue.ref(false);
      var loading = vue.ref(true);
      var style = vue.computed(() => {
        var style2 = {
          width: addUnit(props.width),
          height: addUnit(props.height)
        };
        if (!props.round) {
          style2.overflow = "hidden";
          style2.borderRadius = addUnit(props.radius);
        }
        return style2;
      });
      vue.watch(() => props.src, () => {
        error.value = false;
        loading.value = true;
      });
      var onLoad = (event) => {
        loading.value = false;
        emit("load", event);
      };
      var onError = (event) => {
        error.value = true;
        loading.value = false;
        emit("error", event);
      };
      var renderIcon = (name2, className, slot) => {
        if (slot) {
          return slot();
        }
        return vue.createVNode(Icon, {
          "name": name2,
          "size": props.iconSize,
          "class": className
        }, null);
      };
      var renderPlaceholder = () => {
        if (loading.value && props.showLoading) {
          return vue.createVNode("div", {
            "class": bem2("loading")
          }, [renderIcon(props.loadingIcon, bem2("loading-icon"), slots.loading)]);
        }
        if (error.value && props.showError) {
          return vue.createVNode("div", {
            "class": bem2("error")
          }, [renderIcon(props.errorIcon, bem2("error-icon"), slots.error)]);
        }
      };
      var renderImage = () => {
        if (error.value || !props.src) {
          return;
        }
        var attrs = {
          alt: props.alt,
          class: bem2("img"),
          style: {
            objectFit: props.fit
          }
        };
        return vue.createVNode("img", vue.mergeProps({
          "src": props.src,
          "onLoad": onLoad,
          "onError": onError
        }, attrs), null);
      };
      return () => vue.createVNode("div", {
        "class": bem2({
          round: props.round
        }),
        "style": style.value
      }, [renderImage(), renderPlaceholder(), slots.default == null ? void 0 : slots.default()]);
    }
  });
  var Image = withInstall(_Image);
  var visibility;
  function usePageVisibility() {
    if (!visibility) {
      visibility = vue.ref("visible");
      if (inBrowser$1) {
        var update = () => {
          visibility.value = document.hidden ? "hidden" : "visible";
        };
        update();
        window.addEventListener("visibilitychange", update);
      }
    }
    return visibility;
  }
  var POPUP_TOGGLE_KEY = Symbol();
  function onPopupReopen(callback) {
    var popupToggleStatus = vue.inject(POPUP_TOGGLE_KEY, null);
    if (popupToggleStatus) {
      vue.watch(popupToggleStatus, (show) => {
        if (show) {
          callback();
        }
      });
    }
  }
  var [name$q] = createNamespace("swipe");
  var swipeProps = {
    autoplay: makeNumericProp(0),
    duration: makeNumericProp(500),
    initialSwipe: makeNumericProp(0),
    width: numericProp,
    height: numericProp,
    loop: truthProp,
    showIndicators: truthProp,
    vertical: Boolean,
    touchable: truthProp,
    stopPropagation: truthProp,
    lazyRender: Boolean,
    indicatorColor: String
  };
  var SWIPE_KEY = Symbol(name$q);
  var _Swipe = vue.defineComponent({
    name: name$q,
    props: swipeProps,
    emits: ["change"],
    setup(props, _ref) {
      var {
        emit,
        slots
      } = _ref;
      var bem2 = createNamespace("swipe")[1];
      var root = vue.ref();
      var state = vue.reactive({
        rect: null,
        width: 0,
        height: 0,
        offset: 0,
        active: 0,
        swiping: false
      });
      var touch = useTouch();
      var {
        children,
        linkChildren
      } = useChildren(SWIPE_KEY);
      var count = vue.computed(() => children.length);
      var size = vue.computed(() => state[props.vertical ? "height" : "width"]);
      var delta = vue.computed(() => props.vertical ? touch.deltaY.value : touch.deltaX.value);
      var minOffset = vue.computed(() => {
        if (state.rect) {
          var base = props.vertical ? state.rect.height : state.rect.width;
          return base - size.value * count.value;
        }
        return 0;
      });
      var maxCount = vue.computed(() => Math.ceil(Math.abs(minOffset.value) / size.value));
      var trackSize = vue.computed(() => count.value * size.value);
      var activeIndicator = vue.computed(() => (state.active + count.value) % count.value);
      var isCorrectDirection = vue.computed(() => {
        var expect = props.vertical ? "vertical" : "horizontal";
        return touch.direction.value === expect;
      });
      var trackStyle = vue.computed(() => {
        var style = {
          transitionDuration: (state.swiping ? 0 : props.duration) + "ms",
          transform: "translate" + (props.vertical ? "Y" : "X") + "(" + state.offset + "px)"
        };
        if (size.value) {
          var mainAxis = props.vertical ? "height" : "width";
          var crossAxis = props.vertical ? "width" : "height";
          style[mainAxis] = trackSize.value + "px";
          style[crossAxis] = props[crossAxis] ? props[crossAxis] + "px" : "";
        }
        return style;
      });
      var getTargetActive = (pace) => {
        var {
          active
        } = state;
        if (pace) {
          if (props.loop) {
            return clamp(active + pace, -1, count.value);
          }
          return clamp(active + pace, 0, maxCount.value);
        }
        return active;
      };
      var getTargetOffset = function(targetActive, offset2) {
        if (offset2 === void 0) {
          offset2 = 0;
        }
        var currentPosition = targetActive * size.value;
        if (!props.loop) {
          currentPosition = Math.min(currentPosition, -minOffset.value);
        }
        var targetOffset = offset2 - currentPosition;
        if (!props.loop) {
          targetOffset = clamp(targetOffset, minOffset.value, 0);
        }
        return targetOffset;
      };
      var move = (_ref2) => {
        var {
          pace = 0,
          offset: offset2 = 0,
          emitChange
        } = _ref2;
        if (count.value <= 1) {
          return;
        }
        var {
          active
        } = state;
        var targetActive = getTargetActive(pace);
        var targetOffset = getTargetOffset(targetActive, offset2);
        if (props.loop) {
          if (children[0] && targetOffset !== minOffset.value) {
            var outRightBound = targetOffset < minOffset.value;
            children[0].setOffset(outRightBound ? trackSize.value : 0);
          }
          if (children[count.value - 1] && targetOffset !== 0) {
            var outLeftBound = targetOffset > 0;
            children[count.value - 1].setOffset(outLeftBound ? -trackSize.value : 0);
          }
        }
        state.active = targetActive;
        state.offset = targetOffset;
        if (emitChange && targetActive !== active) {
          emit("change", activeIndicator.value);
        }
      };
      var correctPosition = () => {
        state.swiping = true;
        if (state.active <= -1) {
          move({
            pace: count.value
          });
        } else if (state.active >= count.value) {
          move({
            pace: -count.value
          });
        }
      };
      var prev = () => {
        correctPosition();
        touch.reset();
        doubleRaf(() => {
          state.swiping = false;
          move({
            pace: -1,
            emitChange: true
          });
        });
      };
      var next = () => {
        correctPosition();
        touch.reset();
        doubleRaf(() => {
          state.swiping = false;
          move({
            pace: 1,
            emitChange: true
          });
        });
      };
      var autoplayTimer;
      var stopAutoplay = () => clearTimeout(autoplayTimer);
      var autoplay = () => {
        stopAutoplay();
        if (props.autoplay > 0 && count.value > 1) {
          autoplayTimer = setTimeout(() => {
            next();
            autoplay();
          }, +props.autoplay);
        }
      };
      var initialize = function(active) {
        if (active === void 0) {
          active = +props.initialSwipe;
        }
        if (!root.value) {
          return;
        }
        if (!isHidden(root)) {
          var _props$width, _props$height;
          var rect = {
            width: root.value.offsetWidth,
            height: root.value.offsetHeight
          };
          state.rect = rect;
          state.width = +((_props$width = props.width) != null ? _props$width : rect.width);
          state.height = +((_props$height = props.height) != null ? _props$height : rect.height);
        }
        if (count.value) {
          active = Math.min(count.value - 1, active);
        }
        state.active = active;
        state.swiping = true;
        state.offset = getTargetOffset(active);
        children.forEach((swipe) => {
          swipe.setOffset(0);
        });
        autoplay();
      };
      var resize = () => initialize(state.active);
      var touchStartTime;
      var onTouchStart = (event) => {
        if (!props.touchable)
          return;
        touch.start(event);
        touchStartTime = Date.now();
        stopAutoplay();
        correctPosition();
      };
      var onTouchMove = (event) => {
        if (props.touchable && state.swiping) {
          touch.move(event);
          if (isCorrectDirection.value) {
            preventDefault(event, props.stopPropagation);
            move({
              offset: delta.value
            });
          }
        }
      };
      var onTouchEnd = () => {
        if (!props.touchable || !state.swiping) {
          return;
        }
        var duration = Date.now() - touchStartTime;
        var speed = delta.value / duration;
        var shouldSwipe = Math.abs(speed) > 0.25 || Math.abs(delta.value) > size.value / 2;
        if (shouldSwipe && isCorrectDirection.value) {
          var offset2 = props.vertical ? touch.offsetY.value : touch.offsetX.value;
          var pace = 0;
          if (props.loop) {
            pace = offset2 > 0 ? delta.value > 0 ? -1 : 1 : 0;
          } else {
            pace = -Math[delta.value > 0 ? "ceil" : "floor"](delta.value / size.value);
          }
          move({
            pace,
            emitChange: true
          });
        } else if (delta.value) {
          move({
            pace: 0
          });
        }
        state.swiping = false;
        autoplay();
      };
      var swipeTo = function(index2, options) {
        if (options === void 0) {
          options = {};
        }
        correctPosition();
        touch.reset();
        doubleRaf(() => {
          var targetIndex;
          if (props.loop && index2 === count.value) {
            targetIndex = state.active === 0 ? 0 : index2;
          } else {
            targetIndex = index2 % count.value;
          }
          if (options.immediate) {
            doubleRaf(() => {
              state.swiping = false;
            });
          } else {
            state.swiping = false;
          }
          move({
            pace: targetIndex - state.active,
            emitChange: true
          });
        });
      };
      var renderDot = (_, index2) => {
        var active = index2 === activeIndicator.value;
        var style = active ? {
          backgroundColor: props.indicatorColor
        } : void 0;
        return vue.createVNode("i", {
          "style": style,
          "class": bem2("indicator", {
            active
          })
        }, null);
      };
      var renderIndicator = () => {
        if (slots.indicator) {
          return slots.indicator({
            active: activeIndicator.value
          });
        }
        if (props.showIndicators && count.value > 1) {
          return vue.createVNode("div", {
            "class": bem2("indicators", {
              vertical: props.vertical
            })
          }, [Array(count.value).fill("").map(renderDot)]);
        }
      };
      useExpose({
        prev,
        next,
        state,
        resize,
        swipeTo
      });
      linkChildren({
        size,
        props,
        count,
        activeIndicator
      });
      vue.watch(() => props.initialSwipe, (value) => initialize(+value));
      vue.watch(count, () => initialize(state.active));
      vue.watch(() => props.autoplay, autoplay);
      vue.watch([windowWidth, windowHeight], resize);
      vue.watch(usePageVisibility(), (visible) => {
        if (visible === "visible") {
          autoplay();
        } else {
          stopAutoplay();
        }
      });
      vue.onMounted(initialize);
      vue.onActivated(() => initialize(state.active));
      onPopupReopen(() => initialize(state.active));
      vue.onDeactivated(stopAutoplay);
      vue.onBeforeUnmount(stopAutoplay);
      return () => vue.createVNode("div", {
        "ref": root,
        "class": bem2()
      }, [vue.createVNode("div", {
        "style": trackStyle.value,
        "class": bem2("track", {
          vertical: props.vertical
        }),
        "onTouchstart": onTouchStart,
        "onTouchmove": onTouchMove,
        "onTouchend": onTouchEnd,
        "onTouchcancel": onTouchEnd
      }, [slots.default == null ? void 0 : slots.default()]), renderIndicator()]);
    }
  });
  var Swipe = withInstall(_Swipe);
  var [name$p] = createNamespace("loading");
  var loadingProps = {
    size: numericProp,
    type: makeStringProp("circular"),
    color: String,
    vertical: Boolean,
    textSize: numericProp,
    textColor: String
  };
  var Loading$1 = vue.defineComponent({
    name: name$p,
    props: loadingProps,
    setup(props, _ref) {
      var {
        slots
      } = _ref;
      var bem2 = createNamespace("loading")[1];
      var SpinIcon = Array(12).fill(null).map((_, index2) => vue.createVNode("i", {
        "class": bem2("line", String(index2 + 1))
      }, null));
      var CircularIcon = vue.createVNode("svg", {
        "class": bem2("circular"),
        "viewBox": "25 25 50 50"
      }, [vue.createVNode("circle", {
        "cx": "50",
        "cy": "50",
        "r": "20",
        "fill": "none"
      }, null)]);
      var spinnerStyle = vue.computed(() => extend({
        color: props.color
      }, getSizeStyle(props.size)));
      var renderText = () => {
        if (slots.default) {
          var _props$textColor;
          return vue.createVNode("span", {
            "class": bem2("text"),
            "style": {
              fontSize: addUnit(props.textSize),
              color: (_props$textColor = props.textColor) != null ? _props$textColor : props.color
            }
          }, [slots.default()]);
        }
      };
      var renderIcon = () => vue.createVNode("span", {
        "class": bem2("spinner", "icon"),
        "style": spinnerStyle.value
      }, [slots.icon == null ? void 0 : slots.icon()]);
      var renderDefaultIcon = () => {
        var {
          type,
          vertical
        } = props;
        return vue.createVNode("span", {
          "class": bem2("spinner", type),
          "style": spinnerStyle.value
        }, [type === "spinner" ? SpinIcon : CircularIcon]);
      };
      return () => {
        var {
          type,
          vertical
        } = props;
        return vue.createVNode("div", {
          "class": bem2([type, {
            vertical
          }])
        }, [slots.icon ? renderIcon() : renderDefaultIcon(), renderText()]);
      };
    }
  });
  var Loading = withInstall(Loading$1);
  var [name$o] = createNamespace("swipe-item");
  var _SwipeItem = vue.defineComponent({
    name: name$o,
    setup(props, _ref) {
      var {
        slots
      } = _ref;
      var bem2 = createNamespace("swipe-item")[1];
      var rendered;
      var state = vue.reactive({
        offset: 0,
        inited: false,
        mounted: false
      });
      var {
        parent,
        index: index2
      } = useParent(SWIPE_KEY);
      if (!parent) {
        return;
      }
      var style = vue.computed(() => {
        var style2 = {};
        var {
          vertical
        } = parent.props;
        if (parent.size.value) {
          style2[vertical ? "height" : "width"] = parent.size.value + "px";
        }
        if (state.offset) {
          style2.transform = "translate" + (vertical ? "Y" : "X") + "(" + state.offset + "px)";
        }
        return style2;
      });
      var shouldRender = vue.computed(() => {
        var {
          loop,
          lazyRender
        } = parent.props;
        if (!lazyRender || rendered) {
          return true;
        }
        if (!state.mounted) {
          return false;
        }
        var active = parent.activeIndicator.value;
        var maxActive = parent.count.value - 1;
        var prevActive = active === 0 && loop ? maxActive : active - 1;
        var nextActive = active === maxActive && loop ? 0 : active + 1;
        rendered = index2.value === active || index2.value === prevActive || index2.value === nextActive;
        return rendered;
      });
      var setOffset = (offset2) => {
        state.offset = offset2;
      };
      vue.onMounted(() => {
        vue.nextTick(() => {
          state.mounted = true;
        });
      });
      useExpose({
        setOffset
      });
      return () => vue.createVNode("div", {
        "class": bem2(),
        "style": style.value
      }, [shouldRender.value ? slots.default == null ? void 0 : slots.default() : null]);
    }
  });
  var SwipeItem = withInstall(_SwipeItem);
  var getDistance = (touches) => Math.sqrt(Math.pow(touches[0].clientX - touches[1].clientX, 2) + Math.pow(touches[0].clientY - touches[1].clientY, 2));
  var ImageItemProps = {
    src: String,
    show: Boolean,
    active: Number,
    minZoom: makeRequiredProp(numericProp),
    maxZoom: makeRequiredProp(numericProp),
    rootWidth: makeRequiredProp(Number),
    rootHeight: makeRequiredProp(Number)
  };
  var ImagePreviewItem = vue.defineComponent({
    props: ImageItemProps,
    emits: ["scale", "close"],
    setup(props, _ref) {
      var {
        emit
      } = _ref;
      var bem2 = createNamespace("image-preview")[1];
      var state = vue.reactive({
        scale: 1,
        moveX: 0,
        moveY: 0,
        moving: false,
        zooming: false,
        imageRatio: 0,
        displayWidth: 0,
        displayHeight: 0
      });
      var touch = useTouch();
      var vertical = vue.computed(() => {
        var {
          rootWidth,
          rootHeight
        } = props;
        var rootRatio = rootHeight / rootWidth;
        return state.imageRatio > rootRatio;
      });
      var imageStyle = vue.computed(() => {
        var {
          scale,
          moveX,
          moveY,
          moving,
          zooming
        } = state;
        var style = {
          transitionDuration: zooming || moving ? "0s" : ".3s"
        };
        if (scale !== 1) {
          var offsetX = moveX / scale;
          var offsetY = moveY / scale;
          style.transform = "scale(" + scale + ", " + scale + ") translate(" + offsetX + "px, " + offsetY + "px)";
        }
        return style;
      });
      var maxMoveX = vue.computed(() => {
        if (state.imageRatio) {
          var {
            rootWidth,
            rootHeight
          } = props;
          var displayWidth = vertical.value ? rootHeight / state.imageRatio : rootWidth;
          return Math.max(0, (state.scale * displayWidth - rootWidth) / 2);
        }
        return 0;
      });
      var maxMoveY = vue.computed(() => {
        if (state.imageRatio) {
          var {
            rootWidth,
            rootHeight
          } = props;
          var displayHeight = vertical.value ? rootHeight : rootWidth * state.imageRatio;
          return Math.max(0, (state.scale * displayHeight - rootHeight) / 2);
        }
        return 0;
      });
      var setScale = (scale) => {
        scale = clamp(scale, +props.minZoom, +props.maxZoom);
        if (scale !== state.scale) {
          state.scale = scale;
          emit("scale", {
            scale,
            index: props.active
          });
        }
      };
      var resetScale = () => {
        setScale(1);
        state.moveX = 0;
        state.moveY = 0;
      };
      var toggleScale = () => {
        var scale = state.scale > 1 ? 1 : 2;
        setScale(scale);
        state.moveX = 0;
        state.moveY = 0;
      };
      var startMoveX;
      var startMoveY;
      var startScale;
      var startDistance;
      var doubleTapTimer;
      var touchStartTime;
      var onTouchStart = (event) => {
        var {
          touches
        } = event;
        var {
          offsetX
        } = touch;
        touch.start(event);
        startMoveX = state.moveX;
        startMoveY = state.moveY;
        touchStartTime = Date.now();
        state.moving = touches.length === 1 && state.scale !== 1;
        state.zooming = touches.length === 2 && !offsetX.value;
        if (state.zooming) {
          startScale = state.scale;
          startDistance = getDistance(event.touches);
        }
      };
      var onTouchMove = (event) => {
        var {
          touches
        } = event;
        touch.move(event);
        if (state.moving || state.zooming) {
          preventDefault(event, true);
        }
        if (state.moving) {
          var {
            deltaX,
            deltaY
          } = touch;
          var moveX = deltaX.value + startMoveX;
          var moveY = deltaY.value + startMoveY;
          state.moveX = clamp(moveX, -maxMoveX.value, maxMoveX.value);
          state.moveY = clamp(moveY, -maxMoveY.value, maxMoveY.value);
        }
        if (state.zooming && touches.length === 2) {
          var distance = getDistance(touches);
          var scale = startScale * distance / startDistance;
          setScale(scale);
        }
      };
      var checkTap = () => {
        var {
          offsetX,
          offsetY
        } = touch;
        var deltaTime = Date.now() - touchStartTime;
        var TAP_TIME = 250;
        var TAP_OFFSET = 10;
        if (offsetX.value < TAP_OFFSET && offsetY.value < TAP_OFFSET && deltaTime < TAP_TIME) {
          if (doubleTapTimer) {
            clearTimeout(doubleTapTimer);
            doubleTapTimer = null;
            toggleScale();
          } else {
            doubleTapTimer = setTimeout(() => {
              emit("close");
              doubleTapTimer = null;
            }, TAP_TIME);
          }
        }
      };
      var onTouchEnd = (event) => {
        var stopPropagation2 = false;
        if (state.moving || state.zooming) {
          stopPropagation2 = true;
          if (state.moving && startMoveX === state.moveX && startMoveY === state.moveY) {
            stopPropagation2 = false;
          }
          if (!event.touches.length) {
            if (state.zooming) {
              state.moveX = clamp(state.moveX, -maxMoveX.value, maxMoveX.value);
              state.moveY = clamp(state.moveY, -maxMoveY.value, maxMoveY.value);
              state.zooming = false;
            }
            state.moving = false;
            startMoveX = 0;
            startMoveY = 0;
            startScale = 1;
            if (state.scale < 1) {
              resetScale();
            }
          }
        }
        preventDefault(event, stopPropagation2);
        checkTap();
        touch.reset();
      };
      var onLoad = (event) => {
        var {
          naturalWidth,
          naturalHeight
        } = event.target;
        state.imageRatio = naturalHeight / naturalWidth;
      };
      vue.watch(() => props.active, resetScale);
      vue.watch(() => props.show, (value) => {
        if (!value) {
          resetScale();
        }
      });
      return () => {
        var imageSlots = {
          loading: () => vue.createVNode(Loading, {
            "type": "spinner"
          }, null)
        };
        return vue.createVNode(SwipeItem, {
          "class": bem2("swipe-item"),
          "onTouchstart": onTouchStart,
          "onTouchmove": onTouchMove,
          "onTouchend": onTouchEnd,
          "onTouchcancel": onTouchEnd
        }, {
          default: () => [vue.createVNode(Image, {
            "src": props.src,
            "fit": "contain",
            "radius": 0,
            "class": bem2("image", {
              vertical: vertical.value
            }),
            "style": imageStyle.value,
            "onLoad": onLoad
          }, imageSlots)]
        });
      };
    }
  });
  var [name$n] = createNamespace("image-preview");
  var popupProps$1 = ["show", "transition", "overlayStyle", "closeOnPopstate"];
  var imagePreviewProps = {
    show: Boolean,
    loop: truthProp,
    model: makeStringProp("dark"),
    images: makeArrayProp(),
    minZoom: makeNumericProp(1 / 3),
    maxZoom: makeNumericProp(3),
    overlay: truthProp,
    closeable: truthProp,
    showIndex: truthProp,
    className: unknownProp,
    transition: String,
    beforeClose: Function,
    overlayStyle: Object,
    swipeDuration: makeNumericProp(300),
    startPosition: makeNumericProp(0),
    showIndicators: Boolean,
    closeOnPopstate: truthProp
  };
  var CfImagePreview = vue.defineComponent({
    name: name$n,
    props: imagePreviewProps,
    emits: ["scale", "close", "closed", "change", "update:show"],
    setup(props, _ref) {
      var {
        emit,
        slots
      } = _ref;
      var bem2 = createNamespace("image-preview")[1];
      var {
        HAPTICS_FEEDBACK
      } = useGlobalClassName();
      var swipeRef = vue.ref();
      var state = vue.reactive({
        active: 0,
        rootWidth: 0,
        rootHeight: 0
      });
      var resize = () => {
        if (swipeRef.value) {
          var rect = useRect(swipeRef.value.$el);
          state.rootWidth = rect.width;
          state.rootHeight = rect.height;
          swipeRef.value.resize();
        }
      };
      var emitScale = (args) => emit("scale", args);
      var updateShow = (show) => emit("update:show", show);
      var emitClose = () => {
        callInterceptor(props.beforeClose, {
          args: [state.active],
          done: () => updateShow(false)
        });
      };
      var setActive = (active) => {
        if (active !== state.active) {
          state.active = active;
          emit("change", active);
        }
      };
      var onClosed = () => emit("closed");
      var renderIndex = () => {
        if (props.showIndex) {
          return vue.createVNode("div", {
            "class": bem2("index")
          }, [slots.index ? slots.index({
            index: state.active
          }) : state.active + 1 + " / " + props.images.length]);
        }
      };
      var renderCover = () => {
        if (slots.cover) {
          return vue.createVNode("div", {
            "class": bem2("cover")
          }, [slots.cover()]);
        }
      };
      var renderImages = () => vue.createVNode(Swipe, {
        "ref": swipeRef,
        "lazyRender": true,
        "loop": props.loop,
        "class": bem2("swipe"),
        "duration": props.swipeDuration,
        "initialSwipe": props.startPosition,
        "showIndicators": props.showIndicators,
        "indicatorColor": "white",
        "onChange": setActive
      }, {
        default: () => [props.images.map((image) => vue.createVNode(ImagePreviewItem, {
          "src": image,
          "show": props.show,
          "active": state.active,
          "maxZoom": props.maxZoom,
          "minZoom": props.minZoom,
          "rootWidth": state.rootWidth,
          "rootHeight": state.rootHeight,
          "onScale": emitScale,
          "onClose": emitClose
        }, null))]
      });
      var renderClose = () => {
        if (props.closeable) {
          return vue.createVNode(Icon, {
            "name": "close_out_line",
            "class": [bem2("close-icon"), HAPTICS_FEEDBACK],
            "size": 24,
            "color": props.model === "dark" ? "#DCDEE0" : "rgba(0, 0, 0, 0.6)",
            "onClick": emitClose
          }, null);
        }
      };
      var swipeTo = (index2, options) => {
        var _swipeRef$value;
        return (_swipeRef$value = swipeRef.value) == null ? void 0 : _swipeRef$value.swipeTo(index2, options);
      };
      useExpose({
        swipeTo
      });
      vue.onMounted(resize);
      vue.watch([windowWidth, windowHeight], resize);
      vue.watch(() => props.startPosition, (value) => setActive(+value));
      vue.watch(() => props.show, (value) => {
        var {
          images: images2,
          startPosition
        } = props;
        if (value) {
          setActive(+startPosition);
          vue.nextTick(() => {
            resize();
            swipeTo(+startPosition, {
              immediate: true
            });
          });
        } else {
          emit("close", {
            index: state.active,
            url: images2[state.active]
          });
        }
      });
      return () => vue.createVNode(Popup, vue.mergeProps({
        "class": [bem2(), props.className],
        "overlayClass": bem2("overlay", props.model),
        "onClosed": onClosed,
        "onUpdate:show": updateShow
      }, pick(props, popupProps$1)), {
        default: () => [renderClose(), renderImages(), renderIndex(), renderCover()]
      });
    }
  });
  var instance;
  var defaultConfig = {
    loop: true,
    images: [],
    maxZoom: 3,
    minZoom: 1 / 3,
    onScale: void 0,
    onClose: void 0,
    onChange: void 0,
    teleport: "body",
    className: "",
    showIndex: true,
    closeable: true,
    transition: void 0,
    beforeClose: void 0,
    overlayStyle: void 0,
    startPosition: 0,
    swipeDuration: 300,
    showIndicators: false,
    closeOnPopstate: true,
    closeIconPosition: "top-left"
  };
  function initInstance() {
    ({
      instance
    } = mountComponent({
      setup() {
        var {
          state,
          toggle
        } = usePopupState();
        var onClosed = () => {
          state.images = [];
        };
        return () => vue.createVNode(CfImagePreview, vue.mergeProps(state, {
          "onClosed": onClosed,
          "onUpdate:show": toggle
        }), null);
      }
    }));
  }
  var showImagePreview = function(options, startPosition) {
    if (startPosition === void 0) {
      startPosition = 0;
    }
    if (!inBrowser$1) {
      return;
    }
    if (!instance) {
      initInstance();
    }
    options = Array.isArray(options) ? {
      images: options,
      startPosition
    } : options;
    instance.open(extend({}, defaultConfig, options));
    return instance;
  };
  var ImagePreview = withInstall(CfImagePreview);
  ImagePreview.showImagePreview = function(options, startPosition) {
    if (startPosition === void 0) {
      startPosition = 0;
    }
    return showImagePreview(options, startPosition);
  };
  function onMountedOrActivated(hook) {
    var mounted;
    vue.onMounted(() => {
      hook();
      vue.nextTick(() => {
        mounted = true;
      });
    });
    vue.onActivated(() => {
      if (mounted) {
        hook();
      }
    });
  }
  function useEventListener(type, listener, options) {
    if (options === void 0) {
      options = {};
    }
    if (typeof window === "undefined") {
      return;
    }
    var {
      target = window,
      passive: passive2 = false,
      capture = false
    } = options;
    var attached;
    var add = (target2) => {
      var element = vue.unref(target2);
      if (element && !attached) {
        element.addEventListener(type, listener, {
          capture,
          passive: passive2
        });
        attached = true;
      }
    };
    var remove = (target2) => {
      var element = vue.unref(target2);
      if (element && attached) {
        element.removeEventListener(type, listener, capture);
        attached = false;
      }
    };
    vue.onUnmounted(() => remove(target));
    vue.onDeactivated(() => remove(target));
    onMountedOrActivated(() => add(target));
    if (vue.isRef(target)) {
      vue.watch(target, (val, oldVal) => {
        remove(oldVal);
        add(val);
      });
    }
  }
  var [name$m] = createNamespace("list");
  var listProps = {
    error: Boolean,
    offset: makeNumericProp(300),
    loading: Boolean,
    finished: Boolean,
    errorText: String,
    direction: makeStringProp("down"),
    loadingText: String,
    finishedText: String,
    immediateCheck: truthProp
  };
  var _List = vue.defineComponent({
    name: name$m,
    props: listProps,
    emits: ["load", "update:error", "update:loading"],
    setup(props, _ref) {
      var {
        emit,
        slots
      } = _ref;
      var bem2 = createNamespace("list")[1];
      var loading = vue.ref(false);
      var root = vue.ref();
      var placeholder = vue.ref();
      var tabStatus = useTabStatus();
      var scrollParent = useScrollParent(root);
      var check = () => {
        vue.nextTick(() => {
          if (loading.value || props.finished || props.error || (tabStatus == null ? void 0 : tabStatus.value) === false) {
            return;
          }
          var {
            offset: offset2,
            direction
          } = props;
          var scrollParentRect = useRect(scrollParent);
          if (!scrollParentRect.height || isHidden(root)) {
            return;
          }
          var isReachEdge = false;
          var placeholderRect = useRect(placeholder);
          if (direction === "up") {
            isReachEdge = scrollParentRect.top - placeholderRect.top <= offset2;
          } else {
            isReachEdge = placeholderRect.bottom - scrollParentRect.bottom <= offset2;
          }
          if (isReachEdge) {
            loading.value = true;
            emit("update:loading", true);
            emit("load");
          }
        });
      };
      var renderFinishedText = () => {
        if (props.finished) {
          var text = slots.finished ? slots.finished() : props.finishedText;
          if (text) {
            return vue.createVNode("div", {
              "class": bem2("finished-text")
            }, [text]);
          }
        }
      };
      var clickErrorText = () => {
        emit("update:error", false);
        check();
      };
      var renderErrorText = () => {
        if (props.error) {
          var text = slots.error ? slots.error() : props.errorText;
          if (text) {
            return vue.createVNode("div", {
              "class": bem2("error-text"),
              "onClick": clickErrorText
            }, [text]);
          }
        }
      };
      var renderLoading = () => {
        if (loading.value && !props.finished) {
          return vue.createVNode("div", {
            "class": bem2("loading")
          }, [slots.loading ? slots.loading() : vue.createVNode(Loading, {
            "class": bem2("loading-icon")
          }, {
            default: () => [props.loadingText || "\u52A0\u8F7D\u4E2D\xB7\xB7\xB7"]
          })]);
        }
      };
      vue.watch([() => props.loading, () => props.finished, () => props.error], check);
      if (tabStatus) {
        vue.watch(tabStatus, (tabActive) => {
          if (tabActive) {
            check();
          }
        });
      }
      vue.onUpdated(() => {
        loading.value = props.loading;
      });
      vue.onMounted(() => {
        if (props.immediateCheck) {
          check();
        }
      });
      useExpose({
        check
      });
      useEventListener("scroll", check, {
        target: scrollParent
      });
      return () => {
        var Content = slots.default == null ? void 0 : slots.default();
        var Placeholder = vue.createVNode("div", {
          "ref": placeholder,
          "class": bem2("placeholder")
        }, null);
        return vue.createVNode("div", {
          "ref": root,
          "role": "feed",
          "class": bem2(),
          "aria-busy": loading.value
        }, [props.direction === "down" ? Content : Placeholder, renderLoading(), renderFinishedText(), renderErrorText(), props.direction === "up" ? Content : Placeholder]);
      };
    }
  });
  var List = withInstall(_List);
  var useHeight = (element) => {
    var height2 = vue.ref();
    vue.onMounted(() => vue.nextTick(() => {
      height2.value = useRect(element).height;
    }));
    return height2;
  };
  function usePlaceholder(contentRef, bem2) {
    var height2 = useHeight(contentRef);
    return (renderContent) => vue.createVNode("div", {
      "class": bem2("placeholder"),
      "style": {
        height: height2.value ? height2.value + "px" : void 0
      }
    }, [renderContent()]);
  }
  var [name$l] = createNamespace("nav-bar");
  var navBarProps = {
    title: String,
    fixed: Boolean,
    zIndex: numericProp,
    border: truthProp,
    rightText: String,
    leftArrow: truthProp,
    placeholder: Boolean,
    safeAreaInsetTop: Boolean
  };
  var _NavBar = vue.defineComponent({
    name: name$l,
    props: navBarProps,
    emits: ["click-left", "click-right"],
    setup(props, _ref) {
      var {
        emit,
        slots
      } = _ref;
      var bem2 = createNamespace("nav-bar")[1];
      var {
        BORDER_BOTTOM,
        HAPTICS_FEEDBACK
      } = useGlobalClassName();
      var navBarRef = vue.ref();
      var renderPlaceholder = usePlaceholder(navBarRef, bem2);
      var onClickLeft = (event) => emit("click-left", event);
      var onClickRight = (event) => emit("click-right", event);
      var renderLeft = () => {
        if (slots.left) {
          return slots.left();
        }
        return vue.createVNode(Icon, {
          "class": bem2("arrow"),
          "name": "back",
          "size": "14"
        }, null);
      };
      var renderTitle = () => {
        if (slots.title) {
          return slots.title();
        }
        return vue.createVNode("span", {
          "class": bem2("title", "text")
        }, [props.title]);
      };
      var renderRight = () => {
        if (slots.right) {
          return slots.right();
        }
        return vue.createVNode("span", {
          "class": bem2("text")
        }, [props.rightText]);
      };
      var renderNavBar = () => {
        var {
          fixed,
          border,
          zIndex
        } = props;
        var style = getZIndexStyle(zIndex);
        var hasLeft = props.leftArrow || slots.left;
        var hasRight = props.rightText || slots.right;
        var hasTitle = props.title || slots.title;
        return vue.createVNode("div", {
          "ref": navBarRef,
          "style": style,
          "class": [bem2({
            fixed,
            "safe-area-inset-top": props.safeAreaInsetTop
          }), {
            [BORDER_BOTTOM]: border
          }]
        }, [vue.createVNode("div", {
          "class": bem2("content")
        }, [hasLeft && vue.createVNode("div", {
          "class": [bem2("left"), HAPTICS_FEEDBACK],
          "onClick": onClickLeft
        }, [renderLeft()]), hasTitle && vue.createVNode("div", {
          "class": bem2("title")
        }, [renderTitle()]), hasRight && vue.createVNode("div", {
          "class": [bem2("right"), HAPTICS_FEEDBACK],
          "onClick": onClickRight
        }, [renderRight()])])]);
      };
      return () => {
        if (props.fixed && props.placeholder) {
          return renderPlaceholder(renderNavBar);
        }
        return renderNavBar();
      };
    }
  });
  var NavBar = withInstall(_NavBar);
  function useClickAway(target, listener, options) {
    if (options === void 0) {
      options = {};
    }
    var {
      eventName = "click"
    } = options;
    var onClick = (event) => {
      var element = vue.unref(target);
      if (element && !element.contains(event.target)) {
        listener(event);
      }
    };
    useEventListener(eventName, onClick, {
      target: document
    });
  }
  var [name$k, bem$c] = createNamespace("popover");
  var popupProps = ["show", "overlay", "duration", "teleport", "overlayStyle", "overlayClass", "closeOnClickOverlay"];
  var popoverProps = {
    show: Boolean,
    theme: makeStringProp("light"),
    overlay: Boolean,
    actions: makeArrayProp(),
    trigger: makeStringProp("click"),
    duration: numericProp,
    showArrow: truthProp,
    placement: makeStringProp("bottom"),
    overlayClass: unknownProp,
    overlayStyle: Object,
    closeOnClickAction: truthProp,
    closeOnClickOverlay: truthProp,
    closeOnClickOutside: truthProp,
    showCloseButton: {
      type: Boolean,
      default: false
    },
    offset: {
      type: Array,
      default: () => [0, 10]
    },
    teleport: {
      type: [String, Object],
      default: "body"
    },
    className: String,
    setLockScroll: Boolean
  };
  var _Popover = vue.defineComponent({
    name: name$k,
    props: popoverProps,
    emits: ["select", "touchstart", "update:show", "handleClose"],
    setup(props, _ref) {
      var _props$actions;
      var {
        emit,
        slots,
        attrs
      } = _ref;
      var [name2, bem2] = createNamespace("popover");
      var {
        BORDER_BOTTOM
      } = useGlobalClassName();
      var popper2;
      var wrapperRef = vue.ref();
      var popoverRef = vue.ref();
      var createPopperInstance = () => {
        if (wrapperRef.value && popoverRef.value) {
          return createPopper(wrapperRef.value, popoverRef.value.popupRef.value, {
            placement: props.placement,
            modifiers: [{
              name: "computeStyles",
              options: {
                adaptive: false,
                gpuAcceleration: false
              }
            }, extend({}, offsetModifier, {
              options: {
                offset: props.offset
              }
            })]
          });
        }
        return null;
      };
      var updateLocation = () => {
        vue.nextTick(() => {
          if (!props.show) {
            return;
          }
          if (!popper2) {
            popper2 = createPopperInstance();
          } else {
            popper2.setOptions({
              placement: props.placement
            });
          }
        });
      };
      var updateShow = (value) => emit("update:show", value);
      var handleWrapperClick = () => {
        if (props.trigger === "click") {
          updateShow(!props.show);
        }
      };
      var handleWrapperEnter = () => {
        if (props.trigger === "hover") {
          updateShow(true);
        }
      };
      var handleWrapperLeave = () => {
        if (props.trigger === "hover") {
          updateShow(false);
        }
      };
      var onTouchstart = (event) => {
        event.stopPropagation();
        emit("touchstart", event);
      };
      var onClickAction = (action, index2) => {
        if (action.disabled) {
          return;
        }
        emit("select", action, index2);
        if (props.closeOnClickAction) {
          updateShow(false);
        }
      };
      var closePopover = () => {
        updateShow(false);
        emit("handleClose");
      };
      var onClickAway = () => {
        if (props.closeOnClickOutside && (!props.overlay || props.closeOnClickOverlay)) {
          updateShow(false);
        }
      };
      var renderAction = (action, index2) => {
        var {
          text,
          color,
          disabled,
          className
        } = action;
        return vue.createVNode("div", {
          "role": "menuitem",
          "class": [bem2("action", {
            disabled
          }), className],
          "tabindex": disabled ? void 0 : 0,
          "aria-disabled": disabled || void 0,
          "onClick": () => onClickAction(action, index2)
        }, [vue.createVNode("div", {
          "style": {
            color
          },
          "class": [bem2("action-text"), BORDER_BOTTOM]
        }, [text])]);
      };
      var isActionBox = !slots.default && ((_props$actions = props.actions) == null ? void 0 : _props$actions.length) > 0;
      var popoverContentClassName = isActionBox ? "list" : "content";
      vue.onMounted(updateLocation);
      vue.onBeforeUnmount(() => {
        if (popper2) {
          popper2.destroy();
          popper2 = null;
        }
      });
      vue.watch(() => [props.show, props.placement], updateLocation);
      useClickAway(wrapperRef, onClickAway, {
        eventName: "touchstart"
      });
      return () => vue.createVNode(vue.Fragment, null, [vue.createVNode("span", {
        "ref": wrapperRef,
        "class": bem2("wrapper"),
        "onMouseenter": handleWrapperEnter,
        "onMouseleave": handleWrapperLeave,
        "onClick": handleWrapperClick
      }, [slots.reference == null ? void 0 : slots.reference()]), vue.createVNode(Popup, vue.mergeProps({
        "ref": popoverRef,
        "class": [bem2([props.theme]), props.className],
        "position": "",
        "transition": "cf-popover-zoom",
        "lockScroll": props.setLockScroll,
        "onTouchstart": onTouchstart,
        "onUpdate:show": updateShow
      }, attrs, pick(props, popupProps)), {
        default: () => [props.showArrow && vue.createVNode("div", {
          "class": bem2("arrow")
        }, null), vue.createVNode("div", {
          "role": "menu",
          "class": bem2(popoverContentClassName),
          "onMouseenter": handleWrapperEnter,
          "onMouseleave": handleWrapperLeave
        }, [slots.default ? slots.default() : props.actions.map(renderAction), props.showCloseButton && !isActionBox && vue.createVNode("div", {
          "class": bem2("button")
        }, [vue.createVNode("span", {
          "class": bem2("button-text"),
          "onClick": closePopover
        }, [vue.createTextVNode("\u6211\u77E5\u9053\u4E86")])])])]
      })]);
    }
  });
  var Popover = withInstall(_Popover);
  function _extends$3() {
    _extends$3 = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends$3.apply(this, arguments);
  }
  var [name$j, bem$b] = createNamespace("progress-line");
  var getBackground = (color) => {
    if (!color) {
      return void 0;
    }
    if (isObject$1(color)) {
      var val = Object.keys(color).map((key) => color[key] + " " + key).join(",");
      return {
        backgroundImage: "linear-gradient(to right, " + val + ")"
      };
    }
    return {
      backgroundColor: color
    };
  };
  var ProgressLine = vue.defineComponent({
    name: name$j,
    props: {
      percent: {
        type: Number,
        default: 0
      },
      animation: {
        type: Boolean,
        default: false
      },
      strokeWidth: {
        type: Number,
        default: 6
      },
      width: {
        type: [Number, String],
        default: "100%"
      },
      color: {
        type: [String, Object],
        default: void 0
      },
      trackColor: {
        type: String,
        default: void 0
      },
      showText: Boolean
    },
    setup(props, _ref) {
      var {
        emit,
        slots
      } = _ref;
      var [name2, bem2] = createNamespace("progress-line");
      return () => {
        var {
          width: width2,
          strokeWidth,
          percent,
          color,
          trackColor,
          showText
        } = props;
        var lineWidth = {
          width: width2
        };
        var style = {
          width: width2,
          height: addUnit(strokeWidth),
          backgroundColor: trackColor
        };
        var barStyle = _extends$3({
          width: percent + "%"
        }, getBackground(color));
        var sliderStyle = _extends$3({
          left: percent + "%",
          height: addUnit(strokeWidth + 4),
          width: addUnit(2 + strokeWidth / 6 - 1)
        }, getBackground(color));
        return vue.createVNode("div", {
          "class": bem2(),
          "style": lineWidth
        }, [vue.createVNode("div", {
          "class": bem2("wrapper")
        }, [vue.createVNode("div", {
          "class": bem2("bg"),
          "style": style
        }, [vue.createVNode("div", {
          "class": bem2("bar-buffer")
        }, null), vue.createVNode("div", {
          "class": bem2("bar"),
          "style": barStyle
        }, null)]), vue.createVNode("div", {
          "class": bem2("slider-btn"),
          "style": sliderStyle
        }, null)]), showText ? vue.createVNode("p", {
          "class": bem2("text")
        }, [vue.createTextVNode("\u5DF2\u5B8C\u6210\uFF1A"), percent, vue.createTextVNode("%")]) : vue.createVNode("div", {
          "class": bem2("text")
        }, [slots.default == null ? void 0 : slots.default()])]);
      };
    }
  });
  var [name$i, bem$a] = createNamespace("progress-circle");
  var ProgressCircle = vue.defineComponent({
    name: name$i,
    props: {
      percent: {
        type: Number,
        default: 0
      },
      animation: {
        type: Boolean,
        default: false
      },
      strokeWidth: {
        type: Number,
        default: 6
      },
      width: {
        type: Number,
        default: 94
      },
      color: {
        type: [String, Object],
        default: void 0
      },
      trackColor: {
        type: String,
        default: void 0
      },
      showText: Boolean
    },
    setup(props, _ref) {
      var {
        emit,
        slots
      } = _ref;
      var [name2, bem2] = createNamespace("progress-circle");
      var {
        color
      } = props;
      var linearGradient = () => {
        if (!isObject$1(color)) {
          return;
        }
        var Stops = Object.keys(color).sort((a, b) => parseFloat(a) - parseFloat(b)).map((key, index2) => vue.createVNode("stop", {
          "key": index2,
          "offset": key,
          "stop-color": color[key]
        }, null));
        return vue.createVNode("defs", null, [vue.createVNode("linearGradient", {
          "id": "linearGradientId",
          "x1": 0,
          "y1": 1,
          "x2": 0,
          "y2": 0
        }, [Stops])]);
      };
      return () => {
        var {
          color: color2,
          width: width2,
          strokeWidth,
          percent,
          showText,
          trackColor
        } = props;
        var mergedWidth = vue.computed(() => width2);
        var isLinearGradient = isObject$1(color2);
        var center = vue.computed(() => mergedWidth.value / 2);
        var mergedStrokeWidth = vue.computed(() => strokeWidth);
        var radius = vue.computed(() => (mergedWidth.value - mergedStrokeWidth.value) / 2);
        var perimeter = vue.computed(() => Math.PI * 2 * radius.value);
        var barStyle = vue.computed(() => ({
          stroke: color2,
          strokeDasharray: perimeter.value,
          strokeDashoffset: (percent >= 100 ? 0 : 1 - percent / 100) * perimeter.value
        }));
        var bgStyle = vue.computed(() => ({
          stroke: trackColor
        }));
        return vue.createVNode("div", {
          "class": bem2(),
          "style": {
            width: mergedWidth.value + "px",
            height: mergedWidth.value + "px"
          }
        }, [vue.createVNode("svg", {
          "viewBox": "0 0 " + mergedWidth.value + " " + mergedWidth.value,
          "class": bem2("svg")
        }, [isLinearGradient ? linearGradient : false, vue.createVNode("circle", {
          "class": bem2("bg"),
          "fill": "none",
          "cx": center.value,
          "cy": center.value,
          "r": radius.value,
          "stroke-width": mergedStrokeWidth.value,
          "style": bgStyle.value
        }, null), vue.createVNode("circle", {
          "class": bem2("bar"),
          "fill": "none",
          "cx": center.value,
          "cy": center.value,
          "r": radius.value,
          "stroke-width": mergedStrokeWidth.value,
          "style": barStyle.value
        }, null)]), showText ? vue.createVNode("div", {
          "class": bem2("text")
        }, [vue.createVNode("p", {
          "class": bem2("title")
        }, [vue.createVNode("span", null, [percent]), vue.createTextVNode("%")]), vue.createVNode("p", {
          "class": bem2("info")
        }, [percent, vue.createTextVNode("/100")])]) : vue.createVNode("div", {
          "class": bem2("text")
        }, [slots.default == null ? void 0 : slots.default()])]);
      };
    }
  });
  var _Progress = vue.defineComponent({
    props: {
      type: makeStringProp("line"),
      percent: {
        type: Number,
        default: 0,
        validator: (value) => value >= 0 && value <= 100
      },
      showText: {
        type: Boolean,
        default: true
      },
      strokeWidth: {
        type: Number
      },
      width: {
        type: [Number, String]
      },
      color: {
        type: [String, Object]
      },
      trackColor: {
        type: String
      }
    },
    setup(props, _ref) {
      var {
        slots
      } = _ref;
      var [name2, bem2] = createNamespace("progress");
      return () => {
        var {
          type,
          percent,
          showText,
          strokeWidth,
          width: width2,
          color,
          trackColor
        } = props;
        var className = "type-" + type;
        return vue.createVNode("div", {
          "class": bem2([className])
        }, [type === "line" ? vue.createVNode(ProgressLine, {
          "percent": percent,
          "showText": showText,
          "strokeWidth": strokeWidth,
          "width": width2,
          "color": color,
          "trackColor": trackColor
        }, {
          default: () => [slots.default == null ? void 0 : slots.default()]
        }) : vue.createVNode(ProgressCircle, {
          "percent": percent,
          "showText": showText,
          "strokeWidth": strokeWidth,
          "width": width2,
          "color": color,
          "trackColor": trackColor
        }, {
          default: () => [slots.default == null ? void 0 : slots.default()]
        })]);
      };
    }
  });
  var Progress = withInstall(_Progress);
  var [name$h] = createNamespace("pull-refresh");
  var DEFAULT_HEAD_HEIGHT = 50;
  var TEXT_STATUS = ["pulling", "loosing", "success"];
  var setStatusText;
  var pullRefreshProps = {
    disabled: Boolean,
    modelValue: Boolean,
    headHeight: makeNumericProp(DEFAULT_HEAD_HEIGHT),
    successText: String,
    pullingText: String,
    loosingText: String,
    loadingText: String,
    pullDistance: numericProp,
    successDuration: makeNumericProp(500),
    animationDuration: makeNumericProp(300)
  };
  var _PullRefresh = vue.defineComponent({
    name: name$h,
    props: pullRefreshProps,
    emits: ["refresh", "update:modelValue"],
    setup(props, _ref) {
      var {
        emit,
        slots
      } = _ref;
      var bem2 = createNamespace("pull-refresh")[1];
      var reachTop;
      var root = vue.ref();
      var scrollParent = useScrollParent(root);
      var state = vue.reactive({
        status: "normal",
        distance: 0,
        duration: 0
      });
      var touch = useTouch();
      var getHeadStyle = () => {
        if (props.headHeight !== DEFAULT_HEAD_HEIGHT) {
          return {
            height: props.headHeight + "px"
          };
        }
      };
      var isTouchable = () => state.status !== "loading" && state.status !== "success" && !props.disabled;
      var ease = (distance) => {
        var pullDistance = +(props.pullDistance || props.headHeight);
        if (distance > pullDistance) {
          if (distance < pullDistance * 2) {
            distance = pullDistance + (distance - pullDistance) / 2;
          } else {
            distance = pullDistance * 1.5 + (distance - pullDistance * 2) / 4;
          }
        }
        return Math.round(distance);
      };
      var setStatus = (distance, isLoading) => {
        var pullDistance = +(props.pullDistance || props.headHeight);
        state.distance = distance;
        if (isLoading) {
          state.status = "loading";
          setStatusText = "\u52A0\u8F7D\u4E2D...";
        } else if (distance === 0) {
          state.status = "normal";
        } else if (distance < pullDistance) {
          state.status = "pulling";
          setStatusText = "\u4E0B\u62C9\u5373\u53EF\u5237\u65B0...";
        } else {
          state.status = "loosing";
          setStatusText = "\u91CA\u653E\u5373\u53EF\u5237\u65B0...";
        }
      };
      var getStatusText = () => {
        var {
          status
        } = state;
        if (status === "normal") {
          return "";
        }
        return props[status + "Text"] || setStatusText;
      };
      var renderStatus = () => {
        var {
          status,
          distance
        } = state;
        if (slots[status]) {
          return slots[status]({
            distance
          });
        }
        var nodes = [];
        if (TEXT_STATUS.includes(status)) {
          nodes.push(vue.createVNode("div", {
            "class": bem2("text")
          }, [getStatusText()]));
        }
        if (status === "loading") {
          nodes.push(vue.createVNode(Loading$1, {
            "class": bem2("loading")
          }, {
            default: getStatusText
          }));
        }
        return nodes;
      };
      var showSuccessTip = () => {
        state.status = "success";
        console.log("props.successDuration", props.successDuration);
        setTimeout(() => {
          setStatus(0);
        }, +props.successDuration);
      };
      var checkPosition = (event) => {
        reachTop = getScrollTop(scrollParent.value) === 0;
        console.log("reachTop: ", reachTop);
        if (reachTop) {
          state.duration = 0;
          touch.start(event);
        }
      };
      var onTouchStart = (event) => {
        if (isTouchable()) {
          checkPosition(event);
        }
      };
      var onTouchMove = (event) => {
        if (isTouchable()) {
          if (!reachTop) {
            checkPosition(event);
          }
          var {
            deltaY
          } = touch;
          touch.move(event);
          if (reachTop && deltaY.value >= 0 && touch.isVertical()) {
            preventDefault(event);
            setStatus(ease(deltaY.value));
          }
        }
      };
      var onTouchEnd = () => {
        if (reachTop && touch.deltaY.value && isTouchable()) {
          state.duration = +props.animationDuration;
          if (state.status === "loosing") {
            setStatus(+props.headHeight, true);
            emit("update:modelValue", true);
            vue.nextTick(() => emit("refresh"));
          } else {
            setStatus(0);
          }
        }
      };
      vue.watch(() => props.modelValue, (value) => {
        console.log("value: ", value);
        state.duration = +props.animationDuration;
        if (value) {
          setStatus(+props.headHeight, true);
        } else if (slots.success || props.successText) {
          showSuccessTip();
        } else {
          setStatus(0, false);
        }
      });
      return () => {
        var trackStyle = {
          transitionDuration: state.duration + "ms",
          transform: state.distance ? "translate3d(0," + state.distance + "px, 0)" : ""
        };
        return vue.createVNode("div", {
          "ref": root,
          "class": bem2()
        }, [vue.createVNode("div", {
          "class": bem2("track"),
          "style": trackStyle,
          "onTouchstart": onTouchStart,
          "onTouchmove": onTouchMove,
          "onTouchend": onTouchEnd,
          "onTouchcancel": onTouchEnd
        }, [vue.createVNode("div", {
          "class": bem2("head"),
          "style": getHeadStyle()
        }, [renderStatus()]), slots.default == null ? void 0 : slots.default()])]);
      };
    }
  });
  var PullRefresh = withInstall(_PullRefresh);
  var [name$g] = createNamespace("radio-group");
  var radioGroupProps = {
    disabled: Boolean,
    iconSize: numericProp,
    direction: String,
    modelValue: unknownProp,
    checkedColor: String
  };
  var RADIO_KEY = Symbol(name$g);
  var _RadioGroup = vue.defineComponent({
    name: name$g,
    props: radioGroupProps,
    emits: ["change", "update:modelValue"],
    setup(props, _ref) {
      var {
        emit,
        slots
      } = _ref;
      var bem2 = createNamespace("radio-group")[1];
      var {
        linkChildren
      } = useChildren(RADIO_KEY);
      var updateValue = (value) => emit("update:modelValue", value);
      vue.watch(() => props.modelValue, (value) => emit("change", value));
      linkChildren({
        props,
        updateValue
      });
      return () => vue.createVNode("div", {
        "class": bem2([props.direction]),
        "role": "radiogroup"
      }, [slots.default == null ? void 0 : slots.default()]);
    }
  });
  var [name$f] = createNamespace("radio");
  var _Radio = vue.defineComponent({
    name: name$f,
    props: checkerProps,
    emits: ["update:modelValue"],
    setup(props, _ref) {
      var {
        emit,
        slots
      } = _ref;
      var {
        parent
      } = useParent(RADIO_KEY);
      var bem2 = createNamespace("radio")[1];
      var checked = () => {
        var value = parent ? parent.props.modelValue : props.modelValue;
        return value === props.name;
      };
      var toggle = () => {
        if (parent) {
          parent.updateValue(props.name);
        } else {
          emit("update:modelValue", props.name);
        }
      };
      return () => vue.createVNode(Checker, vue.mergeProps({
        "bem": bem2,
        "role": "radio",
        "parent": parent,
        "checked": checked(),
        "onToggle": toggle
      }, props), pick(slots, ["default", "icon"]));
    }
  });
  var Radio = withInstall(_Radio);
  var RadioGroup = withInstall(_RadioGroup);
  var [name$e] = createNamespace("radio-list");
  var radioListProps = {
    modal: makeStringProp("list"),
    iconPosition: makeStringProp("left"),
    icon: makeStringProp("round"),
    option: makeArrayProp(),
    modelValue: numericProp
  };
  var RadioList = vue.defineComponent({
    name: name$e,
    props: radioListProps,
    emits: ["click", "change", "update:modelValue"],
    setup(props, _ref) {
      var {
        emit
      } = _ref;
      var bem2 = createNamespace("radio-list")[1];
      var check = vue.ref(props.modelValue);
      vue.watch(() => props.modelValue, (value) => {
        check.value = value;
      });
      var renderRadio = (item) => vue.createVNode(Radio, {
        "name": item.value,
        "icon": props.icon === "round" ? "" : props.icon,
        "disabled": item.disabled
      }, null);
      var handleClick = (event, item) => {
        if (!item.disabled) {
          check.value = item.value;
          emit("click", event, item.value);
        }
      };
      var renderCell = (item, index2) => {
        var {
          platform
        } = useConfigProvider();
        return vue.createVNode(Cell, {
          "class": bem2("", {
            disabled: item.disabled,
            checked: !item.disabled && check.value === item.value,
            pc: platform === "pc"
          }),
          "clickable": true,
          "title": item.label,
          "onClick": (event) => handleClick(event, item)
        }, props.iconPosition === "left" ? {
          icon: () => renderRadio(item)
        } : {
          "right-icon": () => renderRadio(item)
        });
      };
      var renderCellGroup = () => vue.createVNode(CellGroup, {
        "inset": true
      }, {
        default: () => [props.option.map(renderCell)]
      });
      var updateValue = (value) => emit("update:modelValue", value);
      var handleChange = (name2) => {
        updateValue(name2);
        emit("change", name2);
      };
      var renderRadioGroup = () => vue.createVNode(RadioGroup, {
        "modelValue": check.value,
        "onUpdate:modelValue": ($event) => check.value = $event,
        "onChange": handleChange
      }, {
        default: () => [renderCellGroup()]
      });
      return () => vue.createVNode("div", {
        "class": bem2()
      }, [renderRadioGroup()]);
    }
  });
  var radioListPropKeys = Object.keys(radioListProps);
  var actionSheetPropsKeys = Object.keys(actionSheetProps);
  var radioActionSheetProps = extend({}, radioListProps, actionSheetProps, {
    title: makeStringProp("\u6807\u9898"),
    show: Boolean,
    modelValue: numericProp
  });
  var [name$d] = createNamespace("radio-action-sheet");
  var RadioActionSheet = vue.defineComponent({
    name: name$d,
    props: radioActionSheetProps,
    emits: ["click", "change", "update:show", "update:modelValue"],
    setup(props, _ref) {
      var {
        attrs,
        emit
      } = _ref;
      var bem2 = createNamespace("radio-action-sheet")[1];
      var updateShow = (show) => emit("update:show", show);
      var updateValue = (value) => emit("update:modelValue", value);
      vue.watch(() => props.show, (val) => {
        updateShow(val);
      });
      vue.watch(() => props.modelValue, (val) => {
        updateValue(val);
      });
      var handleClick = (event, value) => emit("click", event, value);
      var handleChange = (name2) => emit("change", name2);
      var renderContent = () => vue.createVNode(RadioList, vue.mergeProps({
        "onClick": handleClick,
        "onChange": handleChange,
        "onUpdate:modelValue": updateValue
      }, pick(props, radioListPropKeys)), null);
      return () => vue.createVNode(ActionSheet, vue.mergeProps({
        "class": bem2(),
        "onUpdate:show": updateShow
      }, attrs, pick(props, actionSheetPropsKeys)), {
        default: () => [renderContent()]
      });
    }
  });
  var [name$c, bem$9] = createNamespace("radio-pro");
  var radioActionSheetPropKeys = Object.keys(radioActionSheetProps);
  var radioProProps = extend({}, RadioList.props, RadioActionSheet.props, {
    modelValue: numericProp,
    show: Boolean
  });
  var _RadioPro = vue.defineComponent({
    name: name$c,
    props: radioProProps,
    setup(props, _ref) {
      var {
        attrs,
        slots
      } = _ref;
      return () => {
        var isRadioList = props.modal === "list";
        var Component = isRadioList ? RadioList : RadioActionSheet;
        var inheritProps = pick(props, isRadioList ? radioListPropKeys : radioActionSheetPropKeys);
        return vue.createVNode(Component, vue.mergeProps({
          "class": bem$9()
        }, inheritProps, attrs), null);
      };
    }
  });
  var RadioPro = withInstall(_RadioPro);
  var [name$b, bem$8] = createNamespace("search");
  var searchProps = extend({}, fieldSharedProps, {
    label: String,
    shape: makeStringProp("square"),
    leftIcon: makeStringProp("search"),
    clearable: truthProp,
    actionText: String,
    background: String,
    showAction: Boolean
  });
  var _Search = vue.defineComponent({
    name: name$b,
    props: searchProps,
    emits: ["search", "cancel", "update:modelValue"],
    setup(props, _ref) {
      var {
        emit,
        slots,
        attrs
      } = _ref;
      var [name2, bem2] = createNamespace("search");
      var filedRef = vue.ref();
      var focused = vue.ref(false);
      var onCancel = () => {
        if (!slots.action) {
          emit("update:modelValue", "");
          emit("cancel");
        }
      };
      var onKeypress = (event) => {
        var ENTER_CODE = 13;
        if (event.keyCode === ENTER_CODE || event.code === "Enter") {
          preventDefault(event);
          emit("search", props.modelValue);
        }
      };
      var renderLabel = () => {
        if (slots.label || props.label) {
          return vue.createVNode("label", {
            "class": bem2("label"),
            "for": props.id
          }, [slots.label ? slots.label() : props.label]);
        }
      };
      var renderAction = () => {
        if (props.showAction) {
          var text = props.actionText || "\u53D6\u6D88";
          return vue.createVNode("div", {
            "class": bem2("action"),
            "role": "button",
            "tabindex": 0,
            "onClick": onCancel
          }, [slots.action ? slots.action() : text]);
        }
      };
      var blur2 = () => {
        var _filedRef$value;
        return (_filedRef$value = filedRef.value) == null ? void 0 : _filedRef$value.blur();
      };
      var focus2 = () => {
        var _filedRef$value2;
        return (_filedRef$value2 = filedRef.value) == null ? void 0 : _filedRef$value2.focus();
      };
      var onFieldFocus = () => {
        focused.value = true;
      };
      var onFieldBlur = () => {
        focused.value = false;
      };
      var fieldPropNames = Object.keys(fieldSharedProps);
      var renderField = () => {
        var fieldAttrs = extend({}, attrs, pick(props, fieldPropNames));
        var onInput = (value) => emit("update:modelValue", value);
        return vue.createVNode(Field, vue.mergeProps({
          "ref": filedRef,
          "type": "search",
          "class": bem2("field"),
          "border": false,
          "onFocus": onFieldFocus,
          "onBlur": onFieldBlur,
          "onKeypress": onKeypress,
          "onUpdate:modelValue": onInput
        }, fieldAttrs), pick(slots, ["left-icon", "right-icon"]));
      };
      useExpose({
        focus: focus2,
        blur: blur2
      });
      return () => {
        var {
          platform
        } = useConfigProvider();
        return vue.createVNode("div", {
          "class": bem2({
            "show-action": props.showAction
          }),
          "style": {
            background: props.background
          }
        }, [slots.left == null ? void 0 : slots.left(), vue.createVNode("div", {
          "class": bem2("content", [props.shape, {
            ["" + platform]: platform,
            focused: focused.value
          }])
        }, [renderLabel(), renderField()]), renderAction()]);
      };
    }
  });
  var Search = withInstall(_Search);
  function _extends$2() {
    _extends$2 = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends$2.apply(this, arguments);
  }
  var [name$a] = createNamespace("search-pro");
  var searchProProps = extend(searchProps, {
    nameKey: makeStringProp("name"),
    valueKey: makeStringProp("value"),
    labelValue: makeRequiredProp(Object)
  });
  var _SearchPro = vue.defineComponent({
    name: name$a,
    props: searchProProps,
    emits: ["click", "search"],
    setup(props, _ref) {
      var {
        emit,
        slots,
        attrs
      } = _ref;
      var bem2 = createNamespace("search-pro")[1];
      var searchRef = vue.ref();
      var labelClick = (e) => {
        emit("click", e);
      };
      var renderLeft = () => vue.createVNode("div", {
        "class": bem2("label"),
        "onClick": labelClick
      }, [typeof props.labelValue === "object" ? props.labelValue[props.nameKey] : props.labelValue, vue.createVNode(Icon, {
        "name": "down_arrow",
        "color": "#989EA7",
        "size": 14
      }, null)]);
      var searchHandler = (searchValue) => {
        emit("search", searchValue, props.labelValue);
      };
      useExpose({
        focus,
        blur
      });
      return () => vue.createVNode("div", {
        "class": bem2()
      }, [vue.createVNode(Search, vue.mergeProps({
        "ref": searchRef
      }, attrs, props, {
        "onSearch": searchHandler
      }), _extends$2({}, pick(slots, ["left", "action", "left-icon", "right-icon"]), {
        label: () => renderLeft()
      }))]);
    }
  });
  var SearchPro = withInstall(_SearchPro);
  var [name$9] = createNamespace("slider");
  var sliderProps = {
    min: makeNumericProp(0),
    max: makeNumericProp(100),
    step: makeNumericProp(1),
    range: Boolean,
    reverse: Boolean,
    disabled: Boolean,
    readonly: Boolean,
    vertical: Boolean,
    barHeight: numericProp,
    buttonSize: numericProp,
    activeColor: String,
    inactiveColor: String,
    modelValue: {
      type: [Number, Array],
      default: 0
    }
  };
  var _Slider = vue.defineComponent({
    name: name$9,
    props: sliderProps,
    emits: ["change", "drag-end", "drag-start", "update:modelValue"],
    setup(props, _ref) {
      var {
        emit,
        slots
      } = _ref;
      var bem2 = createNamespace("slider")[1];
      var buttonIndex;
      var current2;
      var startValue;
      var root = vue.ref();
      var dragStatus = vue.ref();
      var touch = useTouch();
      var scope = vue.computed(() => Number(props.max) - Number(props.min));
      var wrapperStyle = vue.computed(() => {
        var crossAxis = props.vertical ? "width" : "height";
        return {
          background: props.inactiveColor,
          [crossAxis]: addUnit(props.barHeight)
        };
      });
      var isRange = (val) => props.range && Array.isArray(val);
      var calcMainAxis = () => {
        var {
          modelValue,
          min: min2
        } = props;
        if (isRange(modelValue)) {
          return (modelValue[1] - modelValue[0]) * 100 / scope.value + "%";
        }
        return (modelValue - Number(min2)) * 100 / scope.value + "%";
      };
      var calcOffset = () => {
        var {
          modelValue,
          min: min2
        } = props;
        if (isRange(modelValue)) {
          return (modelValue[0] - Number(min2)) * 100 / scope.value + "%";
        }
        return "0%";
      };
      var barStyle = vue.computed(() => {
        var mainAxis = props.vertical ? "height" : "width";
        var style = {
          [mainAxis]: calcMainAxis(),
          background: props.activeColor
        };
        if (dragStatus.value) {
          style.transition = "none";
        }
        var getPositionKey = () => {
          if (props.vertical) {
            return props.reverse ? "bottom" : "top";
          }
          return props.reverse ? "right" : "left";
        };
        style[getPositionKey()] = calcOffset();
        return style;
      });
      var format = (value) => {
        var min2 = +props.min;
        var max2 = +props.max;
        var step = +props.step;
        value = clamp(value, min2, max2);
        var diff = Math.round((value - min2) / step) * step;
        return addNumber(min2, diff);
      };
      var isSameValue = (newValue, oldValue) => JSON.stringify(newValue) === JSON.stringify(oldValue);
      var handleRangeValue = (value) => {
        var _value$, _value$2;
        var left2 = (_value$ = value[0]) != null ? _value$ : Number(props.min);
        var right2 = (_value$2 = value[1]) != null ? _value$2 : Number(props.max);
        return left2 > right2 ? [right2, left2] : [left2, right2];
      };
      var updateValue = (value, end2) => {
        if (isRange(value)) {
          value = handleRangeValue(value).map(format);
        } else {
          value = format(value);
        }
        if (!isSameValue(value, props.modelValue)) {
          emit("update:modelValue", value);
        }
        if (end2 && !isSameValue(value, startValue)) {
          emit("change", value);
        }
      };
      var onClick = (event) => {
        event.stopPropagation();
        if (props.disabled || props.readonly) {
          return;
        }
        var {
          min: min2,
          reverse,
          vertical,
          modelValue
        } = props;
        var rect = useRect(root);
        var getDelta = () => {
          if (vertical) {
            if (reverse) {
              return rect.bottom - event.clientY;
            }
            return event.clientY - rect.top;
          }
          if (reverse) {
            return rect.right - event.clientX;
          }
          return event.clientX - rect.left;
        };
        var total = vertical ? rect.height : rect.width;
        var value = Number(min2) + getDelta() / total * scope.value;
        if (isRange(modelValue)) {
          var [left2, right2] = modelValue;
          var middle = (left2 + right2) / 2;
          if (value <= middle) {
            updateValue([value, right2], true);
          } else {
            updateValue([left2, value], true);
          }
        } else {
          updateValue(value, true);
        }
      };
      var getButtonClassName = (index2) => {
        if (typeof index2 === "number") {
          var position = ["left", "right"];
          return bem2("button-wrapper", position[index2]);
        }
        return bem2("button-wrapper", props.reverse ? "left" : "right");
      };
      var onTouchStart = (event) => {
        if (props.disabled || props.readonly) {
          return;
        }
        touch.start(event);
        current2 = props.modelValue;
        if (isRange(current2)) {
          startValue = current2.map(format);
        } else {
          startValue = format(current2);
        }
        dragStatus.value = "start";
      };
      var onTouchMove = (event) => {
        if (props.disabled || props.readonly) {
          return;
        }
        if (dragStatus.value === "start") {
          emit("drag-start", event);
        }
        preventDefault(event, true);
        touch.move(event);
        dragStatus.value = "dragging";
        var rect = useRect(root);
        var delta = props.vertical ? touch.deltaY.value : touch.deltaX.value;
        var total = props.vertical ? rect.height : rect.width;
        var diff = delta / total * scope.value;
        if (props.reverse) {
          diff = -diff;
        }
        if (isRange(startValue)) {
          var index2 = props.reverse ? 1 - buttonIndex : buttonIndex;
          current2[index2] = startValue[index2] + diff;
        } else {
          current2 = startValue + diff;
        }
        updateValue(current2);
      };
      var onTouchEnd = (event) => {
        if (props.disabled || props.readonly) {
          return;
        }
        if (dragStatus.value === "dragging") {
          updateValue(current2, true);
          emit("drag-end", event);
        }
        dragStatus.value = "";
      };
      var renderButtonContent = (value, index2) => {
        if (typeof index2 === "number") {
          var slot = slots[index2 === 0 ? "left-button" : "right-button"];
          if (slot) {
            return slot({
              value
            });
          }
        }
        if (slots.button) {
          return slots.button({
            value
          });
        }
        return vue.createVNode("div", {
          "class": bem2("button"),
          "style": getSizeStyle(props.buttonSize)
        }, null);
      };
      var renderButton = (index2) => {
        var current3 = typeof index2 === "number" ? props.modelValue[index2] : props.modelValue;
        return vue.createVNode("div", {
          "role": "slider",
          "class": getButtonClassName(index2),
          "tabindex": props.disabled ? void 0 : 0,
          "aria-valuemin": props.min,
          "aria-valuenow": current3,
          "aria-valuemax": props.max,
          "aria-disabled": props.disabled || void 0,
          "aria-readonly": props.readonly || void 0,
          "aria-orientation": props.vertical ? "vertical" : "horizontal",
          "onTouchstart": (event) => {
            if (typeof index2 === "number") {
              buttonIndex = index2;
            }
            onTouchStart(event);
          },
          "onTouchmove": onTouchMove,
          "onTouchend": onTouchEnd,
          "onTouchcancel": onTouchEnd,
          "onClick": stopPropagation
        }, [renderButtonContent(current3, index2)]);
      };
      updateValue(props.modelValue);
      useCustomFieldValue(() => props.modelValue);
      return () => vue.createVNode("div", {
        "ref": root,
        "style": wrapperStyle.value,
        "class": bem2({
          vertical: props.vertical,
          disabled: props.disabled
        }),
        "onClick": onClick
      }, [vue.createVNode("div", {
        "class": bem2("bar"),
        "style": barStyle.value
      }, [props.range ? [renderButton(0), renderButton(1)] : renderButton()])]);
    }
  });
  var Slider = withInstall(_Slider);
  var stepsProps = {
    active: makeNumericProp(0),
    direction: makeStringProp("horizontal"),
    activeIcon: String,
    iconPrefix: String,
    finishIcon: String,
    activeColor: String,
    inactiveIcon: String,
    inactiveColor: String,
    textAlign: {
      type: String,
      default: "bottom"
    }
  };
  var [name$8, bem$7] = createNamespace("steps");
  var STEPS_KEY = Symbol(name$8);
  var _Steps = vue.defineComponent({
    name: name$8,
    props: stepsProps,
    emits: ["click-step"],
    setup(props, _ref) {
      var {
        emit,
        slots
      } = _ref;
      var [name2, bem2] = createNamespace("steps");
      var {
        linkChildren
      } = useChildren(STEPS_KEY);
      var onClickStep = (index2) => emit("click-step", index2);
      linkChildren({
        props,
        onClickStep
      });
      return () => vue.createVNode("div", {
        "class": bem2([props.direction])
      }, [vue.createVNode("div", {
        "class": bem2("items")
      }, [slots.default == null ? void 0 : slots.default()])]);
    }
  });
  var [name$7, bem$6] = createNamespace("step");
  var _Step = vue.defineComponent({
    name: name$7,
    setup(props, _ref) {
      var {
        emit,
        slots
      } = _ref;
      var [name2, bem2] = createNamespace("step");
      useId();
      var {
        parent,
        index: index2
      } = useParent(STEPS_KEY);
      if (!parent) {
        return;
      }
      var parentProps = parent.props;
      var onClickStep = () => parent.onClickStep(index2.value);
      var getStatus = () => {
        var active = +parentProps.active;
        if (index2.value < active) {
          return "finish";
        }
        return index2.value === active ? "process" : "waiting";
      };
      var isActive = () => getStatus() === "process";
      var lineStyle = vue.computed(() => ({
        background: getStatus() === "finish" ? parentProps.activeColor : parentProps.inactiveColor
      }));
      var renderIcon = () => {
        var {
          iconPrefix,
          finishIcon,
          activeIcon,
          activeColor,
          inactiveIcon
        } = parentProps;
        if (isActive()) {
          if (slots["active-icon"]) {
            return slots["active-icon"]();
          }
          if (activeIcon) {
            return vue.createVNode(Icon, {
              "class": bem2("icon", "active"),
              "name": activeIcon,
              "color": activeColor,
              "classPrefix": iconPrefix
            }, null);
          }
          return vue.createVNode("i", {
            "class": bem2("circle", "active")
          }, [index2.value + 1]);
        }
        if (getStatus() === "finish" && (finishIcon || slots["finish-icon"])) {
          if (slots["finish-icon"]) {
            return slots["finish-icon"]();
          }
          if (finishIcon) {
            return vue.createVNode(Icon, {
              "class": bem2("icon", "finish"),
              "name": finishIcon,
              "color": activeColor,
              "classPrefix": iconPrefix
            }, null);
          }
        }
        if (slots["inactive-icon"]) {
          return slots["inactive-icon"]();
        }
        if (inactiveIcon) {
          return vue.createVNode(Icon, {
            "class": bem2("icon"),
            "name": inactiveIcon,
            "classPrefix": iconPrefix
          }, null);
        }
        return vue.createVNode("i", {
          "class": bem2("circle"),
          "style": lineStyle.value
        }, [index2.value + 1]);
      };
      useConfigProvider();
      return () => {
        if (!slots.default) {
          return;
        }
        var status = getStatus();
        if (parentProps.textAlign === "right") {
          return vue.createVNode("div", {
            "class": bem2(["" + parentProps.direction, status, parentProps.direction + "--textalign--right"])
          }, [vue.createVNode("div", {
            "class": bem2("container"),
            "onClick": onClickStep
          }, [vue.createVNode("div", {
            "class": bem2("icon")
          }, [renderIcon(), vue.createTextVNode(" ")]), vue.createVNode("div", {
            "class": bem2("title")
          }, [slots.default == null ? void 0 : slots.default()])]), vue.createVNode("div", {
            "class": bem2("line")
          }, null)]);
        }
        return vue.createVNode("div", {
          "class": bem2([parentProps.direction, status])
        }, [vue.createVNode("div", {
          "class": bem2("icon-container"),
          "onClick": onClickStep
        }, [renderIcon()]), vue.createVNode("div", {
          "class": bem2("line")
        }, null), vue.createVNode("div", {
          "class": bem2("title", {
            active: isActive()
          }),
          "onClick": onClickStep
        }, [slots.default == null ? void 0 : slots.default()])]);
      };
    }
  });
  var Step = withInstall(_Step);
  var [name$6] = createNamespace("stepper");
  var LONG_PRESS_INTERVAL = 200;
  var LONG_PRESS_START_TIME = 600;
  function equal(value1, value2) {
    return String(value1) === String(value2);
  }
  var stepperProps = {
    min: makeNumericProp(1),
    max: makeNumericProp(Infinity),
    name: makeNumericProp(""),
    step: makeNumericProp(1),
    integer: Boolean,
    disabled: Boolean,
    showPlus: truthProp,
    showMinus: truthProp,
    showInput: truthProp,
    longPress: truthProp,
    allowEmpty: Boolean,
    modelValue: numericProp,
    inputWidth: numericProp,
    buttonSize: numericProp,
    placeholder: String,
    disablePlus: Boolean,
    disableMinus: Boolean,
    disableInput: Boolean,
    beforeChange: Function,
    defaultValue: makeNumericProp(1),
    decimalLength: numericProp
  };
  var _Stepper = vue.defineComponent({
    name: name$6,
    props: stepperProps,
    emits: ["plus", "blur", "minus", "focus", "change", "overlimit", "update:modelValue"],
    setup(props, _ref) {
      var {
        emit
      } = _ref;
      var bem2 = createNamespace("stepper")[1];
      var format = (value) => {
        var {
          min: min2,
          max: max2,
          allowEmpty,
          decimalLength
        } = props;
        if (allowEmpty && value === "") {
          return value;
        }
        value = formatNumber(String(value), !props.integer);
        value = value === "" ? 0 : +value;
        value = Number.isNaN(value) ? +min2 : value;
        value = Math.max(Math.min(+max2, value), +min2);
        if (isDef(decimalLength)) {
          value = value.toFixed(+decimalLength);
        }
        return value;
      };
      var getInitialValue = () => {
        var _props$modelValue;
        var defaultValue = (_props$modelValue = props.modelValue) != null ? _props$modelValue : props.defaultValue;
        var value = format(defaultValue);
        if (!equal(value, props.modelValue)) {
          emit("update:modelValue", value);
        }
        return value;
      };
      var actionType;
      var inputRef = vue.ref();
      var current2 = vue.ref(getInitialValue());
      var minusDisabled = vue.computed(() => props.disabled || props.disableMinus || current2.value <= +props.min);
      var plusDisabled = vue.computed(() => props.disabled || props.disablePlus || current2.value >= +props.max);
      var inputStyle = vue.computed(() => ({
        width: addUnit(props.inputWidth),
        height: addUnit(props.buttonSize)
      }));
      var buttonStyle = vue.computed(() => getSizeStyle(props.buttonSize));
      var check = () => {
        var value = format(current2.value);
        if (!equal(value, current2.value)) {
          current2.value = value;
        }
      };
      var setValue = (value) => {
        if (props.beforeChange) {
          callInterceptor(props.beforeChange, {
            args: [value],
            done() {
              current2.value = value;
            }
          });
        } else {
          current2.value = value;
        }
      };
      var onChange = () => {
        if (actionType === "plus" && plusDisabled.value || actionType === "minus" && minusDisabled.value) {
          emit("overlimit", actionType);
          return;
        }
        var diff = actionType === "minus" ? -props.step : +props.step;
        var value = format(addNumber(+current2.value, diff));
        setValue(value);
        emit(actionType);
      };
      var onInput = (event) => {
        var input = event.target;
        var {
          value
        } = input;
        var {
          decimalLength
        } = props;
        var formatted = formatNumber(String(value), !props.integer);
        if (isDef(decimalLength) && formatted.includes(".")) {
          var pair = formatted.split(".");
          formatted = pair[0] + "." + pair[1].slice(0, +decimalLength);
        }
        if (props.beforeChange) {
          input.value = String(current2.value);
        } else if (!equal(value, formatted)) {
          input.value = formatted;
        }
        var isNumeric2 = formatted === String(+formatted);
        setValue(isNumeric2 ? +formatted : formatted);
      };
      var onFocus = (event) => {
        if (props.disableInput) {
          var _inputRef$value;
          (_inputRef$value = inputRef.value) == null ? void 0 : _inputRef$value.blur();
        } else {
          emit("focus", event);
        }
      };
      var onBlur = (event) => {
        var input = event.target;
        var value = format(input.value);
        input.value = String(value);
        current2.value = value;
        vue.nextTick(() => {
          emit("blur", event);
          resetScroll();
        });
      };
      var isLongPress;
      var longPressTimer;
      var longPressStep = () => {
        longPressTimer = setTimeout(() => {
          onChange();
          longPressStep();
        }, LONG_PRESS_INTERVAL);
      };
      var onTouchStart = () => {
        if (props.longPress) {
          isLongPress = false;
          clearTimeout(longPressTimer);
          longPressTimer = setTimeout(() => {
            isLongPress = true;
            onChange();
            longPressStep();
          }, LONG_PRESS_START_TIME);
        }
      };
      var onTouchEnd = (event) => {
        if (props.longPress) {
          clearTimeout(longPressTimer);
          if (isLongPress) {
            preventDefault(event);
          }
        }
      };
      var onMousedown = (event) => {
        if (props.disableInput) {
          event.preventDefault();
        }
      };
      var createListeners = (type) => ({
        onClick: (event) => {
          event.preventDefault();
          actionType = type;
          onChange();
        },
        onTouchstart: () => {
          actionType = type;
          onTouchStart();
        },
        onTouchend: onTouchEnd,
        onTouchcancel: onTouchEnd
      });
      vue.watch([() => props.max, () => props.min, () => props.integer, () => props.decimalLength], check);
      vue.watch(() => props.modelValue, (value) => {
        if (!equal(value, current2.value)) {
          current2.value = format(value);
        }
      });
      vue.watch(current2, (value) => {
        emit("update:modelValue", value);
        emit("change", value, {
          name: props.name
        });
      });
      useCustomFieldValue(() => props.modelValue);
      var {
        platform
      } = useConfigProvider();
      return () => vue.createVNode("div", {
        "class": bem2({
          pc: platform === "pc"
        })
      }, [vue.withDirectives(vue.createVNode("button", vue.mergeProps({
        "type": "button",
        "style": buttonStyle.value,
        "class": bem2("minus", {
          disabled: minusDisabled.value
        })
      }, createListeners("minus")), null), [[vue.vShow, props.showMinus]]), vue.withDirectives(vue.createVNode("input", {
        "ref": inputRef,
        "type": props.integer ? "tel" : "text",
        "role": "spinbutton",
        "class": bem2("input"),
        "value": current2.value,
        "style": inputStyle.value,
        "disabled": props.disabled,
        "readonly": props.disableInput,
        "inputmode": props.integer ? "numeric" : "decimal",
        "placeholder": props.placeholder,
        "aria-valuemax": +props.max,
        "aria-valuemin": +props.min,
        "aria-valuenow": +current2.value,
        "onBlur": onBlur,
        "onInput": onInput,
        "onFocus": onFocus,
        "onMousedown": onMousedown
      }, null), [[vue.vShow, props.showInput]]), vue.withDirectives(vue.createVNode("button", vue.mergeProps({
        "type": "button",
        "style": buttonStyle.value,
        "class": bem2("plus", {
          disabled: plusDisabled.value
        })
      }, createListeners("plus")), null), [[vue.vShow, props.showPlus]])]);
    }
  });
  var Stepper = withInstall(_Stepper);
  var Steps = withInstall(_Steps);
  var Sticky = withInstall(_Sticky);
  var [name$5, bem$5] = createNamespace("switch");
  var switchProps = {
    size: numericProp,
    loading: Boolean,
    disabled: Boolean,
    modelValue: unknownProp,
    activeColor: String,
    inactiveColor: String,
    small: Boolean,
    activeValue: {
      type: unknownProp,
      default: true
    },
    inactiveValue: {
      type: unknownProp,
      default: false
    }
  };
  var _Switch = vue.defineComponent({
    name: name$5,
    props: switchProps,
    emits: ["change", "update:modelValue"],
    setup(props, _ref) {
      var {
        emit
      } = _ref;
      var [name2, bem2] = createNamespace("switch");
      var isChecked = () => props.modelValue === props.activeValue;
      var onClick = () => {
        if (!props.disabled && !props.loading) {
          var newValue = isChecked() ? props.inactiveValue : props.activeValue;
          emit("update:modelValue", newValue);
          emit("change", newValue);
        }
      };
      return () => {
        var {
          size,
          loading,
          disabled,
          activeColor,
          inactiveColor,
          small
        } = props;
        var checked = isChecked();
        var style = {
          fontSize: addUnit(size),
          backgroundColor: checked ? activeColor : inactiveColor
        };
        return vue.createVNode("div", {
          "role": "switch",
          "class": bem2({
            on: checked,
            loading,
            disabled,
            small
          }),
          "style": style,
          "aria-checked": checked,
          "onClick": onClick
        }, [vue.createVNode("div", {
          "class": bem2("node")
        }, null)]);
      };
    }
  });
  var Switch = withInstall(_Switch);
  var index$2 = "";
  var [name$4, bem$4] = createNamespace("tabbar");
  var tabbarProps = {
    modelValue: makeNumericProp(0),
    activeColor: String,
    inactiveColor: String,
    fixed: truthProp,
    beforeChange: Function,
    safeAreaInsetBottom: {
      type: Boolean,
      default: null
    }
  };
  var TABBAR_KEY = Symbol(name$4);
  var _Tabbar = vue.defineComponent({
    name: name$4,
    props: tabbarProps,
    emits: ["change", "update:modelValue"],
    setup(props, _ref) {
      var {
        emit,
        slots
      } = _ref;
      var [name2, bem2] = createNamespace("tabbar");
      var {
        prefix: prefix2
      } = useConfigProvider();
      var {
        linkChildren
      } = useChildren(TABBAR_KEY);
      var setActive = (active) => {
        callInterceptor(props.beforeChange, {
          args: [active],
          done() {
            emit("update:modelValue", active);
            emit("change", active);
          }
        });
      };
      linkChildren({
        props,
        setActive
      });
      var fixed = props.fixed ? "fixed" : "";
      var enableSafeArea = () => {
        var _props$safeAreaInsetB;
        return (_props$safeAreaInsetB = props.safeAreaInsetBottom) != null ? _props$safeAreaInsetB : props.fixed;
      };
      return () => vue.createVNode("div", {
        "class": [bem2({
          fixed
        }), {
          [prefix2 + "-safe-area-bottom"]: enableSafeArea()
        }]
      }, [slots.default == null ? void 0 : slots.default()]);
    }
  });
  var Tabbar = withInstall(_Tabbar);
  var index$1 = "";
  var [name$3, bem$3] = createNamespace("tabbar-item");
  var tabbarItemProps = {
    name: String,
    icon: String,
    badge: numericProp,
    dot: Boolean
  };
  var _TabbarItem = vue.defineComponent({
    name: name$3,
    props: tabbarItemProps,
    emits: ["click"],
    setup(props, _ref) {
      var {
        emit,
        slots
      } = _ref;
      var [name2, bem2] = createNamespace("tabbar-item");
      var {
        parent,
        index: index2
      } = useParent(TABBAR_KEY);
      if (!parent) {
        return;
      }
      var active = vue.computed(() => {
        var _props$name;
        var {
          modelValue
        } = parent.props;
        return ((_props$name = props.name) != null ? _props$name : index2.value) === modelValue;
      });
      var onClick = (event) => {
        if (!active.value) {
          var _props$name2;
          parent.setActive((_props$name2 = props.name) != null ? _props$name2 : index2.value);
        }
        emit("click", event);
      };
      var renderIcon = () => {
        if (slots.icon) {
          return slots.icon({
            active: active.value
          });
        }
        if (props.icon) {
          return vue.createVNode(Icon, {
            "name": props.icon,
            "size": 20
          }, null);
        }
      };
      return () => {
        var {
          dot,
          badge
        } = props;
        var {
          activeColor,
          inactiveColor
        } = parent.props;
        var color = active.value ? activeColor : inactiveColor;
        return vue.createVNode("div", {
          "class": bem2({
            active: active.value
          }),
          "style": {
            color
          },
          "onClick": onClick
        }, [vue.createVNode(Badge, {
          "dot": dot,
          "content": badge
        }, {
          default: () => [vue.createVNode("div", {
            "class": bem2("icon")
          }, [vue.createVNode("div", null, [renderIcon()])])]
        }), vue.createVNode("div", {
          "class": bem2("text")
        }, [slots.default == null ? void 0 : slots.default({
          active: active.value
        })])]);
      };
    }
  });
  var TabbarItem = withInstall(_TabbarItem);
  var [name$2, bem$2] = createNamespace("tag");
  var tagProps = {
    size: String,
    mark: Boolean,
    show: truthProp,
    type: makeStringProp("default"),
    maxlength: makeNumericProp(7),
    color: String,
    plain: Boolean,
    round: Boolean,
    disabled: Boolean,
    checked: Boolean,
    textColor: String,
    closeable: Boolean
  };
  var _Tag = vue.defineComponent({
    name: name$2,
    props: tagProps,
    emits: ["click", "close"],
    setup(props, _ref) {
      var {
        emit,
        slots
      } = _ref;
      var [name2, bem2] = createNamespace("tag");
      var onClick = (event) => {
        if (!props.disabled) {
          emit("click", event);
        }
      };
      var getStyle = () => {
        if (props.plain) {
          return {
            color: props.textColor || props.color,
            borderColor: props.color
          };
        }
        return {
          color: props.textColor,
          background: props.color
        };
      };
      var renderTag = () => {
        var {
          type,
          mark,
          plain,
          round: round2,
          disabled,
          checked,
          size,
          closeable
        } = props;
        var {
          platform
        } = useConfigProvider();
        var classes = {
          mark,
          plain,
          round: round2,
          disabled,
          checked,
          pc: platform === "pc"
        };
        if (size) {
          classes[size] = size;
        }
        var CheckedIcon = checked && vue.createVNode(Icon, {
          "name": "tag_selected",
          "size": "14px"
        }, null);
        return vue.createVNode("span", {
          "style": getStyle(),
          "class": bem2([classes, type]),
          "onClick": onClick
        }, [slots.default == null ? void 0 : slots.default(), CheckedIcon]);
      };
      return () => vue.createVNode(vue.Transition, {
        "name": props.closeable ? "cf-fade" : void 0
      }, {
        default: () => [props.show ? renderTag() : null]
      });
    }
  });
  var Tag = withInstall(_Tag);
  var lockCount = 0;
  function lockClick(lock, prefix2) {
    if (lock) {
      if (!lockCount) {
        document.body.classList.add(prefix2 + "-toast--unclickable");
      }
      lockCount++;
    } else if (lockCount) {
      lockCount--;
      if (!lockCount) {
        document.body.classList.remove(prefix2 + "-toast--unclickable");
      }
    }
  }
  var [name$1, bem$1] = createNamespace("toast");
  var popupInheritProps = ["show", "overlay", "transition", "overlayClass", "overlayStyle", "closeOnClickOverlay"];
  var toastProps = {
    icon: String,
    show: Boolean,
    type: makeStringProp("text"),
    overlay: Boolean,
    message: numericProp,
    iconSize: numericProp,
    duration: makeNumberProp(2e3),
    position: makeStringProp("middle"),
    className: unknownProp,
    iconPrefix: String,
    transition: makeStringProp("cf-fade"),
    loadingType: String,
    forbidClick: Boolean,
    overlayClass: unknownProp,
    overlayStyle: Object,
    closeOnClick: Boolean,
    closeOnClickOverlay: Boolean
  };
  var CfToast = vue.defineComponent({
    name: name$1,
    props: toastProps,
    emits: ["update:show"],
    setup(props, _ref) {
      var {
        emit
      } = _ref;
      var [name2, bem2] = createNamespace("toast");
      var {
        prefix: prefix2
      } = useConfigProvider();
      var timer;
      var clickable = false;
      var toggleClickable = () => {
        var newValue = props.show && props.forbidClick;
        if (clickable !== newValue) {
          clickable = newValue;
          lockClick(clickable, prefix2);
        }
      };
      var updateShow = (show) => emit("update:show", show);
      var onClick = () => {
        if (props.closeOnClick) {
          updateShow(false);
        }
      };
      var clearTimer = () => clearTimeout(timer);
      var renderIcon = () => {
        var {
          icon,
          type,
          iconSize,
          iconPrefix,
          loadingType
        } = props;
        var hasIcon = icon || type === "success" || type === "fail";
        if (hasIcon) {
          return vue.createVNode(Icon, {
            "name": icon || type,
            "size": iconSize,
            "class": bem2("icon"),
            "classPrefix": iconPrefix
          }, null);
        }
        if (type === "loading") {
          return vue.createVNode(Loading, {
            "class": bem2("loading"),
            "size": iconSize,
            "type": loadingType
          }, null);
        }
      };
      var renderMessage = () => {
        var {
          type,
          message
        } = props;
        if (isDef(message) && message !== "") {
          return type === "html" ? vue.createVNode("div", {
            "class": bem2("text"),
            "innerHTML": String(message)
          }, null) : vue.createVNode("div", {
            "class": bem2("text")
          }, [message]);
        }
      };
      vue.watch(() => [props.show, props.forbidClick], toggleClickable);
      vue.watch(() => [props.show, props.type, props.message, props.duration], () => {
        clearTimer();
        if (props.show && props.duration > 0) {
          timer = setTimeout(() => {
            updateShow(false);
          }, props.duration);
        }
      });
      vue.onMounted(toggleClickable);
      vue.onUnmounted(toggleClickable);
      return () => vue.createVNode(Popup, vue.mergeProps({
        "class": [bem2([props.position, {
          [props.type]: !props.icon
        }]), props.className],
        "lockScroll": false,
        "onClick": onClick,
        "onClosed": clearTimer,
        "onUpdate:show": updateShow
      }, pick(props, popupInheritProps)), {
        default: () => [renderIcon(), renderMessage()]
      });
    }
  });
  var defaultOptions = {
    icon: "",
    type: "text",
    message: "",
    className: "",
    overlay: false,
    onClose: void 0,
    onOpened: void 0,
    duration: 2e3,
    teleport: "body",
    iconSize: void 0,
    iconPrefix: void 0,
    position: "middle",
    transition: "cf-fade",
    forbidClick: false,
    loadingType: void 0,
    overlayClass: "",
    overlayStyle: void 0,
    closeOnClick: false,
    closeOnClickOverlay: false
  };
  var queue = [];
  var allowMultiple = false;
  var currentOptions = extend({}, defaultOptions);
  var defaultOptionsMap = new Map();
  function parseOptions(message) {
    if (isObject$1(message)) {
      return message;
    }
    return {
      message
    };
  }
  function createInstance() {
    var {
      instance: instance2,
      unmount
    } = mountComponent({
      setup() {
        var message = vue.ref("");
        var {
          open,
          state,
          close,
          toggle
        } = usePopupState();
        var onClosed = () => {
          if (allowMultiple) {
            queue = queue.filter((item) => item !== instance2);
            unmount();
          }
        };
        var render = () => {
          var attrs = {
            onClosed,
            "onUpdate:show": toggle
          };
          return vue.createVNode(CfToast, vue.mergeProps(state, attrs), null);
        };
        vue.watch(message, (val) => {
          state.message = val;
        });
        vue.getCurrentInstance().render = render;
        return {
          open,
          clear: close,
          message
        };
      }
    });
    return instance2;
  }
  function getInstance() {
    if (!queue.length || allowMultiple) {
      var instance2 = createInstance();
      queue.push(instance2);
    }
    return queue[queue.length - 1];
  }
  function Toast(options) {
    if (options === void 0) {
      options = {};
    }
    if (!inBrowser$1) {
      return {};
    }
    var toast = getInstance();
    var parsedOptions = parseOptions(options);
    toast.open(extend({}, currentOptions, defaultOptionsMap.get(parsedOptions.type || currentOptions.type), parsedOptions));
    return toast;
  }
  var createMethod = (type) => (options) => Toast(extend({
    type
  }, parseOptions(options)));
  Toast.loading = createMethod("loading");
  Toast.success = createMethod("success");
  Toast.fail = createMethod("fail");
  Toast.clear = (all) => {
    if (queue.length) {
      if (all) {
        queue.forEach((toast) => {
          toast.clear();
        });
        queue = [];
      } else if (!allowMultiple) {
        queue[0].clear();
      } else {
        var _queue$shift;
        (_queue$shift = queue.shift()) == null ? void 0 : _queue$shift.clear();
      }
    }
  };
  function setDefaultOptions(type, options) {
    if (typeof type === "string") {
      defaultOptionsMap.set(type, options);
    } else {
      extend(currentOptions, type);
    }
  }
  Toast.setDefaultOptions = setDefaultOptions;
  Toast.resetDefaultOptions = (type) => {
    if (typeof type === "string") {
      defaultOptionsMap.delete(type);
    } else {
      currentOptions = extend({}, defaultOptions);
      defaultOptionsMap.clear();
    }
  };
  Toast.allowMultiple = function(value) {
    if (value === void 0) {
      value = true;
    }
    allowMultiple = value;
  };
  Toast.install = (app) => {
    app.use(withInstall(CfToast));
    app.config.globalProperties.$toast = Toast;
  };
  var [name, bem] = createNamespace("uploader");
  var toArray = (item) => Array.isArray(item) ? item : [item];
  function readFileContent(file, resultType) {
    return new Promise((resolve) => {
      if (resultType === "file") {
        resolve();
        return;
      }
      var reader = new FileReader();
      reader.onload = (event) => {
        resolve(event.target.result);
      };
      if (resultType === "dataUrl") {
        reader.readAsDataURL(file);
      } else if (resultType === "text") {
        reader.readAsText(file);
      }
    });
  }
  function isOversize(items, maxSize) {
    return toArray(items).some((item) => {
      if (item.file) {
        if (isFunction(maxSize)) {
          return maxSize(item.file);
        }
        return item.file.size > maxSize;
      }
      return false;
    });
  }
  function filterFiles(items, maxSize) {
    var valid = [];
    var invalid = [];
    items.forEach((item) => {
      if (isOversize([item], maxSize)) {
        invalid.push(item);
      } else {
        valid.push(item);
      }
    });
    return {
      valid,
      invalid
    };
  }
  var IMAGE_REGEXP = /\.(jpeg|jpg|gif|png|svg|webp|jfif|bmp|dpg)/i;
  var isImageUrl = (url) => IMAGE_REGEXP.test(url);
  function isImageFile(item) {
    if (item.isImage) {
      return true;
    }
    if (item.file && item.file.type) {
      return item.file.type.indexOf("image") === 0;
    }
    if (item.url) {
      return isImageUrl(item.url);
    }
    if (typeof item.content === "string") {
      return item.content.indexOf("data:image") === 0;
    }
    return false;
  }
  function _extends$1() {
    _extends$1 = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends$1.apply(this, arguments);
  }
  var uploaderPreviewProps = {
    name: numericProp,
    item: makeRequiredProp(Object),
    index: Number,
    imageFit: String,
    lazyLoad: Boolean,
    deletable: Boolean,
    previewSize: numericProp,
    beforeDelete: Function
  };
  var UploaderPreviewItem = vue.defineComponent({
    props: uploaderPreviewProps,
    emits: ["click", "delete", "preview"],
    setup(props, _ref) {
      var {
        emit,
        slots
      } = _ref;
      var renderMask = () => {
        var {
          status,
          message
        } = props.item;
        if (status === "uploading" || status === "failed") {
          var MaskIcon = status === "failed" ? vue.createVNode(Icon, {
            "name": "load_error",
            "class": bem("mask-icon")
          }, null) : vue.createVNode(Loading, {
            "class": bem("loading")
          }, null);
          var showMessage = isDef(message) && message !== "" && status === "failed";
          return vue.createVNode("div", {
            "class": bem("mask", {
              white: status === "failed"
            })
          }, [MaskIcon, showMessage && vue.createVNode("div", {
            "class": bem("mask-message")
          }, [message])]);
        }
      };
      var onDelete = (event) => {
        var {
          name: name2,
          item,
          index: index2,
          beforeDelete
        } = props;
        event.stopPropagation();
        callInterceptor(beforeDelete, {
          args: [item, {
            name: name2,
            index: index2
          }],
          done: () => emit("delete")
        });
      };
      var renderDeleteIcon = () => {
        if (props.deletable && props.item.status !== "uploading") {
          return vue.createVNode("div", {
            "class": bem("preview-delete"),
            "onClick": onDelete
          }, [vue.createVNode(Icon, {
            "name": "close_out_line",
            "class": bem("preview-delete-icon")
          }, null)]);
        }
      };
      var renderCover = () => {
        if (slots["preview-cover"]) {
          var {
            index: index2,
            item
          } = props;
          return vue.createVNode("div", {
            "class": bem("preview-cover")
          }, [slots["preview-cover"](_extends$1({
            index: index2
          }, item))]);
        }
      };
      var onPreview = () => emit("preview");
      var renderPreview = () => {
        var {
          item
        } = props;
        if (isImageFile(item)) {
          return vue.createVNode(Image, {
            "fit": props.imageFit,
            "src": item.content || item.url,
            "class": bem("preview-image"),
            "width": props.previewSize,
            "height": props.previewSize,
            "onClick": onPreview
          }, {
            default: renderCover
          });
        }
        return vue.createVNode("div", {
          "class": bem("file"),
          "style": getSizeStyle(props.previewSize)
        }, [vue.createVNode(Icon, {
          "class": bem("file-icon"),
          "name": "description"
        }, null), vue.createVNode("div", {
          "class": [bem("file-name"), "ellipsis"]
        }, [item.file ? item.file.name : item.url]), renderCover()]);
      };
      var handleClick = () => {
        emit("click");
      };
      return () => vue.createVNode("div", {
        "class": bem("preview"),
        "onClick": handleClick
      }, [renderPreview(), renderMask(), renderDeleteIcon()]);
    }
  });
  function _extends() {
    _extends = Object.assign || function(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  var uploaderProps = {
    modelValue: makeArrayProp(),
    name: makeNumericProp(""),
    accept: makeStringProp("image/*"),
    multiple: Boolean,
    disabled: Boolean,
    readonly: Boolean,
    capture: String,
    maxSize: {
      type: [Number, String, Function],
      default: Infinity
    },
    maxCount: makeNumericProp(Infinity),
    resultType: makeStringProp("dataUrl"),
    beforeRead: Function,
    afterRead: Function,
    deletable: truthProp,
    beforeDelete: Function,
    showUpload: truthProp,
    previewImage: truthProp,
    previewFullImage: truthProp,
    previewOptions: Object,
    previewSize: numericProp,
    imageFit: makeStringProp("cover")
  };
  var _Uploader = vue.defineComponent({
    name,
    props: uploaderProps,
    emits: ["delete", "oversize", "click-upload", "close-preview", "click-preview", "update:modelValue"],
    setup(props, _ref) {
      var {
        emit,
        slots
      } = _ref;
      var inputRef = vue.ref();
      var getDetail = function(index2) {
        if (index2 === void 0) {
          index2 = props.modelValue.length;
        }
        return {
          name: props.name,
          index: index2
        };
      };
      var resetInput = () => {
        if (inputRef.value)
          inputRef.value.value = "";
      };
      var onAfterRead = (items) => {
        resetInput();
        if (isOversize(items, props.maxSize)) {
          if (Array.isArray(items)) {
            var result = filterFiles(items, props.maxSize);
            items = result.valid;
            emit("oversize", result.invalid, getDetail());
            if (!items.length) {
              return;
            }
          } else {
            emit("oversize", items, getDetail());
            return;
          }
        }
        items = vue.reactive(items);
        emit("update:modelValue", [...props.modelValue, ...toArray(items)]);
        if (props.afterRead) {
          props.afterRead(items, getDetail());
        }
      };
      var readFile = (files) => {
        var {
          maxCount,
          modelValue,
          resultType
        } = props;
        if (Array.isArray(files)) {
          var remainCount = +maxCount - modelValue.length;
          if (files.length > remainCount) {
            files = files.slice(0, remainCount);
          }
          Promise.all(files.map((file) => readFileContent(file, resultType))).then((contents) => {
            var fileList = files.map((file, index2) => {
              var result = {
                file,
                status: "",
                message: ""
              };
              if (contents[index2]) {
                result.content = contents[index2];
              }
              return result;
            });
            onAfterRead(fileList);
          });
        } else {
          readFileContent(files, resultType).then((content) => {
            var result = {
              file: files,
              status: "",
              message: ""
            };
            if (content) {
              result.content = content;
            }
            onAfterRead(result);
          });
        }
      };
      var onChange = (e) => {
        var {
          files
        } = e.target;
        if (props.disabled || !files || !files.length) {
          return;
        }
        var file = files.length === 1 ? files[0] : [].slice.call(files);
        if (props.beforeRead) {
          var response = props.beforeRead(file, getDetail());
          if (!response) {
            resetInput();
            return;
          }
          if (isPromise(response)) {
            response.then((data) => {
              if (data) {
                readFile(data);
              } else {
                readFile(file);
              }
            }).catch(resetInput);
            return;
          }
        }
        readFile(file);
      };
      var deleteFile = (item, index2) => {
        var fileList = props.modelValue.slice(0);
        fileList.splice(index2, 1);
        emit("update:modelValue", fileList);
        emit("delete", item, getDetail(index2));
      };
      var onClosePreview = () => emit("close-preview");
      var imagePreview;
      var previewImage = (item) => {
        if (props.previewFullImage) {
          var imageFiles = props.modelValue.filter(isImageFile);
          var images2 = imageFiles.map((item2) => item2.content || item2.url).filter(Boolean);
          imagePreview = ImagePreview.showImagePreview == null ? void 0 : ImagePreview.showImagePreview(_extends({
            images: images2,
            startPosition: imageFiles.indexOf(item),
            onClose: onClosePreview
          }, props.previewOptions));
        }
      };
      var closeImagePreview = () => {
        if (imagePreview) {
          imagePreview.close();
        }
      };
      var renderPreviewItem = (item, index2) => {
        var needPickData = [
          "imageFit",
          "deletable",
          "previewSize",
          "beforeDelete"
        ];
        var previewData = Object.assign(pick(props, needPickData), pick(item, needPickData, true));
        return vue.createVNode(UploaderPreviewItem, vue.mergeProps({
          "item": item,
          "index": index2,
          "onClick": () => emit("click-preview", item, getDetail(index2)),
          "onDelete": () => deleteFile(item, index2),
          "onPreview": () => previewImage(item)
        }, previewData), {
          "preview-cover": slots["preview-cover"]
        });
      };
      var renderPreviewList = () => {
        if (props.previewImage) {
          return props.modelValue.map(renderPreviewItem);
        }
      };
      var onClickUpload = (event) => emit("click-upload", event);
      var renderUpload = () => {
        if (props.modelValue.length >= props.maxCount || !props.showUpload) {
          return;
        }
        var Input = props.readonly ? null : vue.createVNode("input", {
          "ref": inputRef,
          "type": "file",
          "class": bem("input"),
          "accept": props.accept,
          "capture": props.capture,
          "multiple": props.multiple,
          "disabled": props.disabled,
          "onChange": onChange
        }, null);
        if (slots.default) {
          return vue.createVNode("div", {
            "class": bem("input-wrapper"),
            "onClick": onClickUpload
          }, [slots.default(), Input]);
        }
        return vue.createVNode("div", {
          "class": bem("upload", {
            readonly: props.readonly,
            disabled: props.disabled
          }),
          "onClick": onClickUpload
        }, [vue.createVNode(Icon, {
          "name": "camera",
          "class": bem("icon")
        }, null), Input]);
      };
      var chooseFile = () => {
        if (inputRef.value && !props.disabled) {
          inputRef.value.click();
        }
      };
      useExpose({
        chooseFile,
        closeImagePreview
      });
      var {
        platform
      } = useConfigProvider();
      return () => vue.createVNode("div", {
        "class": bem({
          pc: platform === "pc"
        })
      }, [vue.createVNode("div", {
        "class": bem("wrapper")
      }, [renderPreviewList(), renderUpload()])]);
    }
  });
  var Uploader = withInstall(_Uploader);
  var version = "1.6.2";
  function install(app) {
    var components = [ActionBar, ActionBarButton, ActionSheet, Alert, Badge, Breadcrumb, Button, Calendar, Card, Cascader, Cell, CellGroup, Checkbox, CheckboxGroup, CheckboxPro, Collapse, CollapseItem, ConfigProvider, DatetimePicker, Dialog, Divider, Empty, Field, Form, Guide, Icon, Image, ImagePreview, List, Loading, NavBar, Overlay, Picker, Popover, Popup, Progress, PullRefresh, Radio, RadioGroup, RadioPro, Search, SearchPro, Slider, Step, Stepper, Steps, Sticky, Swipe, SwipeItem, Switch, Tab, TabItem, Tabbar, TabbarItem, Tag, Toast, Uploader];
    components.forEach((item) => {
      if (item.install) {
        app.use(item);
      } else if (item.name) {
        app.component(item.name, item);
      }
    });
  }
  var index = {
    install,
    version
  };
  exports2.ActionBar = ActionBar;
  exports2.ActionBarButton = ActionBarButton;
  exports2.ActionSheet = ActionSheet;
  exports2.Alert = Alert;
  exports2.Badge = Badge;
  exports2.Breadcrumb = Breadcrumb;
  exports2.BreadcrumbItem = BreadcrumbItem;
  exports2.Button = Button;
  exports2.Calendar = Calendar;
  exports2.Card = Card;
  exports2.Cascader = Cascader;
  exports2.Cell = Cell;
  exports2.CellGroup = CellGroup;
  exports2.Checkbox = Checkbox;
  exports2.CheckboxGroup = CheckboxGroup;
  exports2.CheckboxPro = CheckboxPro;
  exports2.Collapse = Collapse;
  exports2.CollapseItem = CollapseItem;
  exports2.ConfigProvider = ConfigProvider;
  exports2.DatetimePicker = DatetimePicker;
  exports2.Dialog = Dialog;
  exports2.Divider = Divider;
  exports2.Empty = Empty;
  exports2.Field = Field;
  exports2.Form = Form;
  exports2.Guide = Guide;
  exports2.Icon = Icon;
  exports2.Image = Image;
  exports2.ImagePreview = ImagePreview;
  exports2.List = List;
  exports2.Loading = Loading;
  exports2.NavBar = NavBar;
  exports2.Overlay = Overlay;
  exports2.Picker = Picker;
  exports2.Popover = Popover;
  exports2.Popup = Popup;
  exports2.Progress = Progress;
  exports2.PullRefresh = PullRefresh;
  exports2.Radio = Radio;
  exports2.RadioGroup = RadioGroup;
  exports2.RadioPro = RadioPro;
  exports2.Search = Search;
  exports2.SearchPro = SearchPro;
  exports2.Slider = Slider;
  exports2.Step = Step;
  exports2.Stepper = Stepper;
  exports2.Steps = Steps;
  exports2.Sticky = Sticky;
  exports2.Swipe = Swipe;
  exports2.SwipeItem = SwipeItem;
  exports2.Switch = Switch;
  exports2.Tab = Tab;
  exports2.TabItem = TabItem;
  exports2.Tabbar = Tabbar;
  exports2.TabbarItem = TabbarItem;
  exports2.Tag = Tag;
  exports2.Toast = Toast;
  exports2.Uploader = Uploader;
  exports2.actionSheetProps = actionSheetProps;
  exports2["default"] = index;
  exports2.install = install;
  exports2.searchProps = searchProps;
  exports2.version = version;
  Object.defineProperty(exports2, "__esModule", { value: true });
  exports2[Symbol.toStringTag] = "Module";
});
